import * as En from "react";
import we, { forwardRef as Zi, createElement as _n, createContext as Rn, useContext as ut, useMemo as ze, useCallback as Ne, useLayoutEffect as Br, useEffect as he, useRef as pe, useInsertionEffect as Du, Fragment as Iu, useDebugValue as Sa, memo as nt, useState as de, useId as Ur, Children as Mf, isValidElement as Pf, Component as Rf, useImperativeHandle as Df } from "react";
var or = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ou(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ar = { exports: {} }, _i = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ja;
function If() {
  if (ja) return _i;
  ja = 1;
  var e = we, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, l, d) {
    var c, f = {}, h = null, p = null;
    d !== void 0 && (h = "" + d), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) i.call(l, c) && !s.hasOwnProperty(c) && (f[c] = l[c]);
    if (a && a.defaultProps) for (c in l = a.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: a, key: h, ref: p, props: f, _owner: r.current };
  }
  return _i.Fragment = n, _i.jsx = o, _i.jsxs = o, _i;
}
var Ni = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ta;
function Of() {
  return Ta || (Ta = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = Symbol.iterator, v = "@@iterator";
    function w(b) {
      if (b === null || typeof b != "object")
        return null;
      var O = y && b[y] || b[v];
      return typeof O == "function" ? O : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(b) {
      {
        for (var O = arguments.length, z = new Array(O > 1 ? O - 1 : 0), X = 1; X < O; X++)
          z[X - 1] = arguments[X];
        k("error", b, z);
      }
    }
    function k(b, O, z) {
      {
        var X = x.ReactDebugCurrentFrame, Q = X.getStackAddendum();
        Q !== "" && (O += "%s", z = z.concat([Q]));
        var ke = z.map(function(je) {
          return String(je);
        });
        ke.unshift("Warning: " + O), Function.prototype.apply.call(console[b], console, ke);
      }
    }
    var P = !1, j = !1, N = !1, C = !1, R = !1, I;
    I = Symbol.for("react.module.reference");
    function U(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === i || b === s || R || b === r || b === d || b === c || C || b === p || P || j || N || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === f || b.$$typeof === o || b.$$typeof === a || b.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === I || b.getModuleId !== void 0));
    }
    function W(b, O, z) {
      var X = b.displayName;
      if (X)
        return X;
      var Q = O.displayName || O.name || "";
      return Q !== "" ? z + "(" + Q + ")" : z;
    }
    function ae(b) {
      return b.displayName || "Context";
    }
    function $(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case i:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case a:
            var O = b;
            return ae(O) + ".Consumer";
          case o:
            var z = b;
            return ae(z._context) + ".Provider";
          case l:
            return W(b, b.render, "ForwardRef");
          case f:
            var X = b.displayName || null;
            return X !== null ? X : $(b.type) || "Memo";
          case h: {
            var Q = b, ke = Q._payload, je = Q._init;
            try {
              return $(je(ke));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, K = 0, se, G, te, le, Ce, ce, q;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function oe() {
      {
        if (K === 0) {
          se = console.log, G = console.info, te = console.warn, le = console.error, Ce = console.group, ce = console.groupCollapsed, q = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        K++;
      }
    }
    function ie() {
      {
        if (K--, K === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, b, {
              value: se
            }),
            info: V({}, b, {
              value: G
            }),
            warn: V({}, b, {
              value: te
            }),
            error: V({}, b, {
              value: le
            }),
            group: V({}, b, {
              value: Ce
            }),
            groupCollapsed: V({}, b, {
              value: ce
            }),
            groupEnd: V({}, b, {
              value: q
            })
          });
        }
        K < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ye = x.ReactCurrentDispatcher, Me;
    function Pe(b, O, z) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (Q) {
            var X = Q.stack.trim().match(/\n( *(at )?)/);
            Me = X && X[1] || "";
          }
        return `
` + Me + b;
      }
    }
    var Ee = !1, _e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new Ye();
    }
    function Re(b, O) {
      if (!b || Ee)
        return "";
      {
        var z = _e.get(b);
        if (z !== void 0)
          return z;
      }
      var X;
      Ee = !0;
      var Q = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ke;
      ke = ye.current, ye.current = null, oe();
      try {
        if (O) {
          var je = function() {
            throw Error();
          };
          if (Object.defineProperty(je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(je, []);
            } catch (Ie) {
              X = Ie;
            }
            Reflect.construct(b, [], je);
          } else {
            try {
              je.call();
            } catch (Ie) {
              X = Ie;
            }
            b.call(je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ie) {
            X = Ie;
          }
          b();
        }
      } catch (Ie) {
        if (Ie && X && typeof Ie.stack == "string") {
          for (var ve = Ie.stack.split(`
`), rt = X.stack.split(`
`), Fe = ve.length - 1, Be = rt.length - 1; Fe >= 1 && Be >= 0 && ve[Fe] !== rt[Be]; )
            Be--;
          for (; Fe >= 1 && Be >= 0; Fe--, Be--)
            if (ve[Fe] !== rt[Be]) {
              if (Fe !== 1 || Be !== 1)
                do
                  if (Fe--, Be--, Be < 0 || ve[Fe] !== rt[Be]) {
                    var pt = `
` + ve[Fe].replace(" at new ", " at ");
                    return b.displayName && pt.includes("<anonymous>") && (pt = pt.replace("<anonymous>", b.displayName)), typeof b == "function" && _e.set(b, pt), pt;
                  }
                while (Fe >= 1 && Be >= 0);
              break;
            }
        }
      } finally {
        Ee = !1, ye.current = ke, ie(), Error.prepareStackTrace = Q;
      }
      var qt = b ? b.displayName || b.name : "", xe = qt ? Pe(qt) : "";
      return typeof b == "function" && _e.set(b, xe), xe;
    }
    function lt(b, O, z) {
      return Re(b, !1);
    }
    function Ct(b) {
      var O = b.prototype;
      return !!(O && O.isReactComponent);
    }
    function We(b, O, z) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return Re(b, Ct(b));
      if (typeof b == "string")
        return Pe(b);
      switch (b) {
        case d:
          return Pe("Suspense");
        case c:
          return Pe("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case l:
            return lt(b.render);
          case f:
            return We(b.type, O, z);
          case h: {
            var X = b, Q = X._payload, ke = X._init;
            try {
              return We(ke(Q), O, z);
            } catch {
            }
          }
        }
      return "";
    }
    var wt = Object.prototype.hasOwnProperty, He = {}, gt = x.ReactDebugCurrentFrame;
    function ft(b) {
      if (b) {
        var O = b._owner, z = We(b.type, b._source, O ? O.type : null);
        gt.setExtraStackFrame(z);
      } else
        gt.setExtraStackFrame(null);
    }
    function $e(b, O, z, X, Q) {
      {
        var ke = Function.call.bind(wt);
        for (var je in b)
          if (ke(b, je)) {
            var ve = void 0;
            try {
              if (typeof b[je] != "function") {
                var rt = Error((X || "React class") + ": " + z + " type `" + je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw rt.name = "Invariant Violation", rt;
              }
              ve = b[je](O, je, X, z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Fe) {
              ve = Fe;
            }
            ve && !(ve instanceof Error) && (ft(Q), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", z, je, typeof ve), ft(null)), ve instanceof Error && !(ve.message in He) && (He[ve.message] = !0, ft(Q), S("Failed %s type: %s", z, ve.message), ft(null));
          }
      }
    }
    var De = Array.isArray;
    function kt(b) {
      return De(b);
    }
    function pn(b) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, z = O && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return z;
      }
    }
    function Ut(b) {
      try {
        return rn(b), !1;
      } catch {
        return !0;
      }
    }
    function rn(b) {
      return "" + b;
    }
    function zt(b) {
      if (Ut(b))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pn(b)), rn(b);
    }
    var Wt = x.ReactCurrentOwner, Et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ht, _t;
    function Kt(b) {
      if (wt.call(b, "ref")) {
        var O = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function mn(b) {
      if (wt.call(b, "key")) {
        var O = Object.getOwnPropertyDescriptor(b, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function sn(b, O) {
      typeof b.ref == "string" && Wt.current;
    }
    function Nt(b, O) {
      {
        var z = function() {
          Ht || (Ht = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        z.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: z,
          configurable: !0
        });
      }
    }
    function Je(b, O) {
      {
        var z = function() {
          _t || (_t = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        z.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: z,
          configurable: !0
        });
      }
    }
    var ct = function(b, O, z, X, Q, ke, je) {
      var ve = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: b,
        key: O,
        ref: z,
        props: je,
        // Record the component responsible for creating this element.
        _owner: ke
      };
      return ve._store = {}, Object.defineProperty(ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
    };
    function Yt(b, O, z, X, Q) {
      {
        var ke, je = {}, ve = null, rt = null;
        z !== void 0 && (zt(z), ve = "" + z), mn(O) && (zt(O.key), ve = "" + O.key), Kt(O) && (rt = O.ref, sn(O, Q));
        for (ke in O)
          wt.call(O, ke) && !Et.hasOwnProperty(ke) && (je[ke] = O[ke]);
        if (b && b.defaultProps) {
          var Fe = b.defaultProps;
          for (ke in Fe)
            je[ke] === void 0 && (je[ke] = Fe[ke]);
        }
        if (ve || rt) {
          var Be = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          ve && Nt(je, Be), rt && Je(je, Be);
        }
        return ct(b, ve, rt, Q, X, Wt.current, je);
      }
    }
    var Mt = x.ReactCurrentOwner, Gt = x.ReactDebugCurrentFrame;
    function Qe(b) {
      if (b) {
        var O = b._owner, z = We(b.type, b._source, O ? O.type : null);
        Gt.setExtraStackFrame(z);
      } else
        Gt.setExtraStackFrame(null);
    }
    var Pt;
    Pt = !1;
    function Rt(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function Dt() {
      {
        if (Mt.current) {
          var b = $(Mt.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function gn(b) {
      return "";
    }
    var yn = {};
    function Ke(b) {
      {
        var O = Dt();
        if (!O) {
          var z = typeof b == "string" ? b : b.displayName || b.name;
          z && (O = `

Check the top-level render call using <` + z + ">.");
        }
        return O;
      }
    }
    function it(b, O) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var z = Ke(O);
        if (yn[z])
          return;
        yn[z] = !0;
        var X = "";
        b && b._owner && b._owner !== Mt.current && (X = " It was passed a child from " + $(b._owner.type) + "."), Qe(b), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', z, X), Qe(null);
      }
    }
    function re(b, O) {
      {
        if (typeof b != "object")
          return;
        if (kt(b))
          for (var z = 0; z < b.length; z++) {
            var X = b[z];
            Rt(X) && it(X, O);
          }
        else if (Rt(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var Q = w(b);
          if (typeof Q == "function" && Q !== b.entries)
            for (var ke = Q.call(b), je; !(je = ke.next()).done; )
              Rt(je.value) && it(je.value, O);
        }
      }
    }
    function Se(b) {
      {
        var O = b.type;
        if (O == null || typeof O == "string")
          return;
        var z;
        if (typeof O == "function")
          z = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === f))
          z = O.propTypes;
        else
          return;
        if (z) {
          var X = $(O);
          $e(z, b.props, "prop", X, b);
        } else if (O.PropTypes !== void 0 && !Pt) {
          Pt = !0;
          var Q = $(O);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Q || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ht(b) {
      {
        for (var O = Object.keys(b.props), z = 0; z < O.length; z++) {
          var X = O[z];
          if (X !== "children" && X !== "key") {
            Qe(b), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Qe(null);
            break;
          }
        }
        b.ref !== null && (Qe(b), S("Invalid attribute `ref` supplied to `React.Fragment`."), Qe(null));
      }
    }
    var It = {};
    function Y(b, O, z, X, Q, ke) {
      {
        var je = U(b);
        if (!je) {
          var ve = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var rt = gn();
          rt ? ve += rt : ve += Dt();
          var Fe;
          b === null ? Fe = "null" : kt(b) ? Fe = "array" : b !== void 0 && b.$$typeof === t ? (Fe = "<" + ($(b.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof b, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, ve);
        }
        var Be = Yt(b, O, z, Q, ke);
        if (Be == null)
          return Be;
        if (je) {
          var pt = O.children;
          if (pt !== void 0)
            if (X)
              if (kt(pt)) {
                for (var qt = 0; qt < pt.length; qt++)
                  re(pt[qt], b);
                Object.freeze && Object.freeze(pt);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              re(pt, b);
        }
        if (wt.call(O, "key")) {
          var xe = $(b), Ie = Object.keys(O).filter(function(ki) {
            return ki !== "key";
          }), on = Ie.length > 0 ? "{key: someKey, " + Ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!It[xe + on]) {
            var St = Ie.length > 0 ? "{" + Ie.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, on, xe, St, xe), It[xe + on] = !0;
          }
        }
        return b === i ? ht(Be) : Se(Be), Be;
      }
    }
    function ee(b, O, z) {
      return Y(b, O, z, !0);
    }
    function J(b, O, z) {
      return Y(b, O, z, !1);
    }
    var Ae = J, Ze = ee;
    Ni.Fragment = i, Ni.jsx = Ae, Ni.jsxs = Ze;
  }()), Ni;
}
var Ca;
function Lf() {
  return Ca || (Ca = 1, process.env.NODE_ENV === "production" ? ar.exports = If() : ar.exports = Of()), ar.exports;
}
var u = Lf();
function Lu(e) {
  var t, n, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Lu(e[t])) && (i && (i += " "), i += n);
  } else for (n in e) e[n] && (i && (i += " "), i += n);
  return i;
}
function fe() {
  for (var e, t, n = 0, i = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Lu(e)) && (i && (i += " "), i += t);
  return i;
}
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vf = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), $f = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, i) => i ? i.toUpperCase() : n.toLowerCase()
), ka = (e) => {
  const t = $f(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Vu = (...e) => e.filter((t, n, i) => !!t && t.trim() !== "" && i.indexOf(t) === n).join(" ").trim(), Ff = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Bf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uf = Zi(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: i,
    className: r = "",
    children: s,
    iconNode: o,
    ...a
  }, l) => _n(
    "svg",
    {
      ref: l,
      ...Bf,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: i ? Number(n) * 24 / Number(t) : n,
      className: Vu("lucide", r),
      ...!s && !Ff(a) && { "aria-hidden": "true" },
      ...a
    },
    [
      ...o.map(([d, c]) => _n(d, c)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const me = (e, t) => {
  const n = Zi(
    ({ className: i, ...r }, s) => _n(Uf, {
      ref: s,
      iconNode: t,
      className: Vu(
        `lucide-${Vf(ka(e))}`,
        `lucide-${e}`,
        i
      ),
      ...r
    })
  );
  return n.displayName = ka(e), n;
};
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zf = [
  [
    "path",
    {
      d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
      key: "18u6gg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
], So = me("camera", zf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wf = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], Hf = me("check-check", Wf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kf = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], zr = me("check", Kf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yf = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Gf = me("chevron-down", Yf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qf = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Wr = me("chevron-left", qf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xf = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Zf = me("chevron-right", Xf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jf = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Qf = me("circle-alert", Jf);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eh = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], th = me("clock", eh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nh = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
], ih = me("cloud-fog", nh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rh = [
  ["path", { d: "m16 18 6-6-6-6", key: "eg8j8" }],
  ["path", { d: "m8 6-6 6 6 6", key: "ppft3o" }]
], sh = me("code", rh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oh = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], ah = me("ellipsis-vertical", oh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lh = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
], uh = me("file", lh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ch = [
  ["path", { d: "m15 17 5-5-5-5", key: "nf172w" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
], jo = me("forward", ch);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dh = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], To = me("image", dh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fh = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], hh = me("info", fh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ph = [
  ["path", { d: "M3 5h6", key: "1ltk0q" }],
  ["path", { d: "M3 12h13", key: "ppymz1" }],
  ["path", { d: "M3 19h13", key: "bpdczq" }],
  ["path", { d: "m16 8-3-3 3-3", key: "1pjpp6" }],
  ["path", { d: "M21 19V7a2 2 0 0 0-2-2h-6", key: "4zzq67" }]
], mh = me("list-start", ph);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gh = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], $u = me("log-out", gh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yh = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
], vh = me("mail", yh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xh = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M4.93 4.929a10 10 0 0 0-1.938 11.412 2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 0 0 11.302-1.989",
      key: "7il5tn"
    }
  ],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }]
], bh = me("message-circle-off", xh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wh = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ]
], Sh = me("message-circle", wh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jh = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], Th = me("minimize-2", jh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ch = [
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
      key: "1miecu"
    }
  ]
], kh = me("paperclip", Ch);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eh = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], _h = me("pencil", Eh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nh = [
  [
    "path",
    {
      d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
      key: "9njp5v"
    }
  ]
], Ah = me("phone", Nh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mh = [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
], Ph = me("refresh-ccw", Mh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rh = [
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }],
  ["path", { d: "m9 17-5-5 5-5", key: "nvlc11" }]
], Bi = me("reply", Rh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dh = [
  ["path", { d: "m14.5 9.5 1 1", key: "159eiq" }],
  ["path", { d: "m15.5 8.5-4 4", key: "iirg3q" }],
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.74 9.74 0 0 0-6.74 2.74L3 8", key: "g2jlw" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["circle", { cx: "10", cy: "14", r: "2", key: "1239so" }]
], Ih = me("rotate-ccw-key", Dh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oh = [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], Lh = me("scroll-text", Oh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vh = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], $h = me("search", Vh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fh = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], Bh = me("send", Fh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uh = [
  [
    "path",
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      key: "1s2grr"
    }
  ],
  ["path", { d: "M20 2v4", key: "1rf3ol" }],
  ["path", { d: "M22 4h-4", key: "gwowj6" }],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
], zh = me("sparkles", Uh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wh = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], Hh = me("square-pen", Wh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kh = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], Yh = me("trash-2", Kh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gh = [
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], Fu = me("trash", Gh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qh = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], Xh = me("user-plus", qh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zh = [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
], Bu = me("user-round-x", Zh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jh = [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
], lr = me("user-round", Jh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qh = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], Co = me("users", Qh);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ep = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], Nn = me("user", ep);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tp = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], np = me("video", tp);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ip = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], rp = me("wand-sparkles", ip);
/**
 * @license lucide-react v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sp = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Dn = me("x", sp), ko = Rn({}), Uu = Rn({ strict: !1 }), Eo = Rn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), Hr = /* @__PURE__ */ Rn({});
function Kr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Ui(e) {
  return typeof e == "string" || Array.isArray(e);
}
const _o = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], No = ["initial", ..._o];
function Yr(e) {
  return Kr(e.animate) || No.some((t) => Ui(e[t]));
}
function zu(e) {
  return !!(Yr(e) || e.variants);
}
function op(e, t) {
  if (Yr(e)) {
    const { initial: n, animate: i } = e;
    return {
      initial: n === !1 || Ui(n) ? n : void 0,
      animate: Ui(i) ? i : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function ap(e) {
  const { initial: t, animate: n } = op(e, ut(Hr));
  return ze(() => ({ initial: t, animate: n }), [Ea(t), Ea(n)]);
}
function Ea(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Ao = typeof window < "u", _a = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, li = {};
for (const e in _a)
  li[e] = {
    isEnabled: (t) => _a[e].some((n) => !!t[n])
  };
function lp(e) {
  for (const t in e)
    li[t] = {
      ...li[t],
      ...e[t]
    };
}
const up = Symbol.for("motionComponentSymbol");
function ei(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function cp(e, t, n) {
  return Ne(
    (i) => {
      i && e.onMount && e.onMount(i), t && (i ? t.mount(i) : t.unmount()), n && (typeof n == "function" ? n(i) : ei(n) && (n.current = i));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const Mo = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), dp = "framerAppearId", Wu = "data-" + Mo(dp), Gr = /* @__PURE__ */ Rn(null), Hu = Rn({}), Ku = Ao ? Br : he, ur = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Na = {
  value: null
};
function fp(e, t) {
  let n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), r = !1, s = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = 0;
  function d(f) {
    o.has(f) && (c.schedule(f), e()), l++, f(a);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, h = !1, p = !1) => {
      const v = p && r ? n : i;
      return h && o.add(f), v.has(f) || v.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      i.delete(f), o.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (a = f, r) {
        s = !0;
        return;
      }
      r = !0, [n, i] = [i, n], n.forEach(d), t && Na.value && Na.value.frameloop[t].push(l), l = 0, n.clear(), r = !1, s && (s = !1, c.process(f));
    }
  };
  return c;
}
const xn = {}, hp = 40;
function Yu(e, t) {
  let n = !1, i = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => n = !0, o = ur.reduce((k, P) => (k[P] = fp(s, t ? P : void 0), k), {}), { setup: a, read: l, resolveKeyframes: d, preUpdate: c, update: f, preRender: h, render: p, postRender: y } = o, v = () => {
    const k = xn.useManualTiming ? r.timestamp : performance.now();
    n = !1, xn.useManualTiming || (r.delta = i ? 1e3 / 60 : Math.max(Math.min(k - r.timestamp, hp), 1)), r.timestamp = k, r.isProcessing = !0, a.process(r), l.process(r), d.process(r), c.process(r), f.process(r), h.process(r), p.process(r), y.process(r), r.isProcessing = !1, n && t && (i = !1, e(v));
  }, w = () => {
    n = !0, i = !0, r.isProcessing || e(v);
  };
  return { schedule: ur.reduce((k, P) => {
    const j = o[P];
    return k[P] = (N, C = !1, R = !1) => (n || w(), j.schedule(N, C, R)), k;
  }, {}), cancel: (k) => {
    for (let P = 0; P < ur.length; P++)
      o[ur[P]].cancel(k);
  }, state: r, steps: o };
}
const { schedule: Po } = /* @__PURE__ */ Yu(queueMicrotask, !1);
function pp(e, t, n, i, r) {
  var v, w;
  const { visualElement: s } = ut(Hr), o = ut(Uu), a = ut(Gr), l = ut(Eo).reducedMotion, d = pe(null);
  i = i || o.renderer, !d.current && i && (d.current = i(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = d.current, f = ut(Hu);
  c && !c.projection && r && (c.type === "html" || c.type === "svg") && mp(d.current, n, r, f);
  const h = pe(!1);
  Du(() => {
    c && h.current && c.update(n, a);
  });
  const p = n[Wu], y = pe(!!p && !((v = window.MotionHandoffIsComplete) != null && v.call(window, p)) && ((w = window.MotionHasOptimisedAnimation) == null ? void 0 : w.call(window, p)));
  return Ku(() => {
    c && (h.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), Po.render(c.render), y.current && c.animationState && c.animationState.animateChanges());
  }), he(() => {
    c && (!y.current && c.animationState && c.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      var x;
      (x = window.MotionHandoffMarkAsComplete) == null || x.call(window, p);
    }), y.current = !1));
  }), c;
}
function mp(e, t, n, i) {
  const { layoutId: r, layout: s, drag: o, dragConstraints: a, layoutScroll: l, layoutRoot: d, layoutCrossfade: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Gu(e.parent)), e.projection.setOptions({
    layoutId: r,
    layout: s,
    alwaysMeasureLayout: !!o || a && ei(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: i,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: d
  });
}
function Gu(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Gu(e.parent);
}
let vi = () => {
}, bn = () => {
};
process.env.NODE_ENV !== "production" && (vi = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, bn = (e, t) => {
  if (!e)
    throw new Error(t);
});
function gp({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: i, Component: r }) {
  e && lp(e);
  function s(a, l) {
    let d;
    const c = {
      ...ut(Eo),
      ...a,
      layoutId: yp(a)
    }, { isStatic: f } = c, h = ap(a), p = i(a, f);
    if (!f && Ao) {
      vp(c, e);
      const y = xp(c);
      d = y.MeasureLayout, h.visualElement = pp(r, p, c, t, y.ProjectionNode);
    }
    return u.jsxs(Hr.Provider, { value: h, children: [d && h.visualElement ? u.jsx(d, { visualElement: h.visualElement, ...c }) : null, n(r, a, cp(p, h.visualElement, l), p, f, h.visualElement)] });
  }
  s.displayName = `motion.${typeof r == "string" ? r : `create(${r.displayName ?? r.name ?? ""})`}`;
  const o = Zi(s);
  return o[up] = r, o;
}
function yp({ layoutId: e }) {
  const t = ut(ko).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function vp(e, t) {
  const n = ut(Uu).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const i = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? vi(!1, i) : bn(!1, i);
  }
}
function xp(e) {
  const { drag: t, layout: n } = li;
  if (!t && !n)
    return {};
  const i = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
const qu = (e) => (t) => typeof t == "string" && t.startsWith(e), Ro = /* @__PURE__ */ qu("--"), bp = /* @__PURE__ */ qu("var(--"), Do = (e) => bp(e) ? wp.test(e.split("/*")[0].trim()) : !1, wp = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, zi = {};
function Sp(e) {
  for (const t in e)
    zi[t] = e[t], Ro(t) && (zi[t].isCSSVariable = !0);
}
const xi = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], bi = new Set(xi);
function Xu(e, { layout: t, layoutId: n }) {
  return bi.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!zi[e] || e === "opacity");
}
const vt = (e) => !!(e && e.getVelocity), Zu = (e, t) => t && typeof e == "number" ? t.transform(e) : e, wn = (e, t, n) => n > t ? t : n < e ? e : n, wi = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Wi = {
  ...wi,
  transform: (e) => wn(0, 1, e)
}, cr = {
  ...wi,
  default: 1
}, Aa = {
  ...wi,
  transform: Math.round
}, Ji = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Cn = /* @__PURE__ */ Ji("deg"), ln = /* @__PURE__ */ Ji("%"), ue = /* @__PURE__ */ Ji("px"), jp = /* @__PURE__ */ Ji("vh"), Tp = /* @__PURE__ */ Ji("vw"), Ma = {
  ...ln,
  parse: (e) => ln.parse(e) / 100,
  transform: (e) => ln.transform(e * 100)
}, Cp = {
  rotate: Cn,
  rotateX: Cn,
  rotateY: Cn,
  rotateZ: Cn,
  scale: cr,
  scaleX: cr,
  scaleY: cr,
  scaleZ: cr,
  skew: Cn,
  skewX: Cn,
  skewY: Cn,
  distance: ue,
  translateX: ue,
  translateY: ue,
  translateZ: ue,
  x: ue,
  y: ue,
  z: ue,
  perspective: ue,
  transformPerspective: ue,
  opacity: Wi,
  originX: Ma,
  originY: Ma,
  originZ: ue
}, Io = {
  // Border props
  borderWidth: ue,
  borderTopWidth: ue,
  borderRightWidth: ue,
  borderBottomWidth: ue,
  borderLeftWidth: ue,
  borderRadius: ue,
  radius: ue,
  borderTopLeftRadius: ue,
  borderTopRightRadius: ue,
  borderBottomRightRadius: ue,
  borderBottomLeftRadius: ue,
  // Positioning props
  width: ue,
  maxWidth: ue,
  height: ue,
  maxHeight: ue,
  top: ue,
  right: ue,
  bottom: ue,
  left: ue,
  // Spacing props
  padding: ue,
  paddingTop: ue,
  paddingRight: ue,
  paddingBottom: ue,
  paddingLeft: ue,
  margin: ue,
  marginTop: ue,
  marginRight: ue,
  marginBottom: ue,
  marginLeft: ue,
  // Misc
  backgroundPositionX: ue,
  backgroundPositionY: ue,
  ...Cp,
  zIndex: Aa,
  // SVG
  fillOpacity: Wi,
  strokeOpacity: Wi,
  numOctaves: Aa
}, kp = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Ep = xi.length;
function _p(e, t, n) {
  let i = "", r = !0;
  for (let s = 0; s < Ep; s++) {
    const o = xi[s], a = e[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const d = Zu(a, Io[o]);
      if (!l) {
        r = !1;
        const c = kp[o] || o;
        i += `${c}(${d}) `;
      }
      n && (t[o] = d);
    }
  }
  return i = i.trim(), n ? i = n(t, r ? "" : i) : r && (i = "none"), i;
}
function Oo(e, t, n) {
  const { style: i, vars: r, transformOrigin: s } = e;
  let o = !1, a = !1;
  for (const l in t) {
    const d = t[l];
    if (bi.has(l)) {
      o = !0;
      continue;
    } else if (Ro(l)) {
      r[l] = d;
      continue;
    } else {
      const c = Zu(d, Io[l]);
      l.startsWith("origin") ? (a = !0, s[l] = c) : i[l] = c;
    }
  }
  if (t.transform || (o || n ? i.transform = _p(t, e.transform, n) : i.transform && (i.transform = "none")), a) {
    const { originX: l = "50%", originY: d = "50%", originZ: c = 0 } = s;
    i.transformOrigin = `${l} ${d} ${c}`;
  }
}
const Lo = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Ju(e, t, n) {
  for (const i in t)
    !vt(t[i]) && !Xu(i, n) && (e[i] = t[i]);
}
function Np({ transformTemplate: e }, t) {
  return ze(() => {
    const n = Lo();
    return Oo(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Ap(e, t) {
  const n = e.style || {}, i = {};
  return Ju(i, n, e), Object.assign(i, Np(e, t)), i;
}
function Mp(e, t) {
  const n = {}, i = Ap(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = i, n;
}
const Pp = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Nr(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Pp.has(e);
}
let Qu = (e) => !Nr(e);
function Rp(e) {
  e && (Qu = (t) => t.startsWith("on") ? !Nr(t) : e(t));
}
try {
  Rp(require("@emotion/is-prop-valid").default);
} catch {
}
function Dp(e, t, n) {
  const i = {};
  for (const r in e)
    r === "values" && typeof e.values == "object" || (Qu(r) || n === !0 && Nr(r) || !t && !Nr(r) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && r.startsWith("onDrag")) && (i[r] = e[r]);
  return i;
}
const Ip = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Vo(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ip.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
const Op = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Lp = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Vp(e, t, n = 1, i = 0, r = !0) {
  e.pathLength = 1;
  const s = r ? Op : Lp;
  e[s.offset] = ue.transform(-i);
  const o = ue.transform(t), a = ue.transform(n);
  e[s.array] = `${o} ${a}`;
}
function ec(e, {
  attrX: t,
  attrY: n,
  attrScale: i,
  pathLength: r,
  pathSpacing: s = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, d) {
  if (Oo(e, a, d), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: c, style: f } = e;
  c.transform && (f.transform = c.transform, delete c.transform), (f.transform || c.transformOrigin) && (f.transformOrigin = c.transformOrigin ?? "50% 50%", delete c.transformOrigin), f.transform && (f.transformBox = "fill-box", delete c.transformBox), t !== void 0 && (c.x = t), n !== void 0 && (c.y = n), i !== void 0 && (c.scale = i), r !== void 0 && Vp(c, r, s, o, !1);
}
const tc = () => ({
  ...Lo(),
  attrs: {}
}), nc = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function $p(e, t, n, i) {
  const r = ze(() => {
    const s = tc();
    return ec(s, t, nc(i), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [t]);
  if (e.style) {
    const s = {};
    Ju(s, e.style, e), r.style = { ...s, ...r.style };
  }
  return r;
}
function Fp(e = !1) {
  return (n, i, r, { latestValues: s }, o) => {
    const l = (Vo(n) ? $p : Mp)(i, s, o, n), d = Dp(i, typeof n == "string", e), c = n !== Iu ? { ...d, ...l, ref: r } : {}, { children: f } = i, h = ze(() => vt(f) ? f.get() : f, [f]);
    return _n(n, {
      ...c,
      children: h
    });
  };
}
function Pa(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, i) => {
    t[0][i] = n.get(), t[1][i] = n.getVelocity();
  }), t;
}
function $o(e, t, n, i) {
  if (typeof t == "function") {
    const [r, s] = Pa(i);
    t = t(n !== void 0 ? n : e.custom, r, s);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [r, s] = Pa(i);
    t = t(n !== void 0 ? n : e.custom, r, s);
  }
  return t;
}
function Fo(e) {
  const t = pe(null);
  return t.current === null && (t.current = e()), t.current;
}
function br(e) {
  return vt(e) ? e.get() : e;
}
function Bp({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, i, r) {
  return {
    latestValues: Up(n, i, r, e),
    renderState: t()
  };
}
const ic = (e) => (t, n) => {
  const i = ut(Hr), r = ut(Gr), s = () => Bp(e, t, i, r);
  return n ? s() : Fo(s);
};
function Up(e, t, n, i) {
  const r = {}, s = i(e, {});
  for (const h in s)
    r[h] = br(s[h]);
  let { initial: o, animate: a } = e;
  const l = Yr(e), d = zu(e);
  t && d && !l && e.inherit !== !1 && (o === void 0 && (o = t.initial), a === void 0 && (a = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const f = c ? a : o;
  if (f && typeof f != "boolean" && !Kr(f)) {
    const h = Array.isArray(f) ? f : [f];
    for (let p = 0; p < h.length; p++) {
      const y = $o(e, h[p]);
      if (y) {
        const { transitionEnd: v, transition: w, ...x } = y;
        for (const S in x) {
          let k = x[S];
          if (Array.isArray(k)) {
            const P = c ? k.length - 1 : 0;
            k = k[P];
          }
          k !== null && (r[S] = k);
        }
        for (const S in v)
          r[S] = v[S];
      }
    }
  }
  return r;
}
function Bo(e, t, n) {
  var s;
  const { style: i } = e, r = {};
  for (const o in i)
    (vt(i[o]) || t.style && vt(t.style[o]) || Xu(o, e) || ((s = n == null ? void 0 : n.getValue(o)) == null ? void 0 : s.liveStyle) !== void 0) && (r[o] = i[o]);
  return r;
}
const zp = {
  useVisualState: ic({
    scrapeMotionValuesFromProps: Bo,
    createRenderState: Lo
  })
};
function rc(e, t, n) {
  const i = Bo(e, t, n);
  for (const r in e)
    if (vt(e[r]) || vt(t[r])) {
      const s = xi.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      i[s] = e[r];
    }
  return i;
}
const Wp = {
  useVisualState: ic({
    scrapeMotionValuesFromProps: rc,
    createRenderState: tc
  })
};
function sc(e, t) {
  return function(i, { forwardMotionProps: r } = { forwardMotionProps: !1 }) {
    const o = {
      ...Vo(i) ? Wp : zp,
      preloadedFeatures: e,
      useRender: Fp(r),
      createVisualElement: t,
      Component: i
    };
    return gp(o);
  };
}
const M = /* @__PURE__ */ sc(), Hp = /* @__PURE__ */ M("a"), Kp = /* @__PURE__ */ M("abbr"), Yp = /* @__PURE__ */ M("address"), Gp = /* @__PURE__ */ M("area"), qp = /* @__PURE__ */ M("article"), Xp = /* @__PURE__ */ M("aside"), Zp = /* @__PURE__ */ M("audio"), Jp = /* @__PURE__ */ M("b"), Qp = /* @__PURE__ */ M("base"), em = /* @__PURE__ */ M("bdi"), tm = /* @__PURE__ */ M("bdo"), nm = /* @__PURE__ */ M("big"), im = /* @__PURE__ */ M("blockquote"), rm = /* @__PURE__ */ M("body"), sm = /* @__PURE__ */ M("button"), om = /* @__PURE__ */ M("canvas"), am = /* @__PURE__ */ M("caption"), lm = /* @__PURE__ */ M("cite"), um = /* @__PURE__ */ M("code"), cm = /* @__PURE__ */ M("col"), dm = /* @__PURE__ */ M("colgroup"), fm = /* @__PURE__ */ M("data"), hm = /* @__PURE__ */ M("datalist"), pm = /* @__PURE__ */ M("dd"), mm = /* @__PURE__ */ M("del"), gm = /* @__PURE__ */ M("details"), ym = /* @__PURE__ */ M("dfn"), vm = /* @__PURE__ */ M("dialog"), Rs = /* @__PURE__ */ M("div"), xm = /* @__PURE__ */ M("dl"), bm = /* @__PURE__ */ M("dt"), wm = /* @__PURE__ */ M("em"), Sm = /* @__PURE__ */ M("embed"), jm = /* @__PURE__ */ M("fieldset"), Tm = /* @__PURE__ */ M("figcaption"), Cm = /* @__PURE__ */ M("figure"), km = /* @__PURE__ */ M("footer"), Em = /* @__PURE__ */ M("form"), _m = /* @__PURE__ */ M("h1"), Nm = /* @__PURE__ */ M("h2"), Am = /* @__PURE__ */ M("h3"), Mm = /* @__PURE__ */ M("h4"), Pm = /* @__PURE__ */ M("h5"), Rm = /* @__PURE__ */ M("h6"), Dm = /* @__PURE__ */ M("head"), Im = /* @__PURE__ */ M("header"), Om = /* @__PURE__ */ M("hgroup"), Lm = /* @__PURE__ */ M("hr"), Vm = /* @__PURE__ */ M("html"), $m = /* @__PURE__ */ M("i"), Fm = /* @__PURE__ */ M("iframe"), Bm = /* @__PURE__ */ M("img"), Um = /* @__PURE__ */ M("input"), zm = /* @__PURE__ */ M("ins"), Wm = /* @__PURE__ */ M("kbd"), Hm = /* @__PURE__ */ M("keygen"), Km = /* @__PURE__ */ M("label"), Ym = /* @__PURE__ */ M("legend"), Gm = /* @__PURE__ */ M("li"), qm = /* @__PURE__ */ M("link"), Xm = /* @__PURE__ */ M("main"), Zm = /* @__PURE__ */ M("map"), Jm = /* @__PURE__ */ M("mark"), Qm = /* @__PURE__ */ M("menu"), eg = /* @__PURE__ */ M("menuitem"), tg = /* @__PURE__ */ M("meter"), ng = /* @__PURE__ */ M("nav"), ig = /* @__PURE__ */ M("object"), rg = /* @__PURE__ */ M("ol"), sg = /* @__PURE__ */ M("optgroup"), og = /* @__PURE__ */ M("option"), ag = /* @__PURE__ */ M("output"), lg = /* @__PURE__ */ M("p"), ug = /* @__PURE__ */ M("param"), cg = /* @__PURE__ */ M("picture"), dg = /* @__PURE__ */ M("pre"), fg = /* @__PURE__ */ M("progress"), hg = /* @__PURE__ */ M("q"), pg = /* @__PURE__ */ M("rp"), mg = /* @__PURE__ */ M("rt"), gg = /* @__PURE__ */ M("ruby"), yg = /* @__PURE__ */ M("s"), vg = /* @__PURE__ */ M("samp"), xg = /* @__PURE__ */ M("script"), bg = /* @__PURE__ */ M("section"), wg = /* @__PURE__ */ M("select"), Sg = /* @__PURE__ */ M("small"), jg = /* @__PURE__ */ M("source"), oc = /* @__PURE__ */ M("span"), Tg = /* @__PURE__ */ M("strong"), Cg = /* @__PURE__ */ M("style"), kg = /* @__PURE__ */ M("sub"), Eg = /* @__PURE__ */ M("summary"), _g = /* @__PURE__ */ M("sup"), Ng = /* @__PURE__ */ M("table"), Ag = /* @__PURE__ */ M("tbody"), Mg = /* @__PURE__ */ M("td"), Pg = /* @__PURE__ */ M("textarea"), Rg = /* @__PURE__ */ M("tfoot"), Dg = /* @__PURE__ */ M("th"), Ig = /* @__PURE__ */ M("thead"), Og = /* @__PURE__ */ M("time"), Lg = /* @__PURE__ */ M("title"), Vg = /* @__PURE__ */ M("tr"), $g = /* @__PURE__ */ M("track"), Fg = /* @__PURE__ */ M("u"), Bg = /* @__PURE__ */ M("ul"), Ug = /* @__PURE__ */ M("video"), zg = /* @__PURE__ */ M("wbr"), Wg = /* @__PURE__ */ M("webview"), Hg = /* @__PURE__ */ M("animate"), Kg = /* @__PURE__ */ M("circle"), Yg = /* @__PURE__ */ M("defs"), Gg = /* @__PURE__ */ M("desc"), qg = /* @__PURE__ */ M("ellipse"), Xg = /* @__PURE__ */ M("g"), Zg = /* @__PURE__ */ M("image"), Jg = /* @__PURE__ */ M("line"), Qg = /* @__PURE__ */ M("filter"), ey = /* @__PURE__ */ M("marker"), ty = /* @__PURE__ */ M("mask"), ny = /* @__PURE__ */ M("metadata"), iy = /* @__PURE__ */ M("path"), ry = /* @__PURE__ */ M("pattern"), sy = /* @__PURE__ */ M("polygon"), oy = /* @__PURE__ */ M("polyline"), ay = /* @__PURE__ */ M("rect"), ly = /* @__PURE__ */ M("stop"), uy = /* @__PURE__ */ M("svg"), cy = /* @__PURE__ */ M("symbol"), dy = /* @__PURE__ */ M("text"), fy = /* @__PURE__ */ M("tspan"), hy = /* @__PURE__ */ M("use"), py = /* @__PURE__ */ M("view"), my = /* @__PURE__ */ M("clipPath"), gy = /* @__PURE__ */ M("feBlend"), yy = /* @__PURE__ */ M("feColorMatrix"), vy = /* @__PURE__ */ M("feComponentTransfer"), xy = /* @__PURE__ */ M("feComposite"), by = /* @__PURE__ */ M("feConvolveMatrix"), wy = /* @__PURE__ */ M("feDiffuseLighting"), Sy = /* @__PURE__ */ M("feDisplacementMap"), jy = /* @__PURE__ */ M("feDistantLight"), Ty = /* @__PURE__ */ M("feDropShadow"), Cy = /* @__PURE__ */ M("feFlood"), ky = /* @__PURE__ */ M("feFuncA"), Ey = /* @__PURE__ */ M("feFuncB"), _y = /* @__PURE__ */ M("feFuncG"), Ny = /* @__PURE__ */ M("feFuncR"), Ay = /* @__PURE__ */ M("feGaussianBlur"), My = /* @__PURE__ */ M("feImage"), Py = /* @__PURE__ */ M("feMerge"), Ry = /* @__PURE__ */ M("feMergeNode"), Dy = /* @__PURE__ */ M("feMorphology"), Iy = /* @__PURE__ */ M("feOffset"), Oy = /* @__PURE__ */ M("fePointLight"), Ly = /* @__PURE__ */ M("feSpecularLighting"), Vy = /* @__PURE__ */ M("feSpotLight"), $y = /* @__PURE__ */ M("feTile"), Fy = /* @__PURE__ */ M("feTurbulence"), By = /* @__PURE__ */ M("foreignObject"), Uy = /* @__PURE__ */ M("linearGradient"), zy = /* @__PURE__ */ M("radialGradient"), Wy = /* @__PURE__ */ M("textPath"), Hy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  a: Hp,
  abbr: Kp,
  address: Yp,
  animate: Hg,
  area: Gp,
  article: qp,
  aside: Xp,
  audio: Zp,
  b: Jp,
  base: Qp,
  bdi: em,
  bdo: tm,
  big: nm,
  blockquote: im,
  body: rm,
  button: sm,
  canvas: om,
  caption: am,
  circle: Kg,
  cite: lm,
  clipPath: my,
  code: um,
  col: cm,
  colgroup: dm,
  create: M,
  data: fm,
  datalist: hm,
  dd: pm,
  defs: Yg,
  del: mm,
  desc: Gg,
  details: gm,
  dfn: ym,
  dialog: vm,
  div: Rs,
  dl: xm,
  dt: bm,
  ellipse: qg,
  em: wm,
  embed: Sm,
  feBlend: gy,
  feColorMatrix: yy,
  feComponentTransfer: vy,
  feComposite: xy,
  feConvolveMatrix: by,
  feDiffuseLighting: wy,
  feDisplacementMap: Sy,
  feDistantLight: jy,
  feDropShadow: Ty,
  feFlood: Cy,
  feFuncA: ky,
  feFuncB: Ey,
  feFuncG: _y,
  feFuncR: Ny,
  feGaussianBlur: Ay,
  feImage: My,
  feMerge: Py,
  feMergeNode: Ry,
  feMorphology: Dy,
  feOffset: Iy,
  fePointLight: Oy,
  feSpecularLighting: Ly,
  feSpotLight: Vy,
  feTile: $y,
  feTurbulence: Fy,
  fieldset: jm,
  figcaption: Tm,
  figure: Cm,
  filter: Qg,
  footer: km,
  foreignObject: By,
  form: Em,
  g: Xg,
  h1: _m,
  h2: Nm,
  h3: Am,
  h4: Mm,
  h5: Pm,
  h6: Rm,
  head: Dm,
  header: Im,
  hgroup: Om,
  hr: Lm,
  html: Vm,
  i: $m,
  iframe: Fm,
  image: Zg,
  img: Bm,
  input: Um,
  ins: zm,
  kbd: Wm,
  keygen: Hm,
  label: Km,
  legend: Ym,
  li: Gm,
  line: Jg,
  linearGradient: Uy,
  link: qm,
  main: Xm,
  map: Zm,
  mark: Jm,
  marker: ey,
  mask: ty,
  menu: Qm,
  menuitem: eg,
  metadata: ny,
  meter: tg,
  nav: ng,
  object: ig,
  ol: rg,
  optgroup: sg,
  option: og,
  output: ag,
  p: lg,
  param: ug,
  path: iy,
  pattern: ry,
  picture: cg,
  polygon: sy,
  polyline: oy,
  pre: dg,
  progress: fg,
  q: hg,
  radialGradient: zy,
  rect: ay,
  rp: pg,
  rt: mg,
  ruby: gg,
  s: yg,
  samp: vg,
  script: xg,
  section: bg,
  select: wg,
  small: Sg,
  source: jg,
  span: oc,
  stop: ly,
  strong: Tg,
  style: Cg,
  sub: kg,
  summary: Eg,
  sup: _g,
  svg: uy,
  symbol: cy,
  table: Ng,
  tbody: Ag,
  td: Mg,
  text: dy,
  textPath: Wy,
  textarea: Pg,
  tfoot: Rg,
  th: Dg,
  thead: Ig,
  time: Og,
  title: Lg,
  tr: Vg,
  track: $g,
  tspan: fy,
  u: Fg,
  ul: Bg,
  use: hy,
  video: Ug,
  view: py,
  wbr: zg,
  webview: Wg
}, Symbol.toStringTag, { value: "Module" }));
var jt = function() {
  return jt = Object.assign || function(t) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, jt.apply(this, arguments);
};
function Kn(e, t, n) {
  if (n || arguments.length === 2) for (var i = 0, r = t.length, s; i < r; i++)
    (s || !(i in t)) && (s || (s = Array.prototype.slice.call(t, 0, i)), s[i] = t[i]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function Ky(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Yy = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Gy = /* @__PURE__ */ Ky(
  function(e) {
    return Yy.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ue = "-ms-", Oi = "-moz-", Le = "-webkit-", ac = "comm", qr = "rule", Uo = "decl", qy = "@import", lc = "@keyframes", Xy = "@layer", uc = Math.abs, zo = String.fromCharCode, Ds = Object.assign;
function Zy(e, t) {
  return dt(e, 0) ^ 45 ? (((t << 2 ^ dt(e, 0)) << 2 ^ dt(e, 1)) << 2 ^ dt(e, 2)) << 2 ^ dt(e, 3) : 0;
}
function cc(e) {
  return e.trim();
}
function vn(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function be(e, t, n) {
  return e.replace(t, n);
}
function wr(e, t, n) {
  return e.indexOf(t, n);
}
function dt(e, t) {
  return e.charCodeAt(t) | 0;
}
function ui(e, t, n) {
  return e.slice(t, n);
}
function an(e) {
  return e.length;
}
function dc(e) {
  return e.length;
}
function Mi(e, t) {
  return t.push(e), e;
}
function Jy(e, t) {
  return e.map(t).join("");
}
function Ra(e, t) {
  return e.filter(function(n) {
    return !vn(n, t);
  });
}
var Xr = 1, ci = 1, fc = 0, Bt = 0, ot = 0, Si = "";
function Zr(e, t, n, i, r, s, o, a) {
  return { value: e, root: t, parent: n, type: i, props: r, children: s, line: Xr, column: ci, length: o, return: "", siblings: a };
}
function kn(e, t) {
  return Ds(Zr("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function Zn(e) {
  for (; e.root; )
    e = kn(e.root, { children: [e] });
  Mi(e, e.siblings);
}
function Qy() {
  return ot;
}
function ev() {
  return ot = Bt > 0 ? dt(Si, --Bt) : 0, ci--, ot === 10 && (ci = 1, Xr--), ot;
}
function Jt() {
  return ot = Bt < fc ? dt(Si, Bt++) : 0, ci++, ot === 10 && (ci = 1, Xr++), ot;
}
function Un() {
  return dt(Si, Bt);
}
function Sr() {
  return Bt;
}
function Jr(e, t) {
  return ui(Si, e, t);
}
function Is(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function tv(e) {
  return Xr = ci = 1, fc = an(Si = e), Bt = 0, [];
}
function nv(e) {
  return Si = "", e;
}
function ls(e) {
  return cc(Jr(Bt - 1, Os(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function iv(e) {
  for (; (ot = Un()) && ot < 33; )
    Jt();
  return Is(e) > 2 || Is(ot) > 3 ? "" : " ";
}
function rv(e, t) {
  for (; --t && Jt() && !(ot < 48 || ot > 102 || ot > 57 && ot < 65 || ot > 70 && ot < 97); )
    ;
  return Jr(e, Sr() + (t < 6 && Un() == 32 && Jt() == 32));
}
function Os(e) {
  for (; Jt(); )
    switch (ot) {
      // ] ) " '
      case e:
        return Bt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Os(ot);
        break;
      // (
      case 40:
        e === 41 && Os(e);
        break;
      // \
      case 92:
        Jt();
        break;
    }
  return Bt;
}
function sv(e, t) {
  for (; Jt() && e + ot !== 57; )
    if (e + ot === 84 && Un() === 47)
      break;
  return "/*" + Jr(t, Bt - 1) + "*" + zo(e === 47 ? e : Jt());
}
function ov(e) {
  for (; !Is(Un()); )
    Jt();
  return Jr(e, Bt);
}
function av(e) {
  return nv(jr("", null, null, null, [""], e = tv(e), 0, [0], e));
}
function jr(e, t, n, i, r, s, o, a, l) {
  for (var d = 0, c = 0, f = o, h = 0, p = 0, y = 0, v = 1, w = 1, x = 1, S = 0, k = "", P = r, j = s, N = i, C = k; w; )
    switch (y = S, S = Jt()) {
      // (
      case 40:
        if (y != 108 && dt(C, f - 1) == 58) {
          wr(C += be(ls(S), "&", "&\f"), "&\f", uc(d ? a[d - 1] : 0)) != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        C += ls(S);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        C += iv(y);
        break;
      // \
      case 92:
        C += rv(Sr() - 1, 7);
        continue;
      // /
      case 47:
        switch (Un()) {
          case 42:
          case 47:
            Mi(lv(sv(Jt(), Sr()), t, n, l), l);
            break;
          default:
            C += "/";
        }
        break;
      // {
      case 123 * v:
        a[d++] = an(C) * x;
      // } ; \0
      case 125 * v:
      case 59:
      case 0:
        switch (S) {
          // \0 }
          case 0:
          case 125:
            w = 0;
          // ;
          case 59 + c:
            x == -1 && (C = be(C, /\f/g, "")), p > 0 && an(C) - f && Mi(p > 32 ? Ia(C + ";", i, n, f - 1, l) : Ia(be(C, " ", "") + ";", i, n, f - 2, l), l);
            break;
          // @ ;
          case 59:
            C += ";";
          // { rule/at-rule
          default:
            if (Mi(N = Da(C, t, n, d, c, r, a, k, P = [], j = [], f, s), s), S === 123)
              if (c === 0)
                jr(C, t, N, N, P, s, f, a, j);
              else
                switch (h === 99 && dt(C, 3) === 110 ? 100 : h) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    jr(e, N, N, i && Mi(Da(e, N, N, 0, 0, r, a, k, r, P = [], f, j), j), r, j, f, a, i ? P : j);
                    break;
                  default:
                    jr(C, N, N, N, [""], j, 0, a, j);
                }
        }
        d = c = p = 0, v = x = 1, k = C = "", f = o;
        break;
      // :
      case 58:
        f = 1 + an(C), p = y;
      default:
        if (v < 1) {
          if (S == 123)
            --v;
          else if (S == 125 && v++ == 0 && ev() == 125)
            continue;
        }
        switch (C += zo(S), S * v) {
          // &
          case 38:
            x = c > 0 ? 1 : (C += "\f", -1);
            break;
          // ,
          case 44:
            a[d++] = (an(C) - 1) * x, x = 1;
            break;
          // @
          case 64:
            Un() === 45 && (C += ls(Jt())), h = Un(), c = f = an(k = C += ov(Sr())), S++;
            break;
          // -
          case 45:
            y === 45 && an(C) == 2 && (v = 0);
        }
    }
  return s;
}
function Da(e, t, n, i, r, s, o, a, l, d, c, f) {
  for (var h = r - 1, p = r === 0 ? s : [""], y = dc(p), v = 0, w = 0, x = 0; v < i; ++v)
    for (var S = 0, k = ui(e, h + 1, h = uc(w = o[v])), P = e; S < y; ++S)
      (P = cc(w > 0 ? p[S] + " " + k : be(k, /&\f/g, p[S]))) && (l[x++] = P);
  return Zr(e, t, n, r === 0 ? qr : a, l, d, c, f);
}
function lv(e, t, n, i) {
  return Zr(e, t, n, ac, zo(Qy()), ui(e, 2, -2), 0, i);
}
function Ia(e, t, n, i, r) {
  return Zr(e, t, n, Uo, ui(e, 0, i), ui(e, i + 1, -1), i, r);
}
function hc(e, t, n) {
  switch (Zy(e, t)) {
    // color-adjust
    case 5103:
      return Le + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Le + e + e;
    // tab-size
    case 4789:
      return Oi + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Le + e + Oi + e + Ue + e + e;
    // writing-mode
    case 5936:
      switch (dt(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Le + e + Ue + be(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Le + e + Ue + be(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Le + e + Ue + be(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Le + e + Ue + e + e;
    // order
    case 6165:
      return Le + e + Ue + "flex-" + e + e;
    // align-items
    case 5187:
      return Le + e + be(e, /(\w+).+(:[^]+)/, Le + "box-$1$2" + Ue + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Le + e + Ue + "flex-item-" + be(e, /flex-|-self/g, "") + (vn(e, /flex-|baseline/) ? "" : Ue + "grid-row-" + be(e, /flex-|-self/g, "")) + e;
    // align-content
    case 4675:
      return Le + e + Ue + "flex-line-pack" + be(e, /align-content|flex-|-self/g, "") + e;
    // flex-shrink
    case 5548:
      return Le + e + Ue + be(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Le + e + Ue + be(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Le + "box-" + be(e, "-grow", "") + Le + e + Ue + be(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Le + be(e, /([^-])(transform)/g, "$1" + Le + "$2") + e;
    // cursor
    case 6187:
      return be(be(be(e, /(zoom-|grab)/, Le + "$1"), /(image-set)/, Le + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return be(e, /(image-set\([^]*)/, Le + "$1$`$1");
    // justify-content
    case 4968:
      return be(be(e, /(.+:)(flex-)?(.*)/, Le + "box-pack:$3" + Ue + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Le + e + e;
    // justify-self
    case 4200:
      if (!vn(e, /flex-|baseline/)) return Ue + "grid-column-align" + ui(e, t) + e;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return Ue + be(e, "template-", "") + e;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return n && n.some(function(i, r) {
        return t = r, vn(i.props, /grid-\w+-end/);
      }) ? ~wr(e + (n = n[t].value), "span", 0) ? e : Ue + be(e, "-start", "") + e + Ue + "grid-row-span:" + (~wr(n, "span", 0) ? vn(n, /\d+/) : +vn(n, /\d+/) - +vn(e, /\d+/)) + ";" : Ue + be(e, "-start", "") + e;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return n && n.some(function(i) {
        return vn(i.props, /grid-\w+-start/);
      }) ? e : Ue + be(be(e, "-end", "-span"), "span ", "") + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return be(e, /(.+)-inline(.+)/, Le + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (an(e) - 1 - t > 6)
        switch (dt(e, t + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (dt(e, t + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return be(e, /(.+:)(.+)-([^]+)/, "$1" + Le + "$2-$3$1" + Oi + (dt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          // (s)tretch
          case 115:
            return ~wr(e, "stretch", 0) ? hc(be(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return be(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(i, r, s, o, a, l, d) {
        return Ue + r + ":" + s + d + (o ? Ue + r + "-span:" + (a ? l : +l - +s) + d : "") + e;
      });
    // position: sticky
    case 4949:
      if (dt(e, t + 6) === 121)
        return be(e, ":", ":" + Le) + e;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (dt(e, dt(e, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return be(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Le + (dt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Le + "$2$3$1" + Ue + "$2box$3") + e;
        // (inline-)?gri(d)
        case 100:
          return be(e, ":", ":" + Ue) + e;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return be(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function Ar(e, t) {
  for (var n = "", i = 0; i < e.length; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function uv(e, t, n, i) {
  switch (e.type) {
    case Xy:
      if (e.children.length) break;
    case qy:
    case Uo:
      return e.return = e.return || e.value;
    case ac:
      return "";
    case lc:
      return e.return = e.value + "{" + Ar(e.children, i) + "}";
    case qr:
      if (!an(e.value = e.props.join(","))) return "";
  }
  return an(n = Ar(e.children, i)) ? e.return = e.value + "{" + n + "}" : "";
}
function cv(e) {
  var t = dc(e);
  return function(n, i, r, s) {
    for (var o = "", a = 0; a < t; a++)
      o += e[a](n, i, r, s) || "";
    return o;
  };
}
function dv(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function fv(e, t, n, i) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Uo:
        e.return = hc(e.value, e.length, n);
        return;
      case lc:
        return Ar([kn(e, { value: be(e.value, "@", "@" + Le) })], i);
      case qr:
        if (e.length)
          return Jy(n = e.props, function(r) {
            switch (vn(r, i = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                Zn(kn(e, { props: [be(r, /:(read-\w+)/, ":" + Oi + "$1")] })), Zn(kn(e, { props: [r] })), Ds(e, { props: Ra(n, i) });
                break;
              // :placeholder
              case "::placeholder":
                Zn(kn(e, { props: [be(r, /:(plac\w+)/, ":" + Le + "input-$1")] })), Zn(kn(e, { props: [be(r, /:(plac\w+)/, ":" + Oi + "$1")] })), Zn(kn(e, { props: [be(r, /:(plac\w+)/, Ue + "input-$1")] })), Zn(kn(e, { props: [r] })), Ds(e, { props: Ra(n, i) });
                break;
            }
            return "";
          });
    }
}
var hv = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Yn = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", pc = "active", mc = "data-styled-version", Qr = "6.1.19", Wo = `/*!sc*/
`, Mr = typeof window < "u" && typeof document < "u", pv = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), Oa = /invalid hook call/i, dr = /* @__PURE__ */ new Set(), mv = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = t ? ' with the id of "'.concat(t, '"') : "", i = "The component ".concat(e).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, r = console.error;
    try {
      var s = !0;
      console.error = function(o) {
        for (var a = [], l = 1; l < arguments.length; l++) a[l - 1] = arguments[l];
        Oa.test(o) ? (s = !1, dr.delete(i)) : r.apply(void 0, Kn([o], a, !1));
      }, pe(), s && !dr.has(i) && (console.warn(i), dr.add(i));
    } catch (o) {
      Oa.test(o.message) && dr.delete(i);
    } finally {
      console.error = r;
    }
  }
}, es = Object.freeze([]), di = Object.freeze({});
function gv(e, t, n) {
  return n === void 0 && (n = di), e.theme !== n.theme && e.theme || t || n.theme;
}
var Ls = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), yv = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, vv = /(^-|-$)/g;
function La(e) {
  return e.replace(yv, "-").replace(vv, "");
}
var xv = /(a)(d)/gi, fr = 52, Va = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Vs(e) {
  var t, n = "";
  for (t = Math.abs(e); t > fr; t = t / fr | 0) n = Va(t % fr) + n;
  return (Va(t % fr) + n).replace(xv, "$1-$2");
}
var us, gc = 5381, Vn = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, yc = function(e) {
  return Vn(gc, e);
};
function vc(e) {
  return Vs(yc(e) >>> 0);
}
function xc(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function cs(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var bc = typeof Symbol == "function" && Symbol.for, wc = bc ? Symbol.for("react.memo") : 60115, bv = bc ? Symbol.for("react.forward_ref") : 60112, wv = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, Sv = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Sc = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, jv = ((us = {})[bv] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, us[wc] = Sc, us);
function $a(e) {
  return ("type" in (t = e) && t.type.$$typeof) === wc ? Sc : "$$typeof" in e ? jv[e.$$typeof] : wv;
  var t;
}
var Tv = Object.defineProperty, Cv = Object.getOwnPropertyNames, Fa = Object.getOwnPropertySymbols, kv = Object.getOwnPropertyDescriptor, Ev = Object.getPrototypeOf, Ba = Object.prototype;
function jc(e, t, n) {
  if (typeof t != "string") {
    if (Ba) {
      var i = Ev(t);
      i && i !== Ba && jc(e, i, n);
    }
    var r = Cv(t);
    Fa && (r = r.concat(Fa(t)));
    for (var s = $a(e), o = $a(t), a = 0; a < r.length; ++a) {
      var l = r[a];
      if (!(l in Sv || n && n[l] || o && l in o || s && l in s)) {
        var d = kv(t, l);
        try {
          Tv(e, l, d);
        } catch {
        }
      }
    }
  }
  return e;
}
function fi(e) {
  return typeof e == "function";
}
function Ho(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function $n(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $s(e, t) {
  if (e.length === 0) return "";
  for (var n = e[0], i = 1; i < e.length; i++) n += e[i];
  return n;
}
function hi(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function Fs(e, t, n) {
  if (n === void 0 && (n = !1), !n && !hi(e) && !Array.isArray(e)) return t;
  if (Array.isArray(t)) for (var i = 0; i < t.length; i++) e[i] = Fs(e[i], t[i]);
  else if (hi(t)) for (var i in t) e[i] = Fs(e[i], t[i]);
  return e;
}
function Ko(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var _v = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function Nv() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var n = e[0], i = [], r = 1, s = e.length; r < s; r += 1) i.push(e[r]);
  return i.forEach(function(o) {
    n = n.replace(/%[a-z]/, o);
  }), n;
}
function ji(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(Nv.apply(void 0, Kn([_v[e]], t, !1)).trim());
}
var Av = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var n = 0, i = 0; i < t; i++) n += this.groupSizes[i];
    return n;
  }, e.prototype.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var i = this.groupSizes, r = i.length, s = r; t >= s; ) if ((s <<= 1) < 0) throw ji(16, "".concat(t));
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var o = r; o < s; o++) this.groupSizes[o] = 0;
    }
    for (var a = this.indexOfGroup(t + 1), l = (o = 0, n.length); o < l; o++) this.tag.insertRule(a, n[o]) && (this.groupSizes[t]++, a++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], i = this.indexOfGroup(t), r = i + n;
      this.groupSizes[t] = 0;
      for (var s = i; s < r; s++) this.tag.deleteRule(i);
    }
  }, e.prototype.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0) return n;
    for (var i = this.groupSizes[t], r = this.indexOfGroup(t), s = r + i, o = r; o < s; o++) n += "".concat(this.tag.getRule(o)).concat(Wo);
    return n;
  }, e;
}(), Mv = 1 << 30, Tr = /* @__PURE__ */ new Map(), Pr = /* @__PURE__ */ new Map(), Cr = 1, hr = function(e) {
  if (Tr.has(e)) return Tr.get(e);
  for (; Pr.has(Cr); ) Cr++;
  var t = Cr++;
  if (process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > Mv)) throw ji(16, "".concat(t));
  return Tr.set(e, t), Pr.set(t, e), t;
}, Pv = function(e, t) {
  Cr = t + 1, Tr.set(e, t), Pr.set(t, e);
}, Rv = "style[".concat(Yn, "][").concat(mc, '="').concat(Qr, '"]'), Dv = new RegExp("^".concat(Yn, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Iv = function(e, t, n) {
  for (var i, r = n.split(","), s = 0, o = r.length; s < o; s++) (i = r[s]) && e.registerName(t, i);
}, Ov = function(e, t) {
  for (var n, i = ((n = t.textContent) !== null && n !== void 0 ? n : "").split(Wo), r = [], s = 0, o = i.length; s < o; s++) {
    var a = i[s].trim();
    if (a) {
      var l = a.match(Dv);
      if (l) {
        var d = 0 | parseInt(l[1], 10), c = l[2];
        d !== 0 && (Pv(c, d), Iv(e, c, l[3]), e.getTag().insertRules(d, r)), r.length = 0;
      } else r.push(a);
    }
  }
}, Ua = function(e) {
  for (var t = document.querySelectorAll(Rv), n = 0, i = t.length; n < i; n++) {
    var r = t[n];
    r && r.getAttribute(Yn) !== pc && (Ov(e, r), r.parentNode && r.parentNode.removeChild(r));
  }
};
function Lv() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var Tc = function(e) {
  var t = document.head, n = e || t, i = document.createElement("style"), r = function(a) {
    var l = Array.from(a.querySelectorAll("style[".concat(Yn, "]")));
    return l[l.length - 1];
  }(n), s = r !== void 0 ? r.nextSibling : null;
  i.setAttribute(Yn, pc), i.setAttribute(mc, Qr);
  var o = Lv();
  return o && i.setAttribute("nonce", o), n.insertBefore(i, s), i;
}, Vv = function() {
  function e(t) {
    this.element = Tc(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet) return n.sheet;
      for (var i = document.styleSheets, r = 0, s = i.length; r < s; r++) {
        var o = i[r];
        if (o.ownerNode === n) return o;
      }
      throw ji(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n && n.cssText ? n.cssText : "";
  }, e;
}(), $v = function() {
  function e(t) {
    this.element = Tc(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var i = document.createTextNode(n);
      return this.element.insertBefore(i, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), Fv = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), za = Mr, Bv = { isServer: !Mr, useCSSOMInjection: !pv }, Cc = function() {
  function e(t, n, i) {
    t === void 0 && (t = di), n === void 0 && (n = {});
    var r = this;
    this.options = jt(jt({}, Bv), t), this.gs = n, this.names = new Map(i), this.server = !!t.isServer, !this.server && Mr && za && (za = !1, Ua(this)), Ko(this, function() {
      return function(s) {
        for (var o = s.getTag(), a = o.length, l = "", d = function(f) {
          var h = function(x) {
            return Pr.get(x);
          }(f);
          if (h === void 0) return "continue";
          var p = s.names.get(h), y = o.getGroup(f);
          if (p === void 0 || !p.size || y.length === 0) return "continue";
          var v = "".concat(Yn, ".g").concat(f, '[id="').concat(h, '"]'), w = "";
          p !== void 0 && p.forEach(function(x) {
            x.length > 0 && (w += "".concat(x, ","));
          }), l += "".concat(y).concat(v, '{content:"').concat(w, '"}').concat(Wo);
        }, c = 0; c < a; c++) d(c);
        return l;
      }(r);
    });
  }
  return e.registerId = function(t) {
    return hr(t);
  }, e.prototype.rehydrate = function() {
    !this.server && Mr && Ua(this);
  }, e.prototype.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(jt(jt({}, this.options), t), this.gs, n && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(n) {
      var i = n.useCSSOMInjection, r = n.target;
      return n.isServer ? new Fv(r) : i ? new Vv(r) : new $v(r);
    }(this.options), new Av(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.prototype.registerName = function(t, n) {
    if (hr(t), this.names.has(t)) this.names.get(t).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(t, i);
    }
  }, e.prototype.insertRules = function(t, n, i) {
    this.registerName(t, n), this.getTag().insertRules(hr(t), i);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(hr(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), Uv = /&/g, zv = /^\s*\/\/.*$/gm;
function kc(e, t) {
  return e.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(t, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(t, " ")), n.props = n.props.map(function(i) {
      return "".concat(t, " ").concat(i);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = kc(n.children, t)), n;
  });
}
function Wv(e) {
  var t, n, i, r = di, s = r.options, o = s === void 0 ? di : s, a = r.plugins, l = a === void 0 ? es : a, d = function(h, p, y) {
    return y.startsWith(n) && y.endsWith(n) && y.replaceAll(n, "").length > 0 ? ".".concat(t) : h;
  }, c = l.slice();
  c.push(function(h) {
    h.type === qr && h.value.includes("&") && (h.props[0] = h.props[0].replace(Uv, n).replace(i, d));
  }), o.prefix && c.push(fv), c.push(uv);
  var f = function(h, p, y, v) {
    p === void 0 && (p = ""), y === void 0 && (y = ""), v === void 0 && (v = "&"), t = v, n = p, i = new RegExp("\\".concat(n, "\\b"), "g");
    var w = h.replace(zv, ""), x = av(y || p ? "".concat(y, " ").concat(p, " { ").concat(w, " }") : w);
    o.namespace && (x = kc(x, o.namespace));
    var S = [];
    return Ar(x, cv(c.concat(dv(function(k) {
      return S.push(k);
    })))), S;
  };
  return f.hash = l.length ? l.reduce(function(h, p) {
    return p.name || ji(15), Vn(h, p.name);
  }, gc).toString() : "", f;
}
var Hv = new Cc(), Bs = Wv(), Ec = we.createContext({ shouldForwardProp: void 0, styleSheet: Hv, stylis: Bs });
Ec.Consumer;
we.createContext(void 0);
function Wa() {
  return ut(Ec);
}
var Us = function() {
  function e(t, n) {
    var i = this;
    this.inject = function(r, s) {
      s === void 0 && (s = Bs);
      var o = i.name + s.hash;
      r.hasNameForId(i.id, o) || r.insertRules(i.id, o, s(i.rules, o, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = n, Ko(this, function() {
      throw ji(12, String(i.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Bs), this.name + t.hash;
  }, e;
}(), Kv = function(e) {
  return e >= "A" && e <= "Z";
};
function Ha(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var i = e[n];
    if (n === 1 && i === "-" && e[0] === "-") return e;
    Kv(i) ? t += "-" + i.toLowerCase() : t += i;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var _c = function(e) {
  return e == null || e === !1 || e === "";
}, Nc = function(e) {
  var t, n, i = [];
  for (var r in e) {
    var s = e[r];
    e.hasOwnProperty(r) && !_c(s) && (Array.isArray(s) && s.isCss || fi(s) ? i.push("".concat(Ha(r), ":"), s, ";") : hi(s) ? i.push.apply(i, Kn(Kn(["".concat(r, " {")], Nc(s), !1), ["}"], !1)) : i.push("".concat(Ha(r), ": ").concat((t = r, (n = s) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in hv || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return i;
};
function zn(e, t, n, i) {
  if (_c(e)) return [];
  if (Ho(e)) return [".".concat(e.styledComponentId)];
  if (fi(e)) {
    if (!fi(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [e];
    var r = e(t);
    return process.env.NODE_ENV === "production" || typeof r != "object" || Array.isArray(r) || r instanceof Us || hi(r) || r === null || console.error("".concat(xc(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), zn(r, t, n, i);
  }
  var s;
  return e instanceof Us ? n ? (e.inject(n, i), [e.getName(i)]) : [e] : hi(e) ? Nc(e) : Array.isArray(e) ? Array.prototype.concat.apply(es, e.map(function(o) {
    return zn(o, t, n, i);
  })) : [e.toString()];
}
function Yv(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (fi(n) && !Ho(n)) return !1;
  }
  return !0;
}
var Gv = yc(Qr), qv = function() {
  function e(t, n, i) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (i === void 0 || i.isStatic) && Yv(t), this.componentId = n, this.baseHash = Vn(Gv, n), this.baseStyle = i, Cc.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, i) {
    var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, n, i) : "";
    if (this.isStatic && !i.hash) if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId)) r = $n(r, this.staticRulesId);
    else {
      var s = $s(zn(this.rules, t, n, i)), o = Vs(Vn(this.baseHash, s) >>> 0);
      if (!n.hasNameForId(this.componentId, o)) {
        var a = i(s, ".".concat(o), void 0, this.componentId);
        n.insertRules(this.componentId, o, a);
      }
      r = $n(r, o), this.staticRulesId = o;
    }
    else {
      for (var l = Vn(this.baseHash, i.hash), d = "", c = 0; c < this.rules.length; c++) {
        var f = this.rules[c];
        if (typeof f == "string") d += f, process.env.NODE_ENV !== "production" && (l = Vn(l, f));
        else if (f) {
          var h = $s(zn(f, t, n, i));
          l = Vn(l, h + c), d += h;
        }
      }
      if (d) {
        var p = Vs(l >>> 0);
        n.hasNameForId(this.componentId, p) || n.insertRules(this.componentId, p, i(d, ".".concat(p), void 0, this.componentId)), r = $n(r, p);
      }
    }
    return r;
  }, e;
}(), Ac = we.createContext(void 0);
Ac.Consumer;
var ds = {}, Ka = /* @__PURE__ */ new Set();
function Xv(e, t, n) {
  var i = Ho(e), r = e, s = !cs(e), o = t.attrs, a = o === void 0 ? es : o, l = t.componentId, d = l === void 0 ? function(P, j) {
    var N = typeof P != "string" ? "sc" : La(P);
    ds[N] = (ds[N] || 0) + 1;
    var C = "".concat(N, "-").concat(vc(Qr + N + ds[N]));
    return j ? "".concat(j, "-").concat(C) : C;
  }(t.displayName, t.parentComponentId) : l, c = t.displayName, f = c === void 0 ? function(P) {
    return cs(P) ? "styled.".concat(P) : "Styled(".concat(xc(P), ")");
  }(e) : c, h = t.displayName && t.componentId ? "".concat(La(t.displayName), "-").concat(t.componentId) : t.componentId || d, p = i && r.attrs ? r.attrs.concat(a).filter(Boolean) : a, y = t.shouldForwardProp;
  if (i && r.shouldForwardProp) {
    var v = r.shouldForwardProp;
    if (t.shouldForwardProp) {
      var w = t.shouldForwardProp;
      y = function(P, j) {
        return v(P, j) && w(P, j);
      };
    } else y = v;
  }
  var x = new qv(n, h, i ? r.componentStyle : void 0);
  function S(P, j) {
    return function(N, C, R) {
      var I = N.attrs, U = N.componentStyle, W = N.defaultProps, ae = N.foldedComponentIds, $ = N.styledComponentId, V = N.target, K = we.useContext(Ac), se = Wa(), G = N.shouldForwardProp || se.shouldForwardProp;
      process.env.NODE_ENV !== "production" && Sa($);
      var te = gv(C, K, W) || di, le = function(ie, ye, Me) {
        for (var Pe, Ee = jt(jt({}, ye), { className: void 0, theme: Me }), _e = 0; _e < ie.length; _e += 1) {
          var Ye = fi(Pe = ie[_e]) ? Pe(Ee) : Pe;
          for (var Re in Ye) Ee[Re] = Re === "className" ? $n(Ee[Re], Ye[Re]) : Re === "style" ? jt(jt({}, Ee[Re]), Ye[Re]) : Ye[Re];
        }
        return ye.className && (Ee.className = $n(Ee.className, ye.className)), Ee;
      }(I, C, te), Ce = le.as || V, ce = {};
      for (var q in le) le[q] === void 0 || q[0] === "$" || q === "as" || q === "theme" && le.theme === te || (q === "forwardedAs" ? ce.as = le.forwardedAs : G && !G(q, Ce) || (ce[q] = le[q], G || process.env.NODE_ENV !== "development" || Gy(q) || Ka.has(q) || !Ls.has(Ce) || (Ka.add(q), console.warn('styled-components: it looks like an unknown prop "'.concat(q, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var ne = function(ie, ye) {
        var Me = Wa(), Pe = ie.generateAndInjectStyles(ye, Me.styleSheet, Me.stylis);
        return process.env.NODE_ENV !== "production" && Sa(Pe), Pe;
      }(U, le);
      process.env.NODE_ENV !== "production" && N.warnTooManyClasses && N.warnTooManyClasses(ne);
      var oe = $n(ae, $);
      return ne && (oe += " " + ne), le.className && (oe += " " + le.className), ce[cs(Ce) && !Ls.has(Ce) ? "class" : "className"] = oe, R && (ce.ref = R), _n(Ce, ce);
    }(k, P, j);
  }
  S.displayName = f;
  var k = we.forwardRef(S);
  return k.attrs = p, k.componentStyle = x, k.displayName = f, k.shouldForwardProp = y, k.foldedComponentIds = i ? $n(r.foldedComponentIds, r.styledComponentId) : "", k.styledComponentId = h, k.target = i ? r.target : e, Object.defineProperty(k, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(P) {
    this._foldedDefaultProps = i ? function(j) {
      for (var N = [], C = 1; C < arguments.length; C++) N[C - 1] = arguments[C];
      for (var R = 0, I = N; R < I.length; R++) Fs(j, I[R], !0);
      return j;
    }({}, r.defaultProps, P) : P;
  } }), process.env.NODE_ENV !== "production" && (mv(f, h), k.warnTooManyClasses = /* @__PURE__ */ function(P, j) {
    var N = {}, C = !1;
    return function(R) {
      if (!C && (N[R] = !0, Object.keys(N).length >= 200)) {
        var I = j ? ' with the id of "'.concat(j, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(P).concat(I, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), C = !0, N = {};
      }
    };
  }(f, h)), Ko(k, function() {
    return ".".concat(k.styledComponentId);
  }), s && jc(k, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), k;
}
function Ya(e, t) {
  for (var n = [e[0]], i = 0, r = t.length; i < r; i += 1) n.push(t[i], e[i + 1]);
  return n;
}
var Ga = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function Mc(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  if (fi(e) || hi(e)) return Ga(zn(Ya(es, Kn([e], t, !0))));
  var i = e;
  return t.length === 0 && i.length === 1 && typeof i[0] == "string" ? zn(i) : Ga(zn(Ya(i, t)));
}
function zs(e, t, n) {
  if (n === void 0 && (n = di), !t) throw ji(1, t);
  var i = function(r) {
    for (var s = [], o = 1; o < arguments.length; o++) s[o - 1] = arguments[o];
    return e(t, n, Mc.apply(void 0, Kn([r], s, !1)));
  };
  return i.attrs = function(r) {
    return zs(e, t, jt(jt({}, n), { attrs: Array.prototype.concat(n.attrs, r).filter(Boolean) }));
  }, i.withConfig = function(r) {
    return zs(e, t, jt(jt({}, n), r));
  }, i;
}
var Pc = function(e) {
  return zs(Xv, e);
}, Xn = Pc;
Ls.forEach(function(e) {
  Xn[e] = Pc(e);
});
function Yo(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var i = $s(Mc.apply(void 0, Kn([e], t, !1))), r = vc(i);
  return new Us(r, i);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var pr = "__sc-".concat(Yn, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[pr] || (window[pr] = 0), window[pr] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[pr] += 1);
var Zv = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
Jv(Zv);
function Jv(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
var Ws = "#4fa94d", Rc = { "aria-busy": !0, role: "progressbar" }, Dc = Xn.div`
  display: ${(e) => e.$visible ? "flex" : "none"};
`, Qv = "http://www.w3.org/2000/svg", Xt = 242.776657104492, ex = 1.6, tx = Yo`
12.5% {
  stroke-dasharray: ${Xt * 0.14}px, ${Xt}px;
  stroke-dashoffset: -${Xt * 0.11}px;
}
43.75% {
  stroke-dasharray: ${Xt * 0.35}px, ${Xt}px;
  stroke-dashoffset: -${Xt * 0.35}px;
}
100% {
  stroke-dasharray: ${Xt * 0.01}px, ${Xt}px;
  stroke-dashoffset: -${Xt * 0.99}px;
}
`;
Xn.path`
  stroke-dasharray: ${Xt * 0.01}px, ${Xt};
  stroke-dashoffset: 0;
  animation: ${tx} ${ex}s linear infinite;
`;
var fs = 20, nx = (e) => ["M" + e + " 0c0-9.94-8.06", e, e, e].join("-"), ix = (e, t, n) => {
  let i = Math.max(e, t), r = -20 - i / 2 + 1, s = n * 2 + i;
  return [r, r, s, s].join(" ");
}, Ic = ({ height: e = 80, width: t = 80, color: n = Ws, secondaryColor: i = Ws, ariaLabel: r = "oval-loading", wrapperStyle: s, wrapperClass: o, visible: a = !0, strokeWidth: l = 2, strokeWidthSecondary: d, animationDuration: c = 1 }) => we.createElement(Dc, { style: s, $visible: a, className: o, "data-testid": "oval-loading", "aria-label": r, ...Rc }, we.createElement("svg", { width: t, height: e, viewBox: ix(Number(l), Number(d || l), fs), xmlns: "http://www.w3.org/2000/svg", stroke: n, "data-testid": "oval-svg" }, we.createElement("g", { fill: "none", fillRule: "evenodd" }, we.createElement("g", { transform: "translate(1 1)", strokeWidth: Number(d || l), "data-testid": "oval-secondary-group" }, we.createElement("circle", { strokeOpacity: ".5", cx: "0", cy: "0", r: fs, stroke: i, strokeWidth: l }), we.createElement("path", { d: nx(fs) }, we.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 0 0", to: "360 0 0", dur: `${c}s`, repeatCount: "indefinite" })))))), rx = Yo`
to {
   transform: rotate(360deg);
 }
`;
Xn.svg`
  animation: ${rx} ${(e) => String(e.$animationDuration).endsWith("s") ? String(e.$animationDuration) : `${e.$animationDuration}s`} steps(12, end) infinite;
`;
Xn.polyline`
  stroke-width: ${(e) => `${e.$strokeWidth}px`};
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
var sx = ({ height: e = 80, width: t = 80, radius: n = 9, color: i = Ws, ariaLabel: r = "three-dots-loading", wrapperStyle: s, wrapperClass: o, visible: a = !0 }) => we.createElement(Dc, { style: s, $visible: a, className: o, "data-testid": "three-dots-loading", "aria-label": r, ...Rc }, we.createElement("svg", { width: t, height: e, viewBox: "0 0 120 30", xmlns: Qv, fill: i, "data-testid": "three-dots-svg" }, we.createElement("circle", { cx: "15", cy: "15", r: Number(n) + 6 }, we.createElement("animate", { attributeName: "r", from: "15", to: "15", begin: "0s", dur: "0.8s", values: "15;9;15", calcMode: "linear", repeatCount: "indefinite" }), we.createElement("animate", { attributeName: "fill-opacity", from: "1", to: "1", begin: "0s", dur: "0.8s", values: "1;.5;1", calcMode: "linear", repeatCount: "indefinite" })), we.createElement("circle", { cx: "60", cy: "15", r: n, attributeName: "fill-opacity", from: "1", to: "0.3" }, we.createElement("animate", { attributeName: "r", from: "9", to: "9", begin: "0s", dur: "0.8s", values: "9;15;9", calcMode: "linear", repeatCount: "indefinite" }), we.createElement("animate", { attributeName: "fill-opacity", from: "0.5", to: "0.5", begin: "0s", dur: "0.8s", values: ".5;1;.5", calcMode: "linear", repeatCount: "indefinite" })), we.createElement("circle", { cx: "105", cy: "15", r: Number(n) + 6 }, we.createElement("animate", { attributeName: "r", from: "15", to: "15", begin: "0s", dur: "0.8s", values: "15;9;15", calcMode: "linear", repeatCount: "indefinite" }), we.createElement("animate", { attributeName: "fill-opacity", from: "1", to: "1", begin: "0s", dur: "0.8s", values: "1;.5;1", calcMode: "linear", repeatCount: "indefinite" })))), ox = Yo`
to {
   stroke-dashoffset: 136;
 }
`;
Xn.polygon`
  stroke-dasharray: 17;
  animation: ${ox} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
Xn.svg`
  transform-origin: 50% 65%;
`;
const Sn = nt(function({
  height: t = 32,
  width: n = 32,
  color: i = "#ffffff",
  wrapperClassName: r = "",
  className: s,
  ...o
}) {
  return /* @__PURE__ */ u.jsx(ge, { "data-testid": "oval-loader", className: fe(r, s), ...o, children: /* @__PURE__ */ u.jsx(
    Ic,
    {
      height: t,
      width: n,
      color: i,
      secondaryColor: "#a0a0a0",
      strokeWidth: 4,
      strokeWidthSecondary: 4,
      ariaLabel: "oval-loading",
      visible: !0
    }
  ) });
}), ax = [
  "variants",
  "initial",
  "animate",
  "exit",
  "whileHover",
  "whileTap",
  "whileFocus",
  "whileInView",
  "whileDrag",
  "transition",
  "layout",
  "layoutId",
  "drag",
  "dragConstraints",
  "dragDirectionLock",
  "dragElastic",
  "dragMomentum",
  "onDrag",
  "onDragStart",
  "onDragEnd",
  "onAnimationStart",
  "onAnimationComplete"
], lx = new Set(ax);
function ux(e) {
  const t = {}, n = {};
  for (const i of Object.keys(e))
    lx.has(i) ? t[i] = e[i] : n[i] = e[i];
  return { motion: t, dom: n };
}
function cx(e) {
  return Object.keys(e).length > 0;
}
const dx = Zi(function(t, n) {
  const {
    as: i = "div",
    loading: r = !1,
    skeleton: s,
    loaderClassName: o,
    children: a,
    ...l
  } = t, { motion: d, dom: c } = ux(l), f = cx(d), h = r ? s ?? /* @__PURE__ */ u.jsx(Sn, { wrapperClassName: o ?? "" }) : a, p = i;
  if (f) {
    const y = Hy[p];
    return y ? _n(y, { ...c, ...d, ref: n }, h) : _n(p, { ...c, ref: n }, h);
  }
  return _n(p, { ...c, ref: n }, h);
}), ge = nt(dx), fx = ({
  type: e,
  message: t,
  messages: n = [],
  isPreview: i = !1,
  color: r = "accent",
  onCloseFunc: s,
  onClickFunc: o,
  senderName: a = "",
  attachmentSlot: l,
  className: d,
  ...c
}) => {
  const h = t ?? (Array.isArray(n) && n[0]) ?? {}, { attachments: p, body: y, error: v } = h;
  if (v) return null;
  const w = e === "reply", x = e === "edit", S = r === "accent", k = x ? "Edit message" : (i && w ? "Reply to " : "") + a, P = w || Array.isArray(n) && n.length < 2 ? y : Array.isArray(n) ? n.length + " forwarded messages" : "";
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(
        "ui:flex ui:shrink ui:items-center ui:lg:max-w-272",
        i ? "ui:w-[calc(100%-7rem)] ui:gap-2.75 ui:self-center ui:rounded-xl ui:bg-white ui:p-2 ui:px-2 ui:py-1 ui:shadow-btn" : `ui:-mb-3 ui:flex ui:min-h-15.5 ui:flex-row ui:flex-nowrap ui:items-center ui:gap-1.75 ui:rounded-t-xl ui:pt-0.5 ui:pr-3 ui:pb-3 ui:pl-1 ${S ? "ui:bg-bg-dark/5" : "ui:bg-accent-500/65"} ${o ? "ui:cursor-pointer" : ""}`,
        d
      ),
      onClick: o,
      ...c,
      children: [
        i ? /* @__PURE__ */ u.jsx("span", { children: x ? /* @__PURE__ */ u.jsx(Hh, { size: 28, color: "var(--color-text-dark)" }) : w ? /* @__PURE__ */ u.jsx(Bi, { size: 28, color: S ? "var(--color-text-dark)" : "white" }) : /* @__PURE__ */ u.jsx(jo, { size: 28, color: "var(--color-text-dark)" }) }) : w ? /* @__PURE__ */ u.jsx(Bi, { size: 19, color: S ? "var(--color-text-dark)" : "white", className: "ui:min-w-4.75" }) : null,
        p != null && p.length && l ? /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-10 ui:w-10 ui:min-w-10 ui:overflow-hidden ui:rounded-lg ui:object-cover", children: l }) : null,
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-[calc(100%-5rem)] ui:max-w-full ui:grow ui:flex-col", children: [
          /* @__PURE__ */ u.jsx(
            "p",
            {
              className: `ui:w-full ui:overflow-hidden ui:font-medium ui:text-ellipsis ui:whitespace-nowrap ${S ? "ui:text-accent-500" : "ui:text-white"}`,
              children: k
            }
          ),
          /* @__PURE__ */ u.jsx(
            "p",
            {
              className: `ui:w-full ui:overflow-hidden ui:font-light ui:text-ellipsis ui:whitespace-nowrap ${S ? "" : "ui:text-white"}`,
              children: P
            }
          )
        ] }),
        s && /* @__PURE__ */ u.jsx(
          "span",
          {
            onClick: (j) => {
              j.stopPropagation(), s();
            },
            className: "ui:cursor-pointer",
            children: /* @__PURE__ */ u.jsx(Dn, { size: 28, color: "var(--color-text-dark)" })
          }
        )
      ]
    }
  );
};
var hx = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], Pi = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let i = e[n], r = hx.indexOf(i);
    t = t * 83 + r;
  }
  return t;
}, hs = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, ps = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, px = (e) => e < 0 ? -1 : 1, ms = (e, t) => px(e) * Math.pow(Math.abs(e), t), qa = class extends Error {
  constructor(e) {
    super(e), this.name = "ValidationError", this.message = e;
  }
}, mx = (e) => {
  if (!e || e.length < 6) throw new qa("The blurhash string must be at least 6 characters");
  let t = Pi(e[0]), n = Math.floor(t / 9) + 1, i = t % 9 + 1;
  if (e.length !== 4 + 2 * i * n) throw new qa(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * i * n}`);
}, gx = (e) => {
  let t = e >> 16, n = e >> 8 & 255, i = e & 255;
  return [hs(t), hs(n), hs(i)];
}, yx = (e, t) => {
  let n = Math.floor(e / 361), i = Math.floor(e / 19) % 19, r = e % 19;
  return [ms((n - 9) / 9, 2) * t, ms((i - 9) / 9, 2) * t, ms((r - 9) / 9, 2) * t];
}, vx = (e, t, n, i) => {
  mx(e), i = i | 1;
  let r = Pi(e[0]), s = Math.floor(r / 9) + 1, o = r % 9 + 1, a = (Pi(e[1]) + 1) / 166, l = new Array(o * s);
  for (let f = 0; f < l.length; f++) if (f === 0) {
    let h = Pi(e.substring(2, 6));
    l[f] = gx(h);
  } else {
    let h = Pi(e.substring(4 + f * 2, 6 + f * 2));
    l[f] = yx(h, a * i);
  }
  let d = t * 4, c = new Uint8ClampedArray(d * n);
  for (let f = 0; f < n; f++) for (let h = 0; h < t; h++) {
    let p = 0, y = 0, v = 0;
    for (let k = 0; k < s; k++) for (let P = 0; P < o; P++) {
      let j = Math.cos(Math.PI * h * P / t) * Math.cos(Math.PI * f * k / n), N = l[P + k * o];
      p += N[0] * j, y += N[1] * j, v += N[2] * j;
    }
    let w = ps(p), x = ps(y), S = ps(v);
    c[4 * h + 0 + f * d] = w, c[4 * h + 1 + f * d] = x, c[4 * h + 2 + f * d] = S, c[4 * h + 3 + f * d] = 255;
  }
  return c;
}, xx = vx, bx = Object.defineProperty, wx = Object.defineProperties, Sx = Object.getOwnPropertyDescriptors, Rr = Object.getOwnPropertySymbols, Oc = Object.prototype.hasOwnProperty, Lc = Object.prototype.propertyIsEnumerable, Xa = (e, t, n) => t in e ? bx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Hs = (e, t) => {
  for (var n in t || (t = {})) Oc.call(t, n) && Xa(e, n, t[n]);
  if (Rr) for (var n of Rr(t)) Lc.call(t, n) && Xa(e, n, t[n]);
  return e;
}, Ks = (e, t) => wx(e, Sx(t)), Vc = (e, t) => {
  var n = {};
  for (var i in e) Oc.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && Rr) for (var i of Rr(e)) t.indexOf(i) < 0 && Lc.call(e, i) && (n[i] = e[i]);
  return n;
}, $c = class extends En.PureComponent {
  constructor() {
    super(...arguments), this.canvas = null, this.handleRef = (e) => {
      this.canvas = e, this.draw();
    }, this.draw = () => {
      let { hash: e, height: t, punch: n, width: i } = this.props;
      if (this.canvas) {
        let r = xx(e, i, t, n), s = this.canvas.getContext("2d"), o = s.createImageData(i, t);
        o.data.set(r), s.putImageData(o, 0, 0);
      }
    };
  }
  componentDidUpdate() {
    this.draw();
  }
  render() {
    let e = this.props, { hash: t, height: n, width: i } = e, r = Vc(e, ["hash", "height", "width"]);
    return En.createElement("canvas", Ks(Hs({}, r), { height: n, width: i, ref: this.handleRef }));
  }
};
$c.defaultProps = { height: 128, width: 128 };
var jx = { position: "absolute", top: 0, bottom: 0, left: 0, right: 0, width: "100%", height: "100%" }, Qi = class extends En.PureComponent {
  componentDidUpdate() {
    if (this.props.resolutionX <= 0) throw new Error("resolutionX must be larger than zero");
    if (this.props.resolutionY <= 0) throw new Error("resolutionY must be larger than zero");
  }
  render() {
    let e = this.props, { hash: t, height: n, width: i, punch: r, resolutionX: s, resolutionY: o, style: a } = e, l = Vc(e, ["hash", "height", "width", "punch", "resolutionX", "resolutionY", "style"]);
    return En.createElement("div", Ks(Hs({}, l), { style: Ks(Hs({ display: "inline-block", height: n, width: i }, a), { position: "relative" }) }), En.createElement($c, { hash: t, height: o, width: s, punch: r, style: jx }));
  }
};
Qi.defaultProps = { height: 128, width: 128, resolutionX: 32, resolutionY: 32 };
const en = {
  ESCAPE: 27,
  ENTER: 13,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37
}, Go = [".heic", ".HEIC", "image/jpeg", "image/png"], Za = {
  MESSAGES: "messages",
  APPS: "apps"
}, Tx = 6e3, Cx = 46, kx = { height: [0, 35], opacity: [0, 1] }, Jn = {
  searchedUsers: [],
  searchedChats: [],
  defaultChats: [],
  isUserSearched: null,
  isChatSearched: null,
  isPending: !1
}, Ex = 30, _x = 300, Nx = 800, Ax = 150, Ja = 255, Mx = "U27nLE$*00_N^k,@s9xu#7$2$%xtVD-B-pkW", Px = {
  MOBILE: 767,
  TABLET: 1279,
  LAPTOP: 1536
}, Rx = "0px", Dx = "60dvh", Ix = "up", Qa = 250, Ox = 160, Fc = ({
  status: e = "loading",
  blurHash: t,
  loaderColor: n = "#1a8ee1",
  loaderSecondaryColor: i = "#8dc7f0",
  loaderSize: r = 50
}) => /* @__PURE__ */ u.jsxs("div", { "data-testid": "media-blurhash", className: "ui:h-75 ui:w-87.5 ui:object-cover", children: [
  /* @__PURE__ */ u.jsx(
    Qi,
    {
      className: "ui:static! ui:h-75! ui:w-87.5! ui:flex-1 ui:object-cover",
      hash: t || Mx,
      resolutionX: 32,
      resolutionY: 32
    }
  ),
  /* @__PURE__ */ u.jsx("div", { className: "ui:absolute ui:inset-0 ui:flex ui:h-full ui:w-full ui:items-center ui:justify-center", children: e === "error" ? /* @__PURE__ */ u.jsx(Qf, { className: "ui:h-12.5 ui:w-12.5", color: "#f87171" }) : /* @__PURE__ */ u.jsx(
    Ic,
    {
      height: r,
      width: r,
      color: n,
      visible: !0,
      ariaLabel: "oval-loading",
      secondaryColor: i,
      strokeWidth: 2,
      strokeWidthSecondary: 3
    }
  ) })
] }), Ys = ({ image: e, onClick: t, isFullSize: n = !0, mediaBlurHashProps: i = {} }) => {
  const [r, s] = de("loading"), { file_name: o, file_url: a, file_blur_hash: l } = e || {}, d = ze(() => r === "success" ? null : /* @__PURE__ */ u.jsx(Fc, { status: r, blurHash: l, ...i }), [r, l, i]);
  return he(() => {
    if (!a) return;
    const c = new Image();
    return c.onload = () => s("success"), c.onerror = () => s("error"), c.src = a, () => {
      c.onload = null, c.onerror = null;
    };
  }, [a]), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      "img",
      {
        className: `ui:object-cover ${n ? "ui:h-full ui:w-full" : "ui:max-h-full ui:max-w-full"}`,
        onLoad: () => s("success"),
        onError: () => s("error"),
        onClick: r !== "error" ? t : void 0,
        alt: o,
        src: a
      }
    ),
    d
  ] });
}, Lx = ({ onClick: e }) => /* @__PURE__ */ u.jsx(
  "span",
  {
    "data-testid": "play-button",
    className: "ui:absolute ui:top-1/2 ui:left-1/2 ui:flex ui:h-11.25 ui:w-11.25 ui:-translate-x-1/2 ui:-translate-y-1/2 ui:transform ui:cursor-pointer ui:items-center ui:justify-center ui:rounded-full ui:bg-bg-light/50 ui:text-gray-700",
    onClick: e,
    children: "▶"
  }
), Gs = ({
  video: e,
  onClick: t,
  isFullSize: n = !0,
  removePlayButton: i = !1,
  enableControls: r = !1,
  mediaBlurHashProps: s = {}
}) => {
  const [o, a] = de("loading"), { file_name: l, file_url: d, file_blur_hash: c } = e || {}, f = pe(null), h = ze(() => o === "success" ? r || i ? null : /* @__PURE__ */ u.jsx(Lx, { onClick: t }) : /* @__PURE__ */ u.jsx(Fc, { status: o, blurHash: c, ...s }), [o, c, r, i, t, s]);
  return he(() => {
    const p = f.current;
    if (!p) return;
    const y = () => a("success"), v = () => a("error");
    return p.addEventListener("loadeddata", y), p.addEventListener("error", v), () => {
      p.removeEventListener("loadeddata", y), p.removeEventListener("error", v);
    };
  }, [d]), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      "video",
      {
        ref: f,
        "data-testid": "video",
        className: `ui:object-cover ${n ? "ui:h-full ui:w-full" : "ui:max-h-full ui:max-w-full"} `,
        controls: r,
        autoPlay: r,
        src: d ? `${d}#t=0.1` : void 0,
        poster: l,
        onClick: t
      }
    ),
    h
  ] });
};
function Vx(e) {
  const t = e.length;
  return t <= 2 ? [e] : t <= 5 ? [e.slice(0, Math.ceil(t / 2)), e.slice(Math.ceil(t / 2))] : t <= 9 ? [e.slice(0, 3), e.slice(3, 6), e.slice(6)] : [e.slice(0, 3), e.slice(3, 6), e.slice(6, 9), e.slice(9)];
}
function el(e) {
  return Math.min(1.75, Math.max(0.25, e)) || 1;
}
const $x = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/bmp", "image/heic"], Fx = ["video/mp4", "video/webm", "video/quicktime"], Bx = ["jpeg", "jpg", "gif", "bmp", "png", "heic", "HEIC"], Ux = ["mp4", "webm", "mov"];
function Bc(e, t) {
  if (t) {
    if ($x.includes(t)) return "Image";
    if (Fx.includes(t)) return "Video";
  }
  const n = e == null ? void 0 : e.split(".").slice(-1)[0];
  return n && Bx.includes(n) ? "Image" : n && Ux.includes(n) ? "Video" : null;
}
const zx = "ui:relative ui:flex ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-sm", Wx = nt(function({
  index: t,
  attachment: n,
  flexGrow: i,
  onClick: r,
  onContextMenu: s,
  removeFileFunc: o,
  disableAnimation: a = !1,
  className: l,
  style: d,
  ...c
}) {
  const { file_name: f, file_url: h, file_content_type: p } = n, y = Bc(f || h, p) === "Video", v = ze(
    () => a ? void 0 : {
      hidden: { scale: 0.97 },
      visible: {
        scale: 1,
        transition: { duration: 0.3, delay: t * 0.05 + 0.15 }
      }
    },
    [a, t]
  );
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      variants: v,
      initial: v ? "hidden" : void 0,
      animate: v ? "visible" : void 0,
      className: fe(zx, l),
      style: { flexGrow: i, flexBasis: 0, ...d },
      onContextMenu: s,
      ...c,
      children: [
        y ? /* @__PURE__ */ u.jsx(Gs, { video: n, onClick: r }) : /* @__PURE__ */ u.jsx(Ys, { image: n, onClick: r }),
        o && /* @__PURE__ */ u.jsx(
          "button",
          {
            type: "button",
            className: "ui:absolute ui:top-0.75 ui:right-0.75 ui:cursor-pointer ui:rounded-sm ui:border-0 ui:bg-bg-dark/50 ui:p-0.75",
            onClick: () => o(t),
            "aria-label": "Remove",
            children: /* @__PURE__ */ u.jsx(Yh, { size: 14, className: "ui:text-white" })
          }
        )
      ]
    }
  );
}), Hx = ({
  attachments: e,
  mid: t,
  maxWidth: n = null,
  maxHeight: i = null,
  removeFileFunc: r,
  disableAnimation: s = !1,
  onContextMenu: o,
  onOpenMedia: a,
  className: l,
  style: d,
  ...c
}) => {
  if (!(e != null && e.length)) return null;
  const f = Vx(e), h = n != null ? typeof n == "number" ? `${n}px` : n : "520px", p = i != null ? typeof i == "number" ? `${i}px` : i : "660px";
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(
        "ui:flex ui:min-h-[350px] ui:min-w-0 ui:w-full ui:flex-col ui:gap-0.75 ui:overflow-hidden ui:rounded-lg",
        l
      ),
      style: {
        maxWidth: h,
        maxHeight: p,
        ...d
      },
      ...c,
      children: f.map((y, v) => {
        const w = y.reduce(
          (x, S) => x + el((S.file_width ?? 1) / (S.file_height ?? 1)),
          0
        );
        return /* @__PURE__ */ u.jsx(
          "div",
          {
            className: `ui:flex ui:flex-1 ui:flex-row ui:gap-0.75 ui:overflow-hidden ${t ? "ui:cursor-pointer" : ""}`,
            children: y.map((x, S) => {
              const P = el((x.file_width ?? 1) / (x.file_height ?? 1)) / w;
              return /* @__PURE__ */ u.jsx(
                Wx,
                {
                  index: e.indexOf(x),
                  attachment: x,
                  flexGrow: P,
                  onClick: a ? () => a(e.indexOf(x)) : void 0,
                  removeFileFunc: r,
                  disableAnimation: s,
                  onContextMenu: o ? (j) => o(j, x) : void 0
                },
                S
              );
            })
          },
          v
        );
      })
    }
  );
};
class Kx extends En.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const i = n.offsetParent, r = i instanceof HTMLElement && i.offsetWidth || 0, s = this.props.sizeRef.current;
      s.height = n.offsetHeight || 0, s.width = n.offsetWidth || 0, s.top = n.offsetTop, s.left = n.offsetLeft, s.right = r - s.width - s.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Yx({ children: e, isPresent: t, anchorX: n }) {
  const i = Ur(), r = pe(null), s = pe({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: o } = ut(Eo);
  return Du(() => {
    const { width: a, height: l, top: d, left: c, right: f } = s.current;
    if (t || !r.current || !a || !l)
      return;
    const h = n === "left" ? `left: ${c}` : `right: ${f}`;
    r.current.dataset.motionPopId = i;
    const p = document.createElement("style");
    return o && (p.nonce = o), document.head.appendChild(p), p.sheet && p.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${l}px !important;
            ${h}px !important;
            top: ${d}px !important;
          }
        `), () => {
      document.head.removeChild(p);
    };
  }, [t]), u.jsx(Kx, { isPresent: t, childRef: r, sizeRef: s, children: En.cloneElement(e, { ref: r }) });
}
const Gx = ({ children: e, initial: t, isPresent: n, onExitComplete: i, custom: r, presenceAffectsLayout: s, mode: o, anchorX: a }) => {
  const l = Fo(qx), d = Ur();
  let c = !0, f = ze(() => (c = !1, {
    id: d,
    initial: t,
    isPresent: n,
    custom: r,
    onExitComplete: (h) => {
      l.set(h, !0);
      for (const p of l.values())
        if (!p)
          return;
      i && i();
    },
    register: (h) => (l.set(h, !1), () => l.delete(h))
  }), [n, l, i]);
  return s && c && (f = { ...f }), ze(() => {
    l.forEach((h, p) => l.set(p, !1));
  }, [n]), En.useEffect(() => {
    !n && !l.size && i && i();
  }, [n]), o === "popLayout" && (e = u.jsx(Yx, { isPresent: n, anchorX: a, children: e })), u.jsx(Gr.Provider, { value: f, children: e });
};
function qx() {
  return /* @__PURE__ */ new Map();
}
function Uc(e = !0) {
  const t = ut(Gr);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: i, register: r } = t, s = Ur();
  he(() => {
    if (e)
      return r(s);
  }, [e]);
  const o = Ne(() => e && i && i(s), [s, i, e]);
  return !n && i ? [!1, o] : [!0];
}
const mr = (e) => e.key || "";
function tl(e) {
  const t = [];
  return Mf.forEach(e, (n) => {
    Pf(n) && t.push(n);
  }), t;
}
const zc = ({ children: e, custom: t, initial: n = !0, onExitComplete: i, presenceAffectsLayout: r = !0, mode: s = "sync", propagate: o = !1, anchorX: a = "left" }) => {
  const [l, d] = Uc(o), c = ze(() => tl(e), [e]), f = o && !l ? [] : c.map(mr), h = pe(!0), p = pe(c), y = Fo(() => /* @__PURE__ */ new Map()), [v, w] = de(c), [x, S] = de(c);
  Ku(() => {
    h.current = !1, p.current = c;
    for (let j = 0; j < x.length; j++) {
      const N = mr(x[j]);
      f.includes(N) ? y.delete(N) : y.get(N) !== !0 && y.set(N, !1);
    }
  }, [x, f.length, f.join("-")]);
  const k = [];
  if (c !== v) {
    let j = [...c];
    for (let N = 0; N < x.length; N++) {
      const C = x[N], R = mr(C);
      f.includes(R) || (j.splice(N, 0, C), k.push(C));
    }
    return s === "wait" && k.length && (j = k), S(tl(j)), w(c), null;
  }
  process.env.NODE_ENV !== "production" && s === "wait" && x.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: P } = ut(ko);
  return u.jsx(u.Fragment, { children: x.map((j) => {
    const N = mr(j), C = o && !l ? !1 : c === x || f.includes(N), R = () => {
      if (y.has(N))
        y.set(N, !0);
      else
        return;
      let I = !0;
      y.forEach((U) => {
        U || (I = !1);
      }), I && (P == null || P(), S(p.current), o && (d == null || d()), i && i());
    };
    return u.jsx(Gx, { isPresent: C, initial: !h.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: r, mode: s, onExitComplete: C ? void 0 : R, anchorX: a, children: j }, N);
  }) });
}, Ft = /* @__NO_SIDE_EFFECTS__ */ (e) => e, { schedule: Xe, cancel: An, state: mt, steps: gs } = /* @__PURE__ */ Yu(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ft, !0), nl = /* @__PURE__ */ new Set();
function qo(e, t, n) {
  e || nl.has(t) || (console.warn(t), nl.add(t));
}
function Xx(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...i) => (process.env.NODE_ENV !== "production" && qo(!1, "motion() is deprecated. Use motion.create() instead."), e(...i));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, r) => r === "create" ? e : (t.has(r) || t.set(r, e(r)), t.get(r))
  });
}
function Hi(e, t, n) {
  const i = e.getProps();
  return $o(i, t, n !== void 0 ? n : i.custom, e);
}
const qs = (e) => Array.isArray(e);
let kr;
function Zx() {
  kr = void 0;
}
const Tt = {
  now: () => (kr === void 0 && Tt.set(mt.isProcessing || xn.useManualTiming ? mt.timestamp : performance.now()), kr),
  set: (e) => {
    kr = e, queueMicrotask(Zx);
  }
};
function Xo(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Zo(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class Jo {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Xo(this.subscriptions, t), () => Zo(this.subscriptions, t);
  }
  notify(t, n, i) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](t, n, i);
      else
        for (let s = 0; s < r; s++) {
          const o = this.subscriptions[s];
          o && o(t, n, i);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function Wc(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const il = 30, Jx = (e) => !isNaN(parseFloat(e));
class Qx {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.version = "__VERSION__", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (i, r = !0) => {
      var o, a;
      const s = Tt.now();
      this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(i), this.current !== this.prev && ((o = this.events.change) == null || o.notify(this.current)), r && ((a = this.events.renderRequest) == null || a.notify(this.current));
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Tt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Jx(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && qo(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Jo());
    const i = this.events[t].add(n);
    return t === "change" ? () => {
      i(), Xe.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : i;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, i) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - i;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Tt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > il)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, il);
    return Wc(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t;
    (t = this.events.destroy) == null || t.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ki(e, t) {
  return new Qx(e, t);
}
function e0(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ki(n));
}
function t0(e) {
  return qs(e) ? e[e.length - 1] || 0 : e;
}
function n0(e, t) {
  const n = Hi(e, t);
  let { transitionEnd: i = {}, transition: r = {}, ...s } = n || {};
  s = { ...s, ...i };
  for (const o in s) {
    const a = t0(s[o]);
    e0(e, o, a);
  }
}
function i0(e) {
  return !!(vt(e) && e.add);
}
function Xs(e, t) {
  const n = e.getValue("willChange");
  if (i0(n))
    return n.add(t);
  if (!n && xn.WillChange) {
    const i = new xn.WillChange("auto");
    e.addValue("willChange", i), i.add(t);
  }
}
function Hc(e) {
  return e.props[Wu];
}
const r0 = (e) => e !== null;
function s0(e, { repeat: t, repeatType: n = "loop" }, i) {
  const r = e.filter(r0), s = t && n !== "loop" && t % 2 === 1 ? 0 : r.length - 1;
  return r[s];
}
const o0 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, a0 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), l0 = {
  type: "keyframes",
  duration: 0.8
}, u0 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, c0 = (e, { keyframes: t }) => t.length > 2 ? l0 : bi.has(e) ? e.startsWith("scale") ? a0(t[1]) : o0 : u0;
function d0({ when: e, delay: t, delayChildren: n, staggerChildren: i, staggerDirection: r, repeat: s, repeatType: o, repeatDelay: a, from: l, elapsed: d, ...c }) {
  return !!Object.keys(c).length;
}
function Qo(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Qt = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, un = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, Li = (e) => Math.round(e * 1e5) / 1e5, ea = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function f0(e) {
  return e == null;
}
const h0 = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, ta = (e, t) => (n) => !!(typeof n == "string" && h0.test(n) && n.startsWith(e) || t && !f0(n) && Object.prototype.hasOwnProperty.call(n, t)), Kc = (e, t, n) => (i) => {
  if (typeof i != "string")
    return i;
  const [r, s, o, a] = i.match(ea);
  return {
    [e]: parseFloat(r),
    [t]: parseFloat(s),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, p0 = (e) => wn(0, 255, e), ys = {
  ...wi,
  transform: (e) => Math.round(p0(e))
}, Fn = {
  test: /* @__PURE__ */ ta("rgb", "red"),
  parse: /* @__PURE__ */ Kc("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: i = 1 }) => "rgba(" + ys.transform(e) + ", " + ys.transform(t) + ", " + ys.transform(n) + ", " + Li(Wi.transform(i)) + ")"
};
function m0(e) {
  let t = "", n = "", i = "", r = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), i = e.substring(5, 7), r = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), i = e.substring(3, 4), r = e.substring(4, 5), t += t, n += n, i += i, r += r), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(i, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const Zs = {
  test: /* @__PURE__ */ ta("#"),
  parse: m0,
  transform: Fn.transform
}, ti = {
  test: /* @__PURE__ */ ta("hsl", "hue"),
  parse: /* @__PURE__ */ Kc("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: i = 1 }) => "hsla(" + Math.round(e) + ", " + ln.transform(Li(t)) + ", " + ln.transform(Li(n)) + ", " + Li(Wi.transform(i)) + ")"
}, yt = {
  test: (e) => Fn.test(e) || Zs.test(e) || ti.test(e),
  parse: (e) => Fn.test(e) ? Fn.parse(e) : ti.test(e) ? ti.parse(e) : Zs.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Fn.transform(e) : ti.transform(e)
}, g0 = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function y0(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(ea)) == null ? void 0 : t.length) || 0) + (((n = e.match(g0)) == null ? void 0 : n.length) || 0) > 0;
}
const Yc = "number", Gc = "color", v0 = "var", x0 = "var(", rl = "${}", b0 = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Yi(e) {
  const t = e.toString(), n = [], i = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let s = 0;
  const a = t.replace(b0, (l) => (yt.test(l) ? (i.color.push(s), r.push(Gc), n.push(yt.parse(l))) : l.startsWith(x0) ? (i.var.push(s), r.push(v0), n.push(l)) : (i.number.push(s), r.push(Yc), n.push(parseFloat(l))), ++s, rl)).split(rl);
  return { values: n, split: a, indexes: i, types: r };
}
function qc(e) {
  return Yi(e).values;
}
function Xc(e) {
  const { split: t, types: n } = Yi(e), i = t.length;
  return (r) => {
    let s = "";
    for (let o = 0; o < i; o++)
      if (s += t[o], r[o] !== void 0) {
        const a = n[o];
        a === Yc ? s += Li(r[o]) : a === Gc ? s += yt.transform(r[o]) : s += r[o];
      }
    return s;
  };
}
const w0 = (e) => typeof e == "number" ? 0 : e;
function S0(e) {
  const t = qc(e);
  return Xc(e)(t.map(w0));
}
const Mn = {
  test: y0,
  parse: qc,
  createTransformer: Xc,
  getAnimatableNone: S0
};
function vs(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function j0({ hue: e, saturation: t, lightness: n, alpha: i }) {
  e /= 360, t /= 100, n /= 100;
  let r = 0, s = 0, o = 0;
  if (!t)
    r = s = o = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    r = vs(l, a, e + 1 / 3), s = vs(l, a, e), o = vs(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: i
  };
}
function Dr(e, t) {
  return (n) => n > 0 ? t : e;
}
const qe = (e, t, n) => e + (t - e) * n, xs = (e, t, n) => {
  const i = e * e, r = n * (t * t - i) + i;
  return r < 0 ? 0 : Math.sqrt(r);
}, T0 = [Zs, Fn, ti], C0 = (e) => T0.find((t) => t.test(e));
function sl(e) {
  const t = C0(e);
  if (vi(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === ti && (n = j0(n)), n;
}
const ol = (e, t) => {
  const n = sl(e), i = sl(t);
  if (!n || !i)
    return Dr(e, t);
  const r = { ...n };
  return (s) => (r.red = xs(n.red, i.red, s), r.green = xs(n.green, i.green, s), r.blue = xs(n.blue, i.blue, s), r.alpha = qe(n.alpha, i.alpha, s), Fn.transform(r));
}, Js = /* @__PURE__ */ new Set(["none", "hidden"]);
function k0(e, t) {
  return Js.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
const E0 = (e, t) => (n) => t(e(n)), er = (...e) => e.reduce(E0);
function _0(e, t) {
  return (n) => qe(e, t, n);
}
function na(e) {
  return typeof e == "number" ? _0 : typeof e == "string" ? Do(e) ? Dr : yt.test(e) ? ol : M0 : Array.isArray(e) ? Zc : typeof e == "object" ? yt.test(e) ? ol : N0 : Dr;
}
function Zc(e, t) {
  const n = [...e], i = n.length, r = e.map((s, o) => na(s)(s, t[o]));
  return (s) => {
    for (let o = 0; o < i; o++)
      n[o] = r[o](s);
    return n;
  };
}
function N0(e, t) {
  const n = { ...e, ...t }, i = {};
  for (const r in n)
    e[r] !== void 0 && t[r] !== void 0 && (i[r] = na(e[r])(e[r], t[r]));
  return (r) => {
    for (const s in i)
      n[s] = i[s](r);
    return n;
  };
}
function A0(e, t) {
  const n = [], i = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < t.values.length; r++) {
    const s = t.types[r], o = e.indexes[s][i[s]], a = e.values[o] ?? 0;
    n[r] = a, i[s]++;
  }
  return n;
}
const M0 = (e, t) => {
  const n = Mn.createTransformer(t), i = Yi(e), r = Yi(t);
  return i.indexes.var.length === r.indexes.var.length && i.indexes.color.length === r.indexes.color.length && i.indexes.number.length >= r.indexes.number.length ? Js.has(e) && !r.values.length || Js.has(t) && !i.values.length ? k0(e, t) : er(Zc(A0(i, r), r.values), n) : (vi(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Dr(e, t));
};
function Jc(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? qe(e, t, n) : na(e)(e, t);
}
const P0 = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Xe.update(t, !0),
    stop: () => An(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => mt.isProcessing ? mt.timestamp : Tt.now()
  };
}, Qc = (e, t, n = 10) => {
  let i = "";
  const r = Math.max(Math.round(t / n), 2);
  for (let s = 0; s < r; s++)
    i += e(s / (r - 1)) + ", ";
  return `linear(${i.substring(0, i.length - 2)})`;
}, Ir = 2e4;
function ia(e) {
  let t = 0;
  const n = 50;
  let i = e.next(t);
  for (; !i.done && t < Ir; )
    t += n, i = e.next(t);
  return t >= Ir ? 1 / 0 : t;
}
function R0(e, t = 100, n) {
  const i = n({ ...e, keyframes: [0, t] }), r = Math.min(ia(i), Ir);
  return {
    type: "keyframes",
    ease: (s) => i.next(r * s).value / t,
    duration: /* @__PURE__ */ un(r)
  };
}
const D0 = 5;
function ed(e, t, n) {
  const i = Math.max(t - D0, 0);
  return Wc(n - e(i), t - i);
}
const Ge = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, al = 1e-3;
function I0({ duration: e = Ge.duration, bounce: t = Ge.bounce, velocity: n = Ge.velocity, mass: i = Ge.mass }) {
  let r, s;
  vi(e <= /* @__PURE__ */ Qt(Ge.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - t;
  o = wn(Ge.minDamping, Ge.maxDamping, o), e = wn(Ge.minDuration, Ge.maxDuration, /* @__PURE__ */ un(e)), o < 1 ? (r = (d) => {
    const c = d * o, f = c * e, h = c - n, p = Qs(d, o), y = Math.exp(-f);
    return al - h / p * y;
  }, s = (d) => {
    const f = d * o * e, h = f * n + n, p = Math.pow(o, 2) * Math.pow(d, 2) * e, y = Math.exp(-f), v = Qs(Math.pow(d, 2), o);
    return (-r(d) + al > 0 ? -1 : 1) * ((h - p) * y) / v;
  }) : (r = (d) => {
    const c = Math.exp(-d * e), f = (d - n) * e + 1;
    return -1e-3 + c * f;
  }, s = (d) => {
    const c = Math.exp(-d * e), f = (n - d) * (e * e);
    return c * f;
  });
  const a = 5 / e, l = L0(r, s, a);
  if (e = /* @__PURE__ */ Qt(e), isNaN(l))
    return {
      stiffness: Ge.stiffness,
      damping: Ge.damping,
      duration: e
    };
  {
    const d = Math.pow(l, 2) * i;
    return {
      stiffness: d,
      damping: o * 2 * Math.sqrt(i * d),
      duration: e
    };
  }
}
const O0 = 12;
function L0(e, t, n) {
  let i = n;
  for (let r = 1; r < O0; r++)
    i = i - e(i) / t(i);
  return i;
}
function Qs(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const V0 = ["duration", "bounce"], $0 = ["stiffness", "damping", "mass"];
function ll(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function F0(e) {
  let t = {
    velocity: Ge.velocity,
    stiffness: Ge.stiffness,
    damping: Ge.damping,
    mass: Ge.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ll(e, $0) && ll(e, V0))
    if (e.visualDuration) {
      const n = e.visualDuration, i = 2 * Math.PI / (n * 1.2), r = i * i, s = 2 * wn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(r);
      t = {
        ...t,
        mass: Ge.mass,
        stiffness: r,
        damping: s
      };
    } else {
      const n = I0(e);
      t = {
        ...t,
        ...n,
        mass: Ge.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Or(e = Ge.visualDuration, t = Ge.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: i, restDelta: r } = n;
  const s = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: s }, { stiffness: l, damping: d, mass: c, duration: f, velocity: h, isResolvedFromDuration: p } = F0({
    ...n,
    velocity: -/* @__PURE__ */ un(n.velocity || 0)
  }), y = h || 0, v = d / (2 * Math.sqrt(l * c)), w = o - s, x = /* @__PURE__ */ un(Math.sqrt(l / c)), S = Math.abs(w) < 5;
  i || (i = S ? Ge.restSpeed.granular : Ge.restSpeed.default), r || (r = S ? Ge.restDelta.granular : Ge.restDelta.default);
  let k;
  if (v < 1) {
    const j = Qs(x, v);
    k = (N) => {
      const C = Math.exp(-v * x * N);
      return o - C * ((y + v * x * w) / j * Math.sin(j * N) + w * Math.cos(j * N));
    };
  } else if (v === 1)
    k = (j) => o - Math.exp(-x * j) * (w + (y + x * w) * j);
  else {
    const j = x * Math.sqrt(v * v - 1);
    k = (N) => {
      const C = Math.exp(-v * x * N), R = Math.min(j * N, 300);
      return o - C * ((y + v * x * w) * Math.sinh(R) + j * w * Math.cosh(R)) / j;
    };
  }
  const P = {
    calculatedDuration: p && f || null,
    next: (j) => {
      const N = k(j);
      if (p)
        a.done = j >= f;
      else {
        let C = j === 0 ? y : 0;
        v < 1 && (C = j === 0 ? /* @__PURE__ */ Qt(y) : ed(k, j, N));
        const R = Math.abs(C) <= i, I = Math.abs(o - N) <= r;
        a.done = R && I;
      }
      return a.value = a.done ? o : N, a;
    },
    toString: () => {
      const j = Math.min(ia(P), Ir), N = Qc((C) => P.next(j * C).value, j, 30);
      return j + "ms " + N;
    },
    toTransition: () => {
    }
  };
  return P;
}
Or.applyToOptions = (e) => {
  const t = R0(e, 100, Or);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Qt(t.duration), e.type = "keyframes", e;
};
function eo({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: i = 325, bounceDamping: r = 10, bounceStiffness: s = 500, modifyTarget: o, min: a, max: l, restDelta: d = 0.5, restSpeed: c }) {
  const f = e[0], h = {
    done: !1,
    value: f
  }, p = (R) => a !== void 0 && R < a || l !== void 0 && R > l, y = (R) => a === void 0 ? l : l === void 0 || Math.abs(a - R) < Math.abs(l - R) ? a : l;
  let v = n * t;
  const w = f + v, x = o === void 0 ? w : o(w);
  x !== w && (v = x - f);
  const S = (R) => -v * Math.exp(-R / i), k = (R) => x + S(R), P = (R) => {
    const I = S(R), U = k(R);
    h.done = Math.abs(I) <= d, h.value = h.done ? x : U;
  };
  let j, N;
  const C = (R) => {
    p(h.value) && (j = R, N = Or({
      keyframes: [h.value, y(h.value)],
      velocity: ed(k, R, h.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: s,
      restDelta: d,
      restSpeed: c
    }));
  };
  return C(0), {
    calculatedDuration: null,
    next: (R) => {
      let I = !1;
      return !N && j === void 0 && (I = !0, P(R), C(R)), j !== void 0 && R >= j ? N.next(R - j) : (!I && P(R), h);
    }
  };
}
const Gi = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const i = t - e;
  return i === 0 ? 1 : (n - e) / i;
};
function B0(e, t, n) {
  const i = [], r = n || xn.mix || Jc, s = e.length - 1;
  for (let o = 0; o < s; o++) {
    let a = r(e[o], e[o + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[o] || Ft : t;
      a = er(l, a);
    }
    i.push(a);
  }
  return i;
}
function U0(e, t, { clamp: n = !0, ease: i, mixer: r } = {}) {
  const s = e.length;
  if (bn(s === t.length, "Both input and output ranges must be the same length"), s === 1)
    return () => t[0];
  if (s === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[s - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = B0(t, i, r), l = a.length, d = (c) => {
    if (o && c < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const h = /* @__PURE__ */ Gi(e[f], e[f + 1], c);
    return a[f](h);
  };
  return n ? (c) => d(wn(e[0], e[s - 1], c)) : d;
}
function z0(e, t) {
  const n = e[e.length - 1];
  for (let i = 1; i <= t; i++) {
    const r = /* @__PURE__ */ Gi(0, t, i);
    e.push(qe(n, 1, r));
  }
}
function W0(e) {
  const t = [0];
  return z0(t, e.length - 1), t;
}
function H0(e, t) {
  return e.map((n) => n * t);
}
const td = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, K0 = 1e-7, Y0 = 12;
function G0(e, t, n, i, r) {
  let s, o, a = 0;
  do
    o = t + (n - t) / 2, s = td(o, i, r) - e, s > 0 ? n = o : t = o;
  while (Math.abs(s) > K0 && ++a < Y0);
  return o;
}
function tr(e, t, n, i) {
  if (e === t && n === i)
    return Ft;
  const r = (s) => G0(s, 0, 1, e, n);
  return (s) => s === 0 || s === 1 ? s : td(r(s), t, i);
}
const q0 = /* @__PURE__ */ tr(0.42, 0, 1, 1), X0 = /* @__PURE__ */ tr(0, 0, 0.58, 1), nd = /* @__PURE__ */ tr(0.42, 0, 0.58, 1), Z0 = (e) => Array.isArray(e) && typeof e[0] != "number", id = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, rd = (e) => (t) => 1 - e(1 - t), sd = /* @__PURE__ */ tr(0.33, 1.53, 0.69, 0.99), ra = /* @__PURE__ */ rd(sd), od = /* @__PURE__ */ id(ra), ad = (e) => (e *= 2) < 1 ? 0.5 * ra(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), sa = (e) => 1 - Math.sin(Math.acos(e)), ld = rd(sa), ud = id(sa), cd = (e) => Array.isArray(e) && typeof e[0] == "number", ul = {
  linear: Ft,
  easeIn: q0,
  easeInOut: nd,
  easeOut: X0,
  circIn: sa,
  circInOut: ud,
  circOut: ld,
  backIn: ra,
  backInOut: od,
  backOut: sd,
  anticipate: ad
}, J0 = (e) => typeof e == "string", cl = (e) => {
  if (cd(e)) {
    bn(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, i, r] = e;
    return tr(t, n, i, r);
  } else if (J0(e))
    return bn(ul[e] !== void 0, `Invalid easing type '${e}'`), ul[e];
  return e;
};
function Q0(e, t) {
  return e.map(() => t || nd).splice(0, e.length - 1);
}
function ni({ duration: e = 300, keyframes: t, times: n, ease: i = "easeInOut" }) {
  const r = Z0(i) ? i.map(cl) : cl(i), s = {
    done: !1,
    value: t[0]
  }, o = H0(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : W0(t),
    e
  ), a = U0(o, t, {
    ease: Array.isArray(r) ? r : Q0(t, r)
  });
  return {
    calculatedDuration: e,
    next: (l) => (s.value = a(l), s.done = l >= e, s)
  };
}
const eb = (e) => e !== null;
function oa(e, { repeat: t, repeatType: n = "loop" }, i, r = 1) {
  const s = e.filter(eb), a = r < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : s.length - 1;
  return !a || i === void 0 ? s[a] : i;
}
const tb = {
  decay: eo,
  inertia: eo,
  tween: ni,
  keyframes: ni,
  spring: Or
};
function dd(e) {
  typeof e.type == "string" && (e.type = tb[e.type]);
}
class aa {
  constructor() {
    this.count = 0, this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this.count++, this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const nb = (e) => e / 100;
class fd extends aa {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      const { motionValue: n } = this.options;
      if (n && n.updatedAt !== Tt.now() && this.tick(Tt.now()), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: i } = this.options;
      i && i();
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    dd(t);
    const { type: n = ni, repeat: i = 0, repeatDelay: r = 0, repeatType: s, velocity: o = 0 } = t;
    let { keyframes: a } = t;
    const l = n || ni;
    process.env.NODE_ENV !== "production" && l !== ni && bn(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`), l !== ni && typeof a[0] != "number" && (this.mixKeyframes = er(nb, Jc(a[0], a[1])), a = [0, 100]);
    const d = l({ ...t, keyframes: a });
    s === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -o
    })), d.calculatedDuration === null && (d.calculatedDuration = ia(d));
    const { calculatedDuration: c } = d;
    this.calculatedDuration = c, this.resolvedDuration = c + r, this.totalDuration = this.resolvedDuration * (i + 1) - r, this.generator = d;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: i, totalDuration: r, mixKeyframes: s, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return i.next(0);
    const { delay: d = 0, keyframes: c, repeat: f, repeatType: h, repeatDelay: p, type: y, onUpdate: v, finalKeyframe: w } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - r / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const x = this.currentTime - d * (this.playbackSpeed >= 0 ? 1 : -1), S = this.playbackSpeed >= 0 ? x < 0 : x > r;
    this.currentTime = Math.max(x, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
    let k = this.currentTime, P = i;
    if (f) {
      const R = Math.min(this.currentTime, r) / a;
      let I = Math.floor(R), U = R % 1;
      !U && R >= 1 && (U = 1), U === 1 && I--, I = Math.min(I, f + 1), !!(I % 2) && (h === "reverse" ? (U = 1 - U, p && (U -= p / a)) : h === "mirror" && (P = o)), k = wn(0, 1, U) * a;
    }
    const j = S ? { done: !1, value: c[0] } : P.next(k);
    s && (j.value = s(j.value));
    let { done: N } = j;
    !S && l !== null && (N = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
    const C = this.holdTime === null && (this.state === "finished" || this.state === "running" && N);
    return C && y !== eo && (j.value = oa(c, this.options, w, this.speed)), v && v(j.value), C && this.finish(), j;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ un(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ un(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Qt(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(Tt.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ un(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = P0, onPlay: n, startTime: i } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), n && n();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = i ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Tt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown();
  }
  teardown() {
    this.notifyFinished(), this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), t.observe(this);
  }
}
function ib(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const Bn = (e) => e * 180 / Math.PI, to = (e) => {
  const t = Bn(Math.atan2(e[1], e[0]));
  return no(t);
}, rb = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: to,
  rotateZ: to,
  skewX: (e) => Bn(Math.atan(e[1])),
  skewY: (e) => Bn(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, no = (e) => (e = e % 360, e < 0 && (e += 360), e), dl = to, fl = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), hl = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), sb = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: fl,
  scaleY: hl,
  scale: (e) => (fl(e) + hl(e)) / 2,
  rotateX: (e) => no(Bn(Math.atan2(e[6], e[5]))),
  rotateY: (e) => no(Bn(Math.atan2(-e[2], e[0]))),
  rotateZ: dl,
  rotate: dl,
  skewX: (e) => Bn(Math.atan(e[4])),
  skewY: (e) => Bn(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function pl(e) {
  return e.includes("scale") ? 1 : 0;
}
function io(e, t) {
  if (!e || e === "none")
    return pl(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let i, r;
  if (n)
    i = sb, r = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    i = rb, r = a;
  }
  if (!r)
    return pl(t);
  const s = i[t], o = r[1].split(",").map(ab);
  return typeof s == "function" ? s(o) : o[s];
}
const ob = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return io(n, t);
};
function ab(e) {
  return parseFloat(e.trim());
}
const ml = (e) => e === wi || e === ue, lb = /* @__PURE__ */ new Set(["x", "y", "z"]), ub = xi.filter((e) => !lb.has(e));
function cb(e) {
  const t = [];
  return ub.forEach((n) => {
    const i = e.getValue(n);
    i !== void 0 && (t.push([n, i.get()]), i.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const pi = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => io(t, "x"),
  y: (e, { transform: t }) => io(t, "y")
};
pi.translateX = pi.x;
pi.translateY = pi.y;
const Wn = /* @__PURE__ */ new Set();
let ro = !1, so = !1, oo = !1;
function hd() {
  if (so) {
    const e = Array.from(Wn).filter((i) => i.needsMeasurement), t = new Set(e.map((i) => i.element)), n = /* @__PURE__ */ new Map();
    t.forEach((i) => {
      const r = cb(i);
      r.length && (n.set(i, r), i.render());
    }), e.forEach((i) => i.measureInitialState()), t.forEach((i) => {
      i.render();
      const r = n.get(i);
      r && r.forEach(([s, o]) => {
        var a;
        (a = i.getValue(s)) == null || a.set(o);
      });
    }), e.forEach((i) => i.measureEndState()), e.forEach((i) => {
      i.suspendedScrollY !== void 0 && window.scrollTo(0, i.suspendedScrollY);
    });
  }
  so = !1, ro = !1, Wn.forEach((e) => e.complete(oo)), Wn.clear();
}
function pd() {
  Wn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (so = !0);
  });
}
function db() {
  oo = !0, pd(), hd(), oo = !1;
}
class la {
  constructor(t, n, i, r, s, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = i, this.motionValue = r, this.element = s, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Wn.add(this), ro || (ro = !0, Xe.read(pd), Xe.resolveKeyframes(hd))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: i, motionValue: r } = this;
    if (t[0] === null) {
      const s = r == null ? void 0 : r.get(), o = t[t.length - 1];
      if (s !== void 0)
        t[0] = s;
      else if (i && n) {
        const a = i.readValue(n, o);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = o), r && s === void 0 && r.set(t[0]);
    }
    ib(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Wn.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Wn.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const fb = (e) => e.startsWith("--");
function hb(e, t, n) {
  fb(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
// @__NO_SIDE_EFFECTS__
function ua(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const pb = /* @__PURE__ */ ua(() => window.ScrollTimeline !== void 0), mb = {};
function gb(e, t) {
  const n = /* @__PURE__ */ ua(e);
  return () => mb[t] ?? n();
}
const md = /* @__PURE__ */ gb(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Ri = ([e, t, n, i]) => `cubic-bezier(${e}, ${t}, ${n}, ${i})`, gl = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Ri([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Ri([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Ri([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Ri([0.33, 1.53, 0.69, 0.99])
};
function gd(e, t) {
  if (e)
    return typeof e == "function" ? md() ? Qc(e, t) : "ease-out" : cd(e) ? Ri(e) : Array.isArray(e) ? e.map((n) => gd(n, t) || gl.easeOut) : gl[e];
}
function yb(e, t, n, { delay: i = 0, duration: r = 300, repeat: s = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, d = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const f = gd(a, r);
  Array.isArray(f) && (c.easing = f);
  const h = {
    delay: i,
    duration: r,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return d && (h.pseudoElement = d), e.animate(c, h);
}
function yd(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function vb({ type: e, ...t }) {
  return yd(e) && md() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class xb extends aa {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: i, keyframes: r, pseudoElement: s, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = t;
    this.isPseudoElement = !!s, this.allowFlatten = o, this.options = t, bn(typeof t.type != "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
    const d = vb(t);
    this.animation = yb(n, i, r, d, s), d.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !s) {
        const c = oa(r, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : hb(n, i, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    }, this.animation.oncancel = () => this.notifyFinished();
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, i;
    const t = ((i = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : i.call(n).duration) || 0;
    return /* @__PURE__ */ un(Number(t));
  }
  get time() {
    return /* @__PURE__ */ un(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Qt(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var i;
    return this.allowFlatten && ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && pb() ? (this.animation.timeline = t, Ft) : n(this);
  }
}
const vd = {
  anticipate: ad,
  backInOut: od,
  circInOut: ud
};
function bb(e) {
  return e in vd;
}
function wb(e) {
  typeof e.ease == "string" && bb(e.ease) && (e.ease = vd[e.ease]);
}
const yl = 10;
class Sb extends xb {
  constructor(t) {
    wb(t), dd(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: i, onComplete: r, element: s, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new fd({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ Qt(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - yl).value, a.sample(l).value, yl), a.stop();
  }
}
const vl = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Mn.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function jb(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function Tb(e, t, n, i) {
  const r = e[0];
  if (r === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const s = e[e.length - 1], o = vl(r, t), a = vl(s, t);
  return vi(o === a, `You are trying to animate ${t} from "${r}" to "${s}". ${r} is not an animatable value - to enable this animation set ${r} to a value animatable to ${s} via the \`style\` property.`), !o || !a ? !1 : jb(e) || (n === "spring" || yd(n)) && i;
}
const Cb = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), kb = /* @__PURE__ */ ua(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Eb(e) {
  const { motionValue: t, name: n, repeatDelay: i, repeatType: r, damping: s, type: o } = e;
  if (!t || !t.owner || !(t.owner.current instanceof HTMLElement))
    return !1;
  const { onUpdate: a, transformTemplate: l } = t.owner.getProps();
  return kb() && n && Cb.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !a && !i && r !== "mirror" && s !== 0 && o !== "inertia";
}
const _b = 40;
class Nb extends aa {
  constructor({ autoplay: t = !0, delay: n = 0, type: i = "keyframes", repeat: r = 0, repeatDelay: s = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: d, element: c, ...f }) {
    var y;
    super(), this.stop = () => {
      var v, w;
      this._animation ? (this._animation.stop(), (v = this.stopTimeline) == null || v.call(this)) : (w = this.keyframeResolver) == null || w.cancel();
    }, this.createdAt = Tt.now();
    const h = {
      autoplay: t,
      delay: n,
      type: i,
      repeat: r,
      repeatDelay: s,
      repeatType: o,
      name: l,
      motionValue: d,
      element: c,
      ...f
    }, p = (c == null ? void 0 : c.KeyframeResolver) || la;
    this.keyframeResolver = new p(a, (v, w, x) => this.onKeyframesResolved(v, w, h, !x), l, d, c), (y = this.keyframeResolver) == null || y.scheduleResolve();
  }
  onKeyframesResolved(t, n, i, r) {
    this.keyframeResolver = void 0;
    const { name: s, type: o, velocity: a, delay: l, isHandoff: d, onUpdate: c } = i;
    this.resolvedAt = Tt.now(), Tb(t, s, o, a) || ((xn.instantAnimations || !l) && (c == null || c(oa(t, i, n))), t[0] = t[t.length - 1], i.duration = 0, i.repeat = 0);
    const h = {
      startTime: r ? this.resolvedAt ? this.resolvedAt - this.createdAt > _b ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...i,
      keyframes: t
    }, p = !d && Eb(h) ? new Sb({
      ...h,
      element: h.motionValue.owner.current
    }) : new fd(h);
    p.finished.then(() => this.notifyFinished()).catch(Ft), this.pendingTimeline && (this.stopTimeline = p.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = p;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || db(), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this.animation.cancel();
  }
}
const ca = (e, t, n, i = {}, r, s) => (o) => {
  const a = Qo(i, e) || {}, l = a.delay || i.delay || 0;
  let { elapsed: d = 0 } = i;
  d = d - /* @__PURE__ */ Qt(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -d,
    onUpdate: (h) => {
      t.set(h), a.onUpdate && a.onUpdate(h);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: s ? void 0 : r
  };
  d0(a) || Object.assign(c, c0(e, c)), c.duration && (c.duration = /* @__PURE__ */ Qt(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ Qt(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (f = !0)), (xn.instantAnimations || xn.skipAnimations) && (f = !0, c.duration = 0, c.delay = 0), c.allowFlatten = !a.type && !a.ease, f && !s && t.get() !== void 0) {
    const h = s0(c.keyframes, a);
    if (h !== void 0) {
      Xe.update(() => {
        c.onUpdate(h), c.onComplete();
      });
      return;
    }
  }
  return new Nb(c);
}, xd = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...xi
]);
function Ab({ protectedKeys: e, needsAnimating: t }, n) {
  const i = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, i;
}
function bd(e, t, { delay: n = 0, transitionOverride: i, type: r } = {}) {
  let { transition: s = e.getDefaultTransition(), transitionEnd: o, ...a } = t;
  i && (s = i);
  const l = [], d = r && e.animationState && e.animationState.getState()[r];
  for (const c in a) {
    const f = e.getValue(c, e.latestValues[c] ?? null), h = a[c];
    if (h === void 0 || d && Ab(d, c))
      continue;
    const p = {
      delay: n,
      ...Qo(s || {}, c)
    }, y = f.get();
    if (y !== void 0 && !f.isAnimating && !Array.isArray(h) && h === y && !p.velocity)
      continue;
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const x = Hc(e);
      if (x) {
        const S = window.MotionHandoffAnimation(x, c, Xe);
        S !== null && (p.startTime = S, v = !0);
      }
    }
    Xs(e, c), f.start(ca(c, f, h, e.shouldReduceMotion && xd.has(c) ? { type: !1 } : p, e, v));
    const w = f.animation;
    w && l.push(w);
  }
  return o && Promise.all(l).then(() => {
    Xe.update(() => {
      o && n0(e, o);
    });
  }), l;
}
function ao(e, t, n = {}) {
  var l;
  const i = Hi(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: r = e.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (r = n.transitionOverride);
  const s = i ? () => Promise.all(bd(e, i, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (d = 0) => {
    const { delayChildren: c = 0, staggerChildren: f, staggerDirection: h } = r;
    return Mb(e, t, c + d, f, h, n);
  } : () => Promise.resolve(), { when: a } = r;
  if (a) {
    const [d, c] = a === "beforeChildren" ? [s, o] : [o, s];
    return d().then(() => c());
  } else
    return Promise.all([s(), o(n.delay)]);
}
function Mb(e, t, n = 0, i = 0, r = 1, s) {
  const o = [], a = (e.variantChildren.size - 1) * i, l = r === 1 ? (d = 0) => d * i : (d = 0) => a - d * i;
  return Array.from(e.variantChildren).sort(Pb).forEach((d, c) => {
    d.notify("AnimationStart", t), o.push(ao(d, t, {
      ...s,
      delay: n + l(c)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(o);
}
function Pb(e, t) {
  return e.sortNodePosition(t);
}
function Rb(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let i;
  if (Array.isArray(t)) {
    const r = t.map((s) => ao(e, s, n));
    i = Promise.all(r);
  } else if (typeof t == "string")
    i = ao(e, t, n);
  else {
    const r = typeof t == "function" ? Hi(e, t, n.custom) : t;
    i = Promise.all(bd(e, r, n));
  }
  return i.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function wd(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (t[i] !== e[i])
      return !1;
  return !0;
}
const Db = No.length;
function Sd(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Sd(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < Db; n++) {
    const i = No[n], r = e.props[i];
    (Ui(r) || r === !1) && (t[i] = r);
  }
  return t;
}
const Ib = [..._o].reverse(), Ob = _o.length;
function Lb(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: i }) => Rb(e, n, i)));
}
function Vb(e) {
  let t = Lb(e), n = xl(), i = !0;
  const r = (l) => (d, c) => {
    var h;
    const f = Hi(e, c, l === "exit" ? (h = e.presenceContext) == null ? void 0 : h.custom : void 0);
    if (f) {
      const { transition: p, transitionEnd: y, ...v } = f;
      d = { ...d, ...v, ...y };
    }
    return d;
  };
  function s(l) {
    t = l(e);
  }
  function o(l) {
    const { props: d } = e, c = Sd(e.parent) || {}, f = [], h = /* @__PURE__ */ new Set();
    let p = {}, y = 1 / 0;
    for (let w = 0; w < Ob; w++) {
      const x = Ib[w], S = n[x], k = d[x] !== void 0 ? d[x] : c[x], P = Ui(k), j = x === l ? S.isActive : null;
      j === !1 && (y = w);
      let N = k === c[x] && k !== d[x] && P;
      if (N && i && e.manuallyAnimateOnMount && (N = !1), S.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !S.isActive && j === null || // If we didn't and don't have any defined prop for this animation type
      !k && !S.prevProp || // Or if the prop doesn't define an animation
      Kr(k) || typeof k == "boolean")
        continue;
      const C = $b(S.prevProp, k);
      let R = C || // If we're making this variant active, we want to always make it active
      x === l && S.isActive && !N && P || // If we removed a higher-priority variant (i is in reverse order)
      w > y && P, I = !1;
      const U = Array.isArray(k) ? k : [k];
      let W = U.reduce(r(x), {});
      j === !1 && (W = {});
      const { prevResolvedValues: ae = {} } = S, $ = {
        ...ae,
        ...W
      }, V = (G) => {
        R = !0, h.has(G) && (I = !0, h.delete(G)), S.needsAnimating[G] = !0;
        const te = e.getValue(G);
        te && (te.liveStyle = !1);
      };
      for (const G in $) {
        const te = W[G], le = ae[G];
        if (p.hasOwnProperty(G))
          continue;
        let Ce = !1;
        qs(te) && qs(le) ? Ce = !wd(te, le) : Ce = te !== le, Ce ? te != null ? V(G) : h.add(G) : te !== void 0 && h.has(G) ? V(G) : S.protectedKeys[G] = !0;
      }
      S.prevProp = k, S.prevResolvedValues = W, S.isActive && (p = { ...p, ...W }), i && e.blockInitialAnimation && (R = !1), R && (!(N && C) || I) && f.push(...U.map((G) => ({
        animation: G,
        options: { type: x }
      })));
    }
    if (h.size) {
      const w = {};
      if (typeof d.initial != "boolean") {
        const x = Hi(e, Array.isArray(d.initial) ? d.initial[0] : d.initial);
        x && x.transition && (w.transition = x.transition);
      }
      h.forEach((x) => {
        const S = e.getBaseTarget(x), k = e.getValue(x);
        k && (k.liveStyle = !0), w[x] = S ?? null;
      }), f.push({ animation: w });
    }
    let v = !!f.length;
    return i && (d.initial === !1 || d.initial === d.animate) && !e.manuallyAnimateOnMount && (v = !1), i = !1, v ? t(f) : Promise.resolve();
  }
  function a(l, d) {
    var f;
    if (n[l].isActive === d)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((h) => {
      var p;
      return (p = h.animationState) == null ? void 0 : p.setActive(l, d);
    }), n[l].isActive = d;
    const c = o(l);
    for (const h in n)
      n[h].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: s,
    getState: () => n,
    reset: () => {
      n = xl(), i = !0;
    }
  };
}
function $b(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !wd(t, e) : !1;
}
function On(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function xl() {
  return {
    animate: On(!0),
    whileInView: On(),
    whileHover: On(),
    whileTap: On(),
    whileDrag: On(),
    whileFocus: On(),
    exit: On()
  };
}
class In {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class Fb extends In {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = Vb(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Kr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let Bb = 0;
class Ub extends In {
  constructor() {
    super(...arguments), this.id = Bb++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: i } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === i)
      return;
    const r = this.node.animationState.setActive("exit", !t);
    n && !t && r.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const zb = {
  animation: {
    Feature: Fb
  },
  exit: {
    Feature: Ub
  }
};
function qi(e, t, n, i = { passive: !0 }) {
  return e.addEventListener(t, n, i), () => e.removeEventListener(t, n);
}
const da = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function nr(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const Wb = (e) => (t) => da(t) && e(t, nr(t));
function Vi(e, t, n, i) {
  return qi(e, t, Wb(n), i);
}
function jd({ top: e, left: t, right: n, bottom: i }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: i }
  };
}
function Hb({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Kb(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), i = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: i.y,
    right: i.x
  };
}
const Td = 1e-4, Yb = 1 - Td, Gb = 1 + Td, Cd = 0.01, qb = 0 - Cd, Xb = 0 + Cd;
function xt(e) {
  return e.max - e.min;
}
function Zb(e, t, n) {
  return Math.abs(e - t) <= n;
}
function bl(e, t, n, i = 0.5) {
  e.origin = i, e.originPoint = qe(t.min, t.max, e.origin), e.scale = xt(n) / xt(t), e.translate = qe(n.min, n.max, e.origin) - e.originPoint, (e.scale >= Yb && e.scale <= Gb || isNaN(e.scale)) && (e.scale = 1), (e.translate >= qb && e.translate <= Xb || isNaN(e.translate)) && (e.translate = 0);
}
function $i(e, t, n, i) {
  bl(e.x, t.x, n.x, i ? i.originX : void 0), bl(e.y, t.y, n.y, i ? i.originY : void 0);
}
function wl(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + xt(t);
}
function Jb(e, t, n) {
  wl(e.x, t.x, n.x), wl(e.y, t.y, n.y);
}
function Sl(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + xt(t);
}
function Fi(e, t, n) {
  Sl(e.x, t.x, n.x), Sl(e.y, t.y, n.y);
}
const jl = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), ii = () => ({
  x: jl(),
  y: jl()
}), Tl = () => ({ min: 0, max: 0 }), tt = () => ({
  x: Tl(),
  y: Tl()
});
function $t(e) {
  return [e("x"), e("y")];
}
function bs(e) {
  return e === void 0 || e === 1;
}
function lo({ scale: e, scaleX: t, scaleY: n }) {
  return !bs(e) || !bs(t) || !bs(n);
}
function Ln(e) {
  return lo(e) || kd(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function kd(e) {
  return Cl(e.x) || Cl(e.y);
}
function Cl(e) {
  return e && e !== "0%";
}
function Lr(e, t, n) {
  const i = e - n, r = t * i;
  return n + r;
}
function kl(e, t, n, i, r) {
  return r !== void 0 && (e = Lr(e, r, i)), Lr(e, n, i) + t;
}
function uo(e, t = 0, n = 1, i, r) {
  e.min = kl(e.min, t, n, i, r), e.max = kl(e.max, t, n, i, r);
}
function Ed(e, { x: t, y: n }) {
  uo(e.x, t.translate, t.scale, t.originPoint), uo(e.y, n.translate, n.scale, n.originPoint);
}
const El = 0.999999999999, _l = 1.0000000000001;
function Qb(e, t, n, i = !1) {
  const r = n.length;
  if (!r)
    return;
  t.x = t.y = 1;
  let s, o;
  for (let a = 0; a < r; a++) {
    s = n[a], o = s.projectionDelta;
    const { visualElement: l } = s.options;
    l && l.props.style && l.props.style.display === "contents" || (i && s.options.layoutScroll && s.scroll && s !== s.root && si(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, Ed(e, o)), i && Ln(s.latestValues) && si(e, s.latestValues));
  }
  t.x < _l && t.x > El && (t.x = 1), t.y < _l && t.y > El && (t.y = 1);
}
function ri(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function Nl(e, t, n, i, r = 0.5) {
  const s = qe(e.min, e.max, r);
  uo(e, t, n, s, i);
}
function si(e, t) {
  Nl(e.x, t.x, t.scaleX, t.scale, t.originX), Nl(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function _d(e, t) {
  return jd(Kb(e.getBoundingClientRect(), t));
}
function ew(e, t, n) {
  const i = _d(e, n), { scroll: r } = t;
  return r && (ri(i.x, r.offset.x), ri(i.y, r.offset.y)), i;
}
const Nd = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Al = (e, t) => Math.abs(e - t);
function tw(e, t) {
  const n = Al(e.x, t.x), i = Al(e.y, t.y);
  return Math.sqrt(n ** 2 + i ** 2);
}
class Ad {
  constructor(t, n, { transformPagePoint: i, contextWindow: r, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = Ss(this.lastMoveEventInfo, this.history), h = this.startEvent !== null, p = tw(f.offset, { x: 0, y: 0 }) >= 3;
      if (!h && !p)
        return;
      const { point: y } = f, { timestamp: v } = mt;
      this.history.push({ ...y, timestamp: v });
      const { onStart: w, onMove: x } = this.handlers;
      h || (w && w(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, h) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = ws(h, this.transformPagePoint), Xe.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, h) => {
      this.end();
      const { onEnd: p, onSessionEnd: y, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const w = Ss(f.type === "pointercancel" ? this.lastMoveEventInfo : ws(h, this.transformPagePoint), this.history);
      this.startEvent && p && p(f, w), y && y(f, w);
    }, !da(t))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = i, this.contextWindow = r || window;
    const o = nr(t), a = ws(o, this.transformPagePoint), { point: l } = a, { timestamp: d } = mt;
    this.history = [{ ...l, timestamp: d }];
    const { onSessionStart: c } = n;
    c && c(t, Ss(a, this.history)), this.removeListeners = er(Vi(this.contextWindow, "pointermove", this.handlePointerMove), Vi(this.contextWindow, "pointerup", this.handlePointerUp), Vi(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), An(this.updatePoint);
  }
}
function ws(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Ml(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ss({ point: e }, t) {
  return {
    point: e,
    delta: Ml(e, Md(t)),
    offset: Ml(e, nw(t)),
    velocity: iw(t, 0.1)
  };
}
function nw(e) {
  return e[0];
}
function Md(e) {
  return e[e.length - 1];
}
function iw(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, i = null;
  const r = Md(e);
  for (; n >= 0 && (i = e[n], !(r.timestamp - i.timestamp > /* @__PURE__ */ Qt(t))); )
    n--;
  if (!i)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ un(r.timestamp - i.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (r.x - i.x) / s,
    y: (r.y - i.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function rw(e, { min: t, max: n }, i) {
  return t !== void 0 && e < t ? e = i ? qe(t, e, i.min) : Math.max(e, t) : n !== void 0 && e > n && (e = i ? qe(n, e, i.max) : Math.min(e, n)), e;
}
function Pl(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function sw(e, { top: t, left: n, bottom: i, right: r }) {
  return {
    x: Pl(e.x, n, r),
    y: Pl(e.y, t, i)
  };
}
function Rl(e, t) {
  let n = t.min - e.min, i = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, i] = [i, n]), { min: n, max: i };
}
function ow(e, t) {
  return {
    x: Rl(e.x, t.x),
    y: Rl(e.y, t.y)
  };
}
function aw(e, t) {
  let n = 0.5;
  const i = xt(e), r = xt(t);
  return r > i ? n = /* @__PURE__ */ Gi(t.min, t.max - i, e.min) : i > r && (n = /* @__PURE__ */ Gi(e.min, e.max - r, t.min)), wn(0, 1, n);
}
function lw(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const co = 0.35;
function uw(e = co) {
  return e === !1 ? e = 0 : e === !0 && (e = co), {
    x: Dl(e, "left", "right"),
    y: Dl(e, "top", "bottom")
  };
}
function Dl(e, t, n) {
  return {
    min: Il(e, t),
    max: Il(e, n)
  };
}
function Il(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Zt = {
  x: !1,
  y: !1
};
function Pd() {
  return Zt.x || Zt.y;
}
function cw(e) {
  return e === "x" || e === "y" ? Zt[e] ? null : (Zt[e] = !0, () => {
    Zt[e] = !1;
  }) : Zt.x || Zt.y ? null : (Zt.x = Zt.y = !0, () => {
    Zt.x = Zt.y = !1;
  });
}
const dw = /* @__PURE__ */ new WeakMap();
class fw {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = tt(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const r = (c) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(nr(c).point);
    }, s = (c, f) => {
      const { drag: h, dragPropagation: p, onDragStart: y } = this.getProps();
      if (h && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = cw(h), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), $t((w) => {
        let x = this.getAxisMotionValue(w).get() || 0;
        if (ln.test(x)) {
          const { projection: S } = this.visualElement;
          if (S && S.layout) {
            const k = S.layout.layoutBox[w];
            k && (x = xt(k) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[w] = x;
      }), y && Xe.postRender(() => y(c, f)), Xs(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, o = (c, f) => {
      const { dragPropagation: h, dragDirectionLock: p, onDirectionLock: y, onDrag: v } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: w } = f;
      if (p && this.currentDirection === null) {
        this.currentDirection = hw(w), this.currentDirection !== null && y && y(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, w), this.updateAxis("y", f.point, w), this.visualElement.render(), v && v(c, f);
    }, a = (c, f) => this.stop(c, f), l = () => $t((c) => {
      var f;
      return this.getAnimationState(c) === "paused" && ((f = this.getAxisMotionValue(c).animation) == null ? void 0 : f.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new Ad(t, {
      onSessionStart: r,
      onStart: s,
      onMove: o,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      contextWindow: Nd(this.visualElement)
    });
  }
  stop(t, n) {
    const i = this.isDragging;
    if (this.cancel(), !i)
      return;
    const { velocity: r } = n;
    this.startAnimation(r);
    const { onDragEnd: s } = this.getProps();
    s && Xe.postRender(() => s(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: i } = this.getProps();
    !i && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, i) {
    const { drag: r } = this.getProps();
    if (!i || !gr(t, r, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + i[t];
    this.constraints && this.constraints[t] && (o = rw(o, this.constraints[t], this.elastic[t])), s.set(o);
  }
  resolveConstraints() {
    var s;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (s = this.visualElement.projection) == null ? void 0 : s.layout, r = this.constraints;
    t && ei(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && i ? this.constraints = sw(i.layoutBox, t) : this.constraints = !1, this.elastic = uw(n), r !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && $t((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = lw(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !ei(t))
      return !1;
    const i = t.current;
    bn(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: r } = this.visualElement;
    if (!r || !r.layout)
      return !1;
    const s = ew(i, r.root, this.visualElement.getTransformPagePoint());
    let o = ow(r.layout.layoutBox, s);
    if (n) {
      const a = n(Hb(o));
      this.hasMutatedConstraints = !!a, a && (o = jd(a));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: i, dragElastic: r, dragTransition: s, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, d = $t((c) => {
      if (!gr(c, n, this.currentDirection))
        return;
      let f = l && l[c] || {};
      o && (f = { min: 0, max: 0 });
      const h = r ? 200 : 1e6, p = r ? 40 : 1e7, y = {
        type: "inertia",
        velocity: i ? t[c] : 0,
        bounceStiffness: h,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...f
      };
      return this.startAxisValueAnimation(c, y);
    });
    return Promise.all(d).then(a);
  }
  startAxisValueAnimation(t, n) {
    const i = this.getAxisMotionValue(t);
    return Xs(this.visualElement, t), i.start(ca(t, i, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    $t((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    $t((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, i = this.visualElement.getProps(), r = i[n];
    return r || this.visualElement.getValue(t, (i.initial ? i.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    $t((n) => {
      const { drag: i } = this.getProps();
      if (!gr(n, i, this.currentDirection))
        return;
      const { projection: r } = this.visualElement, s = this.getAxisMotionValue(n);
      if (r && r.layout) {
        const { min: o, max: a } = r.layout.layoutBox[n];
        s.set(t[n] - qe(o, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: i } = this.visualElement;
    if (!ei(n) || !i || !this.constraints)
      return;
    this.stopAnimation();
    const r = { x: 0, y: 0 };
    $t((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const l = a.get();
        r[o] = aw({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", i.root && i.root.updateScroll(), i.updateLayout(), this.resolveConstraints(), $t((o) => {
      if (!gr(o, t, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: d } = this.constraints[o];
      a.set(qe(l, d, r[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    dw.set(this.visualElement, this);
    const t = this.visualElement.current, n = Vi(t, "pointerdown", (l) => {
      const { drag: d, dragListener: c = !0 } = this.getProps();
      d && c && this.start(l);
    }), i = () => {
      const { dragConstraints: l } = this.getProps();
      ei(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: r } = this.visualElement, s = r.addEventListener("measure", i);
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), Xe.read(i);
    const o = qi(window, "resize", () => this.scalePositionWithinConstraints()), a = r.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: d }) => {
      this.isDragging && d && ($t((c) => {
        const f = this.getAxisMotionValue(c);
        f && (this.originPoint[c] += l[c].translate, f.set(f.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), s(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: i = !1, dragPropagation: r = !1, dragConstraints: s = !1, dragElastic: o = co, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: i,
      dragPropagation: r,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function gr(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function hw(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class pw extends In {
  constructor(t) {
    super(t), this.removeGroupControls = Ft, this.removeListeners = Ft, this.controls = new fw(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ft;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Ol = (e) => (t, n) => {
  e && Xe.postRender(() => e(t, n));
};
class mw extends In {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ft;
  }
  onPointerDown(t) {
    this.session = new Ad(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Nd(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: i, onPanEnd: r } = this.node.getProps();
    return {
      onSessionStart: Ol(t),
      onStart: Ol(n),
      onMove: i,
      onEnd: (s, o) => {
        delete this.session, r && Xe.postRender(() => r(s, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Vi(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Er = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Ll(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Ai = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ue.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Ll(e, t.target.x), i = Ll(e, t.target.y);
    return `${n}% ${i}%`;
  }
}, gw = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const i = e, r = Mn.parse(e);
    if (r.length > 5)
      return i;
    const s = Mn.createTransformer(e), o = typeof r[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    r[0 + o] /= a, r[1 + o] /= l;
    const d = qe(a, l, 0.5);
    return typeof r[2 + o] == "number" && (r[2 + o] /= d), typeof r[3 + o] == "number" && (r[3 + o] /= d), s(r);
  }
};
class yw extends Rf {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: i, layoutId: r } = this.props, { projection: s } = t;
    Sp(vw), s && (n.group && n.group.add(s), i && i.register && r && i.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), Er.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: i, drag: r, isPresent: s } = this.props, o = i.projection;
    return o && (o.isPresent = s, r || t.layoutDependency !== n || n === void 0 || t.isPresent !== s ? o.willUpdate() : this.safeToRemove(), t.isPresent !== s && (s ? o.promote() : o.relegate() || Xe.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), Po.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: i } = this.props, { projection: r } = t;
    r && (r.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(r), i && i.deregister && i.deregister(r));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Rd(e) {
  const [t, n] = Uc(), i = ut(ko);
  return u.jsx(yw, { ...e, layoutGroup: i, switchLayoutGroup: ut(Hu), isPresent: t, safeToRemove: n });
}
const vw = {
  borderRadius: {
    ...Ai,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Ai,
  borderTopRightRadius: Ai,
  borderBottomLeftRadius: Ai,
  borderBottomRightRadius: Ai,
  boxShadow: gw
};
function xw(e, t, n) {
  const i = vt(e) ? e : Ki(e);
  return i.start(ca("", i, t, n)), i.animation;
}
function bw(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const ww = (e, t) => e.depth - t.depth;
class Sw {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Xo(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Zo(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(ww), this.isDirty = !1, this.children.forEach(t);
  }
}
function jw(e, t) {
  const n = Tt.now(), i = ({ timestamp: r }) => {
    const s = r - n;
    s >= t && (An(i), e(s - t));
  };
  return Xe.setup(i, !0), () => An(i);
}
const Dd = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Tw = Dd.length, Vl = (e) => typeof e == "string" ? parseFloat(e) : e, $l = (e) => typeof e == "number" || ue.test(e);
function Cw(e, t, n, i, r, s) {
  r ? (e.opacity = qe(0, n.opacity ?? 1, kw(i)), e.opacityExit = qe(t.opacity ?? 1, 0, Ew(i))) : s && (e.opacity = qe(t.opacity ?? 1, n.opacity ?? 1, i));
  for (let o = 0; o < Tw; o++) {
    const a = `border${Dd[o]}Radius`;
    let l = Fl(t, a), d = Fl(n, a);
    if (l === void 0 && d === void 0)
      continue;
    l || (l = 0), d || (d = 0), l === 0 || d === 0 || $l(l) === $l(d) ? (e[a] = Math.max(qe(Vl(l), Vl(d), i), 0), (ln.test(d) || ln.test(l)) && (e[a] += "%")) : e[a] = d;
  }
  (t.rotate || n.rotate) && (e.rotate = qe(t.rotate || 0, n.rotate || 0, i));
}
function Fl(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const kw = /* @__PURE__ */ Id(0, 0.5, ld), Ew = /* @__PURE__ */ Id(0.5, 0.95, Ft);
function Id(e, t, n) {
  return (i) => i < e ? 0 : i > t ? 1 : n(/* @__PURE__ */ Gi(e, t, i));
}
function Bl(e, t) {
  e.min = t.min, e.max = t.max;
}
function Lt(e, t) {
  Bl(e.x, t.x), Bl(e.y, t.y);
}
function Ul(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function zl(e, t, n, i, r) {
  return e -= t, e = Lr(e, 1 / n, i), r !== void 0 && (e = Lr(e, 1 / r, i)), e;
}
function _w(e, t = 0, n = 1, i = 0.5, r, s = e, o = e) {
  if (ln.test(t) && (t = parseFloat(t), t = qe(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let a = qe(s.min, s.max, i);
  e === s && (a -= t), e.min = zl(e.min, t, n, a, r), e.max = zl(e.max, t, n, a, r);
}
function Wl(e, t, [n, i, r], s, o) {
  _w(e, t[n], t[i], t[r], t.scale, s, o);
}
const Nw = ["x", "scaleX", "originX"], Aw = ["y", "scaleY", "originY"];
function Hl(e, t, n, i) {
  Wl(e.x, t, Nw, n ? n.x : void 0, i ? i.x : void 0), Wl(e.y, t, Aw, n ? n.y : void 0, i ? i.y : void 0);
}
function Kl(e) {
  return e.translate === 0 && e.scale === 1;
}
function Od(e) {
  return Kl(e.x) && Kl(e.y);
}
function Yl(e, t) {
  return e.min === t.min && e.max === t.max;
}
function Mw(e, t) {
  return Yl(e.x, t.x) && Yl(e.y, t.y);
}
function Gl(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Ld(e, t) {
  return Gl(e.x, t.x) && Gl(e.y, t.y);
}
function ql(e) {
  return xt(e.x) / xt(e.y);
}
function Xl(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class Pw {
  constructor() {
    this.members = [];
  }
  add(t) {
    Xo(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Zo(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((r) => t === r);
    if (n === 0)
      return !1;
    let i;
    for (let r = n; r >= 0; r--) {
      const s = this.members[r];
      if (s.isPresent !== !1) {
        i = s;
        break;
      }
    }
    return i ? (this.promote(i), !0) : !1;
  }
  promote(t, n) {
    const i = this.lead;
    if (t !== i && (this.prevLead = i, this.lead = t, t.show(), i)) {
      i.instance && i.scheduleRender(), t.scheduleRender(), t.resumeFrom = i, n && (t.resumeFrom.preserveOpacity = !0), i.snapshot && (t.snapshot = i.snapshot, t.snapshot.latestValues = i.animationValues || i.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: r } = t.options;
      r === !1 && i.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: i } = t;
      n.onExitComplete && n.onExitComplete(), i && i.options.onExitComplete && i.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Rw(e, t, n) {
  let i = "";
  const r = e.x.translate / t.x, s = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((r || s || o) && (i = `translate3d(${r}px, ${s}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (i += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: d, rotate: c, rotateX: f, rotateY: h, skewX: p, skewY: y } = n;
    d && (i = `perspective(${d}px) ${i}`), c && (i += `rotate(${c}deg) `), f && (i += `rotateX(${f}deg) `), h && (i += `rotateY(${h}deg) `), p && (i += `skewX(${p}deg) `), y && (i += `skewY(${y}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (i += `scale(${a}, ${l})`), i || "none";
}
const js = ["", "X", "Y", "Z"], Dw = { visibility: "hidden" }, Zl = 1e3;
let Iw = 0;
function Ts(e, t, n, i) {
  const { latestValues: r } = t;
  r[e] && (n[e] = r[e], t.setStaticValue(e, 0), i && (i[e] = 0));
}
function Vd(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Hc(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: r, layoutId: s } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Xe, !(r || s));
  }
  const { parent: i } = e;
  i && !i.hasCheckedOptimisedAppear && Vd(i);
}
function $d({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: i, resetTransform: r }) {
  return class {
    constructor(o = {}, a = t == null ? void 0 : t()) {
      this.id = Iw++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Vw), this.nodes.forEach(zw), this.nodes.forEach(Ww), this.nodes.forEach($w);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Sw());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Jo()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = bw(o), this.instance = o;
      const { layoutId: l, layout: d, visualElement: c } = this.options;
      if (c && !c.current && c.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (d || l) && (this.isLayoutDirty = !0), e) {
        let f;
        const h = () => this.root.updateBlockedByResize = !1;
        e(o, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = jw(h, 250), Er.hasAnimatedSinceResize && (Er.hasAnimatedSinceResize = !1, this.nodes.forEach(Ql));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && c && (l || d) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: h, hasRelativeLayoutChanged: p, layout: y }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || c.getDefaultTransition() || qw, { onLayoutAnimationStart: w, onLayoutAnimationComplete: x } = c.getProps(), S = !this.targetLayout || !Ld(this.targetLayout, y), k = !h && p;
        if (this.options.layoutRoot || this.resumeFrom || k || h && (S || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, k);
          const P = {
            ...Qo(v, "layout"),
            onPlay: w,
            onComplete: x
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (P.delay = 0, P.type = !1), this.startAnimation(P);
        } else
          h || Ql(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = y;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), An(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Hw), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Vd(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Jl);
        return;
      }
      this.isUpdating || this.nodes.forEach(Bw), this.isUpdating = !1, this.nodes.forEach(Uw), this.nodes.forEach(Ow), this.nodes.forEach(Lw), this.clearAllSnapshots();
      const a = Tt.now();
      mt.delta = wn(0, 1e3 / 60, a - mt.timestamp), mt.timestamp = a, mt.isProcessing = !0, gs.update.process(mt), gs.preRender.process(mt), gs.render.process(mt), mt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Po.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Fw), this.sharedNodes.forEach(Kw);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Xe.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Xe.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !xt(this.snapshot.measuredBox.x) && !xt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = tt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a) {
        const l = i(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!r)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Od(this.projectionDelta), l = this.getTransformTemplate(), d = l ? l(this.latestValues, "") : void 0, c = d !== this.prevTransformTemplateValue;
      o && (a || Ln(this.latestValues) || c) && (r(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), Xw(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var d;
      const { visualElement: o } = this.options;
      if (!o)
        return tt();
      const a = o.measureViewportBox();
      if (!(((d = this.scroll) == null ? void 0 : d.wasRoot) || this.path.some(Zw))) {
        const { scroll: c } = this.root;
        c && (ri(a.x, c.offset.x), ri(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var l;
      const a = tt();
      if (Lt(a, o), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let d = 0; d < this.path.length; d++) {
        const c = this.path[d], { scroll: f, options: h } = c;
        c !== this.root && f && h.layoutScroll && (f.wasRoot && Lt(a, o), ri(a.x, f.offset.x), ri(a.y, f.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const l = tt();
      Lt(l, o);
      for (let d = 0; d < this.path.length; d++) {
        const c = this.path[d];
        !a && c.options.layoutScroll && c.scroll && c !== c.root && si(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), Ln(c.latestValues) && si(l, c.latestValues);
      }
      return Ln(this.latestValues) && si(l, this.latestValues), l;
    }
    removeTransform(o) {
      const a = tt();
      Lt(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const d = this.path[l];
        if (!d.instance || !Ln(d.latestValues))
          continue;
        lo(d.latestValues) && d.updateSnapshot();
        const c = tt(), f = d.measurePageBox();
        Lt(c, f), Hl(a, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, c);
      }
      return Ln(this.latestValues) && Hl(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== mt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var h;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || (h = this.parent) != null && h.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: f } = this.options;
      if (!(!this.layout || !(c || f))) {
        if (this.resolvedRelativeTargetAt = mt.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = tt(), this.relativeTargetOrigin = tt(), Fi(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), Lt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = tt(), this.targetWithTransforms = tt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Jb(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Lt(this.target, this.layout.layoutBox), Ed(this.target, this.targetDelta)) : Lt(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const p = this.getClosestProjectingParent();
          p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = tt(), this.relativeTargetOrigin = tt(), Fi(this.relativeTargetOrigin, this.target, p.target), Lt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || lo(this.parent.latestValues) || kd(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var y;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === mt.timestamp && (l = !1), l)
        return;
      const { layout: d, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(d || c))
        return;
      Lt(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, h = this.treeScale.y;
      Qb(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = tt());
      const { target: p } = o;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Ul(this.prevProjectionDelta.x, this.projectionDelta.x), Ul(this.prevProjectionDelta.y, this.projectionDelta.y)), $i(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== h || !Xl(this.projectionDelta.x, this.prevProjectionDelta.x) || !Xl(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = ii(), this.projectionDelta = ii(), this.projectionDeltaWithTransform = ii();
    }
    setAnimationOrigin(o, a = !1) {
      const l = this.snapshot, d = l ? l.latestValues : {}, c = { ...this.latestValues }, f = ii();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const h = tt(), p = l ? l.source : void 0, y = this.layout ? this.layout.source : void 0, v = p !== y, w = this.getStack(), x = !w || w.members.length <= 1, S = !!(v && !x && this.options.crossfade === !0 && !this.path.some(Gw));
      this.animationProgress = 0;
      let k;
      this.mixTargetDelta = (P) => {
        const j = P / 1e3;
        eu(f.x, o.x, j), eu(f.y, o.y, j), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Fi(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Yw(this.relativeTarget, this.relativeTargetOrigin, h, j), k && Mw(this.relativeTarget, k) && (this.isProjectionDirty = !1), k || (k = tt()), Lt(k, this.relativeTarget)), v && (this.animationValues = c, Cw(c, d, this.latestValues, j, S, x)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = j;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (An(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Xe.update(() => {
        Er.hasAnimatedSinceResize = !0, this.currentAnimation = xw(0, Zl, {
          ...o,
          onUpdate: (a) => {
            this.mixTargetDelta(a), o.onUpdate && o.onUpdate(a);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Zl), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: d, latestValues: c } = o;
      if (!(!a || !l || !d)) {
        if (this !== o && this.layout && d && Fd(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          l = this.target || tt();
          const f = xt(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + f;
          const h = xt(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + h;
        }
        Lt(a, l), si(a, c), $i(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new Pw()), this.sharedNodes.get(o).add(a);
      const d = a.options.initialPromotionConfig;
      a.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const d = this.getStack();
      d && d.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const d = {};
      l.z && Ts("z", o, d, this.animationValues);
      for (let c = 0; c < js.length; c++)
        Ts(`rotate${js[c]}`, o, d, this.animationValues), Ts(`skew${js[c]}`, o, d, this.animationValues);
      o.render();
      for (const c in d)
        o.setStaticValue(c, d[c]), this.animationValues && (this.animationValues[c] = d[c]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return Dw;
      const a = {
        visibility: ""
      }, l = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, a.opacity = "", a.pointerEvents = br(o == null ? void 0 : o.pointerEvents) || "", a.transform = l ? l(this.latestValues, "") : "none", a;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const p = {};
        return this.options.layoutId && (p.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, p.pointerEvents = br(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !Ln(this.latestValues) && (p.transform = l ? l({}, "") : "none", this.hasProjected = !1), p;
      }
      const c = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), a.transform = Rw(this.projectionDeltaWithTransform, this.treeScale, c), l && (a.transform = l(c, a.transform));
      const { x: f, y: h } = this.projectionDelta;
      a.transformOrigin = `${f.origin * 100}% ${h.origin * 100}% 0`, d.animationValues ? a.opacity = d === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : a.opacity = d === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const p in zi) {
        if (c[p] === void 0)
          continue;
        const { correct: y, applyTo: v, isCSSVariable: w } = zi[p], x = a.transform === "none" ? c[p] : y(c[p], d);
        if (v) {
          const S = v.length;
          for (let k = 0; k < S; k++)
            a[v[k]] = x;
        } else
          w ? this.options.visualElement.renderState.vars[p] = x : a[p] = x;
      }
      return this.options.layoutId && (a.pointerEvents = d === this ? br(o == null ? void 0 : o.pointerEvents) || "" : "none"), a;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Jl), this.root.sharedNodes.clear();
    }
  };
}
function Ow(e) {
  e.updateLayout();
}
function Lw(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: i, measuredBox: r } = e.layout, { animationType: s } = e.options, o = t.source !== e.layout.source;
    s === "size" ? $t((f) => {
      const h = o ? t.measuredBox[f] : t.layoutBox[f], p = xt(h);
      h.min = i[f].min, h.max = h.min + p;
    }) : Fd(s, t.layoutBox, i) && $t((f) => {
      const h = o ? t.measuredBox[f] : t.layoutBox[f], p = xt(i[f]);
      h.max = h.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + p);
    });
    const a = ii();
    $i(a, i, t.layoutBox);
    const l = ii();
    o ? $i(l, e.applyTransform(r, !0), t.measuredBox) : $i(l, i, t.layoutBox);
    const d = !Od(a);
    let c = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: h, layout: p } = f;
        if (h && p) {
          const y = tt();
          Fi(y, t.layoutBox, h.layoutBox);
          const v = tt();
          Fi(v, i, p.layoutBox), Ld(y, v) || (c = !0), f.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = y, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: i,
      snapshot: t,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: d,
      hasRelativeLayoutChanged: c
    });
  } else if (e.isLead()) {
    const { onExitComplete: i } = e.options;
    i && i();
  }
  e.options.transition = void 0;
}
function Vw(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function $w(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Fw(e) {
  e.clearSnapshot();
}
function Jl(e) {
  e.clearMeasurements();
}
function Bw(e) {
  e.isLayoutDirty = !1;
}
function Uw(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Ql(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function zw(e) {
  e.resolveTargetDelta();
}
function Ww(e) {
  e.calcProjection();
}
function Hw(e) {
  e.resetSkewAndRotation();
}
function Kw(e) {
  e.removeLeadSnapshot();
}
function eu(e, t, n) {
  e.translate = qe(t.translate, 0, n), e.scale = qe(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function tu(e, t, n, i) {
  e.min = qe(t.min, n.min, i), e.max = qe(t.max, n.max, i);
}
function Yw(e, t, n, i) {
  tu(e.x, t.x, n.x, i), tu(e.y, t.y, n.y, i);
}
function Gw(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const qw = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, nu = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), iu = nu("applewebkit/") && !nu("chrome/") ? Math.round : Ft;
function ru(e) {
  e.min = iu(e.min), e.max = iu(e.max);
}
function Xw(e) {
  ru(e.x), ru(e.y);
}
function Fd(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !Zb(ql(t), ql(n), 0.2);
}
function Zw(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Jw = $d({
  attachResizeListener: (e, t) => qi(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Cs = {
  current: void 0
}, Bd = $d({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Cs.current) {
      const e = new Jw({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Cs.current = e;
    }
    return Cs.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Qw = {
  pan: {
    Feature: mw
  },
  drag: {
    Feature: pw,
    ProjectionNode: Bd,
    MeasureLayout: Rd
  }
};
function e1(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let i = document;
    const r = (n == null ? void 0 : n[e]) ?? i.querySelectorAll(e);
    return r ? Array.from(r) : [];
  }
  return Array.from(e);
}
function Ud(e, t) {
  const n = e1(e), i = new AbortController(), r = {
    passive: !0,
    ...t,
    signal: i.signal
  };
  return [n, r, () => i.abort()];
}
function su(e) {
  return !(e.pointerType === "touch" || Pd());
}
function t1(e, t, n = {}) {
  const [i, r, s] = Ud(e, n), o = (a) => {
    if (!su(a))
      return;
    const { target: l } = a, d = t(l, a);
    if (typeof d != "function" || !l)
      return;
    const c = (f) => {
      su(f) && (d(f), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, r);
  };
  return i.forEach((a) => {
    a.addEventListener("pointerenter", o, r);
  }), s;
}
function ou(e, t, n) {
  const { props: i } = e;
  e.animationState && i.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const r = "onHover" + n, s = i[r];
  s && Xe.postRender(() => s(t, nr(t)));
}
class n1 extends In {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = t1(t, (n, i) => (ou(this.node, i, "Start"), (r) => ou(this.node, r, "End"))));
  }
  unmount() {
  }
}
class i1 extends In {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = er(qi(this.node.current, "focus", () => this.onFocus()), qi(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const zd = (e, t) => t ? e === t ? !0 : zd(e, t.parentElement) : !1, r1 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function s1(e) {
  return r1.has(e.tagName) || e.tabIndex !== -1;
}
const Di = /* @__PURE__ */ new WeakSet();
function au(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function ks(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const o1 = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const i = au(() => {
    if (Di.has(n))
      return;
    ks(n, "down");
    const r = au(() => {
      ks(n, "up");
    }), s = () => ks(n, "cancel");
    n.addEventListener("keyup", r, t), n.addEventListener("blur", s, t);
  });
  n.addEventListener("keydown", i, t), n.addEventListener("blur", () => n.removeEventListener("keydown", i), t);
};
function lu(e) {
  return da(e) && !Pd();
}
function a1(e, t, n = {}) {
  const [i, r, s] = Ud(e, n), o = (a) => {
    const l = a.currentTarget;
    if (!lu(a) || Di.has(l))
      return;
    Di.add(l);
    const d = t(l, a), c = (p, y) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", h), !(!lu(p) || !Di.has(l)) && (Di.delete(l), typeof d == "function" && d(p, { success: y }));
    }, f = (p) => {
      c(p, l === window || l === document || n.useGlobalTarget || zd(l, p.target));
    }, h = (p) => {
      c(p, !1);
    };
    window.addEventListener("pointerup", f, r), window.addEventListener("pointercancel", h, r);
  };
  return i.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", o, r), a instanceof HTMLElement && (a.addEventListener("focus", (d) => o1(d, r)), !s1(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), s;
}
function uu(e, t, n) {
  const { props: i } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && i.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const r = "onTap" + (n === "End" ? "" : n), s = i[r];
  s && Xe.postRender(() => s(t, nr(t)));
}
class l1 extends In {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = a1(t, (n, i) => (uu(this.node, i, "Start"), (r, { success: s }) => uu(this.node, r, s ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const fo = /* @__PURE__ */ new WeakMap(), Es = /* @__PURE__ */ new WeakMap(), u1 = (e) => {
  const t = fo.get(e.target);
  t && t(e);
}, c1 = (e) => {
  e.forEach(u1);
};
function d1({ root: e, ...t }) {
  const n = e || document;
  Es.has(n) || Es.set(n, {});
  const i = Es.get(n), r = JSON.stringify(t);
  return i[r] || (i[r] = new IntersectionObserver(c1, { root: e, ...t })), i[r];
}
function f1(e, t, n) {
  const i = d1(t);
  return fo.set(e, n), i.observe(e), () => {
    fo.delete(e), i.unobserve(e);
  };
}
const h1 = {
  some: 0,
  all: 1
};
class p1 extends In {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: i, amount: r = "some", once: s } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: i,
      threshold: typeof r == "number" ? r : h1[r]
    }, a = (l) => {
      const { isIntersecting: d } = l;
      if (this.isInView === d || (this.isInView = d, s && !d && this.hasEnteredView))
        return;
      d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), h = d ? c : f;
      h && h(l);
    };
    return f1(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(m1(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function m1({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const g1 = {
  inView: {
    Feature: p1
  },
  tap: {
    Feature: l1
  },
  focus: {
    Feature: i1
  },
  hover: {
    Feature: n1
  }
}, y1 = {
  layout: {
    ProjectionNode: Bd,
    MeasureLayout: Rd
  }
}, ho = { current: null }, Wd = { current: !1 };
function v1() {
  if (Wd.current = !0, !!Ao)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => ho.current = e.matches;
      e.addListener(t), t();
    } else
      ho.current = !1;
}
const x1 = /* @__PURE__ */ new WeakMap();
function b1(e, t, n) {
  for (const i in t) {
    const r = t[i], s = n[i];
    if (vt(r))
      e.addValue(i, r);
    else if (vt(s))
      e.addValue(i, Ki(r, { owner: e }));
    else if (s !== r)
      if (e.hasValue(i)) {
        const o = e.getValue(i);
        o.liveStyle === !0 ? o.jump(r) : o.hasAnimated || o.set(r);
      } else {
        const o = e.getStaticValue(i);
        e.addValue(i, Ki(o !== void 0 ? o : r, { owner: e }));
      }
  }
  for (const i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
const Hd = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Kd = (e) => /^0[^.\s]+$/u.test(e), w1 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Yd = (e) => (t) => t.test(e), Gd = [wi, ue, ln, Cn, Tp, jp, w1], cu = (e) => Gd.find(Yd(e)), S1 = [...Gd, yt, Mn], j1 = (e) => S1.find(Yd(e)), T1 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function C1(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [i] = n.match(ea) || [];
  if (!i)
    return e;
  const r = n.replace(i, "");
  let s = T1.has(t) ? 1 : 0;
  return i !== n && (s *= 100), t + "(" + s + r + ")";
}
const k1 = /\b([a-z-]*)\(.*?\)/gu, po = {
  ...Mn,
  getAnimatableNone: (e) => {
    const t = e.match(k1);
    return t ? t.map(C1).join(" ") : e;
  }
}, E1 = {
  ...Io,
  // Color props
  color: yt,
  backgroundColor: yt,
  outlineColor: yt,
  fill: yt,
  stroke: yt,
  // Border props
  borderColor: yt,
  borderTopColor: yt,
  borderRightColor: yt,
  borderBottomColor: yt,
  borderLeftColor: yt,
  filter: po,
  WebkitFilter: po
}, qd = (e) => E1[e];
function Xd(e, t) {
  let n = qd(e);
  return n !== po && (n = Mn), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const du = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class _1 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, i) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: i, reducedMotionConfig: r, blockInitialAnimation: s, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = la, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = Tt.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, Xe.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: d } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = d, this.parent = t, this.props = n, this.presenceContext = i, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = r, this.options = a, this.blockInitialAnimation = !!s, this.isControllingVariants = Yr(n), this.isVariantNode = zu(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in f) {
      const p = f[h];
      l[h] !== void 0 && vt(p) && p.set(l[h], !1);
    }
  }
  mount(t) {
    this.current = t, x1.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, i) => this.bindToMotionValue(i, n)), Wd.current || v1(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : ho.current, process.env.NODE_ENV !== "production" && qo(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), this.projection = void 0, An(this.notifyUpdate), An(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const i = bi.has(t);
    i && this.onBindTransform && this.onBindTransform();
    const r = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Xe.preRender(this.notifyUpdate), i && this.projection && (this.projection.isTransformDirty = !0);
    }), s = n.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      r(), s(), o && o(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in li) {
      const n = li[t];
      if (!n)
        continue;
      const { isEnabled: i, Feature: r } = n;
      if (!this.features[t] && r && i(this.props) && (this.features[t] = new r(this)), this.features[t]) {
        const s = this.features[t];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : tt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let i = 0; i < du.length; i++) {
      const r = du[i];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const s = "on" + r, o = t[s];
      o && (this.propEventSubscriptions[r] = this.on(r, o));
    }
    this.prevMotionValues = b1(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const i = this.values.get(t);
    n !== i && (i && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let i = this.values.get(t);
    return i === void 0 && n !== void 0 && (i = Ki(n === null ? void 0 : n, { owner: this }), this.addValue(t, i)), i;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let i = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return i != null && (typeof i == "string" && (Hd(i) || Kd(i)) ? i = parseFloat(i) : !j1(i) && Mn.test(n) && (i = Xd(t, n)), this.setBaseTarget(t, vt(i) ? i.get() : i)), vt(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var s;
    const { initial: n } = this.props;
    let i;
    if (typeof n == "string" || typeof n == "object") {
      const o = $o(this.props, n, (s = this.presenceContext) == null ? void 0 : s.custom);
      o && (i = o[t]);
    }
    if (n && i !== void 0)
      return i;
    const r = this.getBaseTargetFromProps(this.props, t);
    return r !== void 0 && !vt(r) ? r : this.initialValues[t] !== void 0 && i === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Jo()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
const N1 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function A1(e) {
  const t = N1.exec(e);
  if (!t)
    return [,];
  const [, n, i, r] = t;
  return [`--${n ?? i}`, r];
}
const M1 = 4;
function Zd(e, t, n = 1) {
  bn(n <= M1, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [i, r] = A1(e);
  if (!i)
    return;
  const s = window.getComputedStyle(t).getPropertyValue(i);
  if (s) {
    const o = s.trim();
    return Hd(o) ? parseFloat(o) : o;
  }
  return Do(r) ? Zd(r, t, n + 1) : r;
}
function P1(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Kd(e) : !0;
}
const R1 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function D1(e, t, n) {
  let i = 0, r;
  for (; i < e.length && !r; ) {
    const s = e[i];
    typeof s == "string" && !R1.has(s) && Yi(s).values.length && (r = e[i]), i++;
  }
  if (r && n)
    for (const s of t)
      e[s] = Xd(n, r);
}
class I1 extends la {
  constructor(t, n, i, r, s) {
    super(t, n, i, r, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: i } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let d = t[l];
      if (typeof d == "string" && (d = d.trim(), Do(d))) {
        const c = Zd(d, n.current);
        c !== void 0 && (t[l] = c), l === t.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !xd.has(i) || t.length !== 2)
      return;
    const [r, s] = t, o = cu(r), a = cu(s);
    if (o !== a)
      if (ml(o) && ml(a))
        for (let l = 0; l < t.length; l++) {
          const d = t[l];
          typeof d == "string" && (t[l] = parseFloat(d));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, i = [];
    for (let r = 0; r < t.length; r++)
      (t[r] === null || P1(t[r])) && i.push(r);
    i.length && D1(t, i, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: i } = this;
    if (!t || !t.current)
      return;
    i === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = pi[i](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const r = n[n.length - 1];
    r !== void 0 && t.getValue(i, r).jump(r, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: i } = this;
    if (!t || !t.current)
      return;
    const r = t.getValue(n);
    r && r.jump(this.measuredOrigin, !1);
    const s = i.length - 1, o = i[s];
    i[s] = pi[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, d]) => {
      t.getValue(l).set(d);
    }), this.resolveNoneKeyframes();
  }
}
class Jd extends _1 {
  constructor() {
    super(...arguments), this.KeyframeResolver = I1;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: i }) {
    delete n[t], delete i[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    vt(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Qd(e, { style: t, vars: n }, i, r) {
  Object.assign(e.style, t, r && r.getProjectionStyles(i));
  for (const s in n)
    e.style.setProperty(s, n[s]);
}
function O1(e) {
  return window.getComputedStyle(e);
}
class L1 extends Jd {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Qd;
  }
  readValueFromInstance(t, n) {
    if (bi.has(n))
      return ob(t, n);
    {
      const i = O1(t), r = (Ro(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return _d(t, n);
  }
  build(t, n, i) {
    Oo(t, n, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, i) {
    return Bo(t, n, i);
  }
}
const ef = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function V1(e, t, n, i) {
  Qd(e, t, void 0, i);
  for (const r in t.attrs)
    e.setAttribute(ef.has(r) ? r : Mo(r), t.attrs[r]);
}
class $1 extends Jd {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = tt;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (bi.has(n)) {
      const i = qd(n);
      return i && i.default || 0;
    }
    return n = ef.has(n) ? n : Mo(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, i) {
    return rc(t, n, i);
  }
  build(t, n, i) {
    ec(t, n, this.isSVGTag, i.transformTemplate);
  }
  renderInstance(t, n, i, r) {
    V1(t, n, i, r);
  }
  mount(t) {
    this.isSVGTag = nc(t.tagName), super.mount(t);
  }
}
const F1 = (e, t) => Vo(e) ? new $1(t) : new L1(t, {
  allowProjection: e !== Iu
}), B1 = /* @__PURE__ */ sc({
  ...zb,
  ...g1,
  ...Qw,
  ...y1
}, F1), mo = /* @__PURE__ */ Xx(B1), fa = {
  marginTop: "calc(-1 * env(safe-area-inset-top, 0px))",
  marginRight: "calc(-1 * env(safe-area-inset-right, 0px))",
  marginBottom: "calc(-1 * env(safe-area-inset-bottom, 0px))",
  marginLeft: "calc(-1 * env(safe-area-inset-left, 0px))",
  paddingTop: "env(safe-area-inset-top, 0px)",
  paddingRight: "env(safe-area-inset-right, 0px)",
  paddingBottom: "env(safe-area-inset-bottom, 0px)",
  paddingLeft: "env(safe-area-inset-left, 0px)",
  minHeight: "max(100dvh, 100svh)",
  boxSizing: "border-box"
}, U1 = 0.25, z1 = "ui:fixed ui:inset-0 ui:z-100 ui:flex ui:w-screen ui:max-w-none ui:items-center ui:justify-center ui:overflow-y-auto ui:overscroll-y-contain ui:bg-black/50 ui:[-webkit-tap-highlight-color:transparent] ui:isolate", W1 = "ui:flex ui:w-[min(400px,100%)] ui:flex-col ui:gap-3 ui:rounded-3xl ui:bg-bg-light ui:px-6 ui:pt-6 ui:pb-4 ui:max-md:w-[min(94dvw,94vw)] ui:max-md:p-[20px] ui:origin-center", ha = nt(function({
  children: t,
  panelClassName: n = "",
  contentKey: i,
  tall: r = !1,
  className: s,
  onClick: o
}) {
  const a = Ne(
    (l) => {
      l.target === l.currentTarget && (l.stopPropagation(), o == null || o(l));
    },
    [o]
  );
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: fe(z1, s),
      style: fa,
      onClick: a,
      children: /* @__PURE__ */ u.jsx(zc, { mode: "wait", children: /* @__PURE__ */ u.jsx(
        mo.div,
        {
          role: "dialog",
          "aria-modal": "true",
          className: fe(
            W1,
            r && "ui:max-h-[min(80svh,80dvh)] ui:min-h-0 ui:overflow-y-auto",
            n
          ),
          initial: { scale: 0.96 },
          animate: { scale: 1 },
          exit: { scale: 0.96 },
          transition: { duration: U1, ease: "easeOut" },
          onClick: (l) => l.stopPropagation(),
          children: t
        },
        i ?? "modal-panel"
      ) })
    }
  );
}), H1 = nt(function({
  id: t = "",
  className: n = "",
  inputRef: i,
  onInput: r,
  onKeyDown: s,
  onBlur: o,
  placeholder: a,
  disabled: l = !1,
  autoFocus: d = !0,
  autoComplete: c = "off"
}) {
  return /* @__PURE__ */ u.jsx(
    "textarea",
    {
      id: t,
      className: fe("ui:font-light ui:focus:outline-none", n),
      ref: i,
      onInput: r,
      onKeyDown: s,
      onBlur: o,
      autoComplete: c,
      autoFocus: d,
      disabled: l,
      placeholder: a
    }
  );
}), K1 = "ui:max-h-[90svh] ui:w-[500px]! ui:flex-col ui:gap-5 ui:rounded-[32px] ui:p-7 ui:max-sm:w-[94svw]", PS = ({
  files: e,
  onRemoveFile: t,
  onSend: n,
  onCancel: i,
  onAddMore: r,
  inputRef: s,
  onInput: o,
  onKeyDown: a,
  placeholder: l = "Type your message...",
  isSending: d = !1,
  isPending: c = !1,
  title: f,
  attachmentsMaxHeight: h = "min(460px, calc(100svh - 300px))",
  contentClassName: p = "",
  className: y,
  ...v
}) => {
  const w = f ?? (e.length > 1 ? `Selected ${e.length} files` : "Send attachment");
  return /* @__PURE__ */ u.jsx(
    ha,
    {
      className: fe("ui:z-100 ui:p-2.5", y),
      panelClassName: fe(K1, p),
      onClick: i,
      ...v,
      children: /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-col ui:gap-2.75", children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:text-xl ui:font-normal ui:text-black", children: w }),
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:min-h-50 ui:flex-col ui:items-center ui:justify-center", children: d ? /* @__PURE__ */ u.jsx("p", { className: "ui:self-center ui:py-2.5 ui:text-lg", children: "Processing..." }) : c && !e.length ? /* @__PURE__ */ u.jsx(Sn, { width: 80, height: 80, wrapperClassName: "ui:self-center" }) : e.length ? /* @__PURE__ */ u.jsx(
          Hx,
          {
            maxHeight: h,
            attachments: e,
            removeFileFunc: t,
            disableAnimation: !0
          }
        ) : /* @__PURE__ */ u.jsx("p", { className: "ui:self-center ui:py-2.5 ui:text-lg ui:text-gray-500", children: "Select files" }) }),
        /* @__PURE__ */ u.jsx(
          H1,
          {
            className: "ui:max-h-[140px] ui:min-h-10 ui:resize-none ui:rounded-xl ui:bg-hover-light ui:px-3.5 ui:py-3 ui:text-black ui:[&::-webkit-scrollbar]:hidden",
            inputRef: s,
            onInput: o,
            onKeyDown: a,
            onBlur: o,
            placeholder: d ? "Processing and sending files..." : l,
            disabled: d,
            autoFocus: !0
          }
        ),
        /* @__PURE__ */ u.jsx("hr", { className: "ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
        !d && /* @__PURE__ */ u.jsxs("div", { className: "ui:mt-auto ui:flex ui:items-center ui:justify-end ui:gap-7", children: [
          /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:mr-auto ui:flex ui:cursor-pointer ui:items-center ui:px-3 ui:py-2 ui:text-accent-500",
              onClick: r,
              children: "Add"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:flex ui:cursor-pointer ui:items-center ui:px-3 ui:py-2 ui:text-text-dark",
              onClick: i,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:flex ui:cursor-pointer ui:items-center ui:rounded-xl ui:bg-accent-500 ui:px-6 ui:py-2 ui:text-white ui:duration-150 ui:hover:bg-black",
              onClick: n,
              children: "Send"
            }
          )
        ] })
      ] })
    }
  );
}, fu = {
  sent: zr,
  read: Hf,
  default: th
}, tf = nt(function({
  status: t,
  message: n,
  color: i = "accent",
  className: r,
  ...s
}) {
  if (!(n || t)) return null;
  const o = t || (n == null ? void 0 : n.status) || "default", a = i === "white" ? "white" : "#7678e5", l = fu[o] ?? fu.default;
  return /* @__PURE__ */ u.jsx(ge, { as: "span", className: r, ...s, children: /* @__PURE__ */ u.jsx(l, { size: 18, color: a }) });
}), _r = {
  _id: "default_id",
  organization_id: "default_org_id",
  login: "default_login",
  updated_at: "default_updated_at",
  created_at: "default_created_at",
  recent_activity: 0
}, _s = {
  _id: "default_id",
  organization_id: "default_org_id",
  type: "g",
  owner_id: "default_owner_id",
  participants: [],
  messages: [],
  updated_at: "default_updated_at",
  created_at: "default_created_at",
  draft: null,
  last_message: null,
  unread_messages_count: 0
}, Y1 = () => ({
  syncDraftByCid: (x, S, k) => ({}),
  saveDraft: (x, S) => {
  },
  flushDraftToLocalStorage: (x) => {
  },
  saveLastInputText: (x, S) => {
  },
  removeDraft: (x) => {
  },
  removeDraftWithOptions: (x, S, k) => {
  },
  purgeDraft: (x) => {
  },
  pushLocalDraftToReduxNow: (x) => {
  },
  savePreEditComposeText: (x, S) => {
  },
  consumePreEditComposeText: (x) => "",
  getDraft: (x) => ({}),
  getDraftField: (x, S) => {
  },
  getDraftMessage: (x) => "",
  getDraftRepliedMessageId: (x) => {
  },
  getDraftEditedMessageId: (x) => {
  },
  getLastInputText: (x) => "",
  getExternalProps: () => ({})
}), G1 = () => ({
  getParticipantsByIdsAsObject: (d) => ({}),
  getParticipantsByIdsAsList: (d) => [],
  getCurrentUser: () => _r,
  getUserById: (d) => _r,
  getOpponentByCid: (d, c) => _r || null,
  updateCurrentUserAvatar: (d) => {
  },
  updateCurrentUserPassword: (d, c) => {
  },
  updateCurrentUserFields: (d) => !0,
  deleteCurrentUser: () => !0
}), q1 = (e, t) => ze(() => _r, [e, t]), X1 = () => ({
  storeNewConversations: (d) => {
  },
  setSelectedConversation: (d) => {
  },
  getConversationById: (d) => _s,
  getSelectedConversation: () => _s,
  fetchConversations: async () => Promise.resolve([_s]),
  updateChatImage: (d) => {
  },
  updateNameAndDescription: (d) => !0,
  sendTypingStatus: (d) => {
  },
  deleteAndLeave: () => {
  }
});
function Z1() {
  return {
    deleteSelectedMessages: async (o, a) => {
    },
    getSelectedMessages: () => ({ countOfSelectedMessages: 0, midsArrayOfSelectedMessages: [""] }),
    summarizeMessages: async (o, a) => {
    },
    changeMessageTone: async (o, a) => "",
    editMessage: async (o, a, l) => "",
    createAndSendMessage: async (o, a, l, d, c, f, h) => ""
  };
}
function J1() {
  return {
    openContextMenu: (t, n, i) => {
    }
  };
}
const Q1 = {
  useDrafts: Y1,
  useParticipants: G1,
  useOpponentByCid: q1,
  useConversations: X1,
  useMessages: Z1,
  useContextMenu: J1,
  userUtils: {
    getLastMessageUserName: (e) => "",
    getUserFullName: (e) => "",
    getUserInitials: (e) => "",
    getLastVisitTime: (e, t) => ""
  },
  conversationUtils: {
    getLastUpdateTime: (e, t) => ""
  },
  mediaUtils: {
    getFileType: (e, t) => "",
    extractFilesFromClipboard: (e) => []
  },
  formatedUtils: {
    getFormatedTime: (e) => "string",
    calcInputHeight: (e) => 0
  }
};
let go = { ...Q1 };
function RS(e) {
  go = nf(go, e);
}
function at() {
  return go;
}
function nf(e, t) {
  const n = { ...e };
  return yr(e) && yr(t) && Object.keys(t).forEach((i) => {
    const r = t[i], s = e[i];
    Array.isArray(r) ? n[i] = Array.isArray(s) ? [...s, ...r] : [...r] : yr(r) ? n[i] = yr(s) ? nf(s, r) : r : n[i] = r;
  }), n;
}
function yr(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
const e2 = ({ avatarUrl: e, altText: t, fallbackIcon: n }) => {
  const [i, r] = de(n || /* @__PURE__ */ u.jsx(Nn, {}));
  return he(() => {
    if (!e) {
      r(n || /* @__PURE__ */ u.jsx(Nn, {}));
      return;
    }
    const s = new Image();
    s.src = e, s.onload = () => r(
      /* @__PURE__ */ u.jsx(
        "img",
        {
          "data-testid": "avatar-with-fallback",
          className: "ui:h-full ui:w-full ui:object-cover",
          src: e,
          alt: t
        }
      )
    ), s.onerror = () => r(n || /* @__PURE__ */ u.jsx(Nn, {}));
  }, [e, t, n]), /* @__PURE__ */ u.jsx(u.Fragment, { children: i });
}, t2 = ({ blurHash: e = "LEHLk~WB2yk8pyo0adR*.7kCMdnj", isShowLoader: t = !0 }) => /* @__PURE__ */ u.jsxs("div", { "data-testid": "image-loader", className: "ui:relative ui:h-full ui:w-full ui:overflow-hidden ui:rounded-lg", children: [
  /* @__PURE__ */ u.jsx(Qi, { hash: e, width: "100%", height: "100%", resolutionX: 32, resolutionY: 32, punch: 1 }),
  t && /* @__PURE__ */ u.jsx("div", { className: "ui:absolute ui:inset-0 ui:flex ui:items-center ui:justify-center", children: /* @__PURE__ */ u.jsx(Sn, { height: 35, width: 35 }) })
] }), rf = (e) => {
  let t = 0;
  for (let d = 0; d < e.length; d++)
    t = t * 31 + e.charCodeAt(d) | 0;
  const n = Math.abs(t) % 360, i = 55, r = 55, s = 10 + Math.abs(t) % 6, o = t % 2 === 0 ? 1 : -1, a = r, l = Math.min(90, Math.max(70, r + s * o));
  return `linear-gradient(
    25deg,
    hsl(${n}, ${i}%, ${a}%),
    hsl(${n}, ${i}%, ${l}%)
  )`;
}, jn = nt(function({
  customClassName: t = "",
  size: n = 64,
  avatarUrl: i,
  avatarBlurHash: r,
  defaultIcon: s,
  altText: o,
  bgColorKey: a,
  imageLoaderProps: l = {},
  className: d,
  style: c,
  ...f
}) {
  const h = ze(() => i ? /* @__PURE__ */ u.jsx(e2, { avatarUrl: i, altText: o, fallbackIcon: s }) : r ? /* @__PURE__ */ u.jsx(t2, { blurHash: r, ...l }) : s, [r, i, s, o, l]), p = `${n}px`, y = {
    width: p,
    height: p,
    background: rf(a || ""),
    ...c
  };
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(
        "ui:flex ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-3xl ui:font-light ui:text-white ui:uppercase",
        n > 50 ? "ui:text-2xl" : "ui:text-lg",
        t,
        d
      ),
      style: y,
      ...f,
      children: h
    }
  );
}), hu = nt(function({
  user: t,
  isCurrentUser: n = !1,
  size: i = Cx,
  fallbackCurrentUser: r,
  fallbackOtherUser: s,
  className: o,
  style: a,
  ...l
}) {
  var f;
  const { userUtils: d } = at();
  return t && Object.keys(t).length > 0 ? /* @__PURE__ */ u.jsx(ge, { className: o, style: a, ...l, children: /* @__PURE__ */ u.jsx(
    jn,
    {
      size: i,
      avatarUrl: t.avatar_url,
      avatarBlurHash: (f = t.avatar_object) == null ? void 0 : f.file_blur_hash,
      defaultIcon: d.getUserInitials(t),
      altText: "User's Profile",
      bgColorKey: t._id,
      customClassName: "ui:rounded-xl ui:cursor-pointer"
    }
  ) }) : n && r ? /* @__PURE__ */ u.jsx(ge, { className: o, style: a, ...l, children: r }) : !n && s ? /* @__PURE__ */ u.jsx(ge, { className: o, style: a, ...l, children: s }) : /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe("ui:flex ui:items-center ui:justify-center ui:rounded-xl ui:bg-bg-dark/10", o),
      style: { width: i, height: i, ...a },
      ...l,
      children: /* @__PURE__ */ u.jsx(Nn, { size: i * 0.5, className: "ui:text-text-dark/50" })
    }
  );
}), DS = Zi(function({
  message: t,
  sender: n,
  isCurrentUser: i,
  repliedMessage: r,
  bodyContent: s,
  attachmentsNode: o,
  linkPreviewNode: a,
  onUserProfile: l,
  onContextMenu: d,
  onSelectClick: c,
  onUnselectClick: f,
  onReplyClick: h,
  onVisible: p,
  onSwipeReply: y,
  isMobile: v = !1,
  isSelected: w = !1,
  isSelectionMode: x = !1,
  isLongTimeBetweenMessages: S = !1,
  isPrevMessageYours: k = !1,
  isNextMessageYours: P = !1,
  isBlockStart: j,
  isBlockEnd: N,
  showAuthor: C,
  showTimestamp: R,
  senderDisplayName: I = "",
  repliedMessageSenderName: U = "",
  swipeReplyThreshold: W = 50,
  onBubblePointerDown: ae,
  onBubblePointerUp: $,
  onBubblePointerLeave: V,
  onBubbleClick: K,
  hideUserIcon: se = !1,
  className: G,
  ...te
}, le) {
  const { _id: Ce, body: ce, from: q, attachments: ne, status: oe, t: ie, created_at: ye, updated_at: Me, old_id: Pe } = t, Ee = !!t.forwarded_message_id, _e = ye !== Me, Ye = !!(ne != null && ne.length), lt = !(N !== void 0 ? N : !P), Ct = C !== void 0 ? C : !k, We = R !== void 0 ? R : S || !P, wt = (() => {
    const $e = new Date(ie * 1e3);
    return `${$e.getHours()}:${$e.getMinutes() > 9 ? $e.getMinutes() : "0" + $e.getMinutes()}`;
  })(), He = ($e) => l == null ? void 0 : l($e), gt = ($e) => {
    $e.preventDefault(), $e.stopPropagation(), d == null || d($e, null, { message: t });
  }, ft = ($e) => {
    d == null || d($e, ce ? "Text" : null);
  };
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(
        "ui:flex ui:w-full ui:flex-row ui:flex-nowrap ui:items-end ui:gap-2.75",
        i ? "ui:justify-end" : "ui:justify-start",
        G
      ),
      onClick: x ? w ? () => f == null ? void 0 : f() : () => c == null ? void 0 : c() : void 0,
      onContextMenu: gt,
      ...te,
      children: [
        x && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: `ui:flex ui:h-11.5 ui:w-11.5 ui:items-center ui:justify-center ${i ? "ui:mr-auto" : ""}`,
            children: w ? /* @__PURE__ */ u.jsx("span", { className: "ui:flex ui:h-5.5 ui:w-5.5 ui:items-center ui:justify-center ui:rounded-full ui:bg-accent-500/70", children: /* @__PURE__ */ u.jsx(zr, { size: 14, color: "white" }) }) : /* @__PURE__ */ u.jsx("span", { className: "ui:h-5.5 ui:w-5.5 ui:rounded-full ui:border ui:border-black/50" })
          }
        ),
        /* @__PURE__ */ u.jsxs(
          Rs,
          {
            ref: le,
            "data-message-id": Ce,
            className: `ui:relative ui:flex ui:flex-row ui:gap-2.75 ${lt ? "" : "ui:mb-1.5"}`,
            drag: v ? "x" : !1,
            dragDirectionLock: !0,
            dragConstraints: { left: 0, right: 0 },
            onDragEnd: ($e, De) => {
              y && De.offset.x < -W && y();
            },
            whileDrag: { scale: 0.9 },
            children: [
              se ? null : /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:min-w-11.5 ui:items-end", children: lt || i ? null : /* @__PURE__ */ u.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => He(q),
                  className: "ui:cursor-pointer ui:border-0 ui:bg-transparent ui:p-0",
                  children: /* @__PURE__ */ u.jsx(
                    hu,
                    {
                      user: n,
                      isCurrentUser: i,
                      fallbackCurrentUser: /* @__PURE__ */ u.jsx(lr, { color: "white" }),
                      fallbackOtherUser: /* @__PURE__ */ u.jsx(lr, { color: "black" }),
                      className: "ui:flex ui:h-11.5 ui:w-11.5 ui:cursor-pointer ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-xl ui:bg-hover-light"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ u.jsxs(
                "div",
                {
                  className: `ui:flex ui:min-w-0 ui:flex-col ui:max-2xl:max-w-[min(80dvw,520px)] ui:2xl:max-w-[min(60%,520px)] ${i ? "ui:ml-auto" : "ui:mr-auto"}`,
                  children: [
                    Ct ? /* @__PURE__ */ u.jsxs(
                      "div",
                      {
                        className: fe(
                          "ui:mb-1.25 ui:cursor-pointer ui:truncate ui:text-text-dark/60",
                          i && "ui:w-full ui:text-end"
                        ),
                        onClick: () => He(q),
                        children: [
                          "‌",
                          I || "Deleted account"
                        ]
                      }
                    ) : null,
                    /* @__PURE__ */ u.jsxs(
                      "div",
                      {
                        className: `ui:flex ui:w-max ui:max-w-full ui:min-w-0 ui:flex-col ui:rounded-xl ui:shadow-btn ${lt ? "" : i ? "ui:rounded-br-none" : "ui:rounded-bl-none"} ${i ? "ui:self-end" : "ui:self-start"}`,
                        children: [
                          Ee ? /* @__PURE__ */ u.jsxs(
                            "div",
                            {
                              className: `ui:-mb-3 ui:flex ui:flex-row ui:flex-nowrap ui:items-center ui:gap-1.75 ui:rounded-t-xl ui:px-1 ui:pt-0.5 ui:pb-3 ${i ? "ui:bg-accent-500/65" : "ui:bg-bg-dark/5"}`,
                              children: [
                                /* @__PURE__ */ u.jsx(jo, { size: 18, color: i ? "white" : "var(--color-text-dark)" }),
                                /* @__PURE__ */ u.jsx("p", { className: `ui:text-sm ui:font-medium ${i ? "ui:text-white" : "ui:text-black/35"}`, children: "Forwarded" })
                              ]
                            }
                          ) : null,
                          r ? /* @__PURE__ */ u.jsx(
                            fx,
                            {
                              type: "reply",
                              color: i ? "white" : "accent",
                              message: r,
                              onClickFunc: h,
                              senderName: U
                            }
                          ) : null,
                          /* @__PURE__ */ u.jsx(
                            Rs,
                            {
                              className: `ui:relative ui:flex ui:min-h-11.5 ui:max-w-full ui:min-w-0 ui:flex-col ui:justify-between ui:gap-1 ui:rounded-xl ui:p-1 ${i ? "ui:bg-accent-100" : "ui:bg-white"} ${lt ? "" : i ? "ui:rounded-br-none" : "ui:rounded-bl-none"} ${Ee ? "ui:min-w-28" : "ui:min-w-14"} ${w ? "ui:bg-accent-200!" : ""} ${r ? "ui:w-full" : "ui:w-max"}`,
                              whileTap: v ? { scale: 0.95, transition: { duration: 0.3, delay: 0.05 } } : void 0,
                              onClick: K,
                              onPointerDown: ae,
                              onPointerUp: $,
                              onPointerLeave: V,
                              onContextMenu: x ? gt : ft,
                              children: /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-full ui:min-w-0 ui:flex-col ui:flex-wrap ui:overflow-hidden", children: [
                                Ye && o,
                                s,
                                !Ye && a
                              ] })
                            }
                          )
                        ]
                      }
                    ),
                    (_e || We) && /* @__PURE__ */ u.jsxs(
                      "div",
                      {
                        className: `ui:relative ui:mt-1.25 ui:mb-0.5 ui:flex ui:w-full ui:flex-row ui:items-center ui:gap-0.75 ui:self-end ${i ? "ui:justify-end" : "ui:justify-start"}`,
                        children: [
                          _e ? /* @__PURE__ */ u.jsx("span", { className: "ui:text-xs ui:leading-4.5 ui:text-text-dark/60", children: "edited" }) : null,
                          We && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                            /* @__PURE__ */ u.jsx("div", { className: "ui:text-xs ui:text-text-dark/60", children: wt }),
                            i ? /* @__PURE__ */ u.jsx(tf, { status: oe === "sent" || oe === "read" ? oe : void 0 }) : null
                          ] })
                        ]
                      }
                    )
                  ]
                }
              ),
              se ? null : /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:min-w-11.5 ui:items-end", children: lt || !i ? null : /* @__PURE__ */ u.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => He(q),
                  className: "ui:cursor-pointer ui:border-0 ui:bg-transparent ui:p-0",
                  children: /* @__PURE__ */ u.jsx(
                    hu,
                    {
                      user: n,
                      isCurrentUser: i,
                      fallbackCurrentUser: /* @__PURE__ */ u.jsx(lr, { color: "white" }),
                      fallbackOtherUser: /* @__PURE__ */ u.jsx(lr, { color: "black" })
                    }
                  )
                }
              ) })
            ]
          },
          Pe || Ce
        )
      ]
    }
  );
});
function n2(e, t) {
  return typeof t == "number" ? e.keyCode === t : e.key === t;
}
function i2(e) {
  return typeof e == "number" ? `n:${e}` : `s:${e}`;
}
function r2(e) {
  return e.startsWith("n:") ? Number(e.slice(2)) : e.slice(2);
}
const Ii = /* @__PURE__ */ new Map();
let pu = !1;
function s2(e) {
  for (const [t, n] of Ii) {
    if (n.length === 0 || !n2(e, r2(t))) continue;
    n[n.length - 1].callbackRef.current(e);
    return;
  }
}
function o2() {
  pu || (document.addEventListener("keydown", s2), pu = !0);
}
const dn = (e, t, n = !0) => {
  const i = pe(t), r = Ur();
  he(() => {
    i.current = t;
  }, [t]), he(() => {
    if (!n) return;
    o2();
    const s = i2(e);
    let o = Ii.get(s);
    o || (o = [], Ii.set(s, o));
    const a = { id: r, callbackRef: i };
    return o.push(a), () => {
      const l = Ii.get(s);
      if (!l) return;
      const d = l.findIndex((c) => c.id === r);
      d !== -1 && l.splice(d, 1), l.length === 0 && Ii.delete(s);
    };
  }, [e, r, n]);
}, IS = ({ onConfirm: e, onCancel: t, onValidationError: n, className: i, ...r }) => {
  const [s, o] = de(""), [a, l] = de(null), [d, c] = de(null), f = pe(null), h = Ne(() => {
    const v = s == null ? void 0 : s.trim();
    if (!(v != null && v.length)) {
      n == null || n("Enter a name for the group chat.");
      return;
    }
    if (v.length > Ja) {
      n == null || n(`The length of the chat name should not exceed ${Ja} characters.`);
      return;
    }
    e(v, d);
  }, [s, d, e, n]);
  dn(en.ENTER, h);
  const p = () => {
    var v;
    return (v = f.current) == null ? void 0 : v.click();
  }, y = (v) => {
    const w = Array.from(v.target.files ?? []).at(0);
    w && (c(w), l(URL.createObjectURL(w)));
  };
  return /* @__PURE__ */ u.jsxs(ge, { className: fe(i), ...r, children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:flex-row ui:gap-4", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:h-26 ui:w-26 ui:self-center", children: [
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: "ui:relative ui:flex ui:h-full ui:w-full ui:cursor-pointer ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-3xl",
            style: { background: rf("") },
            onClick: p,
            children: [
              a ? /* @__PURE__ */ u.jsx("img", { className: "ui:h-full ui:w-full ui:object-cover", src: a, alt: "Group" }) : /* @__PURE__ */ u.jsx(To, { size: 70, color: "white" }),
              /* @__PURE__ */ u.jsx(
                "input",
                {
                  id: "inputFile",
                  className: "ui:hidden",
                  ref: f,
                  type: "file",
                  onChange: y,
                  accept: Go.join(","),
                  multiple: !1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "ui:absolute ui:-right-1.25 ui:-bottom-1.25 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:rounded-full ui:border-4 ui:border-bg-light ui:bg-accent-500 ui:p-2",
            onClick: p,
            children: /* @__PURE__ */ u.jsx(So, { size: 28, color: "white" })
          }
        )
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:flex-col ui:justify-center ui:gap-2", children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:text-lg ui:font-normal ui:text-black", children: "Group name" }),
        /* @__PURE__ */ u.jsx(
          "input",
          {
            className: "ui:text-p ui:shrink ui:rounded-xl ui:bg-hover-light ui:px-4 ui:py-2 ui:font-light ui:text-black ui:focus:outline-none",
            placeholder: "Enter group name",
            value: s,
            onChange: (v) => o(v.target.value),
            autoFocus: !0
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ u.jsx("hr", { className: "ui:my-2.75 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:justify-between ui:gap-8", children: [
      /* @__PURE__ */ u.jsx("button", { className: "ui:cursor-pointer ui:px-3 ui:font-light ui:text-text-dark/75", onClick: t, children: "Cancel" }),
      /* @__PURE__ */ u.jsx(
        "button",
        {
          className: "ui:flex ui:cursor-pointer ui:items-center ui:gap-2.75 ui:rounded-xl ui:bg-accent-500 ui:px-6 ui:py-2 ui:text-white ui:duration-150 ui:hover:bg-black",
          onClick: h,
          children: "Continue"
        }
      )
    ] })
  ] });
}, a2 = "ui:absolute ui:z-150 ui:flex ui:w-50 ui:flex-col ui:gap-px ui:rounded-xl ui:bg-white ui:p-3 ui:shadow-md ui:animate-context-menu-pop-in ui:origin-top-left", OS = nt(function({
  position: t,
  children: n,
  className: i = "",
  style: r,
  ...s
}) {
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(a2, i),
      style: { left: t.x, top: t.y, ...r },
      role: "menu",
      ...s,
      children: n
    }
  );
}), l2 = ({
  wrapperClassName: e = "",
  mainColor: t = "var(--color-accent-500)",
  width: n = 16,
  height: i = 22
}) => /* @__PURE__ */ u.jsx(
  sx,
  {
    visible: !0,
    height: i,
    width: n,
    color: t,
    radius: "9",
    ariaLabel: "three-dots-loading",
    wrapperClass: e
  }
), sf = nt(function({
  typingUserIds: t,
  isDisplayUserNames: n = !1,
  isDisplayBackground: i = !1,
  className: r,
  ...s
}) {
  const { useParticipants: o, userUtils: a } = at(), { getParticipantsByIdsAsList: l } = o(), d = ze(
    () => t != null && t.length ? l(t) : [],
    [t, l]
  ), c = ze(() => {
    if (!n || !(d != null && d.length)) return "";
    const f = d.length;
    return f > 2 ? `${a.getLastMessageUserName(d[0])} and ${f - 1} more ` : d.map((h, p) => `${a.getLastMessageUserName(h)}${p !== f - 1 ? ", " : " "}`).join("");
  }, [d, n, a]);
  return /* @__PURE__ */ u.jsxs(ge, { className: fe("ui:flex ui:items-center ui:gap-2.5", r), ...s, children: [
    /* @__PURE__ */ u.jsx(l2, { height: 22, width: 16 }),
    /* @__PURE__ */ u.jsxs("p", { className: "ui:font-light ui:text-accent-500", children: [
      c,
      "typing"
    ] })
  ] });
}), LS = ({
  conversation: e,
  isSelectionMode: t,
  currentTab: n,
  changeTabFunc: i,
  closeFormFunc: r,
  closeIcon: s,
  onForwardSection: o,
  onCloseSelectionMode: a,
  onOpenChatOrParticipantInfo: l,
  className: d,
  ...c
}) => {
  var q;
  const { useParticipants: f, useOpponentByCid: h, useMessages: p, useContextMenu: y, userUtils: v } = at(), { getCurrentUser: w } = f(), { deleteSelectedMessages: x, getSelectedMessages: S } = p(), { openContextMenu: k } = y(), { getLastVisitTime: P, getUserFullName: j } = v, N = w(), C = N._id, R = e, I = R._id, U = C === ((q = R.owner_id) == null ? void 0 : q.toString()), W = R.type === "g", ae = N.login.startsWith("sama-user-"), $ = h(I, C), V = $ == null ? void 0 : $._id, K = !!$, se = ze(() => R.name ? R.name : K ? j($) : "Deleted account", [R, V]), G = ze(() => {
    var oe, ie;
    if ((oe = R.typing_users) != null && oe.length)
      return /* @__PURE__ */ u.jsx("div", { className: "ui:text-text-light", children: /* @__PURE__ */ u.jsx(
        sf,
        {
          typingUserIds: R.typing_users,
          isDisplayBackground: W,
          isDisplayUserNames: W
        }
      ) });
    if (R.type === "u") {
      if (!K) return null;
      const ye = $.recent_activity;
      return /* @__PURE__ */ u.jsx("div", { className: "ui:text-sm ui:text-text-light", children: ye === 0 ? /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:gap-2", children: [
        /* @__PURE__ */ u.jsx("span", { className: "ui:h-1.25 ui:w-1.25 ui:shrink-0 ui:rounded-full ui:bg-accent-500", "aria-hidden": !0 }),
        /* @__PURE__ */ u.jsx("span", { className: "ui:font-light ui:text-accent-500", children: "online" })
      ] }) : P(ye) });
    }
    const ne = ((ie = R.participants) == null ? void 0 : ie.length) || 0;
    return /* @__PURE__ */ u.jsxs("p", { className: "ui:text-sm ui:font-light ui:text-text-light", children: [
      ne,
      " member",
      ne > 1 ? "s" : ""
    ] });
  }, [$, R]), te = () => {
    if (!W && !K) {
      console.warn("This account has been deleted.");
      return;
    }
    l == null || l(R, $ ?? null);
  }, le = (ne) => {
    ne.preventDefault(), ne.stopPropagation(), k(
      "conversation",
      [
        //currentPath.includes("/info")
        !K && !W ? null : "convInfo",
        U && W ? "convEdit" : null,
        U && W ? "convAddParticipants" : null,
        ae ? null : "convLeave"
      ].filter((oe) => oe !== null),
      { x: ne.pageX, y: ne.pageY }
    );
  }, { countOfSelectedMessages: Ce, midsArrayOfSelectedMessages: ce } = S() || {};
  return dn(en.ESCAPE, () => a == null ? void 0 : a(), t), t ? /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(
        "ui:flex ui:max-h-15 ui:min-h-[59px] ui:w-full ui:gap-2.5 ui:rounded-xl ui:pt-3.5 ui:pb-1",
        d
      ),
      ...c,
      children: [
        /* @__PURE__ */ u.jsxs(
          "button",
          {
            className: "ui:flex ui:h-max ui:cursor-pointer ui:items-center ui:gap-1.5 ui:self-center ui:rounded-xl ui:bg-accent-500 ui:px-2.5 ui:py-1.5 ui:text-white ui:shadow-btn",
            onClick: o,
            children: [
              /* @__PURE__ */ u.jsx(jo, { size: 18, color: "white" }),
              /* @__PURE__ */ u.jsx("p", { className: "ui:text-base", children: "Forward" }),
              /* @__PURE__ */ u.jsx("span", { className: "ui:text-white/75", children: Ce })
            ]
          }
        ),
        /* @__PURE__ */ u.jsxs(
          "button",
          {
            className: "ui:flex ui:h-max ui:cursor-pointer ui:items-center ui:gap-1.5 ui:self-center ui:rounded-xl ui:bg-accent-500 ui:px-2.5 ui:py-1.5 ui:text-white ui:shadow-btn",
            onClick: async () => await x(I, ce),
            children: [
              /* @__PURE__ */ u.jsx(Fu, { size: 18, color: "white" }),
              /* @__PURE__ */ u.jsx("p", { className: "ui:text-base", children: "Delete" }),
              /* @__PURE__ */ u.jsx("span", { className: "ui:text-white/75", children: Ce })
            ]
          }
        ),
        /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "ui:ml-auto ui:h-max ui:cursor-pointer ui:self-center ui:p-1.5 ui:font-normal ui:text-accent-500",
            onClick: a,
            children: "Cancel"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe("ui:flex ui:h-15 ui:max-h-15 ui:w-full ui:gap-2.5 ui:rounded-xl ui:pt-2 ui:pb-1", d),
      ...c,
      children: [
        /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "ui:h-max ui:cursor-pointer ui:self-center ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white",
            onClick: r,
            children: s ?? /* @__PURE__ */ u.jsx(Wr, { size: 18 })
          }
        ),
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: "ui:flex ui:max-w-[calc(100%-92px)] ui:flex-1 ui:cursor-pointer ui:flex-col ui:justify-center",
            onClick: te,
            children: [
              /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-lg ui:leading-normal ui:font-medium ui:text-ellipsis ui:whitespace-nowrap ui:text-black", children: se }),
              G
            ]
          }
        ),
        U && W ? /* @__PURE__ */ u.jsx("div", { className: "flex gap-1.5", children: /* @__PURE__ */ u.jsx(
          "button",
          {
            className: `ui:h-max ui:cursor-pointer ui:self-center ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white ui:focus:outline-none ${n === "apps" ? "ui:bg-bg-dark! ui:text-white" : ""}`,
            onClick: () => i(n === "messages" ? Za.APPS : Za.MESSAGES),
            children: /* @__PURE__ */ u.jsx(sh, { size: 18 })
          }
        ) }) : null,
        /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "ui:h-max ui:cursor-pointer ui:self-center ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white",
            onContextMenu: le,
            onClick: le,
            children: /* @__PURE__ */ u.jsx(ah, { size: 18 })
          }
        )
      ]
    }
  );
}, Ti = ({
  containerRef: e,
  children: t,
  onScroll: n,
  onScrollStop: i,
  isScrollToBottomVisible: r = !1,
  onScrollToBottom: s,
  minThumbHeight: o = Ex,
  autoHideDelay: a = _x,
  hoverShowDelay: l = Nx,
  containerId: d,
  customId: c,
  persistScrollPosition: f = !0,
  className: h = "",
  contentClassName: p = "",
  customClassName: y = "",
  childrenClassName: v = "",
  customStyle: w,
  autoHeight: x = !1,
  autoHeightMax: S,
  ...k
}) => {
  const P = pe(null), j = e ?? P, N = d ?? c, C = !!N && f, R = pe(null), I = pe(null), U = pe(null), W = pe(null), [ae, $] = de(!1), V = h || y, K = p || v, se = Ne(() => {
    U.current && (clearTimeout(U.current), U.current = null);
  }, []), G = Ne(
    (oe = a) => {
      se(), U.current = setTimeout(() => {
        $(!1), U.current = null;
      }, oe);
    },
    [a, se]
  ), te = Ne(() => {
    const oe = j.current, ie = I.current, ye = R.current;
    if (!oe || !ie || !ye) return;
    const { scrollTop: Me, scrollHeight: Pe, clientHeight: Ee } = oe, _e = Pe - Ee;
    if (_e <= 0) {
      ie.style.height = "0", ie.style.transform = "translateY(0)", n == null || n(Pe - Me - Ee);
      return;
    }
    const Ye = Math.max(Ee / Pe * ye.clientHeight, o), Re = Me / _e * (ye.clientHeight - Ye);
    ie.style.height = `${Ye}px`, ie.style.transform = `translateY(${Re}px)`, $(!0), G(a);
    const lt = Pe - Me - Ee;
    n == null || n(lt), (C || i) && (W.current && clearTimeout(W.current), W.current = setTimeout(() => {
      if (C && oe)
        try {
          localStorage.setItem(`scroll_pos_${N}`, String(oe.scrollTop));
        } catch {
        }
      i == null || i(oe.scrollTop), W.current = null;
    }, Ax));
  }, [
    j,
    N,
    C,
    o,
    a,
    n,
    i,
    G
  ]), le = pe(te);
  le.current = te, he(() => {
    const oe = j.current;
    if (!oe) return;
    if (C)
      try {
        const Me = localStorage.getItem(`scroll_pos_${N}`);
        Me != null && (oe.scrollTop = Number(Me));
      } catch {
      }
    const ie = () => le.current();
    oe.addEventListener("scroll", ie, { passive: !0 }), ie();
    const ye = new ResizeObserver(() => ie());
    return ye.observe(oe), () => {
      oe.removeEventListener("scroll", ie), ye.disconnect(), W.current && clearTimeout(W.current);
    };
  }, [j, N, C]);
  const Ce = Ne(
    (oe) => {
      oe.preventDefault();
      const ie = j.current, ye = R.current;
      if (!ie || !ye) return;
      const Me = oe.clientY, Pe = ie.scrollTop, Ee = (Ye) => {
        const Re = (Ye.clientY - Me) * (ie.scrollHeight / ye.clientHeight);
        ie.scrollTop = Math.max(
          0,
          Math.min(ie.scrollHeight - ie.clientHeight, Pe + Re)
        );
      }, _e = () => {
        document.removeEventListener("mousemove", Ee), document.removeEventListener("mouseup", _e);
      };
      document.addEventListener("mousemove", Ee), document.addEventListener("mouseup", _e);
    },
    [j]
  ), ce = Ne(() => {
    se(), $(!0);
  }, [se]), q = Ne(() => {
    G(l);
  }, [G, l]);
  he(() => () => se(), [se]);
  const ne = {
    ...w,
    ...x && S != null ? { maxHeight: typeof S == "number" ? `${S}px` : S } : {}
  };
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(
        "custom-vertical-scrollbar ui:relative ui:flex ui:w-full ui:max-w-full ui:min-w-0 ui:grow ui:flex-col ui:self-center ui:overflow-hidden",
        V
      ),
      style: Object.keys(ne).length ? ne : void 0,
      ...k,
      children: [
        /* @__PURE__ */ u.jsx(
          "div",
          {
            ref: j,
            id: N,
            className: `ui:h-full ui:w-full ui:min-w-0 ui:overflow-y-scroll ui:[&::-webkit-scrollbar]:hidden ${K}`,
            onScroll: te,
            children: t
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            ref: R,
            className: `ui:absolute ui:top-0 ui:right-1 ui:h-full ui:w-1.5 ui:transition-opacity ui:duration-250 ${ae ? "" : "ui:opacity-0"}`,
            onMouseEnter: ce,
            onMouseLeave: q,
            role: "scrollbar",
            "aria-orientation": "vertical",
            children: /* @__PURE__ */ u.jsx(
              "div",
              {
                ref: I,
                className: "ui:active:ui:cursor-grabbing ui:absolute ui:top-0 ui:w-full ui:cursor-grab ui:rounded-full ui:bg-black/30",
                onMouseDown: Ce
              }
            )
          }
        ),
        r && s && /* @__PURE__ */ u.jsx(
          "button",
          {
            type: "button",
            className: "ui:absolute ui:right-0.75 ui:bottom-4 ui:z-4 ui:flex ui:h-10 ui:w-10 ui:cursor-pointer ui:items-center ui:justify-center ui:rounded-xl ui:border-0 ui:bg-white ui:shadow-btn",
            onClick: s,
            "aria-label": "Scroll to bottom",
            children: /* @__PURE__ */ u.jsx(Gf, { size: 24 })
          }
        )
      ]
    }
  );
}, of = nt(function({
  conversation: t,
  isEditDisabled: n,
  className: i,
  ...r
}) {
  var c;
  const { useConversations: s } = at(), { updateChatImage: o } = s(), a = pe(null), l = Ne(() => {
    var f;
    return (f = a.current) == null ? void 0 : f.click();
  }, []), d = Ne(
    async (f) => {
      f && await o(f);
    },
    [o]
  );
  return /* @__PURE__ */ u.jsxs(ge, { className: fe("ui:relative ui:h-30 ui:w-30 ui:self-center", i), ...r, children: [
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: "ui:flex ui:h-full ui:w-full ui:items-center ui:justify-center ui:gap-2.75 ui:overflow-hidden ui:rounded-3xl ui:bg-hover-light",
        children: [
          /* @__PURE__ */ u.jsx(
            jn,
            {
              size: 120,
              avatarUrl: t.image_url,
              avatarBlurHash: (c = t.image_object) == null ? void 0 : c.file_blur_hash,
              defaultIcon: /* @__PURE__ */ u.jsx(To, { size: 80, color: "white" }),
              altText: "Chat Group",
              bgColorKey: t._id
            }
          ),
          /* @__PURE__ */ u.jsx(
            "input",
            {
              id: "inputFile",
              className: "ui:invisible ui:hidden",
              ref: a,
              type: "file",
              onChange: (f) => d(Array.from(f.target.files ?? []).at(0)),
              accept: Go.join(","),
              multiple: !0
            }
          )
        ]
      }
    ),
    n ? null : /* @__PURE__ */ u.jsx(
      "div",
      {
        className: "ui:absolute ui:-right-1.25 ui:-bottom-1.25 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:rounded-full ui:border-4 ui:border-bg-light ui:bg-accent-500 ui:p-2",
        onClick: l,
        children: /* @__PURE__ */ u.jsx(So, { size: 28, color: "white" })
      }
    )
  ] });
}), u2 = "ui:relative ui:flex ui:w-full ui:cursor-pointer ui:items-center ui:gap-3.75 ui:rounded-2xl ui:px-1.5 ui:py-2.5 ui:duration-100 ui:hover:bg-accent-500/20 ui:focus:outline-none", c2 = ({
  user: e,
  isOwner: t,
  isCurrentUserOwner: n,
  onOpenProfile: i,
  onRequestContextMenu: r,
  className: s,
  onClick: o,
  onContextMenu: a,
  ...l
}) => {
  var S;
  const { useParticipants: d, userUtils: c } = at(), { getCurrentUser: f } = d(), { getUserInitials: h, getUserFullName: p } = c, v = f()._id === e._id, w = () => {
    i == null || i(v ? null : e._id);
  }, x = (k) => {
    k.preventDefault(), r == null || r({
      category: "conversation",
      list: [
        "participantInfo",
        v ? null : "participantSendMessage",
        !n || v ? null : "convRemoveParticipants"
      ],
      coords: { x: k.pageX, y: k.pageY },
      externalProps: { userObject: e },
      clicked: !0
    });
  };
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(u2, s),
      onClick: (k) => {
        w(), o == null || o(k);
      },
      onContextMenu: (k) => {
        x(k), a == null || a(k);
      },
      ...l,
      children: [
        /* @__PURE__ */ u.jsx(
          jn,
          {
            size: 60,
            avatarUrl: e.avatar_url,
            avatarBlurHash: (S = e.avatar_object) == null ? void 0 : S.file_blur_hash,
            defaultIcon: e ? h(e) : null,
            bgColorKey: e._id
          }
        ),
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:flex-col ui:gap-0.75 ui:overflow-hidden", children: [
          /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-lg ui:text-ellipsis ui:whitespace-nowrap", children: p(e) }),
          t ? /* @__PURE__ */ u.jsx("span", { className: "ui:text-sm ui:text-accent-500", children: "admin" }) : null
        ] })
      ]
    }
  );
}, d2 = 0.25, af = Rn(null), VS = ({ children: e }) => {
  var y;
  const [t, n] = de(!1), [i, r] = de({}), [s, o] = de(null), [a, l] = de(null), d = pe(null), c = (v) => (r(v), o(v.initialData ?? {}), n(!0), new Promise((w) => {
    l(() => w);
  })), f = Ne(
    (v) => {
      a && (d.current = { isConfirm: v, data: s, resolver: a }, n(!1));
    },
    [a, s]
  ), h = Ne(() => {
    const v = d.current;
    v && (v.resolver({ isConfirm: v.isConfirm, data: v.data }), d.current = null);
  }, []), p = (v) => {
    v.target === v.currentTarget && f(!1);
  };
  return dn(en.ESCAPE, () => f(!1), t), dn(en.ENTER, () => f(!0), t), /* @__PURE__ */ u.jsxs(af.Provider, { value: { requestConfirm: c }, children: [
    e,
    /* @__PURE__ */ u.jsx(zc, { onExitComplete: h, children: t ? /* @__PURE__ */ u.jsx(
      mo.div,
      {
        className: "ui:fixed ui:inset-0 ui:z-200 ui:flex ui:w-screen ui:max-w-none ui:items-center ui:justify-center ui:bg-black/50 ui:[-webkit-tap-highlight-color:transparent] ui:isolate",
        style: fa,
        initial: { opacity: 1 },
        animate: { opacity: 1 },
        exit: { opacity: 1 },
        transition: { duration: 0 },
        onClick: p,
        children: /* @__PURE__ */ u.jsxs(
          mo.div,
          {
            className: "ui:w-100 ui:max-w-sm ui:origin-center ui:justify-center ui:rounded-3xl ui:bg-bg-light ui:px-6 ui:pt-6 ui:pb-4 ui:shadow-xl ui:will-change-transform",
            initial: { scale: 0.96 },
            animate: { scale: 1 },
            exit: { scale: 0.96 },
            transition: { duration: d2, ease: "easeOut" },
            onClick: (v) => v.stopPropagation(),
            children: [
              i.icon && /* @__PURE__ */ u.jsx("div", { className: "ui:mb-4 ui:flex ui:justify-center", children: i.icon }),
              i.title && /* @__PURE__ */ u.jsx("h2", { className: "ui:mb-2 ui:text-center ui:text-xl ui:font-medium", children: i.title }),
              i.description && /* @__PURE__ */ u.jsx("p", { className: "ui:mb-4 ui:text-center ui:font-light ui:text-text-dark", children: i.description }),
              ((y = i.actions) == null ? void 0 : y.length) && /* @__PURE__ */ u.jsx("div", { className: "ui:mb-4 ui:space-y-3", children: i.actions.map((v, w) => /* @__PURE__ */ u.jsx(v, { data: s, setData: o }, w)) }),
              /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-4 ui:mb-2.75 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
              /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:justify-between", children: [
                /* @__PURE__ */ u.jsx(
                  "button",
                  {
                    className: "ui:cursor-pointer ui:px-3 ui:font-light ui:text-text-dark/75",
                    onClick: () => f(!1),
                    children: i.cancelText ?? "Cancel"
                  }
                ),
                /* @__PURE__ */ u.jsx(
                  "button",
                  {
                    className: fe(
                      "ui:cursor-pointer ui:rounded-lg ui:px-6 ui:py-2 ui:text-white ui:hover:bg-black",
                      i.color === "success" ? "ui:bg-green-800" : "ui:bg-red-500"
                    ),
                    onClick: () => f(!0),
                    children: i.confirmText ?? "Confirm"
                  }
                )
              ] })
            ]
          }
        )
      },
      "confirm-window"
    ) : null })
  ] });
}, lf = () => {
  const e = ut(af);
  if (!e)
    throw new Error("useConfirmWindow must be used within ConfirmWindowProvider");
  return e.requestConfirm;
}, $S = ({
  conversation: e,
  isMobile: t,
  onClose: n,
  onEditConversation: i,
  onAddParticipants: r,
  onParticipantOpenProfile: s,
  onParticipantContextMenu: o,
  className: a,
  ...l
}) => {
  var C, R;
  if (!e) return null;
  const { useParticipants: d, useConversations: c } = at(), { getParticipantsByIdsAsObject: f, getCurrentUser: h } = d(), { deleteAndLeave: p } = c(), y = lf(), v = f(e.participants || []), w = (C = h()) == null ? void 0 : C._id, x = (R = e.owner_id) == null ? void 0 : R.toString(), S = ze(() => {
    var I;
    return !w || !e ? !1 : w === ((I = e.owner_id) == null ? void 0 : I.toString());
  }, [w, e]), k = Ne(() => n(), [n]);
  dn(en.ENTER, (I) => I.preventDefault()), dn(en.ESCAPE, k);
  const P = ze(() => !e.participants || !w ? null : e.participants.map((I) => {
    const U = v[I];
    if (!U) return null;
    const W = U._id === x;
    return /* @__PURE__ */ u.jsx(
      c2,
      {
        user: U,
        isOwner: W,
        isCurrentUserOwner: S,
        onOpenProfile: s,
        onRequestContextMenu: o
      },
      I
    );
  }), [e, v, w]), j = (P == null ? void 0 : P.length) || 0, N = async () => {
    const { isConfirm: I } = await y({
      title: "Delate And Leave",
      description: "Do you want to delete this chat?",
      icon: /* @__PURE__ */ u.jsx(bh, { size: 40, color: "red", strokeWidth: 2 })
    });
    I && p();
  };
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      as: "section",
      className: fe(
        "ui:flex ui:min-h-0 ui:flex-col ui:gap-2.75 ui:bg-bg-light ui:p-3.5",
        t ? "ui:h-full ui:max-h-dvh ui:min-h-dvh ui:w-full ui:flex-1 ui:overflow-y-auto ui:overscroll-y-contain" : "ui:h-full ui:max-h-dvh ui:w-100 ui:min-w-100 ui:overflow-hidden",
        a
      ),
      ...l,
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-2.75", children: [
          /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:justify-between ui:gap-2.5", children: /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:mb-1.5 ui:cursor-pointer ui:self-end ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white",
              onClick: n,
              children: /* @__PURE__ */ u.jsx(Dn, { size: 18 })
            }
          ) }),
          /* @__PURE__ */ u.jsx(of, { conversation: e, isEditDisabled: !S }),
          /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-4/5 ui:flex-col ui:gap-2.75", children: [
            /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-center ui:text-2xl ui:font-medium ui:text-ellipsis ui:whitespace-nowrap", children: e.name || "Group name" }),
            e.description ? /* @__PURE__ */ u.jsx("p", { className: "ui:line-clamp-2 ui:max-h-12 ui:overflow-hidden ui:text-center ui:text-text-dark", children: e.description }) : null,
            S ? /* @__PURE__ */ u.jsx(
              "p",
              {
                className: "ui:-mt-1.75 ui:cursor-pointer ui:text-center ui:text-lg ui:text-accent-500",
                onClick: i,
                children: "Edit Group Info"
              }
            ) : null
          ] })
        ] }),
        /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-5 ui:mb-2.5 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:min-h-100 ui:flex-1 ui:flex-col ui:gap-2.75", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:justify-between ui:gap-2.75", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:gap-1.75 ui:rounded-xl ui:bg-bg-dark/5 ui:p-2 ui:text-text-dark", children: [
              /* @__PURE__ */ u.jsx(Co, { size: 18 }),
              /* @__PURE__ */ u.jsxs("p", { className: "ui:text-sm", children: [
                j,
                " member",
                j > 1 ? "s" : ""
              ] })
            ] }),
            S ? /* @__PURE__ */ u.jsx(
              "button",
              {
                className: "ui:cursor-pointer ui:rounded-xl ui:bg-hover-light ui:p-2 ui:duration-150 ui:hover:bg-accent-500 ui:hover:text-white",
                onClick: r,
                children: /* @__PURE__ */ u.jsx(Xh, { size: 18 })
              }
            ) : null
          ] }),
          /* @__PURE__ */ u.jsx(Ti, { className: "ui:flex ui:flex-1 ui:flex-col ui:overflow-hidden", children: P })
        ] }),
        /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-auto ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
        /* @__PURE__ */ u.jsxs(
          "button",
          {
            className: "ui:mt-2.75 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:gap-2.75 ui:rounded-xl ui:bg-white ui:p-2 ui:text-danger ui:shadow-btn ui:duration-150 ui:hover:bg-danger ui:hover:text-white",
            onClick: N,
            children: [
              /* @__PURE__ */ u.jsx($u, { size: 18 }),
              " Leave Group"
            ]
          }
        )
      ]
    }
  );
};
function vr(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ns = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
var mu;
function f2() {
  return mu || (mu = 1, function(e, t) {
    (function(n) {
      e.exports = n();
    })(function() {
      return function n(i, r, s) {
        function o(d, c) {
          if (!r[d]) {
            if (!i[d]) {
              var f = typeof vr == "function" && vr;
              if (!c && f) return f(d, !0);
              if (a) return a(d, !0);
              var h = new Error("Cannot find module '" + d + "'");
              throw h.code = "MODULE_NOT_FOUND", h;
            }
            var p = r[d] = { exports: {} };
            i[d][0].call(p.exports, function(y) {
              var v = i[d][1][y];
              return o(v || y);
            }, p, p.exports, n, i, r, s);
          }
          return r[d].exports;
        }
        for (var a = typeof vr == "function" && vr, l = 0; l < s.length; l++) o(s[l]);
        return o;
      }({ 1: [function(n, i, r) {
        (function(s) {
          var o = s.MutationObserver || s.WebKitMutationObserver, a;
          if (o) {
            var l = 0, d = new o(y), c = s.document.createTextNode("");
            d.observe(c, {
              characterData: !0
            }), a = function() {
              c.data = l = ++l % 2;
            };
          } else if (!s.setImmediate && typeof s.MessageChannel < "u") {
            var f = new s.MessageChannel();
            f.port1.onmessage = y, a = function() {
              f.port2.postMessage(0);
            };
          } else "document" in s && "onreadystatechange" in s.document.createElement("script") ? a = function() {
            var w = s.document.createElement("script");
            w.onreadystatechange = function() {
              y(), w.onreadystatechange = null, w.parentNode.removeChild(w), w = null;
            }, s.document.documentElement.appendChild(w);
          } : a = function() {
            setTimeout(y, 0);
          };
          var h, p = [];
          function y() {
            h = !0;
            for (var w, x, S = p.length; S; ) {
              for (x = p, p = [], w = -1; ++w < S; )
                x[w]();
              S = p.length;
            }
            h = !1;
          }
          i.exports = v;
          function v(w) {
            p.push(w) === 1 && !h && a();
          }
        }).call(this, typeof or < "u" ? or : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}], 2: [function(n, i, r) {
        var s = n(1);
        function o() {
        }
        var a = {}, l = ["REJECTED"], d = ["FULFILLED"], c = ["PENDING"];
        i.exports = f;
        function f(j) {
          if (typeof j != "function")
            throw new TypeError("resolver must be a function");
          this.state = c, this.queue = [], this.outcome = void 0, j !== o && v(this, j);
        }
        f.prototype.catch = function(j) {
          return this.then(null, j);
        }, f.prototype.then = function(j, N) {
          if (typeof j != "function" && this.state === d || typeof N != "function" && this.state === l)
            return this;
          var C = new this.constructor(o);
          if (this.state !== c) {
            var R = this.state === d ? j : N;
            p(C, R, this.outcome);
          } else
            this.queue.push(new h(C, j, N));
          return C;
        };
        function h(j, N, C) {
          this.promise = j, typeof N == "function" && (this.onFulfilled = N, this.callFulfilled = this.otherCallFulfilled), typeof C == "function" && (this.onRejected = C, this.callRejected = this.otherCallRejected);
        }
        h.prototype.callFulfilled = function(j) {
          a.resolve(this.promise, j);
        }, h.prototype.otherCallFulfilled = function(j) {
          p(this.promise, this.onFulfilled, j);
        }, h.prototype.callRejected = function(j) {
          a.reject(this.promise, j);
        }, h.prototype.otherCallRejected = function(j) {
          p(this.promise, this.onRejected, j);
        };
        function p(j, N, C) {
          s(function() {
            var R;
            try {
              R = N(C);
            } catch (I) {
              return a.reject(j, I);
            }
            R === j ? a.reject(j, new TypeError("Cannot resolve promise with itself")) : a.resolve(j, R);
          });
        }
        a.resolve = function(j, N) {
          var C = w(y, N);
          if (C.status === "error")
            return a.reject(j, C.value);
          var R = C.value;
          if (R)
            v(j, R);
          else {
            j.state = d, j.outcome = N;
            for (var I = -1, U = j.queue.length; ++I < U; )
              j.queue[I].callFulfilled(N);
          }
          return j;
        }, a.reject = function(j, N) {
          j.state = l, j.outcome = N;
          for (var C = -1, R = j.queue.length; ++C < R; )
            j.queue[C].callRejected(N);
          return j;
        };
        function y(j) {
          var N = j && j.then;
          if (j && (typeof j == "object" || typeof j == "function") && typeof N == "function")
            return function() {
              N.apply(j, arguments);
            };
        }
        function v(j, N) {
          var C = !1;
          function R(ae) {
            C || (C = !0, a.reject(j, ae));
          }
          function I(ae) {
            C || (C = !0, a.resolve(j, ae));
          }
          function U() {
            N(I, R);
          }
          var W = w(U);
          W.status === "error" && R(W.value);
        }
        function w(j, N) {
          var C = {};
          try {
            C.value = j(N), C.status = "success";
          } catch (R) {
            C.status = "error", C.value = R;
          }
          return C;
        }
        f.resolve = x;
        function x(j) {
          return j instanceof this ? j : a.resolve(new this(o), j);
        }
        f.reject = S;
        function S(j) {
          var N = new this(o);
          return a.reject(N, j);
        }
        f.all = k;
        function k(j) {
          var N = this;
          if (Object.prototype.toString.call(j) !== "[object Array]")
            return this.reject(new TypeError("must be an array"));
          var C = j.length, R = !1;
          if (!C)
            return this.resolve([]);
          for (var I = new Array(C), U = 0, W = -1, ae = new this(o); ++W < C; )
            $(j[W], W);
          return ae;
          function $(V, K) {
            N.resolve(V).then(se, function(G) {
              R || (R = !0, a.reject(ae, G));
            });
            function se(G) {
              I[K] = G, ++U === C && !R && (R = !0, a.resolve(ae, I));
            }
          }
        }
        f.race = P;
        function P(j) {
          var N = this;
          if (Object.prototype.toString.call(j) !== "[object Array]")
            return this.reject(new TypeError("must be an array"));
          var C = j.length, R = !1;
          if (!C)
            return this.resolve([]);
          for (var I = -1, U = new this(o); ++I < C; )
            W(j[I]);
          return U;
          function W(ae) {
            N.resolve(ae).then(function($) {
              R || (R = !0, a.resolve(U, $));
            }, function($) {
              R || (R = !0, a.reject(U, $));
            });
          }
        }
      }, { 1: 1 }], 3: [function(n, i, r) {
        (function(s) {
          typeof s.Promise != "function" && (s.Promise = n(2));
        }).call(this, typeof or < "u" ? or : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { 2: 2 }], 4: [function(n, i, r) {
        var s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
          return typeof m;
        } : function(m) {
          return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
        };
        function o(m, T) {
          if (!(m instanceof T))
            throw new TypeError("Cannot call a class as a function");
        }
        function a() {
          try {
            if (typeof indexedDB < "u")
              return indexedDB;
            if (typeof webkitIndexedDB < "u")
              return webkitIndexedDB;
            if (typeof mozIndexedDB < "u")
              return mozIndexedDB;
            if (typeof OIndexedDB < "u")
              return OIndexedDB;
            if (typeof msIndexedDB < "u")
              return msIndexedDB;
          } catch {
            return;
          }
        }
        var l = a();
        function d() {
          try {
            if (!l || !l.open)
              return !1;
            var m = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), T = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
            return (!m || T) && typeof indexedDB < "u" && // some outdated implementations of IDB that appear on Samsung
            // and HTC Android devices <4.4 are missing IDBKeyRange
            // See: https://github.com/mozilla/localForage/issues/128
            // See: https://github.com/mozilla/localForage/issues/272
            typeof IDBKeyRange < "u";
          } catch {
            return !1;
          }
        }
        function c(m, T) {
          m = m || [], T = T || {};
          try {
            return new Blob(m, T);
          } catch (E) {
            if (E.name !== "TypeError")
              throw E;
            for (var g = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, _ = new g(), A = 0; A < m.length; A += 1)
              _.append(m[A]);
            return _.getBlob(T.type);
          }
        }
        typeof Promise > "u" && n(3);
        var f = Promise;
        function h(m, T) {
          T && m.then(function(g) {
            T(null, g);
          }, function(g) {
            T(g);
          });
        }
        function p(m, T, g) {
          typeof T == "function" && m.then(T), typeof g == "function" && m.catch(g);
        }
        function y(m) {
          return typeof m != "string" && (console.warn(m + " used as a key, but it is not a string."), m = String(m)), m;
        }
        function v() {
          if (arguments.length && typeof arguments[arguments.length - 1] == "function")
            return arguments[arguments.length - 1];
        }
        var w = "local-forage-detect-blob-support", x = void 0, S = {}, k = Object.prototype.toString, P = "readonly", j = "readwrite";
        function N(m) {
          for (var T = m.length, g = new ArrayBuffer(T), _ = new Uint8Array(g), A = 0; A < T; A++)
            _[A] = m.charCodeAt(A);
          return g;
        }
        function C(m) {
          return new f(function(T) {
            var g = m.transaction(w, j), _ = c([""]);
            g.objectStore(w).put(_, "key"), g.onabort = function(A) {
              A.preventDefault(), A.stopPropagation(), T(!1);
            }, g.oncomplete = function() {
              var A = navigator.userAgent.match(/Chrome\/(\d+)/), E = navigator.userAgent.match(/Edge\//);
              T(E || !A || parseInt(A[1], 10) >= 43);
            };
          }).catch(function() {
            return !1;
          });
        }
        function R(m) {
          return typeof x == "boolean" ? f.resolve(x) : C(m).then(function(T) {
            return x = T, x;
          });
        }
        function I(m) {
          var T = S[m.name], g = {};
          g.promise = new f(function(_, A) {
            g.resolve = _, g.reject = A;
          }), T.deferredOperations.push(g), T.dbReady ? T.dbReady = T.dbReady.then(function() {
            return g.promise;
          }) : T.dbReady = g.promise;
        }
        function U(m) {
          var T = S[m.name], g = T.deferredOperations.pop();
          if (g)
            return g.resolve(), g.promise;
        }
        function W(m, T) {
          var g = S[m.name], _ = g.deferredOperations.pop();
          if (_)
            return _.reject(T), _.promise;
        }
        function ae(m, T) {
          return new f(function(g, _) {
            if (S[m.name] = S[m.name] || q(), m.db)
              if (T)
                I(m), m.db.close();
              else
                return g(m.db);
            var A = [m.name];
            T && A.push(m.version);
            var E = l.open.apply(l, A);
            T && (E.onupgradeneeded = function(D) {
              var L = E.result;
              try {
                L.createObjectStore(m.storeName), D.oldVersion <= 1 && L.createObjectStore(w);
              } catch (F) {
                if (F.name === "ConstraintError")
                  console.warn('The database "' + m.name + '" has been upgraded from version ' + D.oldVersion + " to version " + D.newVersion + ', but the storage "' + m.storeName + '" already exists.');
                else
                  throw F;
              }
            }), E.onerror = function(D) {
              D.preventDefault(), _(E.error);
            }, E.onsuccess = function() {
              var D = E.result;
              D.onversionchange = function(L) {
                L.target.close();
              }, g(D), U(m);
            };
          });
        }
        function $(m) {
          return ae(m, !1);
        }
        function V(m) {
          return ae(m, !0);
        }
        function K(m, T) {
          if (!m.db)
            return !0;
          var g = !m.db.objectStoreNames.contains(m.storeName), _ = m.version < m.db.version, A = m.version > m.db.version;
          if (_ && (m.version !== T && console.warn('The database "' + m.name + `" can't be downgraded from version ` + m.db.version + " to version " + m.version + "."), m.version = m.db.version), A || g) {
            if (g) {
              var E = m.db.version + 1;
              E > m.version && (m.version = E);
            }
            return !0;
          }
          return !1;
        }
        function se(m) {
          return new f(function(T, g) {
            var _ = new FileReader();
            _.onerror = g, _.onloadend = function(A) {
              var E = btoa(A.target.result || "");
              T({
                __local_forage_encoded_blob: !0,
                data: E,
                type: m.type
              });
            }, _.readAsBinaryString(m);
          });
        }
        function G(m) {
          var T = N(atob(m.data));
          return c([T], { type: m.type });
        }
        function te(m) {
          return m && m.__local_forage_encoded_blob;
        }
        function le(m) {
          var T = this, g = T._initReady().then(function() {
            var _ = S[T._dbInfo.name];
            if (_ && _.dbReady)
              return _.dbReady;
          });
          return p(g, m, m), g;
        }
        function Ce(m) {
          I(m);
          for (var T = S[m.name], g = T.forages, _ = 0; _ < g.length; _++) {
            var A = g[_];
            A._dbInfo.db && (A._dbInfo.db.close(), A._dbInfo.db = null);
          }
          return m.db = null, $(m).then(function(E) {
            return m.db = E, K(m) ? V(m) : E;
          }).then(function(E) {
            m.db = T.db = E;
            for (var D = 0; D < g.length; D++)
              g[D]._dbInfo.db = E;
          }).catch(function(E) {
            throw W(m, E), E;
          });
        }
        function ce(m, T, g, _) {
          _ === void 0 && (_ = 1);
          try {
            var A = m.db.transaction(m.storeName, T);
            g(null, A);
          } catch (E) {
            if (_ > 0 && (!m.db || E.name === "InvalidStateError" || E.name === "NotFoundError"))
              return f.resolve().then(function() {
                if (!m.db || E.name === "NotFoundError" && !m.db.objectStoreNames.contains(m.storeName) && m.version <= m.db.version)
                  return m.db && (m.version = m.db.version + 1), V(m);
              }).then(function() {
                return Ce(m).then(function() {
                  ce(m, T, g, _ - 1);
                });
              }).catch(g);
            g(E);
          }
        }
        function q() {
          return {
            // Running localForages sharing a database.
            forages: [],
            // Shared database.
            db: null,
            // Database readiness (promise).
            dbReady: null,
            // Deferred operations on the database.
            deferredOperations: []
          };
        }
        function ne(m) {
          var T = this, g = {
            db: null
          };
          if (m)
            for (var _ in m)
              g[_] = m[_];
          var A = S[g.name];
          A || (A = q(), S[g.name] = A), A.forages.push(T), T._initReady || (T._initReady = T.ready, T.ready = le);
          var E = [];
          function D() {
            return f.resolve();
          }
          for (var L = 0; L < A.forages.length; L++) {
            var F = A.forages[L];
            F !== T && E.push(F._initReady().catch(D));
          }
          var B = A.forages.slice(0);
          return f.all(E).then(function() {
            return g.db = A.db, $(g);
          }).then(function(H) {
            return g.db = H, K(g, T._defaultConfig.version) ? V(g) : H;
          }).then(function(H) {
            g.db = A.db = H, T._dbInfo = g;
            for (var Z = 0; Z < B.length; Z++) {
              var Te = B[Z];
              Te !== T && (Te._dbInfo.db = g.db, Te._dbInfo.version = g.version);
            }
          });
        }
        function oe(m, T) {
          var g = this;
          m = y(m);
          var _ = new f(function(A, E) {
            g.ready().then(function() {
              ce(g._dbInfo, P, function(D, L) {
                if (D)
                  return E(D);
                try {
                  var F = L.objectStore(g._dbInfo.storeName), B = F.get(m);
                  B.onsuccess = function() {
                    var H = B.result;
                    H === void 0 && (H = null), te(H) && (H = G(H)), A(H);
                  }, B.onerror = function() {
                    E(B.error);
                  };
                } catch (H) {
                  E(H);
                }
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function ie(m, T) {
          var g = this, _ = new f(function(A, E) {
            g.ready().then(function() {
              ce(g._dbInfo, P, function(D, L) {
                if (D)
                  return E(D);
                try {
                  var F = L.objectStore(g._dbInfo.storeName), B = F.openCursor(), H = 1;
                  B.onsuccess = function() {
                    var Z = B.result;
                    if (Z) {
                      var Te = Z.value;
                      te(Te) && (Te = G(Te));
                      var Oe = m(Te, Z.key, H++);
                      Oe !== void 0 ? A(Oe) : Z.continue();
                    } else
                      A();
                  }, B.onerror = function() {
                    E(B.error);
                  };
                } catch (Z) {
                  E(Z);
                }
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function ye(m, T, g) {
          var _ = this;
          m = y(m);
          var A = new f(function(E, D) {
            var L;
            _.ready().then(function() {
              return L = _._dbInfo, k.call(T) === "[object Blob]" ? R(L.db).then(function(F) {
                return F ? T : se(T);
              }) : T;
            }).then(function(F) {
              ce(_._dbInfo, j, function(B, H) {
                if (B)
                  return D(B);
                try {
                  var Z = H.objectStore(_._dbInfo.storeName);
                  F === null && (F = void 0);
                  var Te = Z.put(F, m);
                  H.oncomplete = function() {
                    F === void 0 && (F = null), E(F);
                  }, H.onabort = H.onerror = function() {
                    var Oe = Te.error ? Te.error : Te.transaction.error;
                    D(Oe);
                  };
                } catch (Oe) {
                  D(Oe);
                }
              });
            }).catch(D);
          });
          return h(A, g), A;
        }
        function Me(m, T) {
          var g = this;
          m = y(m);
          var _ = new f(function(A, E) {
            g.ready().then(function() {
              ce(g._dbInfo, j, function(D, L) {
                if (D)
                  return E(D);
                try {
                  var F = L.objectStore(g._dbInfo.storeName), B = F.delete(m);
                  L.oncomplete = function() {
                    A();
                  }, L.onerror = function() {
                    E(B.error);
                  }, L.onabort = function() {
                    var H = B.error ? B.error : B.transaction.error;
                    E(H);
                  };
                } catch (H) {
                  E(H);
                }
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Pe(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              ce(T._dbInfo, j, function(E, D) {
                if (E)
                  return A(E);
                try {
                  var L = D.objectStore(T._dbInfo.storeName), F = L.clear();
                  D.oncomplete = function() {
                    _();
                  }, D.onabort = D.onerror = function() {
                    var B = F.error ? F.error : F.transaction.error;
                    A(B);
                  };
                } catch (B) {
                  A(B);
                }
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function Ee(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              ce(T._dbInfo, P, function(E, D) {
                if (E)
                  return A(E);
                try {
                  var L = D.objectStore(T._dbInfo.storeName), F = L.count();
                  F.onsuccess = function() {
                    _(F.result);
                  }, F.onerror = function() {
                    A(F.error);
                  };
                } catch (B) {
                  A(B);
                }
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function _e(m, T) {
          var g = this, _ = new f(function(A, E) {
            if (m < 0) {
              A(null);
              return;
            }
            g.ready().then(function() {
              ce(g._dbInfo, P, function(D, L) {
                if (D)
                  return E(D);
                try {
                  var F = L.objectStore(g._dbInfo.storeName), B = !1, H = F.openKeyCursor();
                  H.onsuccess = function() {
                    var Z = H.result;
                    if (!Z) {
                      A(null);
                      return;
                    }
                    m === 0 || B ? A(Z.key) : (B = !0, Z.advance(m));
                  }, H.onerror = function() {
                    E(H.error);
                  };
                } catch (Z) {
                  E(Z);
                }
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Ye(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              ce(T._dbInfo, P, function(E, D) {
                if (E)
                  return A(E);
                try {
                  var L = D.objectStore(T._dbInfo.storeName), F = L.openKeyCursor(), B = [];
                  F.onsuccess = function() {
                    var H = F.result;
                    if (!H) {
                      _(B);
                      return;
                    }
                    B.push(H.key), H.continue();
                  }, F.onerror = function() {
                    A(F.error);
                  };
                } catch (H) {
                  A(H);
                }
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function Re(m, T) {
          T = v.apply(this, arguments);
          var g = this.config();
          m = typeof m != "function" && m || {}, m.name || (m.name = m.name || g.name, m.storeName = m.storeName || g.storeName);
          var _ = this, A;
          if (!m.name)
            A = f.reject("Invalid arguments");
          else {
            var E = m.name === g.name && _._dbInfo.db, D = E ? f.resolve(_._dbInfo.db) : $(m).then(function(L) {
              var F = S[m.name], B = F.forages;
              F.db = L;
              for (var H = 0; H < B.length; H++)
                B[H]._dbInfo.db = L;
              return L;
            });
            m.storeName ? A = D.then(function(L) {
              if (L.objectStoreNames.contains(m.storeName)) {
                var F = L.version + 1;
                I(m);
                var B = S[m.name], H = B.forages;
                L.close();
                for (var Z = 0; Z < H.length; Z++) {
                  var Te = H[Z];
                  Te._dbInfo.db = null, Te._dbInfo.version = F;
                }
                var Oe = new f(function(Ve, st) {
                  var et = l.open(m.name, F);
                  et.onerror = function(Ot) {
                    var Ei = et.result;
                    Ei.close(), st(Ot);
                  }, et.onupgradeneeded = function() {
                    var Ot = et.result;
                    Ot.deleteObjectStore(m.storeName);
                  }, et.onsuccess = function() {
                    var Ot = et.result;
                    Ot.close(), Ve(Ot);
                  };
                });
                return Oe.then(function(Ve) {
                  B.db = Ve;
                  for (var st = 0; st < H.length; st++) {
                    var et = H[st];
                    et._dbInfo.db = Ve, U(et._dbInfo);
                  }
                }).catch(function(Ve) {
                  throw (W(m, Ve) || f.resolve()).catch(function() {
                  }), Ve;
                });
              }
            }) : A = D.then(function(L) {
              I(m);
              var F = S[m.name], B = F.forages;
              L.close();
              for (var H = 0; H < B.length; H++) {
                var Z = B[H];
                Z._dbInfo.db = null;
              }
              var Te = new f(function(Oe, Ve) {
                var st = l.deleteDatabase(m.name);
                st.onerror = function() {
                  var et = st.result;
                  et && et.close(), Ve(st.error);
                }, st.onblocked = function() {
                  console.warn('dropInstance blocked for database "' + m.name + '" until all open connections are closed');
                }, st.onsuccess = function() {
                  var et = st.result;
                  et && et.close(), Oe(et);
                };
              });
              return Te.then(function(Oe) {
                F.db = Oe;
                for (var Ve = 0; Ve < B.length; Ve++) {
                  var st = B[Ve];
                  U(st._dbInfo);
                }
              }).catch(function(Oe) {
                throw (W(m, Oe) || f.resolve()).catch(function() {
                }), Oe;
              });
            });
          }
          return h(A, T), A;
        }
        var lt = {
          _driver: "asyncStorage",
          _initStorage: ne,
          _support: d(),
          iterate: ie,
          getItem: oe,
          setItem: ye,
          removeItem: Me,
          clear: Pe,
          length: Ee,
          key: _e,
          keys: Ye,
          dropInstance: Re
        };
        function Ct() {
          return typeof openDatabase == "function";
        }
        var We = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", wt = "~~local_forage_type~", He = /^~~local_forage_type~([^~]+)~/, gt = "__lfsc__:", ft = gt.length, $e = "arbf", De = "blob", kt = "si08", pn = "ui08", Ut = "uic8", rn = "si16", zt = "si32", Wt = "ur16", Et = "ui32", Ht = "fl32", _t = "fl64", Kt = ft + $e.length, mn = Object.prototype.toString;
        function sn(m) {
          var T = m.length * 0.75, g = m.length, _, A = 0, E, D, L, F;
          m[m.length - 1] === "=" && (T--, m[m.length - 2] === "=" && T--);
          var B = new ArrayBuffer(T), H = new Uint8Array(B);
          for (_ = 0; _ < g; _ += 4)
            E = We.indexOf(m[_]), D = We.indexOf(m[_ + 1]), L = We.indexOf(m[_ + 2]), F = We.indexOf(m[_ + 3]), H[A++] = E << 2 | D >> 4, H[A++] = (D & 15) << 4 | L >> 2, H[A++] = (L & 3) << 6 | F & 63;
          return B;
        }
        function Nt(m) {
          var T = new Uint8Array(m), g = "", _;
          for (_ = 0; _ < T.length; _ += 3)
            g += We[T[_] >> 2], g += We[(T[_] & 3) << 4 | T[_ + 1] >> 4], g += We[(T[_ + 1] & 15) << 2 | T[_ + 2] >> 6], g += We[T[_ + 2] & 63];
          return T.length % 3 === 2 ? g = g.substring(0, g.length - 1) + "=" : T.length % 3 === 1 && (g = g.substring(0, g.length - 2) + "=="), g;
        }
        function Je(m, T) {
          var g = "";
          if (m && (g = mn.call(m)), m && (g === "[object ArrayBuffer]" || m.buffer && mn.call(m.buffer) === "[object ArrayBuffer]")) {
            var _, A = gt;
            m instanceof ArrayBuffer ? (_ = m, A += $e) : (_ = m.buffer, g === "[object Int8Array]" ? A += kt : g === "[object Uint8Array]" ? A += pn : g === "[object Uint8ClampedArray]" ? A += Ut : g === "[object Int16Array]" ? A += rn : g === "[object Uint16Array]" ? A += Wt : g === "[object Int32Array]" ? A += zt : g === "[object Uint32Array]" ? A += Et : g === "[object Float32Array]" ? A += Ht : g === "[object Float64Array]" ? A += _t : T(new Error("Failed to get type for BinaryArray"))), T(A + Nt(_));
          } else if (g === "[object Blob]") {
            var E = new FileReader();
            E.onload = function() {
              var D = wt + m.type + "~" + Nt(this.result);
              T(gt + De + D);
            }, E.readAsArrayBuffer(m);
          } else
            try {
              T(JSON.stringify(m));
            } catch (D) {
              console.error("Couldn't convert value into a JSON string: ", m), T(null, D);
            }
        }
        function ct(m) {
          if (m.substring(0, ft) !== gt)
            return JSON.parse(m);
          var T = m.substring(Kt), g = m.substring(ft, Kt), _;
          if (g === De && He.test(T)) {
            var A = T.match(He);
            _ = A[1], T = T.substring(A[0].length);
          }
          var E = sn(T);
          switch (g) {
            case $e:
              return E;
            case De:
              return c([E], { type: _ });
            case kt:
              return new Int8Array(E);
            case pn:
              return new Uint8Array(E);
            case Ut:
              return new Uint8ClampedArray(E);
            case rn:
              return new Int16Array(E);
            case Wt:
              return new Uint16Array(E);
            case zt:
              return new Int32Array(E);
            case Et:
              return new Uint32Array(E);
            case Ht:
              return new Float32Array(E);
            case _t:
              return new Float64Array(E);
            default:
              throw new Error("Unkown type: " + g);
          }
        }
        var Yt = {
          serialize: Je,
          deserialize: ct,
          stringToBuffer: sn,
          bufferToString: Nt
        };
        function Mt(m, T, g, _) {
          m.executeSql("CREATE TABLE IF NOT EXISTS " + T.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], g, _);
        }
        function Gt(m) {
          var T = this, g = {
            db: null
          };
          if (m)
            for (var _ in m)
              g[_] = typeof m[_] != "string" ? m[_].toString() : m[_];
          var A = new f(function(E, D) {
            try {
              g.db = openDatabase(g.name, String(g.version), g.description, g.size);
            } catch (L) {
              return D(L);
            }
            g.db.transaction(function(L) {
              Mt(L, g, function() {
                T._dbInfo = g, E();
              }, function(F, B) {
                D(B);
              });
            }, D);
          });
          return g.serializer = Yt, A;
        }
        function Qe(m, T, g, _, A, E) {
          m.executeSql(g, _, A, function(D, L) {
            L.code === L.SYNTAX_ERR ? D.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [T.storeName], function(F, B) {
              B.rows.length ? E(F, L) : Mt(F, T, function() {
                F.executeSql(g, _, A, E);
              }, E);
            }, E) : E(D, L);
          }, E);
        }
        function Pt(m, T) {
          var g = this;
          m = y(m);
          var _ = new f(function(A, E) {
            g.ready().then(function() {
              var D = g._dbInfo;
              D.db.transaction(function(L) {
                Qe(L, D, "SELECT * FROM " + D.storeName + " WHERE key = ? LIMIT 1", [m], function(F, B) {
                  var H = B.rows.length ? B.rows.item(0).value : null;
                  H && (H = D.serializer.deserialize(H)), A(H);
                }, function(F, B) {
                  E(B);
                });
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Rt(m, T) {
          var g = this, _ = new f(function(A, E) {
            g.ready().then(function() {
              var D = g._dbInfo;
              D.db.transaction(function(L) {
                Qe(L, D, "SELECT * FROM " + D.storeName, [], function(F, B) {
                  for (var H = B.rows, Z = H.length, Te = 0; Te < Z; Te++) {
                    var Oe = H.item(Te), Ve = Oe.value;
                    if (Ve && (Ve = D.serializer.deserialize(Ve)), Ve = m(Ve, Oe.key, Te + 1), Ve !== void 0) {
                      A(Ve);
                      return;
                    }
                  }
                  A();
                }, function(F, B) {
                  E(B);
                });
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Dt(m, T, g, _) {
          var A = this;
          m = y(m);
          var E = new f(function(D, L) {
            A.ready().then(function() {
              T === void 0 && (T = null);
              var F = T, B = A._dbInfo;
              B.serializer.serialize(T, function(H, Z) {
                Z ? L(Z) : B.db.transaction(function(Te) {
                  Qe(Te, B, "INSERT OR REPLACE INTO " + B.storeName + " (key, value) VALUES (?, ?)", [m, H], function() {
                    D(F);
                  }, function(Oe, Ve) {
                    L(Ve);
                  });
                }, function(Te) {
                  if (Te.code === Te.QUOTA_ERR) {
                    if (_ > 0) {
                      D(Dt.apply(A, [m, F, g, _ - 1]));
                      return;
                    }
                    L(Te);
                  }
                });
              });
            }).catch(L);
          });
          return h(E, g), E;
        }
        function gn(m, T, g) {
          return Dt.apply(this, [m, T, g, 1]);
        }
        function yn(m, T) {
          var g = this;
          m = y(m);
          var _ = new f(function(A, E) {
            g.ready().then(function() {
              var D = g._dbInfo;
              D.db.transaction(function(L) {
                Qe(L, D, "DELETE FROM " + D.storeName + " WHERE key = ?", [m], function() {
                  A();
                }, function(F, B) {
                  E(B);
                });
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Ke(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              var E = T._dbInfo;
              E.db.transaction(function(D) {
                Qe(D, E, "DELETE FROM " + E.storeName, [], function() {
                  _();
                }, function(L, F) {
                  A(F);
                });
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function it(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              var E = T._dbInfo;
              E.db.transaction(function(D) {
                Qe(D, E, "SELECT COUNT(key) as c FROM " + E.storeName, [], function(L, F) {
                  var B = F.rows.item(0).c;
                  _(B);
                }, function(L, F) {
                  A(F);
                });
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function re(m, T) {
          var g = this, _ = new f(function(A, E) {
            g.ready().then(function() {
              var D = g._dbInfo;
              D.db.transaction(function(L) {
                Qe(L, D, "SELECT key FROM " + D.storeName + " WHERE id = ? LIMIT 1", [m + 1], function(F, B) {
                  var H = B.rows.length ? B.rows.item(0).key : null;
                  A(H);
                }, function(F, B) {
                  E(B);
                });
              });
            }).catch(E);
          });
          return h(_, T), _;
        }
        function Se(m) {
          var T = this, g = new f(function(_, A) {
            T.ready().then(function() {
              var E = T._dbInfo;
              E.db.transaction(function(D) {
                Qe(D, E, "SELECT key FROM " + E.storeName, [], function(L, F) {
                  for (var B = [], H = 0; H < F.rows.length; H++)
                    B.push(F.rows.item(H).key);
                  _(B);
                }, function(L, F) {
                  A(F);
                });
              });
            }).catch(A);
          });
          return h(g, m), g;
        }
        function ht(m) {
          return new f(function(T, g) {
            m.transaction(function(_) {
              _.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(A, E) {
                for (var D = [], L = 0; L < E.rows.length; L++)
                  D.push(E.rows.item(L).name);
                T({
                  db: m,
                  storeNames: D
                });
              }, function(A, E) {
                g(E);
              });
            }, function(_) {
              g(_);
            });
          });
        }
        function It(m, T) {
          T = v.apply(this, arguments);
          var g = this.config();
          m = typeof m != "function" && m || {}, m.name || (m.name = m.name || g.name, m.storeName = m.storeName || g.storeName);
          var _ = this, A;
          return m.name ? A = new f(function(E) {
            var D;
            m.name === g.name ? D = _._dbInfo.db : D = openDatabase(m.name, "", "", 0), m.storeName ? E({
              db: D,
              storeNames: [m.storeName]
            }) : E(ht(D));
          }).then(function(E) {
            return new f(function(D, L) {
              E.db.transaction(function(F) {
                function B(Oe) {
                  return new f(function(Ve, st) {
                    F.executeSql("DROP TABLE IF EXISTS " + Oe, [], function() {
                      Ve();
                    }, function(et, Ot) {
                      st(Ot);
                    });
                  });
                }
                for (var H = [], Z = 0, Te = E.storeNames.length; Z < Te; Z++)
                  H.push(B(E.storeNames[Z]));
                f.all(H).then(function() {
                  D();
                }).catch(function(Oe) {
                  L(Oe);
                });
              }, function(F) {
                L(F);
              });
            });
          }) : A = f.reject("Invalid arguments"), h(A, T), A;
        }
        var Y = {
          _driver: "webSQLStorage",
          _initStorage: Gt,
          _support: Ct(),
          iterate: Rt,
          getItem: Pt,
          setItem: gn,
          removeItem: yn,
          clear: Ke,
          length: it,
          key: re,
          keys: Se,
          dropInstance: It
        };
        function ee() {
          try {
            return typeof localStorage < "u" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
            !!localStorage.setItem;
          } catch {
            return !1;
          }
        }
        function J(m, T) {
          var g = m.name + "/";
          return m.storeName !== T.storeName && (g += m.storeName + "/"), g;
        }
        function Ae() {
          var m = "_localforage_support_test";
          try {
            return localStorage.setItem(m, !0), localStorage.removeItem(m), !1;
          } catch {
            return !0;
          }
        }
        function Ze() {
          return !Ae() || localStorage.length > 0;
        }
        function b(m) {
          var T = this, g = {};
          if (m)
            for (var _ in m)
              g[_] = m[_];
          return g.keyPrefix = J(m, T._defaultConfig), Ze() ? (T._dbInfo = g, g.serializer = Yt, f.resolve()) : f.reject();
        }
        function O(m) {
          var T = this, g = T.ready().then(function() {
            for (var _ = T._dbInfo.keyPrefix, A = localStorage.length - 1; A >= 0; A--) {
              var E = localStorage.key(A);
              E.indexOf(_) === 0 && localStorage.removeItem(E);
            }
          });
          return h(g, m), g;
        }
        function z(m, T) {
          var g = this;
          m = y(m);
          var _ = g.ready().then(function() {
            var A = g._dbInfo, E = localStorage.getItem(A.keyPrefix + m);
            return E && (E = A.serializer.deserialize(E)), E;
          });
          return h(_, T), _;
        }
        function X(m, T) {
          var g = this, _ = g.ready().then(function() {
            for (var A = g._dbInfo, E = A.keyPrefix, D = E.length, L = localStorage.length, F = 1, B = 0; B < L; B++) {
              var H = localStorage.key(B);
              if (H.indexOf(E) === 0) {
                var Z = localStorage.getItem(H);
                if (Z && (Z = A.serializer.deserialize(Z)), Z = m(Z, H.substring(D), F++), Z !== void 0)
                  return Z;
              }
            }
          });
          return h(_, T), _;
        }
        function Q(m, T) {
          var g = this, _ = g.ready().then(function() {
            var A = g._dbInfo, E;
            try {
              E = localStorage.key(m);
            } catch {
              E = null;
            }
            return E && (E = E.substring(A.keyPrefix.length)), E;
          });
          return h(_, T), _;
        }
        function ke(m) {
          var T = this, g = T.ready().then(function() {
            for (var _ = T._dbInfo, A = localStorage.length, E = [], D = 0; D < A; D++) {
              var L = localStorage.key(D);
              L.indexOf(_.keyPrefix) === 0 && E.push(L.substring(_.keyPrefix.length));
            }
            return E;
          });
          return h(g, m), g;
        }
        function je(m) {
          var T = this, g = T.keys().then(function(_) {
            return _.length;
          });
          return h(g, m), g;
        }
        function ve(m, T) {
          var g = this;
          m = y(m);
          var _ = g.ready().then(function() {
            var A = g._dbInfo;
            localStorage.removeItem(A.keyPrefix + m);
          });
          return h(_, T), _;
        }
        function rt(m, T, g) {
          var _ = this;
          m = y(m);
          var A = _.ready().then(function() {
            T === void 0 && (T = null);
            var E = T;
            return new f(function(D, L) {
              var F = _._dbInfo;
              F.serializer.serialize(T, function(B, H) {
                if (H)
                  L(H);
                else
                  try {
                    localStorage.setItem(F.keyPrefix + m, B), D(E);
                  } catch (Z) {
                    (Z.name === "QuotaExceededError" || Z.name === "NS_ERROR_DOM_QUOTA_REACHED") && L(Z), L(Z);
                  }
              });
            });
          });
          return h(A, g), A;
        }
        function Fe(m, T) {
          if (T = v.apply(this, arguments), m = typeof m != "function" && m || {}, !m.name) {
            var g = this.config();
            m.name = m.name || g.name, m.storeName = m.storeName || g.storeName;
          }
          var _ = this, A;
          return m.name ? A = new f(function(E) {
            m.storeName ? E(J(m, _._defaultConfig)) : E(m.name + "/");
          }).then(function(E) {
            for (var D = localStorage.length - 1; D >= 0; D--) {
              var L = localStorage.key(D);
              L.indexOf(E) === 0 && localStorage.removeItem(L);
            }
          }) : A = f.reject("Invalid arguments"), h(A, T), A;
        }
        var Be = {
          _driver: "localStorageWrapper",
          _initStorage: b,
          _support: ee(),
          iterate: X,
          getItem: z,
          setItem: rt,
          removeItem: ve,
          clear: O,
          length: je,
          key: Q,
          keys: ke,
          dropInstance: Fe
        }, pt = function(T, g) {
          return T === g || typeof T == "number" && typeof g == "number" && isNaN(T) && isNaN(g);
        }, qt = function(T, g) {
          for (var _ = T.length, A = 0; A < _; ) {
            if (pt(T[A], g))
              return !0;
            A++;
          }
          return !1;
        }, xe = Array.isArray || function(m) {
          return Object.prototype.toString.call(m) === "[object Array]";
        }, Ie = {}, on = {}, St = {
          INDEXEDDB: lt,
          WEBSQL: Y,
          LOCALSTORAGE: Be
        }, ki = [St.INDEXEDDB._driver, St.WEBSQL._driver, St.LOCALSTORAGE._driver], Tn = ["dropInstance"], rs = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(Tn), Tf = {
          description: "",
          driver: ki.slice(),
          name: "localforage",
          // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
          // we can use without a prompt.
          size: 4980736,
          storeName: "keyvaluepairs",
          version: 1
        };
        function Cf(m, T) {
          m[T] = function() {
            var g = arguments;
            return m.ready().then(function() {
              return m[T].apply(m, g);
            });
          };
        }
        function ss() {
          for (var m = 1; m < arguments.length; m++) {
            var T = arguments[m];
            if (T)
              for (var g in T)
                T.hasOwnProperty(g) && (xe(T[g]) ? arguments[0][g] = T[g].slice() : arguments[0][g] = T[g]);
          }
          return arguments[0];
        }
        var kf = function() {
          function m(T) {
            o(this, m);
            for (var g in St)
              if (St.hasOwnProperty(g)) {
                var _ = St[g], A = _._driver;
                this[g] = A, Ie[A] || this.defineDriver(_);
              }
            this._defaultConfig = ss({}, Tf), this._config = ss({}, this._defaultConfig, T), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
            });
          }
          return m.prototype.config = function(g) {
            if ((typeof g > "u" ? "undefined" : s(g)) === "object") {
              if (this._ready)
                return new Error("Can't call config() after localforage has been used.");
              for (var _ in g) {
                if (_ === "storeName" && (g[_] = g[_].replace(/\W/g, "_")), _ === "version" && typeof g[_] != "number")
                  return new Error("Database version must be a number.");
                this._config[_] = g[_];
              }
              return "driver" in g && g.driver ? this.setDriver(this._config.driver) : !0;
            } else return typeof g == "string" ? this._config[g] : this._config;
          }, m.prototype.defineDriver = function(g, _, A) {
            var E = new f(function(D, L) {
              try {
                var F = g._driver, B = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                if (!g._driver) {
                  L(B);
                  return;
                }
                for (var H = rs.concat("_initStorage"), Z = 0, Te = H.length; Z < Te; Z++) {
                  var Oe = H[Z], Ve = !qt(Tn, Oe);
                  if ((Ve || g[Oe]) && typeof g[Oe] != "function") {
                    L(B);
                    return;
                  }
                }
                var st = function() {
                  for (var Ei = function(Nf) {
                    return function() {
                      var Af = new Error("Method " + Nf + " is not implemented by the current driver"), wa = f.reject(Af);
                      return h(wa, arguments[arguments.length - 1]), wa;
                    };
                  }, os = 0, _f = Tn.length; os < _f; os++) {
                    var as = Tn[os];
                    g[as] || (g[as] = Ei(as));
                  }
                };
                st();
                var et = function(Ei) {
                  Ie[F] && console.info("Redefining LocalForage driver: " + F), Ie[F] = g, on[F] = Ei, D();
                };
                "_support" in g ? g._support && typeof g._support == "function" ? g._support().then(et, L) : et(!!g._support) : et(!0);
              } catch (Ot) {
                L(Ot);
              }
            });
            return p(E, _, A), E;
          }, m.prototype.driver = function() {
            return this._driver || null;
          }, m.prototype.getDriver = function(g, _, A) {
            var E = Ie[g] ? f.resolve(Ie[g]) : f.reject(new Error("Driver not found."));
            return p(E, _, A), E;
          }, m.prototype.getSerializer = function(g) {
            var _ = f.resolve(Yt);
            return p(_, g), _;
          }, m.prototype.ready = function(g) {
            var _ = this, A = _._driverSet.then(function() {
              return _._ready === null && (_._ready = _._initDriver()), _._ready;
            });
            return p(A, g, g), A;
          }, m.prototype.setDriver = function(g, _, A) {
            var E = this;
            xe(g) || (g = [g]);
            var D = this._getSupportedDrivers(g);
            function L() {
              E._config.driver = E.driver();
            }
            function F(Z) {
              return E._extend(Z), L(), E._ready = E._initStorage(E._config), E._ready;
            }
            function B(Z) {
              return function() {
                var Te = 0;
                function Oe() {
                  for (; Te < Z.length; ) {
                    var Ve = Z[Te];
                    return Te++, E._dbInfo = null, E._ready = null, E.getDriver(Ve).then(F).catch(Oe);
                  }
                  L();
                  var st = new Error("No available storage method found.");
                  return E._driverSet = f.reject(st), E._driverSet;
                }
                return Oe();
              };
            }
            var H = this._driverSet !== null ? this._driverSet.catch(function() {
              return f.resolve();
            }) : f.resolve();
            return this._driverSet = H.then(function() {
              var Z = D[0];
              return E._dbInfo = null, E._ready = null, E.getDriver(Z).then(function(Te) {
                E._driver = Te._driver, L(), E._wrapLibraryMethodsWithReady(), E._initDriver = B(D);
              });
            }).catch(function() {
              L();
              var Z = new Error("No available storage method found.");
              return E._driverSet = f.reject(Z), E._driverSet;
            }), p(this._driverSet, _, A), this._driverSet;
          }, m.prototype.supports = function(g) {
            return !!on[g];
          }, m.prototype._extend = function(g) {
            ss(this, g);
          }, m.prototype._getSupportedDrivers = function(g) {
            for (var _ = [], A = 0, E = g.length; A < E; A++) {
              var D = g[A];
              this.supports(D) && _.push(D);
            }
            return _;
          }, m.prototype._wrapLibraryMethodsWithReady = function() {
            for (var g = 0, _ = rs.length; g < _; g++)
              Cf(this, rs[g]);
          }, m.prototype.createInstance = function(g) {
            return new m(g);
          }, m;
        }(), Ef = new kf();
        i.exports = Ef;
      }, { 3: 3 }] }, {}, [4])(4);
    });
  }(Ns)), Ns.exports;
}
var h2 = f2();
const p2 = /* @__PURE__ */ Ou(h2), mi = Math.min, Hn = Math.max, Vr = Math.round, xr = Math.floor, cn = (e) => ({
  x: e,
  y: e
}), m2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, g2 = {
  start: "end",
  end: "start"
};
function yo(e, t, n) {
  return Hn(e, mi(t, n));
}
function ir(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gn(e) {
  return e.split("-")[0];
}
function rr(e) {
  return e.split("-")[1];
}
function uf(e) {
  return e === "x" ? "y" : "x";
}
function pa(e) {
  return e === "y" ? "height" : "width";
}
function gi(e) {
  return ["top", "bottom"].includes(Gn(e)) ? "y" : "x";
}
function ma(e) {
  return uf(gi(e));
}
function y2(e, t, n) {
  n === void 0 && (n = !1);
  const i = rr(e), r = ma(e), s = pa(r);
  let o = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (o = $r(o)), [o, $r(o)];
}
function v2(e) {
  const t = $r(e);
  return [vo(e), t, vo(t)];
}
function vo(e) {
  return e.replace(/start|end/g, (t) => g2[t]);
}
function x2(e, t, n) {
  const i = ["left", "right"], r = ["right", "left"], s = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : i : t ? i : r;
    case "left":
    case "right":
      return t ? s : o;
    default:
      return [];
  }
}
function b2(e, t, n, i) {
  const r = rr(e);
  let s = x2(Gn(e), n === "start", i);
  return r && (s = s.map((o) => o + "-" + r), t && (s = s.concat(s.map(vo)))), s;
}
function $r(e) {
  return e.replace(/left|right|bottom|top/g, (t) => m2[t]);
}
function w2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function cf(e) {
  return typeof e != "number" ? w2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Fr(e) {
  const {
    x: t,
    y: n,
    width: i,
    height: r
  } = e;
  return {
    width: i,
    height: r,
    top: n,
    left: t,
    right: t + i,
    bottom: n + r,
    x: t,
    y: n
  };
}
function gu(e, t, n) {
  let {
    reference: i,
    floating: r
  } = e;
  const s = gi(t), o = ma(t), a = pa(o), l = Gn(t), d = s === "y", c = i.x + i.width / 2 - r.width / 2, f = i.y + i.height / 2 - r.height / 2, h = i[a] / 2 - r[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: c,
        y: i.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: c,
        y: i.y + i.height
      };
      break;
    case "right":
      p = {
        x: i.x + i.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: i.x - r.width,
        y: f
      };
      break;
    default:
      p = {
        x: i.x,
        y: i.y
      };
  }
  switch (rr(t)) {
    case "start":
      p[o] -= h * (n && d ? -1 : 1);
      break;
    case "end":
      p[o] += h * (n && d ? -1 : 1);
      break;
  }
  return p;
}
const S2 = async (e, t, n) => {
  const {
    placement: i = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: o
  } = n, a = s.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: c,
    y: f
  } = gu(d, i, l), h = i, p = {}, y = 0;
  for (let v = 0; v < a.length; v++) {
    const {
      name: w,
      fn: x
    } = a[v], {
      x: S,
      y: k,
      data: P,
      reset: j
    } = await x({
      x: c,
      y: f,
      initialPlacement: i,
      placement: h,
      strategy: r,
      middlewareData: p,
      rects: d,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = S ?? c, f = k ?? f, p = {
      ...p,
      [w]: {
        ...p[w],
        ...P
      }
    }, j && y <= 50 && (y++, typeof j == "object" && (j.placement && (h = j.placement), j.rects && (d = j.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : j.rects), {
      x: c,
      y: f
    } = gu(d, h, l)), v = -1);
  }
  return {
    x: c,
    y: f,
    placement: h,
    strategy: r,
    middlewareData: p
  };
};
async function df(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: i,
    y: r,
    platform: s,
    rects: o,
    elements: a,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = ir(t, e), y = cf(p), w = a[h ? f === "floating" ? "reference" : "floating" : f], x = Fr(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(w))) == null || n ? w : w.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), S = f === "floating" ? {
    x: i,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, k = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), P = await (s.isElement == null ? void 0 : s.isElement(k)) ? await (s.getScale == null ? void 0 : s.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, j = Fr(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: S,
    offsetParent: k,
    strategy: l
  }) : S);
  return {
    top: (x.top - j.top + y.top) / P.y,
    bottom: (j.bottom - x.bottom + y.bottom) / P.y,
    left: (x.left - j.left + y.left) / P.x,
    right: (j.right - x.right + y.right) / P.x
  };
}
const j2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: i,
      placement: r,
      rects: s,
      platform: o,
      elements: a,
      middlewareData: l
    } = t, {
      element: d,
      padding: c = 0
    } = ir(e, t) || {};
    if (d == null)
      return {};
    const f = cf(c), h = {
      x: n,
      y: i
    }, p = ma(r), y = pa(p), v = await o.getDimensions(d), w = p === "y", x = w ? "top" : "left", S = w ? "bottom" : "right", k = w ? "clientHeight" : "clientWidth", P = s.reference[y] + s.reference[p] - h[p] - s.floating[y], j = h[p] - s.reference[p], N = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let C = N ? N[k] : 0;
    (!C || !await (o.isElement == null ? void 0 : o.isElement(N))) && (C = a.floating[k] || s.floating[y]);
    const R = P / 2 - j / 2, I = C / 2 - v[y] / 2 - 1, U = mi(f[x], I), W = mi(f[S], I), ae = U, $ = C - v[y] - W, V = C / 2 - v[y] / 2 + R, K = yo(ae, V, $), se = !l.arrow && rr(r) != null && V !== K && s.reference[y] / 2 - (V < ae ? U : W) - v[y] / 2 < 0, G = se ? V < ae ? V - ae : V - $ : 0;
    return {
      [p]: h[p] + G,
      data: {
        [p]: K,
        centerOffset: V - K - G,
        ...se && {
          alignmentOffset: G
        }
      },
      reset: se
    };
  }
}), T2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, i;
      const {
        placement: r,
        middlewareData: s,
        rects: o,
        initialPlacement: a,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: v = !0,
        ...w
      } = ir(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const x = Gn(r), S = gi(a), k = Gn(a) === a, P = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), j = h || (k || !v ? [$r(a)] : v2(a)), N = y !== "none";
      !h && N && j.push(...b2(a, v, y, P));
      const C = [a, ...j], R = await df(t, w), I = [];
      let U = ((i = s.flip) == null ? void 0 : i.overflows) || [];
      if (c && I.push(R[x]), f) {
        const V = y2(r, o, P);
        I.push(R[V[0]], R[V[1]]);
      }
      if (U = [...U, {
        placement: r,
        overflows: I
      }], !I.every((V) => V <= 0)) {
        var W, ae;
        const V = (((W = s.flip) == null ? void 0 : W.index) || 0) + 1, K = C[V];
        if (K)
          return {
            data: {
              index: V,
              overflows: U
            },
            reset: {
              placement: K
            }
          };
        let se = (ae = U.filter((G) => G.overflows[0] <= 0).sort((G, te) => G.overflows[1] - te.overflows[1])[0]) == null ? void 0 : ae.placement;
        if (!se)
          switch (p) {
            case "bestFit": {
              var $;
              const G = ($ = U.filter((te) => {
                if (N) {
                  const le = gi(te.placement);
                  return le === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  le === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((le) => le > 0).reduce((le, Ce) => le + Ce, 0)]).sort((te, le) => te[1] - le[1])[0]) == null ? void 0 : $[0];
              G && (se = G);
              break;
            }
            case "initialPlacement":
              se = a;
              break;
          }
        if (r !== se)
          return {
            reset: {
              placement: se
            }
          };
      }
      return {};
    }
  };
};
async function C2(e, t) {
  const {
    placement: n,
    platform: i,
    elements: r
  } = e, s = await (i.isRTL == null ? void 0 : i.isRTL(r.floating)), o = Gn(n), a = rr(n), l = gi(n) === "y", d = ["left", "top"].includes(o) ? -1 : 1, c = s && l ? -1 : 1, f = ir(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: y
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof y == "number" && (p = a === "end" ? y * -1 : y), l ? {
    x: p * c,
    y: h * d
  } : {
    x: h * d,
    y: p * c
  };
}
const k2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, i;
      const {
        x: r,
        y: s,
        placement: o,
        middlewareData: a
      } = t, l = await C2(t, e);
      return o === ((n = a.offset) == null ? void 0 : n.placement) && (i = a.arrow) != null && i.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, E2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: i,
        placement: r
      } = t, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: a = {
          fn: (w) => {
            let {
              x,
              y: S
            } = w;
            return {
              x,
              y: S
            };
          }
        },
        ...l
      } = ir(e, t), d = {
        x: n,
        y: i
      }, c = await df(t, l), f = gi(Gn(r)), h = uf(f);
      let p = d[h], y = d[f];
      if (s) {
        const w = h === "y" ? "top" : "left", x = h === "y" ? "bottom" : "right", S = p + c[w], k = p - c[x];
        p = yo(S, p, k);
      }
      if (o) {
        const w = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", S = y + c[w], k = y - c[x];
        y = yo(S, y, k);
      }
      const v = a.fn({
        ...t,
        [h]: p,
        [f]: y
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - i,
          enabled: {
            [h]: s,
            [f]: o
          }
        }
      };
    }
  };
};
function ts() {
  return typeof window < "u";
}
function Ci(e) {
  return ff(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function At(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function hn(e) {
  var t;
  return (t = (ff(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ff(e) {
  return ts() ? e instanceof Node || e instanceof At(e).Node : !1;
}
function tn(e) {
  return ts() ? e instanceof Element || e instanceof At(e).Element : !1;
}
function fn(e) {
  return ts() ? e instanceof HTMLElement || e instanceof At(e).HTMLElement : !1;
}
function yu(e) {
  return !ts() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof At(e).ShadowRoot;
}
function sr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: i,
    display: r
  } = nn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + n) && !["inline", "contents"].includes(r);
}
function _2(e) {
  return ["table", "td", "th"].includes(Ci(e));
}
function ns(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function ga(e) {
  const t = ya(), n = tn(e) ? nn(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((i) => n[i] ? n[i] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((i) => (n.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (n.contain || "").includes(i));
}
function N2(e) {
  let t = Pn(e);
  for (; fn(t) && !yi(t); ) {
    if (ga(t))
      return t;
    if (ns(t))
      return null;
    t = Pn(t);
  }
  return null;
}
function ya() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function yi(e) {
  return ["html", "body", "#document"].includes(Ci(e));
}
function nn(e) {
  return At(e).getComputedStyle(e);
}
function is(e) {
  return tn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Pn(e) {
  if (Ci(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    yu(e) && e.host || // Fallback.
    hn(e)
  );
  return yu(t) ? t.host : t;
}
function hf(e) {
  const t = Pn(e);
  return yi(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : fn(t) && sr(t) ? t : hf(t);
}
function Xi(e, t, n) {
  var i;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = hf(e), s = r === ((i = e.ownerDocument) == null ? void 0 : i.body), o = At(r);
  if (s) {
    const a = xo(o);
    return t.concat(o, o.visualViewport || [], sr(r) ? r : [], a && n ? Xi(a) : []);
  }
  return t.concat(r, Xi(r, [], n));
}
function xo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function pf(e) {
  const t = nn(e);
  let n = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const r = fn(e), s = r ? e.offsetWidth : n, o = r ? e.offsetHeight : i, a = Vr(n) !== s || Vr(i) !== o;
  return a && (n = s, i = o), {
    width: n,
    height: i,
    $: a
  };
}
function va(e) {
  return tn(e) ? e : e.contextElement;
}
function ai(e) {
  const t = va(e);
  if (!fn(t))
    return cn(1);
  const n = t.getBoundingClientRect(), {
    width: i,
    height: r,
    $: s
  } = pf(t);
  let o = (s ? Vr(n.width) : n.width) / i, a = (s ? Vr(n.height) : n.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const A2 = /* @__PURE__ */ cn(0);
function mf(e) {
  const t = At(e);
  return !ya() || !t.visualViewport ? A2 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function M2(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== At(e) ? !1 : t;
}
function qn(e, t, n, i) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = va(e);
  let o = cn(1);
  t && (i ? tn(i) && (o = ai(i)) : o = ai(e));
  const a = M2(s, n, i) ? mf(s) : cn(0);
  let l = (r.left + a.x) / o.x, d = (r.top + a.y) / o.y, c = r.width / o.x, f = r.height / o.y;
  if (s) {
    const h = At(s), p = i && tn(i) ? At(i) : i;
    let y = h, v = xo(y);
    for (; v && i && p !== y; ) {
      const w = ai(v), x = v.getBoundingClientRect(), S = nn(v), k = x.left + (v.clientLeft + parseFloat(S.paddingLeft)) * w.x, P = x.top + (v.clientTop + parseFloat(S.paddingTop)) * w.y;
      l *= w.x, d *= w.y, c *= w.x, f *= w.y, l += k, d += P, y = At(v), v = xo(y);
    }
  }
  return Fr({
    width: c,
    height: f,
    x: l,
    y: d
  });
}
function xa(e, t) {
  const n = is(e).scrollLeft;
  return t ? t.left + n : qn(hn(e)).left + n;
}
function gf(e, t, n) {
  n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), r = i.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    xa(e, i)
  )), s = i.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function P2(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: i,
    strategy: r
  } = e;
  const s = r === "fixed", o = hn(i), a = t ? ns(t.floating) : !1;
  if (i === o || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = cn(1);
  const c = cn(0), f = fn(i);
  if ((f || !f && !s) && ((Ci(i) !== "body" || sr(o)) && (l = is(i)), fn(i))) {
    const p = qn(i);
    d = ai(i), c.x = p.x + i.clientLeft, c.y = p.y + i.clientTop;
  }
  const h = o && !f && !s ? gf(o, l, !0) : cn(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - l.scrollLeft * d.x + c.x + h.x,
    y: n.y * d.y - l.scrollTop * d.y + c.y + h.y
  };
}
function R2(e) {
  return Array.from(e.getClientRects());
}
function D2(e) {
  const t = hn(e), n = is(e), i = e.ownerDocument.body, r = Hn(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), s = Hn(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let o = -n.scrollLeft + xa(e);
  const a = -n.scrollTop;
  return nn(i).direction === "rtl" && (o += Hn(t.clientWidth, i.clientWidth) - r), {
    width: r,
    height: s,
    x: o,
    y: a
  };
}
function I2(e, t) {
  const n = At(e), i = hn(e), r = n.visualViewport;
  let s = i.clientWidth, o = i.clientHeight, a = 0, l = 0;
  if (r) {
    s = r.width, o = r.height;
    const d = ya();
    (!d || d && t === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function O2(e, t) {
  const n = qn(e, !0, t === "fixed"), i = n.top + e.clientTop, r = n.left + e.clientLeft, s = fn(e) ? ai(e) : cn(1), o = e.clientWidth * s.x, a = e.clientHeight * s.y, l = r * s.x, d = i * s.y;
  return {
    width: o,
    height: a,
    x: l,
    y: d
  };
}
function vu(e, t, n) {
  let i;
  if (t === "viewport")
    i = I2(e, n);
  else if (t === "document")
    i = D2(hn(e));
  else if (tn(t))
    i = O2(t, n);
  else {
    const r = mf(e);
    i = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Fr(i);
}
function yf(e, t) {
  const n = Pn(e);
  return n === t || !tn(n) || yi(n) ? !1 : nn(n).position === "fixed" || yf(n, t);
}
function L2(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let i = Xi(e, [], !1).filter((a) => tn(a) && Ci(a) !== "body"), r = null;
  const s = nn(e).position === "fixed";
  let o = s ? Pn(e) : e;
  for (; tn(o) && !yi(o); ) {
    const a = nn(o), l = ga(o);
    !l && a.position === "fixed" && (r = null), (s ? !l && !r : !l && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || sr(o) && !l && yf(e, o)) ? i = i.filter((c) => c !== o) : r = a, o = Pn(o);
  }
  return t.set(e, i), i;
}
function V2(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: i,
    strategy: r
  } = e;
  const o = [...n === "clippingAncestors" ? ns(t) ? [] : L2(t, this._c) : [].concat(n), i], a = o[0], l = o.reduce((d, c) => {
    const f = vu(t, c, r);
    return d.top = Hn(f.top, d.top), d.right = mi(f.right, d.right), d.bottom = mi(f.bottom, d.bottom), d.left = Hn(f.left, d.left), d;
  }, vu(t, a, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function $2(e) {
  const {
    width: t,
    height: n
  } = pf(e);
  return {
    width: t,
    height: n
  };
}
function F2(e, t, n) {
  const i = fn(t), r = hn(t), s = n === "fixed", o = qn(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = cn(0);
  if (i || !i && !s)
    if ((Ci(t) !== "body" || sr(r)) && (a = is(t)), i) {
      const h = qn(t, !0, s, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else r && (l.x = xa(r));
  const d = r && !i && !s ? gf(r, a) : cn(0), c = o.left + a.scrollLeft - l.x - d.x, f = o.top + a.scrollTop - l.y - d.y;
  return {
    x: c,
    y: f,
    width: o.width,
    height: o.height
  };
}
function As(e) {
  return nn(e).position === "static";
}
function xu(e, t) {
  if (!fn(e) || nn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return hn(e) === n && (n = n.ownerDocument.body), n;
}
function vf(e, t) {
  const n = At(e);
  if (ns(e))
    return n;
  if (!fn(e)) {
    let r = Pn(e);
    for (; r && !yi(r); ) {
      if (tn(r) && !As(r))
        return r;
      r = Pn(r);
    }
    return n;
  }
  let i = xu(e, t);
  for (; i && _2(i) && As(i); )
    i = xu(i, t);
  return i && yi(i) && As(i) && !ga(i) ? n : i || N2(e) || n;
}
const B2 = async function(e) {
  const t = this.getOffsetParent || vf, n = this.getDimensions, i = await n(e.floating);
  return {
    reference: F2(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function U2(e) {
  return nn(e).direction === "rtl";
}
const z2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: P2,
  getDocumentElement: hn,
  getClippingRect: V2,
  getOffsetParent: vf,
  getElementRects: B2,
  getClientRects: R2,
  getDimensions: $2,
  getScale: ai,
  isElement: tn,
  isRTL: U2
};
function xf(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function W2(e, t) {
  let n = null, i;
  const r = hn(e);
  function s() {
    var a;
    clearTimeout(i), (a = n) == null || a.disconnect(), n = null;
  }
  function o(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const d = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: h,
      height: p
    } = d;
    if (a || t(), !h || !p)
      return;
    const y = xr(f), v = xr(r.clientWidth - (c + h)), w = xr(r.clientHeight - (f + p)), x = xr(c), k = {
      rootMargin: -y + "px " + -v + "px " + -w + "px " + -x + "px",
      threshold: Hn(0, mi(1, l)) || 1
    };
    let P = !0;
    function j(N) {
      const C = N[0].intersectionRatio;
      if (C !== l) {
        if (!P)
          return o();
        C ? o(!1, C) : i = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !xf(d, e.getBoundingClientRect()) && o(), P = !1;
    }
    try {
      n = new IntersectionObserver(j, {
        ...k,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(j, k);
    }
    n.observe(e);
  }
  return o(!0), s;
}
function H2(e, t, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = i, d = va(e), c = r || s ? [...d ? Xi(d) : [], ...Xi(t)] : [];
  c.forEach((x) => {
    r && x.addEventListener("scroll", n, {
      passive: !0
    }), s && x.addEventListener("resize", n);
  });
  const f = d && a ? W2(d, n) : null;
  let h = -1, p = null;
  o && (p = new ResizeObserver((x) => {
    let [S] = x;
    S && S.target === d && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var k;
      (k = p) == null || k.observe(t);
    })), n();
  }), d && !l && p.observe(d), p.observe(t));
  let y, v = l ? qn(e) : null;
  l && w();
  function w() {
    const x = qn(e);
    v && !xf(v, x) && n(), v = x, y = requestAnimationFrame(w);
  }
  return n(), () => {
    var x;
    c.forEach((S) => {
      r && S.removeEventListener("scroll", n), s && S.removeEventListener("resize", n);
    }), f == null || f(), (x = p) == null || x.disconnect(), p = null, l && cancelAnimationFrame(y);
  };
}
const K2 = k2, Y2 = E2, G2 = T2, q2 = j2, bu = (e, t, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: z2,
    ...n
  }, s = {
    ...r.platform,
    _c: i
  };
  return S2(e, t, {
    ...r,
    platform: s
  });
};
var Ms = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wu;
function X2() {
  return wu || (wu = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var s = "", o = 0; o < arguments.length; o++) {
          var a = arguments[o];
          a && (s = r(s, i(a)));
        }
        return s;
      }
      function i(s) {
        if (typeof s == "string" || typeof s == "number")
          return s;
        if (typeof s != "object")
          return "";
        if (Array.isArray(s))
          return n.apply(null, s);
        if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
          return s.toString();
        var o = "";
        for (var a in s)
          t.call(s, a) && s[a] && (o = r(o, a));
        return o;
      }
      function r(s, o) {
        return o ? s ? s + " " + o : s + o : s;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(Ms)), Ms.exports;
}
var Z2 = X2();
const bo = /* @__PURE__ */ Ou(Z2);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const J2 = "react-tooltip-core-styles", Q2 = "react-tooltip-base-styles", Su = { core: !1, base: !1 };
function ju({ css: e, id: t = Q2, type: n = "base", ref: i }) {
  var r, s;
  if (!e || typeof document > "u" || Su[n] || n === "core" && typeof process < "u" && (!((r = process == null ? void 0 : process.env) === null || r === void 0) && r.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((s = process == null ? void 0 : process.env) === null || s === void 0) && s.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = J2), i || (i = {});
  const { insertAt: o } = i;
  if (document.getElementById(t)) return;
  const a = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = t, l.type = "text/css", o === "top" && a.firstChild ? a.insertBefore(l, a.firstChild) : a.appendChild(l), l.styleSheet ? l.styleSheet.cssText = e : l.appendChild(document.createTextNode(e)), Su[n] = !0;
}
const Tu = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: i = "top", offset: r = 10, strategy: s = "absolute", middlewares: o = [K2(Number(r)), G2({ fallbackAxisSideDirection: "start" }), Y2({ padding: 5 })], border: a, arrowSize: l = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: i };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: i };
  const d = o;
  return n ? (d.push(q2({ element: n, padding: 5 })), bu(e, t, { placement: i, strategy: s, middleware: d }).then(({ x: c, y: f, placement: h, middlewareData: p }) => {
    var y, v;
    const w = { left: `${c}px`, top: `${f}px`, border: a }, { x, y: S } = (y = p.arrow) !== null && y !== void 0 ? y : { x: 0, y: 0 }, k = (v = { top: "bottom", right: "left", bottom: "top", left: "right" }[h.split("-")[0]]) !== null && v !== void 0 ? v : "bottom", P = a && { borderBottom: a, borderRight: a };
    let j = 0;
    if (a) {
      const N = `${a}`.match(/(\d+)px/);
      j = N != null && N[1] ? Number(N[1]) : 1;
    }
    return { tooltipStyles: w, tooltipArrowStyles: { left: x != null ? `${x}px` : "", top: S != null ? `${S}px` : "", right: "", bottom: "", ...P, [k]: `-${l / 2 + j}px` }, place: h };
  })) : bu(e, t, { placement: "bottom", strategy: s, middleware: d }).then(({ x: c, y: f, placement: h }) => ({ tooltipStyles: { left: `${c}px`, top: `${f}px` }, tooltipArrowStyles: {}, place: h }));
}, Cu = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), ku = (e, t, n) => {
  let i = null;
  const r = function(...s) {
    const o = () => {
      i = null;
    };
    !i && (e.apply(this, s), i = setTimeout(o, t));
  };
  return r.cancel = () => {
    i && (clearTimeout(i), i = null);
  }, r;
}, Eu = (e) => e !== null && !Array.isArray(e) && typeof e == "object", wo = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((r, s) => wo(r, t[s]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!Eu(e) || !Eu(t)) return e === t;
  const n = Object.keys(e), i = Object.keys(t);
  return n.length === i.length && n.every((r) => wo(e[r], t[r]));
}, eS = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const i = t.getPropertyValue(n);
    return i === "auto" || i === "scroll";
  });
}, _u = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (eS(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, tS = typeof window < "u" ? Br : he, Vt = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, nS = "DEFAULT_TOOLTIP_ID", iS = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, rS = Rn({ getTooltipData: () => iS });
function bf(e = nS) {
  return ut(rS).getTooltipData(e);
}
var Qn = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Ps = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const sS = ({ forwardRef: e, id: t, className: n, classNameArrow: i, variant: r = "dark", anchorId: s, anchorSelect: o, place: a = "top", offset: l = 10, events: d = ["hover"], openOnClick: c = !1, positionStrategy: f = "absolute", middlewares: h, wrapper: p, delayShow: y = 0, delayHide: v = 0, float: w = !1, hidden: x = !1, noArrow: S = !1, clickable: k = !1, closeOnEsc: P = !1, closeOnScroll: j = !1, closeOnResize: N = !1, openEvents: C, closeEvents: R, globalCloseEvents: I, imperativeModeOnly: U, style: W, position: ae, afterShow: $, afterHide: V, disableTooltip: K, content: se, contentWrapperRef: G, isOpen: te, defaultIsOpen: le = !1, setIsOpen: Ce, previousActiveAnchor: ce, activeAnchor: q, setActiveAnchor: ne, border: oe, opacity: ie, arrowColor: ye, arrowSize: Me = 8, role: Pe = "tooltip" }) => {
  var Ee;
  const _e = pe(null), Ye = pe(null), Re = pe(null), lt = pe(null), Ct = pe(null), [We, wt] = de({ tooltipStyles: {}, tooltipArrowStyles: {}, place: a }), [He, gt] = de(!1), [ft, $e] = de(!1), [De, kt] = de(null), pn = pe(!1), Ut = pe(null), { anchorRefs: rn, setActiveAnchor: zt } = bf(t), Wt = pe(!1), [Et, Ht] = de([]), _t = pe(!1), Kt = c || d.includes("click"), mn = Kt || (C == null ? void 0 : C.click) || (C == null ? void 0 : C.dblclick) || (C == null ? void 0 : C.mousedown), sn = C ? { ...C } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !C && Kt && Object.assign(sn, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Nt = R ? { ...R } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !R && Kt && Object.assign(Nt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const Je = I ? { ...I } : { escape: P || !1, scroll: j || !1, resize: N || !1, clickOutsideAnchor: mn || !1 };
  U && (Object.assign(sn, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Nt, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(Je, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), tS(() => (_t.current = !0, () => {
    _t.current = !1;
  }), []);
  const ct = (Y) => {
    _t.current && (Y && $e(!0), setTimeout(() => {
      _t.current && (Ce == null || Ce(Y), te === void 0 && gt(Y));
    }, 10));
  };
  he(() => {
    if (t) {
      if (He) {
        ee(ce);
        const J = Y(q), Ae = [.../* @__PURE__ */ new Set([...J, t])].filter(Boolean).join(" ");
        q == null || q.setAttribute("aria-describedby", Ae);
      } else ee(q);
      return () => {
        ee(q), ee(ce);
      };
    }
    function Y(J) {
      var Ae;
      return ((Ae = J == null ? void 0 : J.getAttribute("aria-describedby")) === null || Ae === void 0 ? void 0 : Ae.split(" ")) || [];
    }
    function ee(J) {
      const Ae = Y(J).filter((Ze) => Ze !== t);
      Ae.length ? J == null || J.setAttribute("aria-describedby", Ae.join(" ")) : J == null || J.removeAttribute("aria-describedby");
    }
  }, [q, He, t, ce]), he(() => {
    if (te === void 0) return () => null;
    te && $e(!0);
    const Y = setTimeout(() => {
      gt(te);
    }, 10);
    return () => {
      clearTimeout(Y);
    };
  }, [te]), he(() => {
    if (He !== pn.current) if (Vt(Ct), pn.current = He, He) $ == null || $();
    else {
      const Y = ((ee) => {
        const J = ee.match(/^([\d.]+)(ms|s)$/);
        if (!J) return 0;
        const [, Ae, Ze] = J;
        return Number(Ae) * (Ze === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Ct.current = setTimeout(() => {
        $e(!1), kt(null), V == null || V();
      }, Y + 25);
    }
  }, [He]);
  const Yt = (Y) => {
    wt((ee) => wo(ee, Y) ? ee : Y);
  }, Mt = (Y = y) => {
    Vt(Re), ft ? ct(!0) : Re.current = setTimeout(() => {
      ct(!0);
    }, Y);
  }, Gt = (Y = v) => {
    Vt(lt), lt.current = setTimeout(() => {
      Wt.current || ct(!1);
    }, Y);
  }, Qe = (Y) => {
    var ee;
    if (!Y) return;
    const J = (ee = Y.currentTarget) !== null && ee !== void 0 ? ee : Y.target;
    if (!(J != null && J.isConnected)) return ne(null), void zt({ current: null });
    y ? Mt() : ct(!0), ne(J), zt({ current: J }), Vt(lt);
  }, Pt = () => {
    k ? Gt(v || 100) : v ? Gt() : ct(!1), Vt(Re);
  }, Rt = ({ x: Y, y: ee }) => {
    var J;
    const Ae = { getBoundingClientRect: () => ({ x: Y, y: ee, width: 0, height: 0, top: ee, left: Y, right: Y, bottom: ee }) };
    Tu({ place: (J = De == null ? void 0 : De.place) !== null && J !== void 0 ? J : a, offset: l, elementReference: Ae, tooltipReference: _e.current, tooltipArrowReference: Ye.current, strategy: f, middlewares: h, border: oe, arrowSize: Me }).then((Ze) => {
      Yt(Ze);
    });
  }, Dt = (Y) => {
    if (!Y) return;
    const ee = Y, J = { x: ee.clientX, y: ee.clientY };
    Rt(J), Ut.current = J;
  }, gn = (Y) => {
    var ee;
    if (!He) return;
    const J = Y.target;
    J.isConnected && (!((ee = _e.current) === null || ee === void 0) && ee.contains(J) || [document.querySelector(`[id='${s}']`), ...Et].some((Ae) => Ae == null ? void 0 : Ae.contains(J)) || (ct(!1), Vt(Re)));
  }, yn = ku(Qe, 50), Ke = ku(Pt, 50), it = (Y) => {
    Ke.cancel(), yn(Y);
  }, re = () => {
    yn.cancel(), Ke();
  }, Se = Ne(() => {
    var Y, ee;
    const J = (Y = De == null ? void 0 : De.position) !== null && Y !== void 0 ? Y : ae;
    J ? Rt(J) : w ? Ut.current && Rt(Ut.current) : q != null && q.isConnected && Tu({ place: (ee = De == null ? void 0 : De.place) !== null && ee !== void 0 ? ee : a, offset: l, elementReference: q, tooltipReference: _e.current, tooltipArrowReference: Ye.current, strategy: f, middlewares: h, border: oe, arrowSize: Me }).then((Ae) => {
      _t.current && Yt(Ae);
    });
  }, [He, q, se, W, a, De == null ? void 0 : De.place, l, f, ae, De == null ? void 0 : De.position, w, Me]);
  he(() => {
    var Y, ee;
    const J = new Set(rn);
    Et.forEach((xe) => {
      K != null && K(xe) || J.add({ current: xe });
    });
    const Ae = document.querySelector(`[id='${s}']`);
    Ae && !(K != null && K(Ae)) && J.add({ current: Ae });
    const Ze = () => {
      ct(!1);
    }, b = _u(q), O = _u(_e.current);
    Je.scroll && (window.addEventListener("scroll", Ze), b == null || b.addEventListener("scroll", Ze), O == null || O.addEventListener("scroll", Ze));
    let z = null;
    Je.resize ? window.addEventListener("resize", Ze) : q && _e.current && (z = H2(q, _e.current, Se, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const X = (xe) => {
      xe.key === "Escape" && ct(!1);
    };
    Je.escape && window.addEventListener("keydown", X), Je.clickOutsideAnchor && window.addEventListener("click", gn);
    const Q = [], ke = (xe) => !!(xe != null && xe.target && (q != null && q.contains(xe.target))), je = (xe) => {
      He && ke(xe) || Qe(xe);
    }, ve = (xe) => {
      He && ke(xe) && Pt();
    }, rt = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Fe = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(sn).forEach(([xe, Ie]) => {
      Ie && (rt.includes(xe) ? Q.push({ event: xe, listener: it }) : Fe.includes(xe) && Q.push({ event: xe, listener: je }));
    }), Object.entries(Nt).forEach(([xe, Ie]) => {
      Ie && (rt.includes(xe) ? Q.push({ event: xe, listener: re }) : Fe.includes(xe) && Q.push({ event: xe, listener: ve }));
    }), w && Q.push({ event: "pointermove", listener: Dt });
    const Be = () => {
      Wt.current = !0;
    }, pt = () => {
      Wt.current = !1, Pt();
    }, qt = k && (Nt.mouseout || Nt.mouseleave);
    return qt && ((Y = _e.current) === null || Y === void 0 || Y.addEventListener("mouseover", Be), (ee = _e.current) === null || ee === void 0 || ee.addEventListener("mouseout", pt)), Q.forEach(({ event: xe, listener: Ie }) => {
      J.forEach((on) => {
        var St;
        (St = on.current) === null || St === void 0 || St.addEventListener(xe, Ie);
      });
    }), () => {
      var xe, Ie;
      Je.scroll && (window.removeEventListener("scroll", Ze), b == null || b.removeEventListener("scroll", Ze), O == null || O.removeEventListener("scroll", Ze)), Je.resize ? window.removeEventListener("resize", Ze) : z == null || z(), Je.clickOutsideAnchor && window.removeEventListener("click", gn), Je.escape && window.removeEventListener("keydown", X), qt && ((xe = _e.current) === null || xe === void 0 || xe.removeEventListener("mouseover", Be), (Ie = _e.current) === null || Ie === void 0 || Ie.removeEventListener("mouseout", pt)), Q.forEach(({ event: on, listener: St }) => {
        J.forEach((ki) => {
          var Tn;
          (Tn = ki.current) === null || Tn === void 0 || Tn.removeEventListener(on, St);
        });
      });
    };
  }, [q, Se, ft, rn, Et, C, R, I, Kt, y, v]), he(() => {
    var Y, ee;
    let J = (ee = (Y = De == null ? void 0 : De.anchorSelect) !== null && Y !== void 0 ? Y : o) !== null && ee !== void 0 ? ee : "";
    !J && t && (J = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const Ae = new MutationObserver((Ze) => {
      const b = [], O = [];
      Ze.forEach((z) => {
        if (z.type === "attributes" && z.attributeName === "data-tooltip-id" && (z.target.getAttribute("data-tooltip-id") === t ? b.push(z.target) : z.oldValue === t && O.push(z.target)), z.type === "childList") {
          if (q) {
            const X = [...z.removedNodes].filter((Q) => Q.nodeType === 1);
            if (J) try {
              O.push(...X.filter((Q) => Q.matches(J))), O.push(...X.flatMap((Q) => [...Q.querySelectorAll(J)]));
            } catch {
            }
            X.some((Q) => {
              var ke;
              return !!(!((ke = Q == null ? void 0 : Q.contains) === null || ke === void 0) && ke.call(Q, q)) && ($e(!1), ct(!1), ne(null), Vt(Re), Vt(lt), !0);
            });
          }
          if (J) try {
            const X = [...z.addedNodes].filter((Q) => Q.nodeType === 1);
            b.push(...X.filter((Q) => Q.matches(J))), b.push(...X.flatMap((Q) => [...Q.querySelectorAll(J)]));
          } catch {
          }
        }
      }), (b.length || O.length) && Ht((z) => [...z.filter((X) => !O.includes(X)), ...b]);
    });
    return Ae.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Ae.disconnect();
    };
  }, [t, o, De == null ? void 0 : De.anchorSelect, q]), he(() => {
    Se();
  }, [Se]), he(() => {
    if (!(G != null && G.current)) return () => null;
    const Y = new ResizeObserver(() => {
      setTimeout(() => Se());
    });
    return Y.observe(G.current), () => {
      Y.disconnect();
    };
  }, [se, G == null ? void 0 : G.current]), he(() => {
    var Y;
    const ee = document.querySelector(`[id='${s}']`), J = [...Et, ee];
    q && J.includes(q) || ne((Y = Et[0]) !== null && Y !== void 0 ? Y : ee);
  }, [s, Et, q]), he(() => (le && ct(!0), () => {
    Vt(Re), Vt(lt);
  }), []), he(() => {
    var Y;
    let ee = (Y = De == null ? void 0 : De.anchorSelect) !== null && Y !== void 0 ? Y : o;
    if (!ee && t && (ee = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), ee) try {
      const J = Array.from(document.querySelectorAll(ee));
      Ht(J);
    } catch {
      Ht([]);
    }
  }, [t, o, De == null ? void 0 : De.anchorSelect]), he(() => {
    Re.current && (Vt(Re), Mt(y));
  }, [y]);
  const ht = (Ee = De == null ? void 0 : De.content) !== null && Ee !== void 0 ? Ee : se, It = He && Object.keys(We.tooltipStyles).length > 0;
  return Df(e, () => ({ open: (Y) => {
    if (Y != null && Y.anchorSelect) try {
      document.querySelector(Y.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${Y.anchorSelect}" is not a valid CSS selector`);
    }
    kt(Y ?? null), Y != null && Y.delay ? Mt(Y.delay) : ct(!0);
  }, close: (Y) => {
    Y != null && Y.delay ? Gt(Y.delay) : ct(!1);
  }, activeAnchor: q, place: We.place, isOpen: !!(ft && !x && ht && It) })), ft && !x && ht ? we.createElement(p, { id: t, role: Pe, className: bo("react-tooltip", Qn.tooltip, Ps.tooltip, Ps[r], n, `react-tooltip__place-${We.place}`, Qn[It ? "show" : "closing"], It ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && Qn.fixed, k && Qn.clickable), onTransitionEnd: (Y) => {
    Vt(Ct), He || Y.propertyName !== "opacity" || ($e(!1), kt(null), V == null || V());
  }, style: { ...W, ...We.tooltipStyles, opacity: ie !== void 0 && It ? ie : void 0 }, ref: _e }, ht, we.createElement(p, { className: bo("react-tooltip-arrow", Qn.arrow, Ps.arrow, i, S && Qn.noArrow), style: { ...We.tooltipArrowStyles, background: ye ? `linear-gradient(to right bottom, transparent 50%, ${ye} 50%)` : void 0, "--rt-arrow-size": `${Me}px` }, ref: Ye })) : null;
}, oS = ({ content: e }) => we.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), ba = we.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: i, html: r, render: s, className: o, classNameArrow: a, variant: l = "dark", place: d = "top", offset: c = 10, wrapper: f = "div", children: h = null, events: p = ["hover"], openOnClick: y = !1, positionStrategy: v = "absolute", middlewares: w, delayShow: x = 0, delayHide: S = 0, float: k = !1, hidden: P = !1, noArrow: j = !1, clickable: N = !1, closeOnEsc: C = !1, closeOnScroll: R = !1, closeOnResize: I = !1, openEvents: U, closeEvents: W, globalCloseEvents: ae, imperativeModeOnly: $ = !1, style: V, position: K, isOpen: se, defaultIsOpen: G = !1, disableStyleInjection: te = !1, border: le, opacity: Ce, arrowColor: ce, arrowSize: q, setIsOpen: ne, afterShow: oe, afterHide: ie, disableTooltip: ye, role: Me = "tooltip" }, Pe) => {
  const [Ee, _e] = de(i), [Ye, Re] = de(r), [lt, Ct] = de(d), [We, wt] = de(l), [He, gt] = de(c), [ft, $e] = de(x), [De, kt] = de(S), [pn, Ut] = de(k), [rn, zt] = de(P), [Wt, Et] = de(f), [Ht, _t] = de(p), [Kt, mn] = de(v), [sn, Nt] = de(null), [Je, ct] = de(null), Yt = pe(null), Mt = pe(te), { anchorRefs: Gt, activeAnchor: Qe } = bf(e), Pt = (Ke) => Ke == null ? void 0 : Ke.getAttributeNames().reduce((it, re) => {
    var Se;
    return re.startsWith("data-tooltip-") && (it[re.replace(/^data-tooltip-/, "")] = (Se = Ke == null ? void 0 : Ke.getAttribute(re)) !== null && Se !== void 0 ? Se : null), it;
  }, {}), Rt = (Ke) => {
    const it = { place: (re) => {
      var Se;
      Ct((Se = re) !== null && Se !== void 0 ? Se : d);
    }, content: (re) => {
      _e(re ?? i);
    }, html: (re) => {
      Re(re ?? r);
    }, variant: (re) => {
      var Se;
      wt((Se = re) !== null && Se !== void 0 ? Se : l);
    }, offset: (re) => {
      gt(re === null ? c : Number(re));
    }, wrapper: (re) => {
      var Se;
      Et((Se = re) !== null && Se !== void 0 ? Se : f);
    }, events: (re) => {
      const Se = re == null ? void 0 : re.split(" ");
      _t(Se ?? p);
    }, "position-strategy": (re) => {
      var Se;
      mn((Se = re) !== null && Se !== void 0 ? Se : v);
    }, "delay-show": (re) => {
      $e(re === null ? x : Number(re));
    }, "delay-hide": (re) => {
      kt(re === null ? S : Number(re));
    }, float: (re) => {
      Ut(re === null ? k : re === "true");
    }, hidden: (re) => {
      zt(re === null ? P : re === "true");
    }, "class-name": (re) => {
      Nt(re);
    } };
    Object.values(it).forEach((re) => re(null)), Object.entries(Ke).forEach(([re, Se]) => {
      var ht;
      (ht = it[re]) === null || ht === void 0 || ht.call(it, Se);
    });
  };
  he(() => {
    _e(i);
  }, [i]), he(() => {
    Re(r);
  }, [r]), he(() => {
    Ct(d);
  }, [d]), he(() => {
    wt(l);
  }, [l]), he(() => {
    gt(c);
  }, [c]), he(() => {
    $e(x);
  }, [x]), he(() => {
    kt(S);
  }, [S]), he(() => {
    Ut(k);
  }, [k]), he(() => {
    zt(P);
  }, [P]), he(() => {
    mn(v);
  }, [v]), he(() => {
    Mt.current !== te && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [te]), he(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: te === "core", disableBase: te } }));
  }, []), he(() => {
    var Ke;
    const it = new Set(Gt);
    let re = n;
    if (!re && e && (re = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), re) try {
      document.querySelectorAll(re).forEach((ee) => {
        it.add({ current: ee });
      });
    } catch {
      console.warn(`[react-tooltip] "${re}" is not a valid CSS selector`);
    }
    const Se = document.querySelector(`[id='${t}']`);
    if (Se && it.add({ current: Se }), !it.size) return () => null;
    const ht = (Ke = Je ?? Se) !== null && Ke !== void 0 ? Ke : Qe.current, It = new MutationObserver((ee) => {
      ee.forEach((J) => {
        var Ae;
        if (!ht || J.type !== "attributes" || !(!((Ae = J.attributeName) === null || Ae === void 0) && Ae.startsWith("data-tooltip-"))) return;
        const Ze = Pt(ht);
        Rt(Ze);
      });
    }), Y = { attributes: !0, childList: !1, subtree: !1 };
    if (ht) {
      const ee = Pt(ht);
      Rt(ee), It.observe(ht, Y);
    }
    return () => {
      It.disconnect();
    };
  }, [Gt, Qe, Je, t, n]), he(() => {
    V != null && V.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), le && !Cu("border", `${le}`) && console.warn(`[react-tooltip] "${le}" is not a valid \`border\`.`), V != null && V.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), Ce && !Cu("opacity", `${Ce}`) && console.warn(`[react-tooltip] "${Ce}" is not a valid \`opacity\`.`);
  }, []);
  let Dt = h;
  const gn = pe(null);
  if (s) {
    const Ke = s({ content: (Je == null ? void 0 : Je.getAttribute("data-tooltip-content")) || Ee || null, activeAnchor: Je });
    Dt = Ke ? we.createElement("div", { ref: gn, className: "react-tooltip-content-wrapper" }, Ke) : null;
  } else Ee && (Dt = Ee);
  Ye && (Dt = we.createElement(oS, { content: Ye }));
  const yn = { forwardRef: Pe, id: e, anchorId: t, anchorSelect: n, className: bo(o, sn), classNameArrow: a, content: Dt, contentWrapperRef: gn, place: lt, variant: We, offset: He, wrapper: Wt, events: Ht, openOnClick: y, positionStrategy: Kt, middlewares: w, delayShow: ft, delayHide: De, float: pn, hidden: rn, noArrow: j, clickable: N, closeOnEsc: C, closeOnScroll: R, closeOnResize: I, openEvents: U, closeEvents: W, globalCloseEvents: ae, imperativeModeOnly: $, style: V, position: K, isOpen: se, defaultIsOpen: G, border: le, opacity: Ce, arrowColor: ce, arrowSize: q, setIsOpen: ne, afterShow: oe, afterHide: ie, disableTooltip: ye, activeAnchor: Je, previousActiveAnchor: Yt.current, setActiveAnchor: (Ke) => {
    ct((it) => (Ke != null && Ke.isSameNode(it) || (Yt.current = it), Ke));
  }, role: Me };
  return we.createElement(sS, { ...yn });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || ju({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || ju({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const aS = ({ inputTextRef: e, isBlockedConv: t }) => {
  const { useConversations: n, useMessages: i } = at(), { getSelectedConversation: r } = n(), { summarizeMessages: s, changeMessageTone: o } = i(), [a, l] = de(!1), [d, c] = de(!1), h = r()._id, p = (w, x = "") => w.map((S, k) => /* @__PURE__ */ u.jsxs(
    "button",
    {
      className: `z-6 flex cursor-pointer items-center gap-[7px] ${x} ${S.customStyle}`,
      onClick: S.onClick,
      children: [
        S.icon,
        S.label
      ]
    },
    k
  )), y = async (w) => {
    l(!1), await s(h, w);
  }, v = async (w) => {
    l(!1);
    const x = e.current.value;
    if (!x.length) {
      console.log("No text to change.");
      return;
    }
    c(!0);
    const S = await o(x, w);
    S && (e.current.value = S, console.log("Message formatted.")), c(!1);
  };
  return /* @__PURE__ */ u.jsxs("div", { className: "magic-wand ui:flex ui:items-center ui:justify-center ui:rounded-xl", children: [
    d ? /* @__PURE__ */ u.jsx(Sn, { width: 28, height: 28 }) : /* @__PURE__ */ u.jsx(
      zh,
      {
        size: 28,
        "data-tooltip-id": "editor-options-tooltip",
        "data-tooltip-delay-hide": 500,
        color: "var(--color-accent-500)",
        className: "ui:cursor-pointer",
        onClick: () => l((w) => !w)
      }
    ),
    /* @__PURE__ */ u.jsx(
      ba,
      {
        clickable: !0,
        events: ["click"],
        isOpen: a,
        id: "editor-options-tooltip",
        className: "editor-tooltip-style",
        classNameArrow: "editor-tooltip-arrow",
        children: /* @__PURE__ */ u.jsx("div", { className: "ui:z-10 ui:flex ui:flex-col ui:justify-start ui:gap-2", children: p(
          [
            {
              label: "Get summary:",
              customStyle: "ui:pb-1.25 ui:text-left! ui:text-lg! ui:text-black/80! ui:cursor-auto!",
              icon: /* @__PURE__ */ u.jsx(Lh, { size: 18 })
            },
            // {
            //   label: "- unreads",
            //   onClick: async () => await summarizeActionOnClick("unreads"),
            //   customStyle:
            //     "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:hover:text-accent-500!",
            // },
            {
              label: "- last day",
              onClick: async () => await y("last-day"),
              customStyle: "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:text-base! ui:font-light! ui:hover:text-accent-500!"
            },
            {
              label: "- last 7 days",
              onClick: async () => await y("last-7-days"),
              customStyle: "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:text-base! ui:font-light! ui:hover:text-accent-500!"
            },
            ...t ? [] : [
              {
                label: "Change tone:",
                customStyle: "ui:pb-1.25 ui:text-left! ui:text-lg! ui:text-black/80! ui:cursor-auto!",
                icon: /* @__PURE__ */ u.jsx(ih, { size: 18 })
              },
              {
                label: "- positive",
                onClick: async () => await v("positive"),
                customStyle: "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:text-base! ui:font-light! ui:hover:text-accent-500!"
              },
              {
                label: "- negative",
                onClick: async () => await v("negative"),
                customStyle: "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:text-base! ui:font-light! ui:hover:text-accent-500!"
              },
              {
                label: "- cringe",
                onClick: async () => await v("cringe"),
                customStyle: "ui:-mt-2.5! ui:ml-2.5! ui:text-left! ui:text-base! ui:font-light! ui:hover:text-accent-500!"
              }
            ]
          ],
          " ui:text-text-dark"
        ) })
      }
    )
  ] });
}, lS = ({
  inputTextRef: e,
  onSubmitFunc: t,
  isBlockedConv: n,
  isEditAction: i,
  isMobile: r = !1,
  isSending: s = !1,
  isEnableMagicButton: o = !1,
  onOpenAttachmentHub: a,
  isLocationIncludeAttach: l = !1
}) => {
  const { useConversations: d, useDrafts: c, formatedUtils: f, mediaUtils: h } = at(), { getSelectedConversation: p, sendTypingStatus: y } = d(), { saveDraft: v, removeDraftWithOptions: w, getDraftMessage: x, flushDraftToLocalStorage: S } = c(), { calcInputHeight: k } = f, { extractFilesFromClipboard: P } = h, j = pe(null), C = p()._id, R = ($) => {
    const V = $.target.value;
    if (V.length > 0) {
      const K = Tx;
      (!j.current || Date.now() - j.current > K - 1e3) && (y(C), j.current = Date.now());
    }
    e.current && ((V == null ? void 0 : V.length) > 0 ? v(C, { text: V }) : w(C, "text"), e.current.style.height = `${k(V)}px`, e.current.scrollTop = e.current.scrollHeight);
  }, I = ($) => {
    $.keyCode === en.ENTER && (!r && !$.shiftKey || r && $.shiftKey) && ($.preventDefault(), t($));
  }, U = ($) => {
    R($), i && C && S(C);
  }, W = () => {
    var V;
    const $ = (V = e.current) == null ? void 0 : V.value;
    $ && (v(C, { text: $ }), S(C), e.current.value = "", e.current.style.height = "28px");
  }, ae = () => {
    const $ = l ? "" : x(C);
    $ && !i && e.current && (e.current.value = $ || "", e.current.style.height = `${k($ || "")}px`, e.current.scrollTop = e.current.scrollHeight);
  };
  return he(() => ae(), [C, l, i]), he(() => {
    function $(K) {
      K.preventDefault(), K.stopPropagation();
    }
    function V(K) {
      var te, le;
      if (!C) return;
      let se = [];
      const G = K.clipboardData || ((te = K.originalEvent) == null ? void 0 : te.clipboardData);
      G != null && G.items ? se = P(G) : (le = K.dataTransfer) != null && le.files && (se = Array.from(K.dataTransfer.files)), se.length && (p2.setItem("attachFiles", se), a == null || a(), W());
    }
    return document.addEventListener("dragover", $), document.addEventListener("dragenter", $), document.addEventListener("dragleave", $), document.addEventListener("drop", V), document.addEventListener("paste", V), () => {
      document.removeEventListener("dragover", $), document.removeEventListener("dragenter", $), document.removeEventListener("dragleave", $), document.removeEventListener("drop", V), document.removeEventListener("paste", V);
    };
  }, [C, a]), /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-full ui:gap-2.5", children: [
    /* @__PURE__ */ u.jsx(
      "button",
      {
        className: "ui:h-max ui:cursor-pointer ui:self-end ui:rounded-xl ui:bg-white ui:p-2 ui:text-text-dark ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white",
        onClick: () => {
          s || (a == null || a(), W());
        },
        children: /* @__PURE__ */ u.jsx(kh, { size: 28 })
      }
    ),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:grow ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn", children: [
      /* @__PURE__ */ u.jsx(
        "textarea",
        {
          className: "ui:max-h-full ui:grow ui:resize-none ui:text-base ui:font-light ui:placeholder:text-base ui:focus:outline-hidden ui:max-xl:disabled:p-2.25 ui:[&::-webkit-scrollbar]:hidden",
          ref: e,
          onInput: R,
          onKeyDown: I,
          onBlur: U,
          autoComplete: "off",
          autoFocus: !r,
          disabled: s,
          placeholder: "Type your message..."
        }
      ),
      o ? /* @__PURE__ */ u.jsx(aS, { isBlockedConv: n, inputTextRef: e }) : null
    ] }),
    /* @__PURE__ */ u.jsx(
      "button",
      {
        className: "ui:h-max ui:cursor-pointer ui:self-end ui:rounded-xl ui:bg-white ui:p-2 ui:text-text-dark ui:shadow-btn ui:duration-150 ui:hover:bg-bg-dark ui:hover:text-white",
        onClick: s ? void 0 : ($) => t($),
        children: s ? /* @__PURE__ */ u.jsx(Sn, { width: 28, height: 28 }) : i ? /* @__PURE__ */ u.jsx(zr, { size: 28 }) : /* @__PURE__ */ u.jsx(Bh, { size: 28 })
      }
    )
  ] });
}, FS = ({
  chatMessagesBlockRef: e,
  editedMessage: t,
  isEnableMagicButton: n = !0,
  onOpenAttachmentHub: i,
  isLocationIncludeAttach: r,
  className: s,
  ...o
}) => {
  const { useDrafts: a, useMessages: l, useConversations: d, useParticipants: c, formatedUtils: f } = at(), {
    saveDraft: h,
    savePreEditComposeText: p,
    consumePreEditComposeText: y,
    getDraft: v,
    getDraftEditedMessageId: w,
    getDraftMessage: x,
    getExternalProps: S
  } = a(), { editMessage: k, createAndSendMessage: P } = l(), { getSelectedConversation: j } = d(), { getUserById: N } = c(), { calcInputHeight: C } = f, R = S(), I = j(), U = I == null ? void 0 : I._id, W = pe(null), ae = pe(void 0), $ = pe(!1), V = pe(!1), [K, se] = de(!1);
  he(() => {
    const ce = () => {
      W.current && W.current.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    };
    return window.addEventListener("resize", ce), () => window.removeEventListener("resize", ce);
  }, []);
  const G = async () => {
    var ne, oe;
    const ce = (oe = (ne = W.current) == null ? void 0 : ne.value) == null ? void 0 : oe.trim();
    if (ce === void 0) return;
    let q;
    t ? (q = await k(ce, I, t), V.current = !0) : (q = await P(
      ce,
      I,
      R,
      K,
      te,
      le,
      () => {
        W.current && (W.current.style.height = "28px");
      }
    ), setTimeout(() => {
      var ye;
      (ye = W.current) == null || ye.focus({ preventScroll: !0 });
      const ie = e.current;
      ie && (ie.scrollTop = ie.scrollHeight);
    }, 50)), W.current && (W.current.value = q || "");
  }, te = () => se(!0), le = () => se(!1);
  he(() => {
    var ne, oe;
    if (!W.current || !U) return;
    const ce = ae.current !== U;
    if (ce && (ae.current = U, $.current = !1, V.current = !1), t) {
      if (!$.current) {
        const Ee = ((ne = W.current) == null ? void 0 : ne.value) ?? "";
        Ee.length > 0 && p(U, Ee);
      }
      $.current = !0;
      const ie = v(U), ye = w(U) === t._id, Me = Object.prototype.hasOwnProperty.call(ie, "text"), Pe = ye && Me ? ie.text == null ? "" : String(ie.text) : t.body;
      h(U, { text: Pe }), W.current.value = Pe, W.current.style.height = `${C(Pe)}px`, (oe = W.current) == null || oe.focus({ preventScroll: !0 });
      return;
    }
    if ($.current && !ce) {
      if (V.current) {
        V.current = !1, $.current = !1;
        return;
      }
      const ie = y(U);
      W.current.value = ie, h(U, { text: ie }), W.current.style.height = `${C(ie)}px`;
      return;
    }
    $.current = !1;
    const q = x(U) || "";
    W.current.value = q, W.current.style.height = `${C(q)}px`;
  }, [U, t]), he(() => {
    var ce, q;
    (ce = R[U]) != null && ce.draft_replied_mid && ((q = W.current) == null || q.focus());
  }, [R]);
  const Ce = ze(() => {
    var oe, ie;
    const { type: ce, owner_id: q, opponent_id: ne } = I;
    return ce === "u" && !(ne && ((oe = N(ne)) != null && oe.login) && q && ((ie = N(q)) != null && ie.login));
  }, [I, N]);
  return Ce ? /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(
        "ui:mb-3.5 ui:flex ui:min-h-11 ui:w-full ui:justify-center ui:gap-2.5 ui:self-center ui:overflow-hidden ui:p-2 ui:lg:max-w-300",
        s
      ),
      ...o,
      children: /* @__PURE__ */ u.jsx("p", { className: "ui:font-light ui:text-text-dark", children: "The user you are currently chatting with has deleted their account. You can no longer continue the chat." })
    }
  ) : /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe("ui:flex ui:w-full ui:items-end ui:gap-2.5 ui:self-center ui:pb-3.5 ui:lg:max-w-300", s),
      ...o,
      children: /* @__PURE__ */ u.jsx(
        lS,
        {
          inputTextRef: W,
          isBlockedConv: Ce,
          isEditAction: !!t,
          isSending: K,
          isMobile: !1,
          isEnableMagicButton: n,
          onSubmitFunc: G,
          onOpenAttachmentHub: i,
          isLocationIncludeAttach: r
        }
      )
    }
  );
}, uS = ({ attachment: e, fileType: t, isSelected: n }) => {
  var s, o;
  const i = t ?? ((s = e.file_content_type) != null && s.startsWith("image") ? "Image" : (o = e.file_content_type) != null && o.startsWith("video") ? "Video" : "Image"), r = {
    Image: /* @__PURE__ */ u.jsx(To, { color: n ? "white" : "#6d6d6d", size: 16, strokeWidth: 1 }),
    Video: /* @__PURE__ */ u.jsx(np, { color: n ? "white" : "#6d6d6d", size: 16, strokeWidth: 1 })
  };
  return /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-4 ui:w-4 ui:items-center ui:justify-center", children: e.file_blur_hash ? /* @__PURE__ */ u.jsx(
    Qi,
    {
      hash: e.file_blur_hash,
      className: "ui:h-4! ui:w-4! ui:overflow-hidden ui:rounded-[3px]",
      resolutionX: 32,
      resolutionY: 32
    }
  ) : r[i] });
}, cS = ({
  message: e,
  draft: t,
  countOfUnreadMessages: n,
  isShowUserName: i,
  isSelected: r = !1
}) => {
  const { mediaUtils: s, userUtils: o, useParticipants: a } = at(), { getCurrentUser: l, getUserById: d } = a(), f = l()._id === (e == null ? void 0 : e.from), { text: h, replied_mid: p } = t || {};
  if (!e && !h && !p) return null;
  if ((h || p) && n < 1)
    return /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:items-center ui:gap-1.25 ui:overflow-y-hidden", children: [
      /* @__PURE__ */ u.jsxs("p", { className: "ui:flex ui:items-center ui:gap-0.75 ui:font-light ui:text-nowrap ui:text-accent-500", children: [
        p && /* @__PURE__ */ u.jsx(Bi, { strokeWidth: 2 }),
        " Draft:"
      ] }),
      /* @__PURE__ */ u.jsx("p", { className: "ui:w-full ui:overflow-hidden ui:font-extralight ui:text-ellipsis ui:whitespace-nowrap ui:text-text-dark", children: h })
    ] });
  const { attachments: y, body: v } = e || {}, w = y == null ? void 0 : y.slice(-1)[0], x = (k, P) => k || (P != null && P.file_name || P != null && P.file_content_type ? s.getFileType(P.file_name, P.file_content_type) : ""), S = ze(() => {
    if (f) return "You";
    if (e != null && e.from) {
      const k = d(e.from);
      return o.getLastMessageUserName(k);
    }
    return null;
  }, [f, e == null ? void 0 : e.from, d, o]);
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:items-center ui:gap-1.25 ui:overflow-y-hidden", children: [
      i ? /* @__PURE__ */ u.jsxs("p", { className: "ui:font-light ui:text-nowrap ui:text-accent-500", children: [
        S,
        ":"
      ] }) : null,
      w ? /* @__PURE__ */ u.jsx(uS, { isSelected: r, attachment: w }) : null,
      /* @__PURE__ */ u.jsx(
        "p",
        {
          className: "ui:w-full ui:overflow-hidden ui:font-extralight ui:text-ellipsis ui:whitespace-nowrap ui:normal-nums!",
          children: x(v, w)
        }
      )
    ] }),
    n > 0 ? /* @__PURE__ */ u.jsx("div", { className: "ui:text-md ui:rounded-lg ui:bg-accent-500 ui:px-1.5 ui:py-0.5 ui:font-light ui:text-white", children: n }) : f ? /* @__PURE__ */ u.jsx(tf, { message: e, color: "accent" }) : null
  ] });
}, wf = nt(function({
  conversation: t,
  isSelected: n,
  className: i,
  ...r
}) {
  var ae;
  const { useParticipants: s, conversationUtils: o, userUtils: a } = at(), { getUserById: l, getCurrentUser: d } = s(), {
    _id: c,
    type: f,
    name: h,
    typing_users: p,
    draft: y,
    image_url: v,
    image_object: w,
    owner_id: x,
    opponent_id: S,
    last_message: k,
    unread_messages_count: P,
    updated_at: j
  } = t, N = f === "g", C = d()._id, R = C === x ? S : x, I = ze(() => {
    if (N) return null;
    const $ = x === C ? S : x;
    return $ ? l($) : null;
  }, [N, x, S, C, l]), U = ze(() => {
    if (h) return h;
    if (!N && I) {
      const $ = a.getUserFullName(I);
      if ($) return $;
    }
    return "Deleted account";
  }, [h, N, I, a]), W = ze(
    () => o.getLastUpdateTime(j, k == null ? void 0 : k.t),
    [o, j, k == null ? void 0 : k.t]
  );
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      "data-conversation-id": c,
      className: fe(
        "ui:relative ui:flex ui:w-full ui:cursor-pointer ui:items-center ui:gap-3.75 ui:rounded-2xl ui:px-2.5 ui:py-2.5 ui:duration-100 ui:focus:outline-none",
        n ? "ui:bg-accent-100 ui:shadow-btn" : "ui:hover:bg-accent-100/50",
        i
      ),
      ...r,
      children: [
        /* @__PURE__ */ u.jsx(
          jn,
          {
            size: 60,
            avatarUrl: v || (I == null ? void 0 : I.avatar_url),
            avatarBlurHash: (w == null ? void 0 : w.file_blur_hash) || ((ae = I == null ? void 0 : I.avatar_object) == null ? void 0 : ae.file_blur_hash),
            defaultIcon: N || U !== "Deleted account" ? U.slice(0, 2).toUpperCase() : /* @__PURE__ */ u.jsx(Bu, { size: 32 }),
            altText: N ? "Chat Group" : "User's Profile",
            bgColorKey: N ? c : R
          }
        ),
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:max-h-17.5 ui:max-w-[calc(100%-60px)] ui:flex-1 ui:flex-col ui:justify-between ui:overflow-hidden", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:justify-between ui:gap-3", children: [
            /* @__PURE__ */ u.jsxs(
              "p",
              {
                className: "ui:flex ui:flex-nowrap ui:items-center ui:gap-1.5 ui:overflow-hidden ui:text-lg ui:text-ellipsis ui:whitespace-nowrap",
                children: [
                  N && /* @__PURE__ */ u.jsx(Co, { size: 18 }),
                  U
                ]
              }
            ),
            /* @__PURE__ */ u.jsx("div", { className: "ui:text-md ui:font-light ui:text-text-dark/60 ui:ordinal!", children: W })
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-8 ui:items-center ui:justify-between ui:gap-3", children: p != null && p.length && !n ? /* @__PURE__ */ u.jsx(sf, { typingUserIds: p, isDisplayUserNames: N }) : /* @__PURE__ */ u.jsx(
            cS,
            {
              isSelected: n,
              message: k,
              draft: n ? null : y,
              countOfUnreadMessages: P,
              isShowUserName: N
            }
          ) })
        ] })
      ]
    }
  );
});
function Nu(e, t, n) {
  if (t <= 0) return;
  const i = e.scrollHeight - t;
  i !== 0 && (e.scrollTop = n + i);
}
const BS = ({
  conversations: e,
  selectedConversation: t,
  additionalOnClickfunc: n,
  className: i,
  scrollContainerRef: r,
  listInnerRef: s,
  disableBuiltinScrollPersistence: o = !1,
  onListScrollFromBottom: a,
  scrollContainerId: l = "conversationItemsScrollable",
  scrollbarClassName: d,
  scrollbarContentClassName: c,
  ...f
}) => {
  const { useConversations: h } = at(), { setSelectedConversation: p, storeNewConversations: y, fetchConversations: v } = h(), [w, x] = de(!0), S = pe(!1), k = pe(!0), P = pe(null), j = pe(null), N = r ?? P, C = s ?? j, R = pe(null);
  k.current = w, Br(() => {
    const V = R.current;
    if (!V) return;
    const K = N.current;
    if (R.current = null, !K) return;
    const se = { ...V };
    Nu(K, V.prevScrollHeight, V.prevScrollTop), requestAnimationFrame(() => {
      const G = N.current;
      G && Nu(G, se.prevScrollHeight, se.prevScrollTop);
    });
  }, [e.length]);
  const I = Ne(() => !k.current || S.current ? Promise.resolve() : (S.current = !0, v().then((V) => {
    const K = N.current, se = (K == null ? void 0 : K.scrollHeight) ?? 0, G = (K == null ? void 0 : K.scrollTop) ?? 0;
    if (!V.length) {
      k.current = !1, x(!1);
      return;
    }
    se > 0 && (R.current = { prevScrollHeight: se, prevScrollTop: G }), y(V);
  }).finally(() => {
    S.current = !1;
  })), [v, y]), U = Ne(() => {
    !k.current || S.current || I();
  }, [I]), W = Ne(
    (V) => {
      !k.current || S.current || V > Ox || U();
    },
    [U]
  ), ae = Ne(
    (V) => {
      W(V), a == null || a(V);
    },
    [a, W]
  ), $ = Ne(
    (V) => {
      p(V), n && n(V);
    },
    [n, p]
  );
  return /* @__PURE__ */ u.jsx(ge, { className: fe("ui:flex ui:h-full ui:min-h-0 ui:flex-col", i), ...f, children: /* @__PURE__ */ u.jsx(
    Ti,
    {
      containerRef: N,
      customId: l,
      persistScrollPosition: !o,
      customClassName: fe("ui:min-h-0 ui:flex-1 ui:w-full", d),
      childrenClassName: c,
      onScroll: ae,
      children: /* @__PURE__ */ u.jsx("div", { ref: C, className: "ui:flex ui:w-full ui:min-w-0 ui:flex-col", children: e.map((V) => /* @__PURE__ */ u.jsx(
        wf,
        {
          conversation: V,
          onClick: () => $(V._id),
          isSelected: (t == null ? void 0 : t._id) === V._id
        },
        V._id
      )) })
    }
  ) });
}, dS = "ui:h-[80svh] ui:w-[min(460px,100%)] ui:gap-5 ui:rounded-[32px] ui:bg-bg-light ui:p-[30px] ui:max-md:w-[94svw] ui:max-md:max-h-[90svh] ui:max-md:p-5", US = ({ title: e, onClose: t, topContent: n, children: i }) => /* @__PURE__ */ u.jsx(ha, { panelClassName: dS, onClick: t, children: /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:min-h-0 ui:flex-1 ui:flex-col ui:gap-2.75", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:shrink-0 ui:items-center ui:justify-between", children: [
    /* @__PURE__ */ u.jsx("p", { className: "ui:text-xl ui:font-normal ui:text-black", children: e }),
    /* @__PURE__ */ u.jsx(
      "button",
      {
        type: "button",
        "aria-label": "Close",
        className: "ui:mb-1.5 ui:cursor-pointer ui:self-start ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:hover:bg-bg-dark ui:hover:text-white",
        onClick: t,
        children: /* @__PURE__ */ u.jsx(Dn, { size: 18 })
      }
    )
  ] }),
  n != null && /* @__PURE__ */ u.jsx("div", { className: "ui:shrink-0", children: n }),
  /* @__PURE__ */ u.jsx(Ti, { className: "ui:min-h-0 ui:flex-1 ui:overscroll-contain", children: i })
] }) }), Au = {
  phone: Ah,
  email: vh,
  login: Nn
}, bt = nt(function({
  title: t,
  systemTitle: n,
  value: i,
  iconType: r = "login",
  placeholder: s = "",
  hideIfNull: o = !1,
  isEnableToEdit: a = !1,
  isIconEnable: l = !0,
  onClick: d,
  onChangeValue: c,
  className: f,
  ...h
}) {
  if (!i && o) return null;
  const p = Au[r] ?? Au.login;
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe("ui:flex ui:flex-col ui:gap-0.75 ui:rounded-xl", d && "ui:cursor-pointer", f),
      onClick: d,
      ...h,
      children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:font-light ui:text-text-dark", children: t }),
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:gap-2.75 ui:rounded-xl ui:bg-text-dark/5 ui:p-2", children: [
          l ? /* @__PURE__ */ u.jsx(p, { size: 16 }) : null,
          c && n ? /* @__PURE__ */ u.jsx(
            "input",
            {
              className: "ui:grow ui:font-light ui:focus:outline-none",
              defaultValue: i || "",
              placeholder: "Empty",
              onChange: (y) => c(n, y.target.value)
            }
          ) : /* @__PURE__ */ u.jsx("p", { className: "ui:grow ui:overflow-hidden ui:text-base ui:font-light ui:text-ellipsis ui:whitespace-nowrap ui:text-black", children: i || /* @__PURE__ */ u.jsx("span", { className: "ui:text-text-dark", children: s }) }),
          a && !c ? /* @__PURE__ */ u.jsx(_h, { size: 18, color: "var(--color-accent-500)" }) : null
        ] })
      ]
    }
  );
}), fS = ({ onChageValue: e }) => {
  const { useConversations: t } = at(), { getSelectedConversation: n } = t(), i = n();
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(of, { conversation: i, isEditDisabled: !1 }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:grow ui:flex-col ui:gap-1.75", children: [
      /* @__PURE__ */ u.jsx(
        bt,
        {
          title: "Group name",
          value: i.name,
          systemTitle: "name",
          isIconEnable: !1,
          onChangeValue: e
        }
      ),
      /* @__PURE__ */ u.jsx(
        bt,
        {
          title: "Description",
          value: i.description,
          systemTitle: "description",
          isIconEnable: !1,
          onChangeValue: e
        }
      )
    ] })
  ] });
}, Sf = nt(function({
  user: t,
  swapAccentAndMainColor: n,
  className: i,
  ...r
}) {
  const { useParticipants: s } = at(), { updateCurrentUserAvatar: o } = s(), { avatar_url: a, avatar_blur_hash: l, _id: d } = t, c = pe(null), f = Ne(() => {
    var p;
    return (p = c.current) == null ? void 0 : p.click();
  }, []), h = Ne(
    async (p) => {
      p && await o(p);
    },
    [o]
  );
  return /* @__PURE__ */ u.jsxs(ge, { className: fe("ui:relative ui:h-30 ui:w-30 ui:self-center", i), ...r, children: [
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: fe(
          "ui:flex ui:h-full ui:w-full ui:items-center ui:justify-center ui:gap-2.75 ui:overflow-hidden ui:rounded-full ui:bg-hover-light",
          n ? "ui:bg-accent-100" : "ui:bg-bg-light"
        ),
        children: [
          /* @__PURE__ */ u.jsx(
            jn,
            {
              size: 120,
              avatarUrl: a,
              avatarBlurHash: l,
              defaultIcon: /* @__PURE__ */ u.jsx(Nn, { size: 80, color: "white" }),
              altText: "User profile",
              bgColorKey: d
            }
          ),
          /* @__PURE__ */ u.jsx(
            "input",
            {
              id: "inputFile",
              className: "ui:invisible ui:hidden",
              ref: c,
              type: "file",
              onChange: (p) => h(Array.from(p.target.files ?? []).at(0)),
              accept: Go.join(","),
              multiple: !0
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ u.jsx(
      "div",
      {
        className: "ui:absolute ui:-right-1.25 ui:-bottom-1.25 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:rounded-full ui:border-4 ui:border-bg-light ui:bg-accent-500 ui:p-2",
        onClick: f,
        children: /* @__PURE__ */ u.jsx(So, { strokeWidth: 1, size: 28, color: "white" })
      }
    )
  ] });
}), hS = ({ onChageValue: e }) => {
  const { useParticipants: t } = at(), { getCurrentUser: n } = t(), i = n(), { first_name: r, last_name: s, email: o, phone: a } = i;
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(Sf, { user: i, swapAccentAndMainColor: !0 }),
    /* @__PURE__ */ u.jsx(
      bt,
      {
        title: "First name",
        value: r,
        systemTitle: "first_name",
        isIconEnable: !1,
        onChangeValue: e
      }
    ),
    /* @__PURE__ */ u.jsx(
      bt,
      {
        title: "Last name",
        value: s,
        systemTitle: "last_name",
        isIconEnable: !1,
        onChangeValue: e
      }
    ),
    /* @__PURE__ */ u.jsx(
      bt,
      {
        title: "Mobile phone",
        value: a,
        systemTitle: "phone",
        isIconEnable: !1,
        onChangeValue: e
      }
    ),
    /* @__PURE__ */ u.jsx(
      bt,
      {
        title: "Email address",
        value: o,
        systemTitle: "email",
        isIconEnable: !1,
        onChangeValue: e
      }
    )
  ] });
}, zS = ({ type: e, onClose: t, className: n, ...i }) => {
  const { useParticipants: r, useConversations: s } = at(), { updateCurrentUserFields: o } = r(), { updateNameAndDescription: a } = s(), [l, d] = de({}), c = (v, w) => d((x) => ({ ...x, [v]: w == null ? void 0 : w.trim() })), f = {
    conversation: {
      component: /* @__PURE__ */ u.jsx(fS, { onChageValue: c }),
      title: "Chat Information"
    },
    user: {
      component: /* @__PURE__ */ u.jsx(hS, { onChageValue: c }),
      title: "Edit Profile"
    }
  }, { component: h, title: p } = f[e] || {}, y = Ne(async () => {
    var S;
    const { name: v, description: w } = l;
    (e === "conversation" ? await a({ name: v, description: w }) : await o({
      ...l,
      email: (S = l.email) == null ? void 0 : S.toLocaleLowerCase()
    })) && t();
  }, [t, l, e, a, o]);
  return dn(en.ENTER, y), dn(en.ESCAPE, t), /* @__PURE__ */ u.jsxs(ha, { className: n, onClick: t, ...i, children: [
    /* @__PURE__ */ u.jsx("p", { className: "ui:text-center ui:text-xl", children: p }),
    /* @__PURE__ */ u.jsx("div", { className: "ui:mt-3.5 ui:flex ui:flex-col ui:gap-2.75", children: h }),
    /* @__PURE__ */ u.jsx("hr", { className: "ui:my-1.75 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:-mt-1.75 ui:flex ui:items-center ui:justify-between ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("button", { className: "ui:cursor-pointer ui:rounded-xl ui:px-3 ui:text-text-dark", onClick: t, children: "Cancel" }),
      /* @__PURE__ */ u.jsx(
        "button",
        {
          className: "ui:flex ui:cursor-pointer ui:items-center ui:gap-2.75 ui:rounded-xl ui:bg-accent-500 ui:px-6 ui:py-2 ui:text-white ui:duration-150 ui:hover:bg-black",
          onClick: y,
          children: "Save"
        }
      )
    ] })
  ] });
}, WS = ({ statusText: e, children: t, className: n, ...i }) => /* @__PURE__ */ u.jsx(ge, { className: fe("ui:relative ui:flex ui:grow-3 ui:items-end", n), ...i, children: /* @__PURE__ */ u.jsxs("div", { className: "ui:absolute ui:top-0 ui:left-1/2 ui:h-full ui:w-full ui:-translate-x-1/2 ui:py-3.5 ui:font-normal ui:lg:max-w-300", children: [
  t,
  /* @__PURE__ */ u.jsx("div", { className: "ui:-mt-6.25 ui:h-6.25 ui:w-full ui:text-end ui:lg:max-w-300", children: /* @__PURE__ */ u.jsxs("p", { className: "ui:text-gray-400", children: [
    "Recent changes - ",
    e
  ] }) })
] }) }), HS = ({
  docsHref: e,
  docsLabel: t,
  tooltipId: n,
  actions: i,
  actionButtonClassName: r = "",
  className: s,
  ...o
}) => /* @__PURE__ */ u.jsxs(
  ge,
  {
    className: fe(
      "ui:editor-helper ui:flex ui:h-full ui:items-center ui:gap-2.75 ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn",
      s
    ),
    ...o,
    children: [
      /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ u.jsx(hh, { size: 28, color: "var(--color-text-dark)" }) }),
      /* @__PURE__ */ u.jsx("span", { className: "ui:h-[30px] ui:w-px ui:bg-gray-400" }),
      /* @__PURE__ */ u.jsx(mh, { color: "var(--color-text-dark)", "data-tooltip-id": n, "data-tooltip-delay-hide": 500, size: 28 }),
      /* @__PURE__ */ u.jsx(ba, { clickable: !0, id: n, className: "editor-tooltip-style", classNameArrow: "editor-tooltip-arrow", children: /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:flex-col ui:gap-2", children: i.map((a, l) => /* @__PURE__ */ u.jsx(
        "button",
        {
          type: "button",
          className: `ui:cursor-pointer ui:text-black/40 ui:underline ui:underline-offset-4 ${r}`,
          onClick: a.onClick,
          children: a.label
        },
        l
      )) }) })
    ]
  }
), KS = ({ visible: e, onClose: t, children: n, className: i, ...r }) => e ? /* @__PURE__ */ u.jsxs(
  ge,
  {
    className: fe(
      "ui:relative ui:mb-2.5 ui:max-h-[min(400px,25svh)] ui:w-full ui:grow-2 ui:self-center ui:overflow-hidden ui:rounded-xl ui:border ui:border-dashed ui:border-gray-300 ui:lg:max-w-300",
      i
    ),
    animate: { opacity: [0, 1], scale: [0.8, 1.02, 1] },
    exit: { scale: [1, 0.8], opacity: [1, 0] },
    transition: { duration: 0.3 },
    ...r,
    children: [
      /* @__PURE__ */ u.jsxs("div", { className: "ui:z-10 ui:flex ui:justify-between ui:p-3", children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:h-6.25 ui:text-gray-500", children: "Debugging log:" }),
        /* @__PURE__ */ u.jsx("button", { type: "button", className: "ui:cursor-pointer", onClick: t, children: /* @__PURE__ */ u.jsx(Th, { size: 25, color: "var(--color-text-dark)" }) })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "ui:absolute ui:top-8.75 ui:left-0 ui:h-[calc(100%)] ui:w-full ui:pt-4 ui:pb-4", children: n })
    ]
  }
) : null, YS = ({
  statusNode: e,
  tooltipId: t,
  tooltipContent: n,
  onCheck: i,
  onSave: r,
  saveDisabled: s,
  children: o,
  className: a,
  ...l
}) => /* @__PURE__ */ u.jsxs(ge, { className: fe("ui:flex ui:grow ui:items-end ui:gap-2.75", a), ...l, children: [
  /* @__PURE__ */ u.jsxs("div", { className: "ui:editor-validation ui:flex ui:h-full ui:grow ui:items-center ui:justify-end ui:gap-2.75 ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn", children: [
    /* @__PURE__ */ u.jsx("div", { "data-tooltip-id": t, "data-tooltip-delay-hide": 500, className: "ui:flex ui:items-center ui:px-1", children: e }),
    /* @__PURE__ */ u.jsx(ba, { id: t, className: "editor-tooltip-style", classNameArrow: "editor-tooltip-arrow", children: n }),
    /* @__PURE__ */ u.jsx("span", { className: "ui:h-full ui:w-px ui:bg-gray-300" }),
    o
  ] }),
  /* @__PURE__ */ u.jsx(
    "button",
    {
      type: "button",
      className: "ui:flex ui:h-11.5 ui:cursor-pointer ui:items-center ui:gap-1.75 ui:self-end ui:rounded-xl ui:border ui:bg-accent-500 ui:px-6 ui:py-2 ui:text-base ui:text-white ui:duration-150 ui:hover:bg-black",
      onClick: i,
      children: "Check"
    }
  ),
  /* @__PURE__ */ u.jsx(
    "button",
    {
      type: "button",
      className: `ui:flex ui:h-11.5 ui:cursor-pointer ui:items-center ui:gap-1.75 ui:self-end ui:rounded-xl ui:border ui:px-6 ui:py-2 ui:text-base ui:text-white ui:duration-150 ${s ? "ui:bg-gray-500" : "ui:bg-accent-500 ui:hover:bg-black"}`,
      disabled: s,
      onClick: r,
      children: "Save"
    }
  )
] }), GS = ({
  attachments: e,
  currentIndex: t,
  onIndexChange: n,
  onClose: i,
  getFileType: r = Bc,
  isMobile: s = !1,
  swipeRef: o,
  className: a,
  style: l,
  ...d
}) => {
  const c = t === e.length - 1, f = t === 0, h = e[t], p = r(h == null ? void 0 : h.file_name, h == null ? void 0 : h.file_content_type);
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      ref: o,
      className: fe("ui:absolute ui:top-0 ui:z-10 ui:flex ui:h-dvh ui:w-dvw ui:flex-col ui:bg-black/90", a),
      style: l,
      onClick: s ? void 0 : i,
      ...d,
      children: [
        s && /* @__PURE__ */ u.jsx(
          "button",
          {
            type: "button",
            className: "ui:absolute ui:top-10 ui:right-10 ui:z-[11] ui:rounded ui:p-1 ui:text-white ui:hover:bg-white/20",
            onClick: i,
            "aria-label": "Close",
            children: /* @__PURE__ */ u.jsx(Dn, { size: 24 })
          }
        ),
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:shrink-0 ui:justify-center ui:pt-8 ui:pb-2", children: /* @__PURE__ */ u.jsxs("p", { className: "ui:text-lg ui:text-gray-300", children: [
          t + 1,
          " / ",
          e.length
        ] }) }),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "ui:flex ui:max-h-[calc(100dvh-250px)] ui:flex-1 ui:items-center ui:justify-center ui:px-7 ui:md:px-[max(10%,90px)]",
            onClick: (y) => y.stopPropagation(),
            children: p === "Video" ? /* @__PURE__ */ u.jsx(Gs, { video: h, enableControls: !0, isFullSize: !1 }) : /* @__PURE__ */ u.jsx(Ys, { image: h, isFullSize: !1 })
          }
        ),
        !f && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "ui:absolute ui:top-0 ui:left-0 ui:flex ui:h-full ui:w-[max(8%,80px)] ui:cursor-pointer ui:items-center ui:justify-center ui:opacity-0 ui:duration-200 ui:select-none ui:hover:bg-bg-light/25 ui:md:opacity-100",
            onClick: (y) => {
              y.stopPropagation(), n(t - 1);
            },
            children: /* @__PURE__ */ u.jsx(Wr, { className: "ui:text-white", size: 32 })
          }
        ),
        !c && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "ui:absolute ui:top-0 ui:right-0 ui:flex ui:h-full ui:w-[max(8%,80px)] ui:cursor-pointer ui:items-center ui:justify-center ui:opacity-0 ui:duration-200 ui:select-none ui:hover:bg-bg-light/25 ui:md:opacity-100",
            onClick: (y) => {
              y.stopPropagation(), n(t + 1);
            },
            children: /* @__PURE__ */ u.jsx(Zf, { className: "ui:text-white", size: 32 })
          }
        ),
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-[min(175px,20%)] ui:flex-shrink-0 ui:items-center ui:justify-center ui:gap-2.5 ui:pt-3 ui:pb-3", children: e.map((y, v) => /* @__PURE__ */ u.jsx(
          "button",
          {
            type: "button",
            className: `ui:cursor-pointer ui:overflow-hidden ui:rounded-xl ui:border-0 ui:bg-transparent ui:p-0 ${v === t ? "ui:h-full ui:w-[10%]" : "ui:h-[85%] ui:w-[8%]"}`,
            onClick: (w) => {
              w.stopPropagation(), n(v);
            },
            children: r(y.file_name, y.file_content_type) === "Video" ? /* @__PURE__ */ u.jsx(Gs, { video: y, removePlayButton: !0 }) : /* @__PURE__ */ u.jsx(Ys, { image: y })
          },
          v
        )) })
      ]
    }
  );
};
function pS({
  user: e,
  displayName: t,
  statusActivity: n = "",
  isMobile: i,
  onAction: r,
  onStartConversation: s,
  contentClassName: o = "ui:py-5 ui:flex ui:flex-col ui:gap-3.75 ui:max-md:py-0"
}) {
  const { login: a, email: l, phone: d, avatar_url: c, avatar_object: f } = e;
  return /* @__PURE__ */ u.jsxs(Ti, { childrenClassName: o, children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-5 ui:rounded-[32px] ui:bg-accent-100 ui:py-10 ui:max-md:rounded-t-none", children: [
      /* @__PURE__ */ u.jsx(
        "button",
        {
          type: "button",
          className: "ui:absolute ui:top-8 ui:right-8 ui:cursor-pointer ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:hover:bg-black ui:hover:text-white ui:max-md:top-8 ui:max-md:left-[4svw]",
          onClick: r,
          "aria-label": i ? "Back" : "Close",
          children: /* @__PURE__ */ u.jsx(Dn, { size: 18 })
        }
      ),
      /* @__PURE__ */ u.jsx(
        jn,
        {
          size: 160,
          avatarUrl: c,
          avatarBlurHash: f == null ? void 0 : f.file_blur_hash,
          defaultIcon: /* @__PURE__ */ u.jsx(Nn, { size: 80, color: "white" }),
          altText: "User's Profile",
          className: "rounded-full",
          bgColorKey: e == null ? void 0 : e._id
        }
      ),
      /* @__PURE__ */ u.jsxs("div", { className: "ui:w-[90%]", children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:-mt-1.25 ui:overflow-hidden ui:text-center ui:text-2xl ui:font-medium ui:text-ellipsis ui:whitespace-nowrap ui:text-black", children: t }),
        n ? /* @__PURE__ */ u.jsx("p", { className: "ui:mt-2.5 ui:mb-[-10px] ui:text-center ui:text-base ui:font-light ui:text-text-dark", children: n }) : null
      ] })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-col ui:gap-2.75 ui:rounded-[32px] ui:bg-bg-light ui:px-5 ui:py-7.5 ui:max-md:flex-1 ui:max-md:rounded-b-none", children: [
      /* @__PURE__ */ u.jsx("p", { className: "ui:mb-2.5 ui:text-center ui:text-xl ui:font-normal ui:text-text-dark", children: "Personal information" }),
      /* @__PURE__ */ u.jsx(bt, { iconType: "login", title: "Username", value: a, hideIfNull: !0 }),
      /* @__PURE__ */ u.jsx(bt, { iconType: "phone", title: "Mobile phone", value: d, hideIfNull: !0 }),
      /* @__PURE__ */ u.jsx(bt, { iconType: "email", title: "Email address", value: l, hideIfNull: !0 }),
      /* @__PURE__ */ u.jsx("hr", { className: "ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
      s && /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: "ui:mt-2.5 ui:flex ui:cursor-pointer ui:items-center ui:gap-2.5 ui:px-0.5",
          onClick: s,
          onKeyDown: (h) => h.key === "Enter" && s(),
          role: "button",
          tabIndex: 0,
          children: [
            /* @__PURE__ */ u.jsx(Bi, { size: 18, color: "var(--color-accent-500)" }),
            /* @__PURE__ */ u.jsx("p", { className: "ui:text-h6 ui:text-accent-500", children: "Start a conversation" })
          ]
        }
      )
    ] })
  ] });
}
function mS({
  user: e,
  displayName: t,
  statusActivity: n = "",
  onAction: i,
  onStartConversation: r
}) {
  const { login: s, email: o, phone: a, avatar_url: l, avatar_object: d } = e;
  return /* @__PURE__ */ u.jsxs("section", { className: "ui:flex ui:min-h-0 ui:w-full ui:flex-1 ui:flex-col ui:gap-2.75 ui:p-3.5 ui:md:w-100", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:justify-between", children: /* @__PURE__ */ u.jsx(
        "button",
        {
          type: "button",
          className: "ui:mb-1.5 ui:cursor-pointer ui:self-start ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:hover:bg-bg-dark ui:hover:text-white",
          onClick: i,
          "aria-label": "Back",
          children: /* @__PURE__ */ u.jsx(Wr, { size: 18 })
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-30 ui:w-30 ui:items-center ui:justify-center ui:self-center ui:overflow-hidden ui:rounded-full ui:bg-bg-light", children: /* @__PURE__ */ u.jsx(
        jn,
        {
          size: 120,
          avatarUrl: l,
          avatarBlurHash: d == null ? void 0 : d.file_blur_hash,
          defaultIcon: /* @__PURE__ */ u.jsx(Nn, { size: 80, color: "white" }),
          altText: "User's Profile",
          bgColorKey: e == null ? void 0 : e._id
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-4/5 ui:flex-nowrap ui:items-center ui:justify-center ui:gap-2.75", children: /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-center ui:text-2xl ui:text-ellipsis ui:whitespace-nowrap", children: t }) }),
      n ? /* @__PURE__ */ u.jsx("p", { className: "ui:-mt-1.75 ui:text-center ui:text-lg ui:text-text-dark", children: n }) : null
    ] }),
    /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-5 ui:mb-2.5 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:flex-col ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("p", { className: "ui:mb-2.75 ui:text-xl", children: "Personal information" }),
      /* @__PURE__ */ u.jsx(bt, { title: "Username", value: s, iconType: "login", hideIfNull: !0 }),
      /* @__PURE__ */ u.jsx(bt, { title: "Phone number", value: a, iconType: "phone", hideIfNull: !0 }),
      /* @__PURE__ */ u.jsx(bt, { title: "Email address", value: o, iconType: "email", hideIfNull: !0 }),
      r && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-5 ui:mb-2.5 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: "ui:mt-2.75 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:gap-2.75 ui:rounded-xl ui:bg-white ui:p-2 ui:text-accent-500 ui:shadow-btn ui:duration-150 ui:hover:bg-accent-500 ui:hover:text-white",
            onClick: r,
            onKeyDown: (c) => c.key === "Enter" && r(),
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ u.jsx(Bi, { size: 18 }),
              /* @__PURE__ */ u.jsx("span", { children: "Start a conversation" })
            ]
          }
        )
      ] })
    ] })
  ] });
}
const qS = ({
  user: e,
  displayName: t,
  statusActivity: n = "",
  isMobile: i = !1,
  onClose: r,
  onBack: s,
  onStartConversation: o,
  contentClassName: a = "ui:py-5 ui:flex ui:flex-col ui:gap-3.75 ui:max-md:py-0",
  closeButton: l,
  backButton: d,
  view: c,
  defaultView: f = "card",
  className: h,
  ...p
}) => {
  const y = c ?? f, v = i ? s : r;
  return /* @__PURE__ */ u.jsxs(ge, { className: h, ...p, children: [
    y === "card" && /* @__PURE__ */ u.jsx(
      pS,
      {
        user: e,
        displayName: t,
        statusActivity: n,
        isMobile: i,
        onAction: v ?? (() => {
        }),
        onStartConversation: o,
        contentClassName: a
      }
    ),
    y === "compact" && /* @__PURE__ */ u.jsx(
      mS,
      {
        user: e,
        displayName: t,
        statusActivity: n,
        onAction: v ?? (() => {
        }),
        onStartConversation: o
      }
    )
  ] });
}, XS = ({ href: e, label: t = "documentation" }) => /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:justify-center ui:rounded-lg ui:bg-accent-100 ui:py-2", children: /* @__PURE__ */ u.jsxs("p", { className: "ui:font-light", children: [
  "Please read the documentation before you start:",
  " ",
  /* @__PURE__ */ u.jsx(
    "a",
    {
      href: e,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "ui:cursor-pointer ui:font-normal ui:text-accent-500 ui:underline",
      children: t
    }
  )
] }) });
function gS(e) {
  const t = Math.floor(e / 60), n = e % 60;
  return `${t}:${n.toString().padStart(2, "0")}`;
}
const ZS = ({
  isOpen: e,
  onClose: t,
  onSendOTP: n,
  onResetPassword: i,
  onResendOTP: r,
  onValidationError: s
}) => {
  var k, P, j, N;
  const [o, a] = de({}), [l, d] = de(1), [c, f] = de(!1), [h, p] = de(0);
  he(() => {
    let C;
    return h > 0 && (C = setTimeout(() => p((R) => R - 1), 1e3)), () => C ? clearTimeout(C) : void 0;
  }, [h]), he(() => {
    if (e) {
      const C = typeof localStorage < "u" ? localStorage.getItem("reset_email") : null;
      C ? (a({ email: C }), d(2)) : (d(1), a({})), f(!1);
    }
  }, [e]);
  const y = Ne(async () => {
    var I;
    const C = (I = o.email) == null ? void 0 : I.trim();
    if (!(C != null && C.length)) {
      s == null || s("No email to resend token.");
      return;
    }
    f(!0), await n(C) && d(2), f(!1);
  }, [o.email, n, s]), v = Ne(async () => {
    var R, I;
    if (!o.email || !((R = o.token) != null && R.length) || !((I = o.new_password) != null && I.length)) {
      s == null || s("Please fill all fields.");
      return;
    }
    f(!0), await i(o) && x(), f(!1);
  }, [o, i, s]), w = Ne(async () => {
    var R;
    const C = (R = o.email) == null ? void 0 : R.trim();
    if (!(C != null && C.length)) {
      s == null || s("No email to resend token.");
      return;
    }
    f(!0), await r(C), p(90), f(!1);
  }, [o.email, r, s]), x = Ne(() => {
    typeof localStorage < "u" && localStorage.removeItem("reset_email"), t();
  }, [t]), S = Ne((C, R) => {
    a((I) => ({ ...I, [C]: R }));
  }, []);
  return e ? /* @__PURE__ */ u.jsx(
    ge,
    {
      className: "ui:fixed ui:inset-0 ui:isolate ui:z-50 ui:flex ui:w-screen ui:max-w-none ui:items-center ui:justify-center ui:overflow-y-auto ui:overscroll-y-contain ui:bg-black/50 ui:[-webkit-tap-highlight-color:transparent]",
      style: fa,
      children: /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:max-h-[80svh] ui:w-[min(460px,100%)] ui:flex-col ui:gap-[10px] ui:rounded-[32px] ui:bg-(--color-bg-light) ui:p-[30px] ui:max-md:w-[94svw] ui:max-md:p-[20px]", children: [
        /* @__PURE__ */ u.jsx("p", { className: "ui:mb-[5px] ui:text-xl ui:font-medium ui:text-black", children: "Reset Password" }),
        l === 1 && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx("p", { className: "ui:mb-[5px] ui:font-light", children: "To reset your password, enter the email that you used assigned to your account." }),
          /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:rounded-lg ui:bg-(--color-hover-light) ui:px-[14px] ui:py-[7px] ui:font-light", children: /* @__PURE__ */ u.jsx(
            "input",
            {
              className: "ui:h-[40px] ui:flex-1 ui:bg-transparent ui:outline-none",
              onKeyDown: (C) => C.key === " " && C.preventDefault(),
              onChange: ({ target: C }) => S("email", C.value),
              placeholder: "Enter your email",
              type: "text",
              autoComplete: "off",
              autoFocus: !0,
              value: o.email ?? ""
            }
          ) }),
          /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:mt-[10px] ui:flex ui:w-full ui:cursor-pointer ui:justify-center ui:rounded-lg ui:bg-(--color-accent-500) ui:px-[14px] ui:py-[14px] ui:text-white ui:transition-colors ui:hover:bg-(--color-accent-500)/80 ui:disabled:opacity-60",
              disabled: c || !((P = (k = o.email) == null ? void 0 : k.trim()) != null && P.length),
              onClick: y,
              children: c ? "Sending..." : "Confirm"
            }
          )
        ] }),
        l === 2 && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsxs("p", { className: "ui:mb-[5px] ui:font-light", children: [
            "We have sent a verification code to ",
            /* @__PURE__ */ u.jsx("span", { className: "text-accent-500", children: o.email })
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:rounded-lg ui:bg-(--color-hover-light) ui:px-[14px] ui:py-[7px]", children: /* @__PURE__ */ u.jsx(
            "input",
            {
              className: "ui:h-[40px] ui:flex-1 ui:bg-transparent ui:outline-none",
              onKeyDown: (C) => C.key === " " && C.preventDefault(),
              onChange: ({ target: C }) => S("token", C.value),
              placeholder: "Enter the 6 digit OTP sent to your email..",
              type: "text",
              autoComplete: "off",
              value: o.token ?? ""
            }
          ) }),
          /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:rounded-lg ui:bg-(--color-hover-light) ui:px-[14px] ui:py-[7px]", children: /* @__PURE__ */ u.jsx(
            "input",
            {
              className: "ui:h-[40px] ui:flex-1 ui:bg-transparent ui:outline-none",
              onKeyDown: (C) => C.key === " " && C.preventDefault(),
              onChange: ({ target: C }) => S("new_password", C.value),
              placeholder: "Enter new password..",
              type: "password",
              autoComplete: "off",
              value: o.new_password ?? ""
            }
          ) }),
          /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "ui:mt-[10px] ui:flex ui:w-full ui:cursor-pointer ui:justify-center ui:rounded-lg ui:bg-(--color-accent-500) ui:px-[14px] ui:py-[14px] ui:text-white ui:transition-colors ui:hover:bg-(--color-accent-500)/80 ui:disabled:opacity-60",
              disabled: c || !((j = o.token) != null && j.length) || !((N = o.new_password) != null && N.length),
              onClick: v,
              children: c ? "Confirming..." : "Confirm"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "button",
            {
              onClick: w,
              disabled: c || h > 0,
              className: "ui:flex ui:cursor-pointer ui:justify-center ui:rounded-lg ui:bg-(--color-accent-500) ui:px-[14px] ui:py-[14px] ui:text-white ui:transition-colors ui:hover:bg-(--color-accent-500)/80 ui:disabled:opacity-60",
              children: c ? "..." : h > 0 ? gS(h) : "Resend OTP"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "ui:flex ui:cursor-pointer ui:justify-center ui:rounded-lg ui:px-[14px] ui:py-[7px] ui:text-gray-500 ui:hover:text-black",
            onClick: x,
            children: "Cancel"
          }
        )
      ] })
    }
  ) : null;
}, Mu = ({
  conversations: e,
  selectedConversationId: t,
  onConversationClick: n,
  showTitle: i = !0,
  emptyMessage: r
}) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  i ? /* @__PURE__ */ u.jsxs("div", { className: "ui:mx-2 ui:my-0.5 ui:mt-1 ui:flex ui:items-center ui:gap-1.75 ui:rounded-xl ui:bg-bg-dark/5 ui:p-2 ui:text-sm ui:text-text-dark", children: [
    /* @__PURE__ */ u.jsx(Sh, { size: 18 }),
    " Chats"
  ] }) : null,
  e.map((s) => /* @__PURE__ */ u.jsx(
    wf,
    {
      conversation: s,
      isSelected: t === s._id,
      onClick: () => n(s._id)
    },
    s._id
  )),
  r ? /* @__PURE__ */ u.jsx("p", { className: "ui:pt-2 ui:text-center ui:text-text-dark", children: r }) : null
] }), yS = "ui:relative ui:flex ui:w-full ui:cursor-pointer ui:items-center ui:gap-3.75 ui:rounded-2xl ui:px-1.5 ui:py-2.5 ui:duration-100 ui:hover:bg-accent-500/20 ui:focus:outline-none", vS = nt(function({
  user: t,
  isSelected: n = !1,
  isClickDisabled: i = !1,
  onClick: r,
  className: s,
  ...o
}) {
  var d;
  const { userUtils: a } = at(), l = Ne(
    (c) => {
      (c.key === "Enter" || c.key === " ") && (c.preventDefault(), i || r());
    },
    [i, r]
  );
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(yS, s),
      onClick: r,
      onKeyDown: l,
      role: "button",
      tabIndex: 0,
      ...o,
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ u.jsx(
            jn,
            {
              size: 60,
              avatarUrl: t.avatar_url,
              avatarBlurHash: (d = t.avatar_object) == null ? void 0 : d.file_blur_hash,
              defaultIcon: a.getUserInitials(t),
              altText: "User's Profile",
              bgColorKey: t._id
            }
          ),
          n ? /* @__PURE__ */ u.jsx("div", { className: "ui:absolute ui:-right-2 ui:-bottom-1 ui:z-10 ui:flex ui:h-6 ui:w-6 ui:items-center ui:justify-center ui:rounded-full ui:bg-accent-500", children: /* @__PURE__ */ u.jsx(zr, { size: 14, color: "white" }) }) : null
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:flex-1 ui:flex-col ui:gap-0.75 ui:overflow-hidden", children: /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-lg ui:text-ellipsis ui:whitespace-nowrap", children: a.getUserFullName(t) }) })
      ]
    }
  );
}), JS = (e) => {
  const {
    searchText: t,
    searchOptions: n,
    searchedUsers: i,
    searchedChats: r,
    defaultChats: s,
    isShowDefaultConvs: o,
    isSearchOnlyUsers: a,
    isUserSearched: l,
    isChatSearched: d,
    isPending: c,
    selectedUsers: f,
    onAddUser: h,
    onRemoveUser: p,
    addUserToArray: y,
    removeUserFromArray: v,
    isClickDisabledFunc: w,
    isMaxLimit: x,
    onClearInputText: S,
    isClearInputText: k,
    onConversationClick: P,
    onUserClick: j,
    isSelectUserToArray: N,
    selectedConversationId: C,
    customClassName: R = ""
  } = e, I = h ?? y, U = p ?? v, W = at(), ae = W.getSearchBlockData && t !== void 0 && n !== void 0, $ = ae ? W.getSearchBlockData() : null, V = t ?? null, K = ae && $ ? $ : null, se = i ?? (K == null ? void 0 : K.searchedUsers) ?? Jn.searchedUsers, G = r ?? (K == null ? void 0 : K.searchedChats) ?? Jn.searchedChats, te = s ?? (K == null ? void 0 : K.defaultChats) ?? Jn.defaultChats, le = l ?? (K == null ? void 0 : K.isUserSearched) ?? Jn.isUserSearched, Ce = d ?? (K == null ? void 0 : K.isChatSearched) ?? Jn.isChatSearched;
  c ?? (K == null ? void 0 : K.isPending) ?? Jn.isPending;
  const ce = (ne) => {
    if (N) {
      const oe = f.some((ye) => ye._id === ne._id);
      if ((w == null ? void 0 : w(ne)) ?? !1) return;
      k && (S == null || S()), oe ? U == null || U(ne) : I == null || I(ne);
    } else
      k && (S == null || S()), j == null || j(ne);
  }, q = (ne) => {
    k && (S == null || S()), P == null || P(ne);
  };
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(
        "ui:mt-[5px] ui:flex ui:h-100 ui:items-center ui:justify-start ui:max-xl:mt-0 ui:max-xl:w-full ui:max-xl:rounded-[16px] ui:max-xl:bg-bg-light",
        R
      ),
      children: /* @__PURE__ */ u.jsx(
        Ti,
        {
          customClassName: "ui:w-[400px]! ui:min-h-0 ui:max-xl:w-full! ui:self-start!",
          childrenClassName: "ui:flex ui:flex-col ui:!overflow-x-hidden",
          children: o && !(V != null && V.length) ? /* @__PURE__ */ u.jsx(
            Mu,
            {
              conversations: te,
              showTitle: !1,
              selectedConversationId: C,
              onConversationClick: q
            }
          ) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            a ? null : /* @__PURE__ */ u.jsxs("div", { className: "ui:mx-2 ui:my-0.5 ui:flex ui:items-center ui:gap-1.75 ui:rounded-xl ui:bg-bg-dark/5 ui:p-2 ui:text-sm ui:text-text-dark", children: [
              /* @__PURE__ */ u.jsx(Co, { size: 18 }),
              " Users"
            ] }),
            le ? /* @__PURE__ */ u.jsx("p", { className: "ui:py-2 ui:text-center ui:text-text-dark", children: le }) : null,
            se.map((ne) => {
              const oe = f.some((ye) => ye._id === ne._id), ie = x ? ((w == null ? void 0 : w(ne)) ?? !1) || !oe : ((w == null ? void 0 : w(ne)) ?? !1) && oe;
              return /* @__PURE__ */ u.jsx(
                vS,
                {
                  user: ne,
                  isSelected: oe,
                  isClickDisabled: ie,
                  onClick: () => ce(ne)
                },
                ne._id
              );
            }),
            a ? null : /* @__PURE__ */ u.jsx(
              Mu,
              {
                conversations: G,
                showTitle: !0,
                emptyMessage: Ce,
                selectedConversationId: C,
                onConversationClick: q
              }
            )
          ] })
        }
      )
    }
  );
}, QS = ({ summaryContent: e, onClose: t, getFilterLabel: n }) => {
  if (!e) return null;
  const { isLoading: i, text: r, filter: s } = e;
  return /* @__PURE__ */ u.jsxs("div", { className: "ui:absolute ui:right-1/2 ui:bottom-17 ui:z-45 ui:w-[calc(100%-28px)] ui:max-w-300 ui:translate-x-1/2 ui:rounded-2xl ui:bg-black/65 ui:p-3 ui:text-end ui:text-white", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:justify-between", children: [
      /* @__PURE__ */ u.jsx("span", { className: "ui:text-span ui:text-gray-300", children: "Only you can see this summary" }),
      /* @__PURE__ */ u.jsx(Dn, { color: "white", size: 16, className: "ui:cursor-pointer", onClick: t })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:gap-1.75", children: [
      /* @__PURE__ */ u.jsx(rp, { size: 22, color: "white" }),
      /* @__PURE__ */ u.jsx("p", { className: "ui:my-2 ui:text-xl", children: /* @__PURE__ */ u.jsx("b", { children: "Here's what you missed: " }) })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:max-h-100 ui:flex-col ui:overflow-auto ui:rounded-lg ui:text-left", children: i ? /* @__PURE__ */ u.jsx(Sn, { width: 35, height: 35, wrapperClassName: "ui:my-[10px] ui:self-center" }) : /* @__PURE__ */ u.jsx("p", { children: r }) }),
    n && /* @__PURE__ */ u.jsx("span", { className: "ui:text-span ui:mt-2.25 ui:ml-auto ui:text-gray-300", children: n(s) })
  ] });
}, ej = ({ user: e, onLogout: t, onClose: n, onEditProfile: i, onNavigateToAuth: r }) => {
  const { useParticipants: s } = at(), { updateCurrentUserPassword: o, deleteCurrentUser: a } = s(), l = lf(), { login: d, email: c, phone: f, first_name: h, last_name: p } = e, y = d == null ? void 0 : d.startsWith("sama-user-"), v = async () => {
    const { isConfirm: w } = await l({
      title: "Delete User",
      description: `You're going to delete your "Account"`,
      icon: /* @__PURE__ */ u.jsx(Bu, { size: 40, color: "red", strokeWidth: 2 })
    });
    if (!w) return;
    await a() && (r == null || r());
  };
  return dn(en.ESCAPE, n), /* @__PURE__ */ u.jsxs("aside", { className: "ui:flex ui:h-full ui:min-h-0 ui:w-full ui:flex-col ui:gap-2.75 ui:overflow-x-hidden ui:p-3.5 ui:max-md:max-h-dvh ui:max-md:overflow-y-auto ui:md:w-100", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:w-full ui:justify-between", children: /* @__PURE__ */ u.jsx(
        "button",
        {
          className: "ui:mb-1.5 ui:cursor-pointer ui:self-start ui:rounded-xl ui:bg-white ui:p-2 ui:shadow-btn ui:hover:bg-bg-dark ui:hover:text-white",
          onClick: n,
          children: /* @__PURE__ */ u.jsx(Wr, { size: 18 })
        }
      ) }),
      /* @__PURE__ */ u.jsx(Sf, { user: e }),
      /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-4/5 ui:flex-nowrap ui:items-center ui:justify-center ui:gap-2.75", children: [
        h ? /* @__PURE__ */ u.jsx("p", { className: "ui:text-2xl", children: h }) : null,
        p ? /* @__PURE__ */ u.jsx("p", { className: "ui:overflow-hidden ui:text-2xl ui:text-ellipsis ui:whitespace-nowrap", children: p }) : null,
        !h && !p ? /* @__PURE__ */ u.jsx("p", { className: "ui:text-2xl ui:text-text-dark/45", children: "First & Last Name" }) : null
      ] }),
      /* @__PURE__ */ u.jsx(
        "p",
        {
          className: "ui:-mt-1.75 ui:cursor-pointer ui:text-center ui:text-lg ui:text-accent-500",
          onClick: i,
          children: "Edit User Info"
        }
      )
    ] }),
    /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-5 ui:mb-2.5 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-1 ui:flex-col ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("p", { className: "ui:mb-2.75 ui:text-xl", children: "Personal information" }),
      /* @__PURE__ */ u.jsx(bt, { title: "Username", value: d, iconType: "login" }),
      /* @__PURE__ */ u.jsx(
        bt,
        {
          title: "Phone number",
          value: f,
          iconType: "phone",
          placeholder: "Enter your phone number",
          onClick: i,
          isEnableToEdit: !0
        }
      ),
      /* @__PURE__ */ u.jsx(
        bt,
        {
          title: "Email address",
          value: c,
          iconType: "email",
          placeholder: "Enter your email address",
          onClick: i,
          isEnableToEdit: !0
        }
      ),
      /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-5 ui:mb-2.5 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
      /* @__PURE__ */ u.jsx("p", { className: "ui:mb-2.75 ui:text-xl", children: "Settings" }),
      y ? null : /* @__PURE__ */ u.jsxs(
        "button",
        {
          className: "ui:flex ui:cursor-pointer ui:items-center ui:gap-2.75 ui:text-text-dark",
          onClick: () => {
            const w = window.prompt("Enter your current password:");
            if (!w) return;
            const x = window.prompt("Enter a new password:");
            !x || !w || o(w, x);
          },
          children: [
            /* @__PURE__ */ u.jsx(Ih, { size: 18, color: "var(--color-text-dark)" }),
            /* @__PURE__ */ u.jsx("p", { className: "ui:font-light", children: "Change password" })
          ]
        }
      ),
      y ? null : /* @__PURE__ */ u.jsxs(
        "button",
        {
          className: "ui:mt-2.75 ui:flex ui:cursor-pointer ui:items-center ui:gap-2.75",
          onClick: v,
          children: [
            /* @__PURE__ */ u.jsx(Fu, { size: 18, className: "ui:text-danger" }),
            /* @__PURE__ */ u.jsx("p", { className: "ui:font-light ui:text-danger", children: "Delete account" })
          ]
        }
      ),
      /* @__PURE__ */ u.jsx("hr", { className: "ui:mt-auto ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
      /* @__PURE__ */ u.jsxs(
        "button",
        {
          className: "ui:mt-2.75 ui:flex ui:cursor-pointer ui:items-center ui:justify-center ui:gap-2.75 ui:rounded-xl ui:bg-white ui:p-2 ui:text-accent-500 ui:shadow-btn ui:duration-150 ui:hover:bg-accent-500 ui:hover:text-white",
          onClick: () => {
            r == null || r(), t();
          },
          children: [
            /* @__PURE__ */ u.jsx($u, { size: 18 }),
            "Log out"
          ]
        }
      )
    ] })
  ] });
}, xS = "ui:flex ui:max-h-8 ui:min-w-max ui:cursor-pointer ui:flex-row ui:items-center ui:gap-1.75 ui:rounded-[8px] ui:bg-hover-light ui:p-1.5", bS = nt(function({ user: t, onRemove: n, className: i, ...r }) {
  var c;
  const [s, o] = de(!1), { userUtils: a } = at(), l = Ne(() => o(!0), []), d = Ne(() => o(!1), []);
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(xS, i),
      onClick: n,
      onMouseEnter: l,
      onMouseLeave: d,
      ...r,
      children: [
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-6 ui:w-6 ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-[8px]", children: s ? /* @__PURE__ */ u.jsx("p", { className: "ui:flex ui:items-center ui:justify-center ui:text-text-dark", children: /* @__PURE__ */ u.jsx(Dn, { size: 14, className: "ui:shrink-0" }) }) : /* @__PURE__ */ u.jsx(
          jn,
          {
            size: 24,
            avatarUrl: t.avatar_url,
            avatarBlurHash: (c = t.avatar_object) == null ? void 0 : c.file_blur_hash,
            defaultIcon: a.getUserInitials(t),
            altText: "",
            bgColorKey: t._id,
            customClassName: "ui:rounded-[8px] ui:text-sm"
          }
        ) }),
        /* @__PURE__ */ u.jsx("p", { className: "ui:text-text-dark", children: a.getUserFullName(t) })
      ]
    }
  );
}), tj = ({
  selectedUsers: e,
  onAddUser: t,
  onRemoveUser: n,
  initSelectedUsers: i,
  onClose: r,
  onCreate: s,
  searchInputSlot: o,
  searchResultsSlot: a,
  isSearchExpanded: l = !1,
  maxCount: d = 50,
  submitLabel: c
}) => {
  const [f, h] = de(!1), p = i ? 0 : 1, y = e.length + p, v = c ?? (i != null && i.length ? "Add" : "Create"), w = ze(() => i != null && i.length ? e.filter((k) => !i.some((P) => P._id === k._id)) : e, [e, i]), x = Ne(async () => {
    const k = i != null && i.length ? e.filter((P) => !i.some((j) => j._id === P._id)) : e;
    h(!0);
    try {
      await s(k);
    } finally {
      h(!1);
    }
  }, [e, i, s]);
  dn(en.ENTER, x);
  const S = /* @__PURE__ */ u.jsx("div", { className: "ui:-mt-[5px] ui:-mb-[5px] ui:flex ui:max-h-[64px] ui:min-h-[32px] ui:items-center", children: w.length ? /* @__PURE__ */ u.jsx(Ti, { childrenClassName: "ui:flex ui:flex-row ui:gap-[7px] ui:rounded-[8px]", children: w.map((k) => /* @__PURE__ */ u.jsx(bS, { user: k, onRemove: () => n(k) }, k._id)) }) : /* @__PURE__ */ u.jsx("p", { className: "ui:text-md ui:text-text-dark", children: "Select users to add..." }) });
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:justify-between", children: [
      /* @__PURE__ */ u.jsx("p", { className: "ui:text-xl ui:font-normal ui:text-black", children: "Add participants" }),
      /* @__PURE__ */ u.jsxs("p", { className: "ui:text-xl ui:font-normal ui:text-text-dark", children: [
        y,
        "/",
        d
      ] })
    ] }),
    o,
    S,
    /* @__PURE__ */ u.jsx(
      "div",
      {
        className: "ui:flex ui:flex-col ui:overflow-hidden ui:transition-[max-height] ui:duration-700 ui:ease-out",
        style: { maxHeight: l ? Dx : Rx },
        children: /* @__PURE__ */ u.jsx("div", { className: "ui:min-h-0 ui:overflow-auto", children: a })
      }
    ),
    /* @__PURE__ */ u.jsx("hr", { className: "ui:my-1.75 ui:h-0.5 ui:border-dashed ui:text-text-dark/40" }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:-mt-1.75 ui:flex ui:items-center ui:justify-between ui:gap-2.75", children: [
      /* @__PURE__ */ u.jsx("button", { className: "ui:cursor-pointer ui:rounded-xl ui:px-3 ui:text-text-dark", onClick: r, children: "Cancel" }),
      f ? /* @__PURE__ */ u.jsx(Sn, { wrapperClassName: "ui:px-[31px]!", height: 40, width: 16 }) : /* @__PURE__ */ u.jsx(
        "button",
        {
          className: "ui:flex ui:cursor-pointer ui:items-center ui:gap-2.75 ui:rounded-xl ui:bg-accent-500 ui:px-6 ui:py-2 ui:text-white ui:duration-150 ui:hover:bg-black",
          onClick: () => x(),
          children: v
        }
      )
    ] })
  ] });
}, nj = nt(function({
  text: t,
  icon: n,
  onClick: i,
  isDangerStyle: r = !1,
  id: s,
  className: o,
  uId: a,
  uObject: l,
  additionalContent: d,
  ...c
}) {
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    d,
    /* @__PURE__ */ u.jsxs(
      ge,
      {
        role: "menuitem",
        className: fe(
          "ui:flex ui:cursor-pointer ui:items-center ui:gap-1.75 ui:rounded-lg ui:p-1.25 ui:hover:bg-hover-light/45",
          r && "ui:mt-1.25",
          r ? "ui:text-danger" : "ui:text-text-dark",
          o
        ),
        onClick: i,
        animate: kx,
        ...c,
        children: [
          n,
          /* @__PURE__ */ u.jsx("p", { className: "ui:whitespace-nowrap", children: t })
        ]
      },
      s ?? t
    )
  ] });
}), wS = "ui:cursor-pointer ui:self-center", ij = nt(function({
  text: t,
  onClick: n,
  isNextMessageUsers: i = !1,
  className: r,
  ...s
}) {
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe(wS, i && "ui:mb-1.5", r),
      onClick: n,
      role: n ? "button" : void 0,
      tabIndex: n ? 0 : void 0,
      ...s,
      children: /* @__PURE__ */ u.jsx("p", { className: "ui:font-light ui:text-text-dark/40", children: t })
    }
  );
}), SS = {
  weekday: "short",
  day: "numeric",
  month: "short"
}, rj = ({ date: e, locale: t = "en-US", options: n = SS }) => {
  const i = typeof e == "number" ? e * 1e3 : e, r = new Date(i).toLocaleDateString(t, n);
  return /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:justify-center ui:py-2", children: /* @__PURE__ */ u.jsx("span", { className: "ui:mb-1.25 ui:p-2 ui:font-light ui:text-text-dark/40", children: r }) });
};
function Pu({ children: e }) {
  const [t, n] = de(!1);
  return Br(() => {
    let i = 0, r = 0;
    return i = requestAnimationFrame(() => {
      r = requestAnimationFrame(() => n(!0));
    }), () => {
      cancelAnimationFrame(i), cancelAnimationFrame(r);
    };
  }, []), /* @__PURE__ */ u.jsx(
    "div",
    {
      className: "ui:grid ui:min-h-0 ui:overflow-hidden ui:ease-out",
      style: {
        gridTemplateRows: t ? "1fr" : "0fr",
        transition: `grid-template-rows ${Qa}ms ease-out`,
        contain: "layout"
      },
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          className: "ui:min-h-0 ui:overflow-hidden ui:ease-out",
          style: {
            opacity: t ? 1 : 0,
            transition: `opacity ${Qa}ms ease-out`
          },
          children: e
        }
      )
    }
  );
}
const sj = ({
  urlData: e,
  color: t = "accent",
  onRefresh: n,
  isDocument: i = !1,
  formattedFileSize: r,
  expandDirection: s = Ix
}) => {
  const [o, a] = de(!1);
  if (!e) return null;
  const { url: l, title: d, siteName: c, description: f, images: h = [], favicons: p = [], file_name: y } = e, v = t === "white" ? "ui:bg-bg-dark/5" : "ui:bg-accent-500/20", w = t === "white" ? "ui:text-gray-200" : "ui:text-gray-500", x = s === "up" ? "ui:flex-col-reverse" : "ui:flex-col";
  return i ? /* @__PURE__ */ u.jsx("a", { href: l, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ u.jsx("div", { className: fe("ui:mt-1.25 ui:flex ui:rounded-lg", x), children: /* @__PURE__ */ u.jsx(Pu, { children: /* @__PURE__ */ u.jsxs("div", { className: `ui:flex ui:flex-row ui:gap-2.5 ui:rounded-lg ui:p-1.25 ${v}`, children: [
    /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-13.75 ui:w-11.25 ui:items-center ui:justify-center ui:rounded-md ui:bg-bg-dark/15 ui:px-1.75", children: /* @__PURE__ */ u.jsx(uh, { size: 36, color: "white" }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-col ui:justify-center", children: [
      /* @__PURE__ */ u.jsx("p", { className: "ui:line-clamp-1 ui:overflow-hidden ui:font-light ui:text-ellipsis", children: y }),
      r != null && /* @__PURE__ */ u.jsx("p", { className: `ui:font-light ui:text-text-dark ${w}`, children: r })
    ] })
  ] }) }) }) }) : !f && h.length === 0 ? null : /* @__PURE__ */ u.jsx("a", { href: l, className: "ui:max-w-full", target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ u.jsxs("div", { className: fe(`ui:mt-1.25 ui:flex ui:rounded-lg ui:p-2.5 ${v}`, x), children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:flex-row ui:items-center ui:gap-1.25", children: [
      p[0] && /* @__PURE__ */ u.jsx("img", { src: p[0], alt: "Preview", className: "ui:h-2.5 ui:w-2.5 ui:rounded-md ui:object-contain" }),
      /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:w-full ui:flex-1 ui:flex-col", children: [
        c && /* @__PURE__ */ u.jsx("p", { className: "ui:line-clamp-1 ui:overflow-hidden ui:text-ellipsis", children: c }),
        /* @__PURE__ */ u.jsx("p", { className: "ui:line-clamp-1 ui:overflow-hidden ui:text-ellipsis", children: d })
      ] }),
      /* @__PURE__ */ u.jsx(
        Ph,
        {
          size: 18,
          color: "var(--color-hover-dark)",
          className: "ui:cursor-pointer",
          onClick: (S) => n(S, l)
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs(Pu, { children: [
      f && /* @__PURE__ */ u.jsx("p", { className: "ui:mt-0.5 ui:line-clamp-2 ui:overflow-hidden ui:font-light ui:text-ellipsis ui:text-text-dark", children: f }),
      h[0] && !o && /* @__PURE__ */ u.jsx(
        "img",
        {
          src: h[0],
          alt: "Preview",
          className: "ui:mt-1 ui:h-full ui:max-h-60 ui:w-full ui:rounded-md ui:object-cover",
          onError: () => a(!0)
        }
      )
    ] })
  ] }) });
}, jS = "ui:relative ui:flex ui:h-9 ui:cursor-text ui:flex-row ui:items-center ui:gap-1.5 ui:rounded-xl ui:bg-white ui:px-2.5 ui:shadow-btn", oj = nt(function({
  placeholder: t = "Search",
  value: n,
  onChange: i,
  isLargeSize: r = !1,
  customClassName: s = "",
  className: o,
  ...a
}) {
  const l = pe(null), d = n.length > 0;
  return /* @__PURE__ */ u.jsxs(
    ge,
    {
      className: fe(jS, s, o),
      onClick: () => {
        var c;
        return (c = l.current) == null ? void 0 : c.focus();
      },
      role: "search",
      ...a,
      children: [
        /* @__PURE__ */ u.jsx($h, { size: r ? 24 : 18, className: "ui:shrink-0 ui:text-text-dark" }),
        /* @__PURE__ */ u.jsx(
          "input",
          {
            ref: l,
            type: "search",
            className: "ui:min-w-0 ui:flex-1 ui:border-0 ui:bg-transparent ui:font-light ui:text-black ui:placeholder:text-text-dark ui:focus:outline-none",
            style: { fontSize: r ? "var(--text-h6, 1rem)" : "1rem" },
            placeholder: t,
            value: n,
            onChange: (c) => i(c.target.value),
            "aria-label": t
          }
        ),
        d ? /* @__PURE__ */ u.jsx(
          "button",
          {
            type: "button",
            className: "ui:shrink-0 ui:cursor-pointer ui:rounded ui:p-0.5 ui:text-text-dark ui:duration-150 ui:hover:bg-hover-light",
            onClick: (c) => {
              c.stopPropagation(), i("");
            },
            "aria-label": "Clear search",
            children: /* @__PURE__ */ u.jsx(Dn, { size: r ? 24 : 18 })
          }
        ) : null
      ]
    }
  );
}), TS = "ui:absolute ui:top-0 ui:z-100 ui:flex ui:h-7 ui:w-full ui:items-center ui:justify-center ui:bg-accent-500 ui:shadow-md", aj = nt(function({
  isSocketConnected: t,
  message: n = "Connecting...",
  className: i,
  ...r
}) {
  return t ? null : /* @__PURE__ */ u.jsx(ge, { className: fe(TS, i), ...r, children: /* @__PURE__ */ u.jsx("p", { className: "ui:text-center ui:text-[18px] ui:font-light ui:text-white", children: n }) });
}), lj = nt(function({
  avatarUrl: t,
  avatarBlurHash: n,
  defaultIcon: i,
  wrapperClassName: r,
  height: s = 64,
  width: o = 64,
  alt: a = "User's profile picture",
  className: l,
  style: d,
  ...c
}) {
  const f = ze(() => t ? /* @__PURE__ */ u.jsx(
    "img",
    {
      src: t,
      alt: a,
      width: o,
      height: s,
      className: "ui:h-full ui:w-full ui:rounded-full ui:object-cover",
      loading: "lazy"
    }
  ) : n ? /* @__PURE__ */ u.jsxs("div", { className: "ui:relative ui:h-full ui:w-full", children: [
    /* @__PURE__ */ u.jsx(
      Qi,
      {
        hash: n || "LEHLk~WB2yk8pyo0adR*.7kCMdnj",
        width: "100%",
        height: "100%",
        resolutionX: 32,
        resolutionY: 32,
        punch: 1
      }
    ),
    /* @__PURE__ */ u.jsx(
      Sn,
      {
        wrapperClassName: "ui:absolute ui:top-1/2 ui:left-1/2 ui:transform ui:-translate-x-1/2 ui:-translate-y-1/2",
        height: 30,
        width: 30
      }
    )
  ] }) : i || /* @__PURE__ */ u.jsx("div", { className: "flex ui:h-full ui:w-full ui:items-center ui:justify-center ui:rounded-full ui:bg-gray-200", children: /* @__PURE__ */ u.jsx("span", { className: "ui:text-sm ui:text-gray-500", children: "?" }) }), [t, n, i, a, s, o]);
  return /* @__PURE__ */ u.jsx(
    ge,
    {
      className: fe("ui:relative ui:overflow-hidden ui:rounded-full", r, l),
      style: { width: o, height: s, ...d },
      ...c,
      children: f
    }
  );
});
function Ru() {
  const e = typeof window > "u" ? 1024 : window.innerWidth, { MOBILE: t, TABLET: n, LAPTOP: i } = Px;
  return {
    isMobile: e <= t,
    isTablet: e > t && e <= n,
    isLaptop: e > n && e <= i
  };
}
function uj() {
  const [e, t] = de(Ru);
  return he(() => {
    const n = () => t(Ru());
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), e;
}
const cj = ({ className: e = "" }) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: `ui:flex ui:flex-1 ui:items-center ui:justify-center ui:pl-7 ${e}`,
    role: "status",
    "aria-label": "Loading",
    children: /* @__PURE__ */ u.jsx(oc, { initial: { scale: 0 }, animate: { scale: 1 }, transition: { duration: 0.2 }, children: /* @__PURE__ */ u.jsx(Sn, { height: 100, width: 100, color: "var(--color-accent-500)", wrapperClassName: "" }) })
  }
), CS = we.createContext({}), jf = !0;
function kS({ baseColor: e, highlightColor: t, width: n, height: i, borderRadius: r, circle: s, direction: o, duration: a, enableAnimation: l = jf, customHighlightBackground: d }) {
  const c = {};
  return o === "rtl" && (c["--animation-direction"] = "reverse"), typeof a == "number" && (c["--animation-duration"] = `${a}s`), l || (c["--pseudo-element-display"] = "none"), (typeof n == "string" || typeof n == "number") && (c.width = n), (typeof i == "string" || typeof i == "number") && (c.height = i), (typeof r == "string" || typeof r == "number") && (c.borderRadius = r), s && (c.borderRadius = "50%"), typeof e < "u" && (c["--base-color"] = e), typeof t < "u" && (c["--highlight-color"] = t), typeof d == "string" && (c["--custom-highlight-background"] = d), c;
}
function oi({ count: e = 1, wrapper: t, className: n, containerClassName: i, containerTestId: r, circle: s = !1, style: o, ...a }) {
  var l, d, c;
  const f = we.useContext(CS), h = { ...a };
  for (const [k, P] of Object.entries(a))
    typeof P > "u" && delete h[k];
  const p = {
    ...f,
    ...h,
    circle: s
  }, y = {
    ...o,
    ...kS(p)
  };
  let v = "react-loading-skeleton";
  n && (v += ` ${n}`);
  const w = (l = p.inline) !== null && l !== void 0 ? l : !1, x = [], S = Math.ceil(e);
  for (let k = 0; k < S; k++) {
    let P = y;
    if (S > e && k === S - 1) {
      const N = (d = P.width) !== null && d !== void 0 ? d : "100%", C = e % 1, R = typeof N == "number" ? N * C : `calc(${N} * ${C})`;
      P = { ...P, width: R };
    }
    const j = we.createElement("span", { className: v, style: P, key: k }, "‌");
    w ? x.push(j) : x.push(we.createElement(
      we.Fragment,
      { key: k },
      j,
      we.createElement("br", null)
    ));
  }
  return we.createElement("span", { className: i, "data-testid": r, "aria-live": "polite", "aria-busy": (c = p.enableAnimation) !== null && c !== void 0 ? c : jf }, t ? x.map((k, P) => we.createElement(t, { key: P }, k)) : x);
}
const ES = ({ className: e = "" }) => /* @__PURE__ */ u.jsxs(
  "div",
  {
    className: `ui:relative ui:flex ui:w-full ui:cursor-pointer ui:items-center ui:gap-3.75 ui:rounded-xl ui:p-2.5 ${e}`,
    "aria-hidden": !0,
    children: [
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-[70px] ui:w-[70px] ui:shrink-0 ui:items-center ui:justify-center ui:overflow-hidden ui:rounded-lg", children: /* @__PURE__ */ u.jsx(oi, { height: 80, width: 80 }) }),
      /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:max-h-[70px] ui:min-w-0 ui:flex-1 ui:flex-col ui:gap-1.75 ui:overflow-hidden", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "ui:flex ui:items-center ui:justify-between ui:gap-3", children: [
          /* @__PURE__ */ u.jsx("span", { className: "ui:block ui:min-w-0 ui:flex-1 ui:overflow-hidden ui:text-ellipsis ui:whitespace-nowrap", children: /* @__PURE__ */ u.jsx(oi, { width: 120 }) }),
          /* @__PURE__ */ u.jsx("span", { className: "ui:shrink-0", children: /* @__PURE__ */ u.jsx(oi, { width: 60 }) })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:h-8 ui:items-center", children: /* @__PURE__ */ u.jsx(oi, { containerClassName: "ui:grow" }) })
      ] })
    ]
  }
), _S = ({ bubbleWidth: e = 280, className: t = "" }) => /* @__PURE__ */ u.jsxs(
  "div",
  {
    className: `ui:relative ui:flex ui:w-max ui:max-w-[min(80%,820px)] ui:flex-row ui:gap-4 ${t}`,
    "aria-hidden": !0,
    children: [
      /* @__PURE__ */ u.jsx("div", { className: "ui:flex ui:min-w-[46px] ui:items-end", children: /* @__PURE__ */ u.jsx(oi, { height: 46, width: 46, circle: !0 }) }),
      /* @__PURE__ */ u.jsx("div", { className: "ui:min-w-0", children: /* @__PURE__ */ u.jsx(oi, { height: 122, width: e }) })
    ]
  }
), dj = ({ count: e = 6, className: t = "", scrollContainerId: n }) => /* @__PURE__ */ u.jsx("div", { className: `ui:h-auto ui:overflow-auto ${t}`, id: n, "aria-hidden": !0, children: Array.from({ length: e }, (i, r) => /* @__PURE__ */ u.jsx(_S, { bubbleWidth: 260 + r % 3 * 40 }, r)) }), fj = ({ count: e = 8, className: t = "" }) => /* @__PURE__ */ u.jsx("div", { className: t, "aria-hidden": !0, children: Array.from({ length: e }, (n, i) => /* @__PURE__ */ u.jsx(ES, {}, i)) });
export {
  Go as ALLOWED_AVATAR_FORMATS,
  fx as AdditionalMessages,
  zc as AnimatePresence,
  PS as AttachModal,
  fj as ChatListSkeleton,
  DS as ChatMessage,
  _S as ChatMessageSkeleton,
  IS as ChatNameInput,
  VS as ConfirmWindowProvider,
  OS as ContextMenu,
  nj as ContextMenuItem,
  LS as ConversationHeader,
  $S as ConversationInfo,
  FS as ConversationInput,
  wf as ConversationItem,
  BS as ConversationItemList,
  ES as ConversationItemSkeleton,
  US as ConversationSelectModal,
  Ti as CustomVerticalScrollbar,
  l2 as DotsLoader,
  jn as DynamicAvatar,
  zS as EditModalContainer,
  WS as EditorCodePanel,
  HS as EditorHelperBar,
  KS as EditorLogsPanel,
  YS as EditorValidationBar,
  t2 as ImageLoader,
  Ys as ImageView,
  bt as InfoBox,
  ij as InformativeMessage,
  rj as InteractiveDate,
  en as KEY_CODES,
  fa as MODAL_IOS_FULL_BLEED_STYLE,
  aS as MagicButton,
  Wx as MediaAttachment,
  Hx as MediaAttachments,
  Fc as MediaBlurHash,
  GS as MediaViewer,
  lS as MessageInput,
  sj as MessageLinkPreview,
  dj as MessageListSkeleton,
  tf as MessageStatus,
  hu as MessageUserIcon,
  ha as Modal,
  qS as OtherUserProfile,
  Sn as OvalLoader,
  Ix as PREVIEW_EXPAND_DIRECTION,
  cj as PageLoaderSkeleton,
  XS as ProgrammableEditorDocsBanner,
  ZS as ResetPasswordModal,
  JS as SearchBlock,
  Mu as SearchConversationList,
  oj as SearchInput,
  vS as SearchedUser,
  aj as SocketConnectingLine,
  QS as SummaryContainer,
  H1 as TextAreaInput,
  sf as TypingLine,
  lj as UserAvatar,
  bS as UserInfo,
  ej as UserProfile,
  tj as UserSelectorBlock,
  Px as VIEWPORT_BREAKPOINTS,
  Gs as VideoView,
  Vx as chunkMedia,
  Bc as getFileType,
  o2 as initDocumentKeyDown,
  el as normalizeRatio,
  RS as setAdapters,
  lf as useConfirmWindow,
  dn as useKeyDown,
  uj as useViewportBreakpoints
};
//# sourceMappingURL=@sama-communications.ui-kit.mjs.map
